(function(){
'use strict';
/* ---------- core ---------- */
const root = document.documentElement;
root.classList.add('js');
const $ = (s, r) => (r || document).querySelector(s);
const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
const lerp = (a, b, t) => a + (b - a) * t;
const damp = (a, b, k, dt) => a + (b - a) * (1 - Math.exp(-k * dt));
const seg = (v, a, b) => clamp((v - a) / (b - a), 0, 1);
const ease = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
const easeOut = t => 1 - Math.pow(1 - t, 3);
const backOut = t => { const c = 1.9; return 1 + (c + 1) * Math.pow(t - 1, 3) + c * Math.pow(t - 1, 2); };
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches || /[?&]rm\b/.test(location.search);
const FINE = matchMedia('(hover:hover) and (pointer:fine)').matches;
const money = n => '$' + n.toFixed(2);
const num = n => Math.round(n).toLocaleString('en-AU');
if (RM) root.classList.add('rm');

const BLENDS = [
  { id: 'pe', name: 'People Everyday', line: '(tastes like Coco Pops and vanilla milkshakes)', w: '#8CCDE3', ink: '#111A37', ghost: 'rgba(17,26,55,.09)', edge: '#111A37', dark: false,
    art: 'People Everyday label art: palm trees, a rolling wave and people out on the beach path',
    taste: 'A People Everyday bag in front of a stack of ice cream scoops running with caramel, under a neon sign that says Life is Sweet' },
  { id: 'nsb', name: 'No Sleep Till Brooklyn', line: '(like dipping Jaffa cakes into a dark chocolate thickshake)', w: '#F27B20', ink: '#111A37', ghost: 'rgba(17,26,55,.1)', edge: '#111A37', dark: false,
    art: 'No Sleep Till Brooklyn label art: Brooklyn street signs over a wall of boomboxes',
    taste: 'A No Sleep Till Brooklyn bag on a graffiti wall in a splash of paint, dark chocolate and orange' },
  { id: 'hyd', name: 'Hyperdrive', line: '(deep-space chocolate, with malt and honey)', w: '#111A37', ink: '#F0F0EA', ghost: 'rgba(200,136,248,.16)', edge: '#C888F8', dark: true,
    art: 'Hyperdrive label art: a spaceship firing green lasers past flying saucers over a purple canyon',
    taste: 'A Hyperdrive bag flying through a purple galaxy with chocolate malt balls' }
];
const PRICE = { '250g': 20, '1kg': 65 };
const SUB_RATE = 0.8;

/* the store. Every cart line is a real Shopify line: a variant for the size and grind (in GRINDS order) and, on a
   subscription, the Recharge selling plan for how often it is delivered. The numbers below are the store as it stood when
   this was written; inside the theme they are replaced by the store's own product data (see liveStore) */
const GRINDS = ['Wholebean', 'Ground for Espresso', 'Ground for Plunger', 'Ground for AeroPress'];
const FREQ = [1, 2, 3, 4, 5].map(n => ({ k: n + '-week', n: n, unit: 'week' }));
const weekPlans = ids => { const o = {}; ids.forEach((id, i) => { o[(i + 1) + '-week'] = id; }); return o; };
const SHOP = {
  pe: { handle: 'everyday',
    v: { '250g': [39302166773849, 42473882779737, 42473882845273, 42473882812505], '1kg': [39302166511705, 42473882681433, 42473882746969, 42473882714201] },
    plans: weekPlans([1722351705, 1722384473, 1722417241, 1722450009, 1722482777]) },
  nsb: { handle: 'no-sleep-till-brooklyn',
    v: { '250g': [39302164545625, 42474177429593, 42474177462361, 42474177495129], '1kg': [39302164283481, 42474177331289, 42474177364057, 42474177396825] },
    plans: weekPlans([1722712153, 1722744921, 1722777689, 1722810457, 1722843225]) },
  hyd: { handle: 'hyperdrive',
    v: { '250g': [39302147735641, 43142943244377, 43142943277145, 43142943309913], '1kg': [39302147473497, 43142943146073, 43142943178841, 43142943211609] },
    plans: weekPlans([1722548313, 1722581081, 1722613849, 1722646617, 1722679385]) }
};
Object.keys(SHOP).forEach(k => { SHOP[k].price = {}; SHOP[k].sub = {}; SHOP[k].out = {}; });
let SUB_PCT = 20, STORE_LIVE = false;
/* inside the theme the layout prints the three products as the store has them right now (#cflStore): variants, prices,
   what is in stock, and the Recharge plans with the price each one gives. That replaces the table above, so a price or a
   plan changed in Shopify or Recharge shows up here without touching this file */
(function liveStore() {
  const el = document.getElementById('cflStore');
  if (!el) return;
  let data; try { data = JSON.parse(el.textContent); } catch (err) { return; }
  const DAYS = { day: 1, week: 7, month: 30, year: 365 }, freq = [];
  let pct = null;
  Object.keys(SHOP).forEach(key => {
    const p = SHOP[key], d = data && data[p.handle];
    if (!d || !d.variants || !d.variants.length) return;
    d.variants.forEach(x => {
      const o = (x.o || []).map(t => String(t).toLowerCase().trim());
      const size = Object.keys(p.v).find(t => o.indexOf(t.toLowerCase()) > -1);
      const gi = GRINDS.findIndex(g => o.indexOf(g.toLowerCase()) > -1);
      if (!size || gi < 0 || !x.id) return;
      p.v[size][gi] = x.id;
      p.price[x.id] = x.price / 100;
      p.out[x.id] = x.ok === false;
      p.sub[x.id] = {};
      (x.plans || []).forEach(a => { p.sub[x.id][a.id] = a.price / 100; if (pct === null && x.price > 0) pct = Math.round((1 - a.price / x.price) * 100); });
    });
    const plans = {};
    (d.plans || []).forEach(sp => {
      let m = null;
      (sp.opts || []).forEach(t => { m = m || /^(\d+)[\s-]*(day|week|month|year)s?$/i.exec(String(t).trim()); });
      m = m || /every\s+(\d+)\s*(day|week|month|year)/i.exec(sp.name || '');
      if (!m || !sp.id) return;
      const unit = m[2].toLowerCase(), k = +m[1] + '-' + unit;
      if (!plans[k]) plans[k] = sp.id;
      if (!freq.some(f => f.k === k)) freq.push({ k: k, n: +m[1], unit: unit });
    });
    p.plans = plans; p.live = true; STORE_LIVE = true;
  });
  if (!STORE_LIVE) return;
  freq.sort((x, y) => x.n * DAYS[x.unit] - y.n * DAYS[y.unit]);
  FREQ.length = 0; freq.forEach(f => FREQ.push(f));
  if (pct !== null && pct > 0) SUB_PCT = pct;
})();
const shopOf = b => SHOP[BLENDS[b].id];
/* bundle and save (8 Oct, Jos): One for a mate takes 10% off two or more one-off 250g bags, and Pick and mix makes every third
   one-off 250g bag half price. Both are automatic discounts in the store, set not to stack, so the cart takes whichever saves
   more. Everything goes in the cart as our normal bags ("so we see the existing skus") */
const MATE = 0.1, PICK = 0.5, PICK_PAGE = 'pages/pick-and-mix';
/* the better of the two on a list of one-off 250g bag prices */
function bndBest(units) {
  const q = units.length; if (q < 2) return { amt: 0, kind: '' };
  const mate = MATE * units.reduce((a, b) => a + b, 0), s = units.slice().sort((a, b) => a - b);
  let pick = 0; for (let i = 0; i < Math.floor(q / 3); i++) pick += PICK * s[i];
  return pick > mate + 1e-9 ? { amt: pick, kind: 'pick' } : { amt: mate, kind: 'mate' };
}
const variantOf = (b, size, grind) => shopOf(b).v[size][Math.max(0, GRINDS.indexOf(grind))];
const planOf = (b, k) => { const pl = shopOf(b).plans; return pl[k] || pl[Object.keys(pl)[0]] || 0; };
/* what one bag costs: the store's own figure when we have it, otherwise the list price less the subscription saving */
function priceOf(b, size, grind, plan, k) {
  const p = shopOf(b), id = variantOf(b, size, grind), base = p.price[id] != null ? p.price[id] : PRICE[size];
  if (plan !== 'sub') return base;
  const live = p.sub[id] && p.sub[id][planOf(b, k)];
  return live != null ? live : base * SUB_RATE;
}
const freqOf = k => FREQ.find(f => f.k === k) || FREQ[0] || { k: '', n: 0, unit: 'week' };
const everyText = k => { const f = freqOf(k); return 'every ' + (f.n === 1 ? f.unit : f.n + ' ' + f.unit + 's'); };
const freqLabel = f => (f.n === 1 ? f.unit.charAt(0).toUpperCase() + f.unit.slice(1) : f.n + ' ' + f.unit + 's');
/* 8 Oct: in a theme preview Shopify's own bar sits along the bottom of the screen (customers never get it), so the cart
   gives its last lines room to clear it */
try { if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') document.documentElement.classList.add('pvbar'); } catch (e) {}
/* where the pictures and songs live. A Shopify theme keeps its files in one flat folder, so the theme sets window.CFL
   before this runs: { img: '<assets url>/cfl-', aud: '<files url>/cfl-', shop: '/' }. shop switches the real checkout on */
const CFG = window.CFL || {};
/* the wholesale page: the store marks it on <html>; here ?roompage shows it */
const ROOMPAGE = document.documentElement.classList.contains('roompage');
const IMG = CFG.img || 'i/', AUD = CFG.aud || 'a/';
/* a picture's address. Anything already on the page keeps the exact address the page gave it (a theme adds a version to
   each one), so a picture fetched ahead of time and the same picture in the markup are one download, not two */
const PICS = {};
(function () {
  const pre = IMG.split('/').pop();
  $$('img[src], img[data-src], [data-box]').forEach(el => {
    [el.getAttribute('src'), el.getAttribute('data-src'), el.getAttribute('data-box')].forEach(u => {
      const m = u && /([\w-]+)\.webp(?:[?#]|$)/.exec(u);
      if (!m) return;
      const n = pre && m[1].indexOf(pre) === 0 ? m[1].slice(pre.length) : m[1];
      if (!PICS[n]) PICS[n] = u;
    });
  });
})();
if (matchMedia('(max-width: 760px)').matches) $$('img[srcset], img[data-srcset]').forEach(el => {   /* phones: the small copy (15 Oct) */
  const ss = el.getAttribute('srcset') || el.getAttribute('data-srcset'), u = ss.split(',')[0].trim().split(/\s+/)[0], m = /([\w-]+)\.webp/.exec(u);
  if (!m) return;
  const pre = IMG.split('/').pop(), n = pre && m[1].indexOf(pre) === 0 ? m[1].slice(pre.length) : m[1];
  PICS[n] = u;
});
const pic = n => PICS[n] || IMG + n + '.webp';
const REVIEWS = [
  ["It feels like a hug in a cup!", "Kara", "pe", "on espresso", 5],
  ["Hyper Drive isn't just coffee, it's fuel.", "Jade", "hyd", "in a plunger", 5],
  ["No Sleep til Brooklyn is my absolute favourite coffee beans out of all the ones I've tried! So freshly roasted and smooth! 10/10 would recommend!", "Gemma", "nsb", "on espresso", 5],
  ["If coffee were a soulmate, this would be mine.", "Abi", "pe", "on a Breville", 5],
  ["Wow this coffee blows your socks off, keeps you going all day, and it tastes absolutely amazing.", "Karen", "hyd", "on a De'Longhi", 5],
  ["PED is the ultimate all-rounder.", "Travis", "pe", "on espresso", 5],
  ["We think No Sleep til Brooklyn is so delicious we buy it regularly to have in our espresso machine at home. All our family and friends love it too when they visit for a coffee!", "Belinda", "nsb", "on a Breville", 5],
  ["I discovered you guys back in 2018 when I was posted over in WA. Ever since I've been reordering no matter where I was around the country. No other beans taste as smooth.", "Hannah", "pe", "on a Breville", 4],
  ["Amazing beans for dark roast lovers. Best enjoyed black. Leave the milk in the fridge!", "Leonard", "hyd", "as pour over", 5],
  ["This coffee takes the morning fuzzies away.", "Vicki", "pe", "in a plunger", 5],
  ["It is delicious and I order it from BOM WA as NSW coffee is terrible. I have been in NSW for 3 years and searched for a coffee to match with no luck.", "Toni", "decaf", "on espresso", 5],
  ["Honestly, it's the kind of coffee that makes you look forward to getting out of bed.", "John", "pe", "on a Breville", 5],
  ["BOM coffee is by far the best. We love that we can buy the fresh roasted beans and have them delivered to our house to enjoy at home. You won't be disappointed!", "Heather", "nsb", "on espresso", 5],
  ["That first sip in the morning or that afternoon coffee to break the 3pm fuzzys, it's just plain good, perfect for everyone and perfect for everyday.", "Brenton", "pe", "on a Breville", 5],
  ["This blend is easy to drink and tastes amazing. Doesn't matter how it's drunk, espresso, long black or cold brew, it retains the same flavour and satisfaction.", "Steven", "hyd", "on a Breville", 5],
  ["It's the only beans that I'll have at home for the coffee machine. If it's not BOM.. I'm not drinking it!", "Amanda", "pe", "on espresso", 5],
  ["Verryyyy yummy coffee, so smooth & creamy! Have been preferring and craving coffees from home rather than buying out since we have had our People Everyday beans.", "Ashleigh", "pe", "on a Breville", 5],
  ["Normally we get sick of the same coffee bean. But every time I'm ever tempted to try another bean I always have regrets and come back.", "Cherrish", "pe", "on a Breville", 5]
];

/* shared state, written by the scroll loop and read by everything else */
const S = {
  entered: false,
  vw: innerWidth, vh: innerHeight,
  y: 0, vel: 0,
  blend: 0,
  px: 0, py: 0,        // pointer in -1..1
  mx: -999, my: -999,  // pointer in px
  overlay: null,
  mobile: innerWidth <= 700,
  stacked: innerWidth <= 980   // blend panels flow down the page instead of stacking
};

/* toast */
const toastEl = $('#toast');
let toastT = 0;
function toast(msg) {
  toastEl.textContent = msg;
  toastEl.classList.add('show');
  clearTimeout(toastT);
  toastT = setTimeout(() => toastEl.classList.remove('show'), 2600);
}
/* always open at the top, never where the browser remembers you were */
try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (err) {}
window.scrollTo(0, 0);

/* ---------- recipes: our own, as they stand on the store's blend pages today. B is the numbers, STEPS the method, G the timed
   stages, TIPS and TROUBLE the advice. Single origins and decaf have no recipe of their own, so they run on People Everyday's ---------- */
const RECIPES = {"G":{"pe":{"plg":[[0,"POUR ALL WATER","","1000G AT 94°C"],[30,"STIR ONCE","purple","WET ALL GROUNDS"],[60,"PUT LID ON","","DON'T PLUNGE YET"],[240,"PLUNGE SLOWLY","pink","ALL THE WAY DOWN"],[270,"LET IT SETTLE","gold","2-3 MINUTES"],[420,"POUR GENTLY","g","DON'T TIP TO THE END"],[430,"DONE ✓","g","ENJOY"]],"v60":[[0,"BLOOM 30G","","WET ALL GROUNDS"],[10,"SWIRL V60","purple","MIX EVENLY"],[45,"POUR TO 150G","pink","SLOW CIRCLES"],[75,"POUR TO 250G","gold","KEEP V60 FULL"],[105,"STIR + SWIRL","purple","FLAT BED"],[150,"DRAW DOWN","gold","NEARLY THERE"],[180,"DONE ✓","g","ENJOY"]],"aero":[[0,"POUR + STIR 3X","","200G AT 93°C"],[10,"STEEP","purple","WAIT"],[90,"CAP + FLIP","pink","CAREFUL"],[100,"PRESS SLOWLY","gold","30 SECONDS"],[120,"DONE ✓","g","ADD 50-80G WATER FOR AMERICANO"]]},"nsb":{"plg":[[0,"POUR ALL WATER","","1000G AT 92°C"],[30,"STIR ONCE","purple","WET ALL GROUNDS"],[60,"PUT LID ON","","DON'T PLUNGE YET"],[240,"PLUNGE SLOWLY","pink","ALL THE WAY DOWN"],[270,"LET IT SETTLE","gold","2-3 MINUTES"],[420,"POUR GENTLY","g","DON'T TIP TO THE END"],[430,"DONE ✓","g","ENJOY"]],"v60":[[0,"BLOOM 30G","","WET ALL GROUNDS"],[10,"SWIRL V60","purple","MIX EVENLY"],[45,"POUR TO 150G","pink","SLOW CIRCLES"],[75,"POUR TO 240G","gold","KEEP V60 FULL"],[105,"STIR + SWIRL","purple","FLAT BED"],[130,"DRAW DOWN","gold","NEARLY THERE"],[150,"DONE ✓","g","ENJOY"]],"aero":[[0,"POUR + STIR 3X","","190G AT 91°C"],[10,"STEEP","purple","WAIT"],[60,"CAP + FLIP","pink","CAREFUL"],[70,"PRESS SLOWLY","gold","30 SECONDS"],[90,"DONE ✓","g","ADD 50-80G WATER FOR AMERICANO"]]},"hyd":{"plg":[[0,"POUR ALL WATER","","1000G AT 90°C"],[30,"STIR ONCE","purple","WET ALL GROUNDS"],[60,"PUT LID ON","","DON'T PLUNGE YET"],[210,"PLUNGE SLOWLY","pink","ALL THE WAY DOWN"],[240,"LET IT SETTLE","gold","2-3 MINUTES"],[390,"POUR GENTLY","g","DON'T TIP TO THE END"],[400,"DONE ✓","g","ENJOY"]],"v60":[[0,"BLOOM 40G","","WET ALL GROUNDS"],[10,"SWIRL V60","purple","MIX EVENLY"],[45,"POUR TO 150G","pink","SLOW CIRCLES"],[75,"POUR TO 250G","gold","KEEP V60 FULL"],[105,"STIR + SWIRL","purple","FLAT BED"],[130,"DRAW DOWN","gold","NEARLY THERE"],[150,"DONE ✓","g","ENJOY"]],"aero":[[0,"POUR + STIR 3X","","180G AT 88°C"],[10,"STEEP","purple","WAIT"],[60,"CAP + FLIP","pink","CAREFUL"],[70,"PRESS SLOWLY","gold","30 SECONDS"],[90,"DONE ✓","g","ADD 50-80G WATER FOR AMERICANO"]]}},"B":{"pe":{"esp":{"dose":20,"yield":40,"yl":"YIELD","time":"27-30","temp":93,"ratio":2,"grind":"FINE","ds":0.5,"ys":1,"rs":0.1,"tMin":27,"tMax":30,"hasCups":false},"plg":{"dose":15,"yield":250,"yl":"WATER","time":"7:00","temp":94,"ratio":16.67,"grind":"COARSE","ds":5,"ys":50,"rs":1,"tMin":390,"tMax":450,"hasCups":true},"v60":{"dose":15,"yield":250,"yl":"WATER","time":"3:00","temp":94,"ratio":16.67,"grind":"MEDIUM","ds":0.5,"ys":10,"rs":1,"tMin":165,"tMax":210,"hasCups":true},"aero":{"dose":15,"yield":200,"yl":"WATER","time":"2:00","temp":93,"ratio":13.33,"grind":"MEDIUM","ds":0.5,"ys":10,"rs":1,"tMin":110,"tMax":130,"hasCups":false}},"nsb":{"esp":{"dose":19.5,"yield":37,"yl":"YIELD","time":"27-30","temp":92,"ratio":1.9,"grind":"FINE","ds":0.5,"ys":1,"rs":0.1,"tMin":27,"tMax":30,"hasCups":false},"plg":{"dose":15,"yield":250,"yl":"WATER","time":"7:00","temp":92,"ratio":16.67,"grind":"COARSE","ds":5,"ys":50,"rs":1,"tMin":390,"tMax":450,"hasCups":true},"v60":{"dose":15,"yield":240,"yl":"WATER","time":"2:30","temp":92,"ratio":16,"grind":"MED-COARSE","ds":0.5,"ys":10,"rs":1,"tMin":140,"tMax":165,"hasCups":true},"aero":{"dose":15,"yield":190,"yl":"WATER","time":"1:30","temp":91,"ratio":12.67,"grind":"MEDIUM","ds":0.5,"ys":10,"rs":1,"tMin":80,"tMax":100,"hasCups":false}},"hyd":{"esp":{"dose":19,"yield":34,"yl":"YIELD","time":"27-30","temp":90,"ratio":1.8,"grind":"FINE","ds":0.5,"ys":1,"rs":0.1,"tMin":27,"tMax":30,"hasCups":false},"plg":{"dose":16,"yield":250,"yl":"WATER","time":"6:30","temp":90,"ratio":15.63,"grind":"COARSE","ds":5,"ys":50,"rs":1,"tMin":360,"tMax":420,"hasCups":true},"v60":{"dose":18,"yield":250,"yl":"WATER","time":"2:30","temp":90,"ratio":13.89,"grind":"MED-COARSE","ds":0.5,"ys":10,"rs":1,"tMin":140,"tMax":165,"hasCups":true},"aero":{"dose":15,"yield":180,"yl":"WATER","time":"1:30","temp":88,"ratio":12,"grind":"MEDIUM","ds":0.5,"ys":10,"rs":1,"tMin":80,"tMax":100,"hasCups":false}}},"STEPS":{"pe":{"esp":["DOSE <span class=\"h\">%Dg</span> INTO PORTAFILTER","DISTRIBUTE + TAMP FLAT","FLUSH GROUP HEAD 2S","EXTRACT <span class=\"h\">%Yg</span> IN <span class=\"h\">27-30S</span>","HONEY FLOW ✓ | GUSH = FINER | DRIP = COARSER"],"plg":["BOIL. SIT TO <span class=\"h\">94°C</span>","ADD <span class=\"h\">%Dg</span> COARSE. POUR <span class=\"h\">%Yg</span>","STIR ONCE. LID ON. WAIT <span class=\"h\">4M:00S</span>","PLUNGE SLOWLY ALL THE WAY DOWN","LET IT SETTLE <span class=\"h\">2-3 MINUTES</span>","POUR GENTLY. DON'T TIP TO THE END"],"v60":["RINSE FILTER. ADD <span class=\"h\">%Dg</span>","BLOOM <span class=\"h\">30g</span> — SWIRL TO MIX","AT 0M:45S POUR TO <span class=\"h\">150g</span>","AT 1M:15S POUR TO <span class=\"h\">%Yg</span>","STIR 1X EACH WAY. SWIRL FOR FLAT BED","DRAW DOWN BY <span class=\"h\">3M:00S</span>"],"aero":["INVERTED. ADD <span class=\"h\">%Dg</span>","POUR <span class=\"h\">%Yg</span> AT <span class=\"h\">93°C</span>. STIR 3X","CAP + FLIP AT <span class=\"h\">1M:30S</span>","PRESS SLOWLY 30S"]},"nsb":{"esp":["DOSE <span class=\"h\">%Dg</span> INTO PORTAFILTER","DISTRIBUTE + TAMP FLAT","FLUSH GROUP HEAD 2S","EXTRACT <span class=\"h\">%Yg</span> IN <span class=\"h\">27-30S</span>","DARK HONEY FLOW | ASHY = DROP TEMP"],"plg":["BOIL. SIT TO <span class=\"h\">92°C</span>","ADD <span class=\"h\">%Dg</span> COARSE. POUR <span class=\"h\">%Yg</span>","STIR ONCE. LID ON. WAIT <span class=\"h\">4M:00S</span>","PLUNGE SLOWLY ALL THE WAY DOWN","LET IT SETTLE <span class=\"h\">2-3 MINUTES</span>","POUR GENTLY. DON'T TIP TO THE END"],"v60":["RINSE FILTER. ADD <span class=\"h\">%Dg</span> MED-COARSE","BLOOM <span class=\"h\">30g</span> — SWIRL TO MIX","AT 0M:45S POUR TO <span class=\"h\">150g</span>","AT 1M:15S POUR TO <span class=\"h\">%Yg</span>","STIR 1X EACH WAY. SWIRL FOR FLAT BED","DRAW DOWN BY <span class=\"h\">2M:30S</span>"],"aero":["INVERTED. ADD <span class=\"h\">%Dg</span>","POUR <span class=\"h\">%Yg</span> AT <span class=\"h\">91°C</span>. STIR 3X","CAP + FLIP AT <span class=\"h\">1M:00S</span>","PRESS SLOWLY 30S"]},"hyd":{"esp":["DOSE <span class=\"h\">%Dg</span> INTO PORTAFILTER","DISTRIBUTE + TAMP FLAT","FLUSH GROUP HEAD 2S","EXTRACT <span class=\"h\">%Yg</span> IN <span class=\"h\">27-30S</span> SHORT + TIGHT","THICK FLOW | SYRUPY | BITTER = 89°C"],"plg":["BOIL. SIT TO <span class=\"h\">90°C</span>","ADD <span class=\"h\">%Dg</span> COARSE. POUR <span class=\"h\">%Yg</span>","STIR ONCE. LID ON. WAIT <span class=\"h\">3M:30S</span>","PLUNGE SLOWLY ALL THE WAY DOWN","LET IT SETTLE <span class=\"h\">2-3 MINUTES</span>","POUR GENTLY. DON'T TIP TO THE END"],"v60":["RINSE FILTER. ADD <span class=\"h\">%Dg</span> MED-COARSE","BLOOM <span class=\"h\">40g</span> — SWIRL TO MIX","AT 0M:45S POUR TO <span class=\"h\">150g</span>","AT 1M:15S POUR TO <span class=\"h\">%Yg</span>","STIR 1X EACH WAY. SWIRL FOR FLAT BED","DRAW DOWN BY <span class=\"h\">2M:30S</span>"],"aero":["INVERTED. ADD <span class=\"h\">%Dg</span>","POUR <span class=\"h\">%Yg</span> AT <span class=\"h\">88°C</span>. STIR 3X","CAP + FLIP AT <span class=\"h\">1M:00S</span>","PRESS SLOWLY 30S"]}},"TIPS":{"pe":{"esp":"FORGIVING BLEND. CHOCOLATE + VANILLA AT 1:2. FOR BLACK, PULL 2-3G LONGER.","plg":"CHOCOLATE SWEETNESS SHINES. DON'T RUSH — LET IT SETTLE.","v60":"SLOW CIRCLES. SWIRL AFTER LAST POUR FOR A FLAT BED.","aero":"VANILLA MILKSHAKE VIBES. ADD 50-80G HOT WATER FOR AMERICANO."},"nsb":{"esp":"DON'T OVER-EXTRACT. JAFFA AT SHORTER PULL. FOR BLACK, PULL 2-3G LONGER.","plg":"SHORTER STEEP. DARK CHOC + ORANGE COME THROUGH CLEAN.","v60":"COARSER THAN PE. JAFFA NOTES SHINE ON POUR OVER.","aero":"DARK CHOC + ORANGE POP. ADD 50-80G HOT WATER FOR AMERICANO."},"hyd":{"esp":"BURNS EASY. 89-91°C MAX. MALTESERS AT SHORT PULL. FOR BLACK, PULL 2-3G LONGER.","plg":"COOLER WATER KEY. MALTESERS SWEETNESS AT 90°C.","v60":"FAST POUR. KEEP IT MOVING. DARK ROAST V60 IS INCREDIBLE.","aero":"88°C. PURE CHOCOLATE BOMB. ADD 50-80G HOT WATER FOR AMERICANO."}},"TROUBLE":{"esp":"SOUR = GRIND FINER | BITTER = GRIND COARSER | WATERY = MORE DOSE","plg":"WEAK = MORE COFFEE | BITTER = COOLER WATER OR SHORTER BREW | SILTY = LET IT SETTLE LONGER","v60":"SOUR = GRIND FINER | BITTER = GRIND COARSER | SLOW DRAIN = COARSER GRIND","aero":"SOUR = GRIND FINER OR STEEP LONGER | BITTER = COARSER OR COOLER WATER"}};
/* what's in the cup: a picture and a name for each tasting note */
const CUP_NOTES = {
  pe: [['el-pe-cereal', 'Coco Pops'], ['el-pe-shake', 'Vanilla milkshake'], ['el-pe-popcorn', 'Popcorn']],
  nsb: [['el-nsb-jaffa', 'Jaffa cakes'], ['el-nsb-shake', 'Dark chocolate thickshake'], ['el-nsb-orange', 'Marmalade']],
  hyd: [['el-hyd-choc', 'Dark chocolate'], ['el-hyd-malt', 'Malt'], ['el-hyd-honey', 'Honey']],
  peru: [['el-hyd-choc', 'Chocolate'], ['fl-panela', 'Panela'], ['fl-driedfruit', 'Dried fruit']],
  colombia: [['fl-milkchoc', 'Milk chocolate'], ['fl-toffeeapple', 'Toffee apple']],
  brazil: [['fl-milkchoc', 'Milk chocolate'], ['fl-hazelnut', 'Hazelnut'], ['fl-toffees', 'Nan\'s toffees']],
  decaf: [['el-hyd-choc', 'Chocolate'], ['fl-driedfruit', 'Dried fruit'], ['fl-trailmix', 'Trail mix']]
};
/* a single origin or the decaf borrows the People Everyday numbers, but not what that recipe says about the blend and its
   flavours. These are the parts of our own tips that hold for any coffee */
const SINGLE_TIPS = { esp: 'FOR BLACK, PULL 2-3G LONGER.', plg: 'DON\'T RUSH — LET IT SETTLE.', v60: 'SLOW CIRCLES. SWIRL AFTER LAST POUR FOR A FLAT BED.', aero: 'ADD 50-80G HOT WATER FOR AMERICANO.' };
const BREW_METHOD = { esp: 'Espresso', plg: 'Plunger', v60: 'V60', aero: 'AeroPress' };
const GRIND_FOR = { esp: 'Ground for Espresso', plg: 'Ground for Plunger', aero: 'Ground for AeroPress' };
/* how to brew each method, in a few lines: the words are the brew guide page's own. {t} is the time the clock calls that step
   for this coffee, {g} the grams of the first pour, so the how-to never argues with the plays */
const HOWTO = {
  esp: { line: 'The foundation. Get this right and everything else follows. Pressure, precision, 27 seconds of focus.', grind: 'fine, like caster sugar',
    need: ['Espresso machine', 'Grinder', 'Scale', 'Tamper'],
    steps: [['Dose and tamp', 'Dose into your portafilter. Distribute evenly and tamp flat and level.'], ['Flush the group', 'Flush the group head for 2 seconds before locking in.'], ['Extract', 'Start extracting. You\'re looking for a steady, honey-coloured flow.'], ['Weigh your yield', 'Stop at your target yield. Weigh it, don\'t guess it.']],
    fix: 'Gushing fast and tasting sour? Grind finer. Dripping slow and tasting bitter? Grind coarser. Tastes both sour and bitter? That\'s channelling. Fix your puck prep, not your grind.' },
  plg: { line: 'The easiest great coffee you\'ll ever make. Full-bodied, forgiving, and feeds a crowd. Just don\'t skip the settle.', grind: 'coarse, like raw sugar',
    need: ['Plunger', 'Grinder', 'Scale', 'Kettle'],
    steps: [['Boil and rest', 'Boil your kettle. Let it sit for 30 seconds.'], ['Add coffee and water', 'Add coffee (coarse grind). Pour all the water in with a bit of force to wet everything.'], ['Stir and steep', 'Stir once. Put the lid on. Don\'t push the plunger down yet. Wait until {t} on the clock.'], ['Plunge', 'At {t}, plunge slowly and steadily all the way down.'], ['Let it settle', 'Don\'t pour yet. Let it settle for 2-3 minutes. This is the single biggest upgrade you can make. The fine particles drop to the bottom and your cup comes out noticeably cleaner.'], ['Pour', 'Pour gently. Don\'t tip the plunger right to the end.']],
    fix: 'Weak? Use more coffee. Bitter? Use cooler water or brew for less time. Silty? Let it settle longer before pouring.' },
  v60: { line: 'Clean, bright, and reveals every nuance. The ritual brewer. Slow circles, steady pour, total control.', grind: 'medium, like sand',
    need: ['V60 dripper', 'Filters', 'Grinder', 'Gooseneck kettle', 'Scale'],
    steps: [['Rinse the filter', 'Rinse the paper filter with hot water. This removes paper taste and preheats the brewer. Discard the water.'], ['Bloom', 'Add coffee. Pour just enough water to wet all the grounds (about {g}g). This is the bloom. The bubbling means your beans are fresh.'], ['Swirl', 'Swirl the V60 gently to mix evenly.'], ['Pour in circles', 'Pour the rest of the water in slow, steady circles from the centre outward. Avoid pouring on the filter walls.'], ['Stir and draw down', 'Once all water is in, give it one stir and a gentle swirl for a flat bed. Let it draw down.']],
    fix: 'Draining too fast? Grind finer. Too slow? Grind coarser. Coffee bed should be flat at the end.' },
  aero: { line: 'The most forgiving brewer out there. Compact, fast, and near impossible to make a bad cup. Travel essential.', grind: 'medium',
    need: ['AeroPress', 'Filters', 'Grinder', 'Kettle', 'Scale'],
    steps: [['Set up inverted', 'Inverted method. Insert the plunger about 2cm into the chamber. Flip it upside down.'], ['Add and stir', 'Add coffee. Pour water. Stir 3 times.'], ['Cap it', 'Place the filter cap with a rinsed paper filter on top.'], ['Flip and press', 'At {t}, carefully flip onto your cup. Press gently and steadily for 30 seconds. Stop when you hear the hiss.'], ['Dilute (optional)', 'Want it longer? Add 50-80g of hot water for an Americano-style cup.']],
    fix: 'Too strong? Add water after. Sour? Steep longer or grind finer. Bitter? Coarser grind or cooler water.' }
};
/* the store keeps its recipes in capitals with a few shorthand marks; here they read as sentences */
function nice(t) {
  t = String(t).replace(/\s*—\s*/g, '. ').replace(/\s*✓/g, '').replace(/\s*\|\s*/g, '. ').replace(/ = /g, ': ').toLowerCase();
  t = t.replace(/(\d+)m:(\d+)s/g, '$1:$2').replace(/\b1x\b/g, 'once').replace(/\b(\d+)x\b/g, '$1 times').replace(/\bmed-coarse\b/g, 'medium coarse').replace(/\bchoc\b/g, 'chocolate').replace(/\bpe\b/g, 'People Everyday');
  t = t.replace(/(^|[.!?]\s+)([a-z])/g, (m, a, c) => a + c.toUpperCase());
  return t.replace(/°c/g, '°C').replace(/\bv60\b/gi, 'V60').replace(/\baeropress\b/gi, 'AeroPress').replace(/\bmaltesers\b/gi, 'Maltesers').replace(/\bjaffa\b/gi, 'Jaffa');
}
const mmss = sec => Math.floor(sec / 60) + ':' + String(Math.floor(sec % 60)).padStart(2, '0');

/* ---------- sound: everything is synthesised, no audio files ---------- */
const SFX = (() => {
  let ctx = null, master, bus, comp, revSend, analyser, noiseBuf, ambBus, musicIn, musicAn;
  let on = false, lastTick = 0, lastSlide = 0;
  let scene = null, want = 'none', air = null, ducked = false, musicOn = false;
  let ambOn = true, ambVol = 0.42, fxOn = true, hushed = false;   /* the three things BOM Radio can switch */
  /* which switch a sound answers to (6 Oct): 'fx' the Clicks switch (the page's own controls), 'amb' the Sound switch (the
     scene and everything in it), 'clock' the shot clock's own Beeps switch */
  let lane = 'fx', clockOn = true;
  const laneOn = () => (lane === 'amb' ? ambOn : lane === 'clock' ? clockOn : fxOn);
  function inLane(l, f, args) { const was = lane; lane = l; try { return f.apply(null, args || []); } finally { lane = was; } }
  const LEVEL = 0.85, AMB = 1.45;   /* scene sound sits under the song, a bit above where it started */
  const BEAT = 60 / 86;

  function init() {
    if (ctx) return true;
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return false;
    try { ctx = new AC(); } catch (e) { ctx = null; return false; }
    master = ctx.createGain(); master.gain.value = 0;
    comp = ctx.createDynamicsCompressor();
    comp.threshold.value = -14; comp.knee.value = 10; comp.ratio.value = 5;
    comp.attack.value = 0.003; comp.release.value = 0.18;
    bus = ctx.createGain();
    analyser = ctx.createAnalyser(); analyser.fftSize = 2048;
    bus.connect(comp); comp.connect(master); master.connect(analyser); analyser.connect(ctx.destination);

    noiseBuf = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate);
    const d = noiseBuf.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;

    const len = Math.floor(ctx.sampleRate * 2.4);
    const ir = ctx.createBuffer(2, len, ctx.sampleRate);
    for (let c = 0; c < 2; c++) {
      const ch = ir.getChannelData(c);
      for (let i = 0; i < len; i++) ch[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2.8);
    }
    const conv = ctx.createConvolver(); conv.buffer = ir;
    const revLP = ctx.createBiquadFilter(); revLP.type = 'lowpass'; revLP.frequency.value = 5200;
    const revOut = ctx.createGain(); revOut.gain.value = 0.5;
    revSend = ctx.createGain();
    revSend.connect(conv); conv.connect(revLP); revLP.connect(revOut); revOut.connect(bus);
    ambBus = ctx.createGain(); ambBus.gain.value = hushed ? 0 : AMB * ambVol; ambBus.connect(bus);
    /* music goes round the master so muting the site sounds never mutes a song */
    musicIn = ctx.createGain(); musicIn.gain.value = 0.9;
    musicAn = ctx.createAnalyser(); musicAn.fftSize = 256; musicAn.smoothingTimeConstant = 0.75;
    musicIn.connect(musicAn); musicAn.connect(ctx.destination);
    return true;
  }
  const live = () => !!ctx && on;
  const when = o => (o.at != null ? o.at : ctx.currentTime + (o.t || 0));

  function shape(g, t, a, d, peak) {
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(Math.max(peak, 0.0002), t + a);
    g.gain.exponentialRampToValueAtTime(0.0001, t + a + d);
  }
  function route(g, o) {
    g.connect(o.dest || bus);
    if (o.rev) { const s = ctx.createGain(); s.gain.value = o.rev; g.connect(s); s.connect(revSend); }
  }
  function tone(o) {
    if (!live() || (!o.dest && !laneOn())) return;
    const t = when(o), a = o.a || 0.004;
    const osc = ctx.createOscillator(), g = ctx.createGain();
    osc.type = o.type || 'sine';
    osc.frequency.setValueAtTime(o.f, t);
    if (o.f2) osc.frequency.exponentialRampToValueAtTime(o.f2, t + a + o.d);
    shape(g, t, a, o.d, o.g);
    osc.connect(g); route(g, o);
    osc.start(t); osc.stop(t + a + o.d + 0.05);
  }
  function noise(o) {
    if (!live() || (!o.dest && !laneOn())) return;
    const t = when(o), a = o.a || 0.002;
    const src = ctx.createBufferSource(); src.buffer = noiseBuf; src.loop = true;
    const f = ctx.createBiquadFilter(); f.type = o.type || 'bandpass';
    f.frequency.setValueAtTime(o.f, t);
    if (o.f2) f.frequency.exponentialRampToValueAtTime(o.f2, t + a + o.d);
    f.Q.value = o.q || 0.8;
    const g = ctx.createGain();
    shape(g, t, a, o.d, o.g);
    src.connect(f); f.connect(g); route(g, o);
    src.start(t, Math.random() * 1.5); src.stop(t + a + o.d + 0.05);
  }

  /* ---- scene ambience: one bed per place, crossfaded as you move through the site ---- */
  const rnd = (a, b) => a + Math.random() * (b - a);
  function bed(out, type, f, q, g) {            /* looping filtered noise */
    const n = ctx.createBufferSource(); n.buffer = noiseBuf; n.loop = true;
    const fl = ctx.createBiquadFilter(); fl.type = type; fl.frequency.value = f; fl.Q.value = q;
    const gn = ctx.createGain(); gn.gain.value = g;
    n.connect(fl); fl.connect(gn); gn.connect(out); n.start(0, Math.random() * 1.5);
    return { n: n, f: fl, g: gn };
  }
  function lfo(rate, depth, param) {
    const o = ctx.createOscillator(); o.frequency.value = rate;
    const g = ctx.createGain(); g.gain.value = depth;
    o.connect(g); g.connect(param); o.start();
    return o;
  }
  function pan(out, v) {
    if (!ctx.createStereoPanner) return out;
    const p = ctx.createStereoPanner(); p.pan.value = v; p.connect(out);
    return p;
  }
  /* a voice with its own pitch and loudness curve: pts = [[time, freq, gain], ...] */
  function voice(out, type, pts, o) {
    if (!ctx || (out === bus && (!on || !laneOn()))) return;   /* the beds pass their own bus and are faded there */
    o = o || {};
    const t0 = ctx.currentTime + (o.t || 0);
    const osc = ctx.createOscillator(); osc.type = type;
    const g = ctx.createGain(); g.gain.setValueAtTime(0.0001, t0);
    osc.frequency.setValueAtTime(pts[0][1], t0);
    if (o.vib) { const l = ctx.createOscillator(), lg = ctx.createGain(); l.frequency.value = o.vib[0]; lg.gain.value = o.vib[1]; l.connect(lg); lg.connect(osc.frequency); l.start(t0); l.stop(t0 + pts[pts.length - 1][0] + 0.1); }
    pts.forEach(p => { osc.frequency.linearRampToValueAtTime(p[1], t0 + p[0]); g.gain.linearRampToValueAtTime(Math.max(p[2], 0.0001), t0 + p[0]); });
    let last = osc;
    if (o.bp) { const f = ctx.createBiquadFilter(); f.type = o.ft || 'bandpass'; f.frequency.value = o.bp; f.Q.value = o.q || 1; osc.connect(f); last = f; }
    last.connect(g);
    const dest = o.pan != null ? pan(out, o.pan) : out;
    g.connect(dest);
    if (o.rev) { const s = ctx.createGain(); s.gain.value = o.rev; g.connect(s); s.connect(revSend); }
    const end = pts[pts.length - 1][0];
    osc.start(t0); osc.stop(t0 + end + 0.08);
  }
  function gullCry(out, far, p) {
    const n = 2 + ((Math.random() * 4) | 0), base = rnd(1500, 2100);
    for (let k = 0; k < n; k++) {
      const f = base * (1 - k * 0.035), t = k * rnd(0.3, 0.38);
      voice(out, 'sawtooth', [[0, f * 0.82, 0], [0.05, f * 1.22, 0.05 * far], [0.12, f * 1.12, 0.045 * far], [0.3, f * 0.7, 0]], { t: t, bp: f * 1.5, q: 3.5, pan: p, rev: 0.5 });
    }
  }
  const SCENES = {
    /* People Everyday: surf rolling in, gulls overhead */
    beach(out, every) {
      const low = bed(out, 'lowpass', 420, 0.3, 0.1), mid = bed(out, 'bandpass', 900, 0.4, 0.03);
      const keep = [low, mid, lfo(0.09, 120, low.f.frequency)];
      function wave() {
        if (!live()) return;
        const t = ctx.currentTime, len = rnd(5.5, 8);
        low.g.gain.cancelScheduledValues(t); low.g.gain.setValueAtTime(low.g.gain.value, t);
        low.g.gain.linearRampToValueAtTime(0.3, t + len * 0.42); low.g.gain.linearRampToValueAtTime(0.09, t + len);
        mid.g.gain.cancelScheduledValues(t); mid.g.gain.setValueAtTime(mid.g.gain.value, t);
        mid.g.gain.linearRampToValueAtTime(0.1, t + len * 0.45); mid.g.gain.linearRampToValueAtTime(0.02, t + len);
        noise({ t: len * 0.36, a: len * 0.14, d: len * 0.5, g: 0.085, type: 'highpass', f: 1700, f2: 900, dest: out, rev: 0.12 });
      }
      function gull() { if (live() && !document.hidden) gullCry(out, rnd(0.35, 1), rnd(-0.8, 0.8)); }
      wave();
      every(wave, 6500, 9500); every(gull, 5000, 12000); setTimeout(gull, 1800);
      return keep;
    },
    /* No Sleep Till Brooklyn: traffic, horns, a siren somewhere, a boombox going past */
    street(out, every) {
      const rum = bed(out, 'lowpass', 170, 0.3, 0.26), air = bed(out, 'bandpass', 1100, 0.4, 0.022);
      const keep = [rum, air, lfo(0.13, 45, rum.f.frequency)];
      function car() {
        if (!live() || document.hidden) return;
        const dir = Math.random() < 0.5 ? -1 : 1, len = rnd(2.6, 4.2), t = ctx.currentTime;
        const n = ctx.createBufferSource(); n.buffer = noiseBuf; n.loop = true;
        const f = ctx.createBiquadFilter(); f.type = 'bandpass'; f.Q.value = 0.7;
        f.frequency.setValueAtTime(260, t); f.frequency.linearRampToValueAtTime(rnd(700, 1000), t + len * 0.5); f.frequency.linearRampToValueAtTime(220, t + len);
        const g = ctx.createGain(); g.gain.setValueAtTime(0.0001, t); g.gain.linearRampToValueAtTime(rnd(0.07, 0.13), t + len * 0.5); g.gain.linearRampToValueAtTime(0.0001, t + len);
        let dest = out;
        if (ctx.createStereoPanner) { const p = ctx.createStereoPanner(); p.pan.setValueAtTime(-dir, t); p.pan.linearRampToValueAtTime(dir, t + len); p.connect(out); dest = p; }
        n.connect(f); f.connect(g); g.connect(dest); n.start(t, Math.random()); n.stop(t + len + 0.1);
      }
      function horn() {
        if (!live() || document.hidden) return;
        const p = rnd(-0.9, 0.9), base = [392, 415, 440, 466][(Math.random() * 4) | 0], far = rnd(0.4, 1);
        const beeps = Math.random() < 0.4 ? 2 : 1;
        for (let k = 0; k < beeps; k++) {
          const t = k * 0.3, d = k === beeps - 1 ? rnd(0.25, 0.6) : 0.14;
          [1, 1.26].forEach(m => voice(out, 'square', [[0, base * m, 0], [0.02, base * m, 0.022 * far], [d, base * m, 0.02 * far], [d + 0.05, base * m, 0]], { t: t, bp: 1500, ft: 'lowpass', q: 0.6, pan: p, rev: 0.6 }));
        }
      }
      function siren() {
        if (!live() || document.hidden) return;
        const pts = [[0, 640, 0]], p = rnd(-0.7, 0.7);
        for (let k = 0; k < 5; k++) { pts.push([k * 1.5 + 0.75, 960, 0.012]); pts.push([k * 1.5 + 1.5, 640, k === 4 ? 0 : 0.012]); }
        voice(out, 'triangle', pts, { bp: 1300, ft: 'lowpass', q: 0.5, pan: p, rev: 0.8 });
      }
      function boombox() {           /* someone walks past with the stereo up */
        if (!live() || document.hidden) return;
        const t0 = ctx.currentTime + 0.1, g = ctx.createGain(), lp = ctx.createBiquadFilter();
        lp.type = 'lowpass'; lp.frequency.value = 420;
        g.gain.setValueAtTime(0.0001, t0); g.gain.linearRampToValueAtTime(0.5, t0 + BEAT * 4); g.gain.linearRampToValueAtTime(0.0001, t0 + BEAT * 8);
        lp.connect(g); g.connect(out);
        [0, 1.75, 2.5, 4, 5.75, 6.5].forEach(b => tone({ at: t0 + b * BEAT, f: 130, f2: 44, d: 0.24, g: 0.5, dest: lp }));
        [1, 3, 5, 7].forEach(b => noise({ at: t0 + b * BEAT, d: 0.12, g: 0.3, type: 'bandpass', f: 900, q: 0.8, dest: lp }));
        setTimeout(() => { try { g.disconnect(); } catch (e) {} }, BEAT * 9000);
      }
      every(car, 2800, 6500); every(horn, 7000, 17000); every(siren, 38000, 70000); every(boombox, 26000, 44000);
      setTimeout(car, 400); setTimeout(horn, 3200); setTimeout(boombox, 9000);
      return keep;
    },
    /* Hyperdrive: engine drone, solar wind, pings and bleeps */
    space(out, every) {
      const lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 230;
      const dg = ctx.createGain(); dg.gain.value = 0.05; lp.connect(dg); dg.connect(out);
      const keep = [lfo(0.05, 90, lp.frequency)];
      [[55, 'sawtooth'], [55.35, 'sawtooth'], [82.4, 'sine'], [110.3, 'sine'], [36.7, 'sine']].forEach(v => {
        const o = ctx.createOscillator(); o.type = v[1]; o.frequency.value = v[0]; o.connect(lp); o.start(); keep.push(o);
      });
      const wind = bed(out, 'bandpass', 2600, 5, 0.02);
      keep.push(wind, lfo(0.045, 1500, wind.f.frequency), lfo(0.11, 0.012, wind.g.gain));
      function ping() {
        if (!live() || document.hidden) return;
        const f = [660, 880, 990, 1320][(Math.random() * 4) | 0];
        tone({ f: f, d: 1.9, g: 0.03, a: 0.006, dest: out, rev: 1 });
        tone({ t: 0.42, f: f, d: 1.2, g: 0.008, a: 0.006, dest: out, rev: 1 });
      }
      function bleeps() {
        if (!live() || document.hidden) return;
        const n = 4 + ((Math.random() * 5) | 0);
        for (let k = 0; k < n; k++) tone({ t: k * 0.075, f: rnd(1100, 2600), d: 0.045, g: 0.012, type: 'square', dest: out, rev: 0.4 });
      }
      function sweep() {
        if (!live() || document.hidden) return;
        noise({ a: 1.6, d: 2.2, g: 0.03, type: 'bandpass', f: 300, f2: 3400, q: 3, dest: out, rev: 0.5 });
      }
      every(ping, 5500, 10000); every(bleeps, 8000, 15000); every(sweep, 16000, 28000);
      setTimeout(ping, 1200);
      return keep;
    },
    /* the roastery: Betty's drum turning, beans cracking, the burner */
    roast(out, every) {
      const drum = bed(out, 'lowpass', 150, 0.4, 0.2), hiss = bed(out, 'highpass', 5200, 0.3, 0.008), tumble = bed(out, 'bandpass', 2300, 0.9, 0.012);
      const keep = [drum, hiss, tumble, lfo(0.85, 0.07, drum.g.gain), lfo(1.7, 0.006, tumble.g.gain)];
      function crack() {
        if (!live() || document.hidden || Math.random() > 0.5) return;
        noise({ t: Math.random() * 0.12, d: rnd(0.005, 0.016), g: rnd(0.012, 0.045), type: 'highpass', f: rnd(1800, 5000), dest: out });
      }
      function clank() {
        if (!live() || document.hidden) return;
        const f = rnd(520, 760);
        tone({ f: f, d: 0.16, g: 0.016, type: 'triangle', dest: out, rev: 0.7 });
        tone({ f: f * 1.51, d: 0.1, g: 0.01, type: 'triangle', dest: out, rev: 0.7 });
      }
      every(crack, 120, 160); every(clank, 9000, 19000);
      return keep;
    },
    /* a cafe in service: the room, cups, the steam wand, the grinder */
    cafe(out, every) {
      const room = bed(out, 'lowpass', 380, 0.3, 0.07);
      const keep = [room];
      for (let k = 0; k < 6; k++) {          /* a murmur of voices: narrow bands of noise that swell at talking speed */
        const v = bed(out, 'bandpass', rnd(280, 1300), 4, 0.0);
        keep.push(v, lfo(rnd(2.2, 5), 0.02, v.g.gain), lfo(rnd(0.15, 0.4), 0.014, v.g.gain));
        v.g.gain.value = 0.02;
      }
      function clink() {
        if (!live() || document.hidden) return;
        const f = rnd(2300, 4200), p = rnd(-0.8, 0.8), n = Math.random() < 0.4 ? 2 : 1;
        for (let k = 0; k < n; k++) voice(out, 'sine', [[0, f * (1 + k * 0.06), 0], [0.004, f * (1 + k * 0.06), 0.02], [0.12, f * (1 + k * 0.06), 0]], { t: k * 0.09, pan: p, rev: 0.6 });
      }
      function steam() {
        if (!live() || document.hidden) return;
        noise({ a: 0.25, d: rnd(1.6, 2.6), g: 0.035, type: 'highpass', f: 3600, dest: out, rev: 0.25 });
        noise({ t: 0.2, a: 0.2, d: 1.6, g: 0.016, type: 'bandpass', f: 700, f2: 1500, q: 2.5, dest: out });
      }
      function grind() {
        if (!live() || document.hidden) return;
        noise({ a: 0.08, d: rnd(1.2, 1.9), g: 0.028, type: 'bandpass', f: 1100, q: 1.3, dest: out, rev: 0.2 });
        tone({ f: 118, d: 1.5, g: 0.012, type: 'sawtooth', a: 0.06, dest: out });
      }
      every(clink, 3500, 9000); every(steam, 14000, 26000); every(grind, 24000, 40000);
      setTimeout(clink, 900); setTimeout(steam, 5000);
      return keep;
    }
  };
  function stopScene(sc, fade) {
    sc.timers.forEach(t => clearTimeout(t)); sc.timers.length = 0; sc.dead = true;
    const t = ctx.currentTime;
    try { sc.out.gain.cancelScheduledValues(t); sc.out.gain.setValueAtTime(sc.out.gain.value, t); sc.out.gain.linearRampToValueAtTime(0, t + fade); } catch (e) {}
    setTimeout(() => {
      sc.keep.forEach(k => { try { (k.n || k).stop(); } catch (e) {} });
      try { sc.out.disconnect(); } catch (e) {}
    }, fade * 1000 + 200);
  }
  function setScene(name) {
    want = SCENES[name] ? name : 'none';
    if (!ctx || !on) return;
    if (scene && scene.name === want) return;
    if (scene) { stopScene(scene, 1.4); scene = null; }
    if (want === 'none') return;
    const out = ctx.createGain(); out.gain.value = 0.0001; out.connect(ambBus);
    out.gain.linearRampToValueAtTime(1, ctx.currentTime + 1.6);
    const sc = { name: want, out: out, timers: [], dead: false, keep: [] };
    const every = (fn, a, b) => {           /* call fn again and again, a..b ms apart, until the scene ends */
      const loop = () => { if (sc.dead) return; fn(); sc.timers.push(setTimeout(loop, rnd(a, b))); };
      sc.timers.push(setTimeout(loop, rnd(a, b)));
    };
    sc.keep = SCENES[want](out, every) || [];
    scene = sc;
  }
  function duck() {
    if (!ctx) return;
    const t = ctx.currentTime;
    ambBus.gain.cancelScheduledValues(t); ambBus.gain.setValueAtTime(ambBus.gain.value, t);
    ambBus.gain.linearRampToValueAtTime(ambOn && !hushed && !musicOn ? AMB * ambVol : 0, t + (musicOn ? 0.9 : 0.6));   /* 8 Oct (Jos): the scene rests while our music plays */
  }

  /* phones: tell the system this is playback, so the ring switch on silent doesn't mute the scene and button sounds while the music plays on */
  function session(v) {
    try { if (navigator.audioSession) navigator.audioSession.type = v ? 'playback' : 'auto'; } catch (e) {}
  }
  function setOn(v) {
    if (v && !init()) return false;
    on = !!v;
    if (!ctx) return false;
    const t = ctx.currentTime;
    master.gain.cancelScheduledValues(t);
    master.gain.setValueAtTime(master.gain.value, t);
    session(on);
    if (on) {
      if (ctx.state !== 'running' && ctx.resume) ctx.resume();
      master.gain.linearRampToValueAtTime(LEVEL, t + 0.4);
      setScene(want);
      setTimeout(() => { if (on) warm(['scratch', 'scratch2', 'station', 'station2']); }, 2500);
      setTimeout(() => { if (on) warm(['betty']); }, 9000);
    } else {
      if (scene) { stopScene(scene, 0.3); scene = null; }
      master.gain.linearRampToValueAtTime(0, t + 0.3);
      setTimeout(() => { if (!on && !musicOn && ctx.suspend) ctx.suspend(); }, 600);
    }
    return on;
  }

  /* ---- recorded sounds: the few things a synth can't fake (a crowd, a real scratch). Each kind has one or more takes;
     a kind with no take recorded yet falls back to the synth. Files sit beside the songs as sfx-<take>.mp3 ---- */
  const TAKES = { applause: ['applause'], betty: ['betty'], scratch: ['scratch'], scratch2: ['scratch2'], station: ['station'], station2: ['station2'] };
  const takes = {}, turn = {}, going = {};
  function loadTake(name) {
    if (name in takes) return;
    takes[name] = null;
    fetch(AUD + 'sfx-' + name + '.mp3').then(r => { if (!r.ok) throw new Error('missing'); return r.arrayBuffer(); })
      .then(b => new Promise((ok, no) => ctx.decodeAudioData(b, ok, no)))
      .then(buf => { takes[name] = buf; }).catch(() => { takes[name] = false; });
  }
  function warm(kinds) { if (ctx) (kinds || Object.keys(TAKES)).forEach(k => TAKES[k].forEach(loadTake)); }
  /* plays the next take of a kind and says how long it runs; 0 means nothing recorded is ready */
  function sample(kind, o) {
    if (!live() || !ambOn) return 0;   /* every recorded take is part of the scene: Betty, the records, the crowd, the station */
    const list = TAKES[kind] || [];
    if (!list.length) return 0;
    list.forEach(loadTake);
    const ready = list.filter(n => takes[n]);
    if (!ready.length) return 0;
    turn[kind] = ((turn[kind] || 0) + 1) % ready.length;
    const buf = takes[ready[turn[kind]]], src = ctx.createBufferSource(), g = ctx.createGain(), t = ctx.currentTime;
    if (going[kind]) {   /* poked again before the last one finished: the old one ducks out so they never pile up */
      const was = going[kind];
      try { was.g.gain.cancelScheduledValues(t); was.g.gain.setValueAtTime(was.g.gain.value, t); was.g.gain.linearRampToValueAtTime(0, t + 0.05); was.src.stop(t + 0.06); } catch (e) {}
    }
    src.buffer = buf; g.gain.value = (o && o.g) || 0.8;
    src.connect(g); route(g, o || {});
    src.start(t + 0.01);
    going[kind] = { src: src, g: g };
    src.onended = () => { if (going[kind] && going[kind].src === src) going[kind] = null; };
    return buf.duration;
  }
  /* fades out whatever take of a kind is playing */
  function stopTake(kind, fade) {
    const was = going[kind];
    if (!was || !ctx) return;
    const t = ctx.currentTime, d = fade || 0.35;
    try { was.g.gain.cancelScheduledValues(t); was.g.gain.setValueAtTime(was.g.gain.value, t); was.g.gain.linearRampToValueAtTime(0, t + d); was.src.stop(t + d + 0.03); } catch (e) {}
    going[kind] = null;
  }
  let bettyWait = 0;

  /* ---- one-shots ---- */
  const api = {
    init, setOn,
    isOn: () => on,
    scene: setScene,
    sceneName: () => (scene ? scene.name : 'none'),
    setAmb(v) { ambOn = !!v; duck(); return ambOn; },
    ambOn: () => ambOn,
    ambGain: () => (ambBus ? ambBus.gain.value : 0),   /* read only, for the tests */
    /* a tool that needs to be heard (the shot clock) quietens the scene while it is open */
    hush(v) { hushed = !!v; duck(); return hushed; },
    ambLevel(v) { if (v != null) { ambVol = clamp(v, 0, 1); duck(); } return ambVol; },
    setFx(v) { fxOn = !!v; return fxOn; },
    fxOn: () => fxOn,
    /* the music player borrows the audio context so songs get a level meter */
    musicNode(el) {
      if (!init()) return null;
      try { const src = ctx.createMediaElementSource(el); src.connect(musicIn); return src; } catch (e) { return null; }
    },
    musicState(playing) {
      musicOn = !!playing;
      if (!ctx) return;
      if (musicOn && ctx.state !== 'running' && ctx.resume) ctx.resume();
      if (!musicOn && !on && ctx.suspend) setTimeout(() => { if (!on && !musicOn) ctx.suspend(); }, 600);
      duck();
    },
    musicLevel() {
      if (!musicAn || !musicOn) return 0;
      const b = new Uint8Array(musicAn.frequencyBinCount);
      musicAn.getByteFrequencyData(b);
      let s = 0; for (let i = 1; i < 24; i++) s += b[i];
      return s / (23 * 255);
    },
    /* poke a character and it answers back */
    critter(kind) {
      if (!live() || !laneOn()) return;
      if (kind === 'gull') gullCry(bus, 1.6, 0);
      else if (kind === 'pigeon') [0, 0.4].forEach(t => voice(bus, 'sine', [[0, 300, 0], [0.06, 430, 0.12], [0.2, 385, 0.1], [0.34, 300, 0]], { t: t, bp: 800, ft: 'lowpass', q: 0.7, rev: 0.25, vib: [24, 28] }));
      else if (kind === 'alien') {
        for (let k = 0; k < 5; k++) tone({ t: k * 0.07, f: rnd(900, 2400), d: 0.05, g: 0.05, type: 'square', rev: 0.3 });
        voice(bus, 'sine', [[0, 500, 0], [0.05, 700, 0.07], [0.4, 1500, 0.06], [0.58, 900, 0]], { t: 0.38, vib: [9, 40], rev: 0.5 });
      } else if (kind === 'ufo') voice(bus, 'sine', [[0, 420, 0], [0.08, 520, 0.08], [0.5, 980, 0.08], [0.9, 520, 0.06], [1.1, 420, 0]], { vib: [6.5, 30], rev: 0.6 });
      else if (kind === 'boombox') {
        [0, 0.17, 0.52].forEach(t => { tone({ t: t, f: 150, f2: 42, d: 0.2, g: 0.5 }); });
        [0.35, 0.7].forEach(t => { noise({ t: t, d: 0.14, g: 0.2, type: 'bandpass', f: 1900, q: 0.7, rev: 0.18 }); tone({ t: t, f: 210, f2: 150, d: 0.08, g: 0.1, type: 'triangle' }); });
        [0, 0.17, 0.35, 0.52, 0.7].forEach(t => noise({ t: t, d: 0.03, g: 0.03, type: 'highpass', f: 7500 }));
      } else if (kind === 'horn') [0, 0.16].forEach(t => [520, 655].forEach(f => voice(bus, 'square', [[0, f, 0], [0.015, f, 0.035], [0.1, f, 0.03], [0.13, f, 0]], { t: t, bp: 1700, ft: 'lowpass', q: 0.6, rev: 0.2 })));
      else if (kind === 'rocket') { noise({ a: 0.05, d: 0.9, g: 0.14, type: 'bandpass', f: 300, f2: 2600, q: 1.2, rev: 0.3 }); tone({ f: 70, f2: 240, d: 0.8, g: 0.12, type: 'sawtooth' }); }
      else if (kind === 'splash') { noise({ a: 0.02, d: 0.5, g: 0.16, type: 'bandpass', f: 2600, f2: 700, q: 0.8, rev: 0.3 }); }
      else if (kind === 'scratch' || kind === 'scratch2') {   /* scratch: the b-boy; scratch2: the records */
        if (!sample(kind, { g: 0.38, rev: 0.08 })) { noise({ a: 0.01, d: 0.12, g: 0.14, type: 'bandpass', f: 900, f2: 2600, q: 3 }); noise({ t: 0.14, a: 0.01, d: 0.14, g: 0.14, type: 'bandpass', f: 2600, f2: 700, q: 3 }); }
      } else if (kind === 'sat' || kind === 'sat2') {   /* two calls: one from the landing scene, one from Hyperdrive's own page */
        if (!sample(kind === 'sat2' ? 'station2' : 'station', { g: 0.85, rev: 0.2 })) {
          /* three pings home, a burst of telemetry, a breath of radio and the hum of the thing itself */
          [0, 0.13, 0.26].forEach(t => tone({ t: t, f: 1245, d: 0.07, g: 0.14, type: 'sine', a: 0.004, rev: 0.45 }));
          const set = [1568, 1760, 2093, 2349, 2637, 3136];
          for (let k = 0; k < 12; k++) tone({ t: 0.42 + k * 0.032, f: set[Math.floor(Math.random() * set.length)], d: 0.026, g: 0.06, type: 'square', rev: 0.3 });
          noise({ t: 0.82, a: 0.02, d: 0.3, g: 0.07, type: 'bandpass', f: 2600, f2: 1500, q: 2.2, rev: 0.5 });
          tone({ t: 0.4, f: 92, f2: 61, d: 0.85, g: 0.11, type: 'sine', a: 0.08 });
          tone({ t: 1.12, f: 1976, d: 0.22, g: 0.06, type: 'sine', a: 0.004, rev: 0.7 });
        }
      }
      else { tone({ f: 620, f2: 880, d: 0.09, g: 0.09, type: 'triangle' }); tone({ t: 0.09, f: 880, f2: 1240, d: 0.12, g: 0.08, type: 'triangle', rev: 0.3 }); }
    },
    beep(hi) { tone({ f: hi ? 1320 : 880, d: 0.12, g: 0.16, type: 'square' }); },
    count() { tone({ f: 660, d: 0.06, g: 0.11, type: 'square' }); },   /* one tick of the shot clock's three, two, one */
    /* something with wheels goes past and says so. van: two friendly beeps. cab: a short honk and a longer one. bike: a bell,
       twice. rover: two blips. x is where it is across the screen, -1 to 1, so the sound sits where the thing is */
    honk(kind, x) {
      if (!live() || !laneOn()) return;
      const p = clamp(x || 0, -0.7, 0.7);
      if (kind === 'tram') {
        /* ding ding: a struck gong, twice, then the weight of the thing rolling through on its joints */
        [0, 0.3].forEach(t => {
          [[1396, 0.15], [2793, 0.065], [4180, 0.036], [5870, 0.016]].forEach((h, i) => voice(bus, 'sine', [[0, h[0], 0], [0.003, h[0], h[1]], [0.09, h[0], h[1] * 0.5], [0.9 - i * 0.15, h[0], 0]], { t: t, pan: p, rev: 0.35 }));
          noise({ t: t, d: 0.012, g: 0.1, type: 'highpass', f: 4200 });
        });
        noise({ t: 0.1, a: 0.9, d: 1.9, g: 0.34, type: 'lowpass', f: 190, f2: 130, q: 0.6 });
        [0.75, 0.87, 1.35, 1.47, 1.95, 2.07].forEach(t => tone({ t: t, f: 96, f2: 52, d: 0.08, g: 0.2 }));
      } else if (kind === 'bike') {
        [0, 0.24].forEach(t => {
          [[2093, 0.075], [3136, 0.04], [4699, 0.018]].forEach(h => voice(bus, 'sine', [[0, h[0], 0], [0.004, h[0], h[1]], [0.06, h[0], h[1] * 0.45], [0.55, h[0], 0]], { t: t, pan: p, rev: 0.4 }));
          noise({ t: t, d: 0.014, g: 0.05, type: 'highpass', f: 5200 });   /* the striker */
        });
      } else if (kind === 'rover') {
        voice(bus, 'square', [[0, 880, 0], [0.01, 880, 0.045], [0.09, 1320, 0.04], [0.12, 1320, 0]], { bp: 2600, ft: 'lowpass', pan: p, rev: 0.5 });
        voice(bus, 'square', [[0, 1320, 0], [0.01, 1320, 0.045], [0.1, 990, 0.04], [0.14, 990, 0]], { t: 0.19, bp: 2600, ft: 'lowpass', pan: p, rev: 0.5 });
      } else {
        const cab = kind === 'cab', notes = cab ? [392, 494] : [440, 554], g = cab ? 0.05 : 0.055;
        (cab ? [[0, 0.1], [0.2, 0.34]] : [[0, 0.13], [0.23, 0.16]]).forEach(b => {
          notes.forEach(f => {
            voice(bus, 'sawtooth', [[0, f, 0], [0.012, f, g], [b[1], f, g * 0.92], [b[1] + 0.035, f, 0]], { t: b[0], bp: cab ? 1700 : 2100, ft: 'lowpass', q: 0.9, pan: p, rev: 0.2 });
            voice(bus, 'square', [[0, f, 0], [0.012, f, g * 0.5], [b[1], f, g * 0.45], [b[1] + 0.035, f, 0]], { t: b[0], bp: 1200, ft: 'lowpass', q: 0.7, pan: p });
          });
        });
      }
    },
    whistle() { voice(bus, 'sine', [[0, 2300, 0], [0.03, 2500, 0.16], [0.34, 2450, 0.15], [0.42, 2300, 0]], { vib: [38, 90], rev: 0.25 }); },
    buzzer(len) {   /* the arena horn: a fat, raspy held note */
      if (!live() || !laneOn()) return;
      const t = ctx.currentTime, dur = len || 0.9;
      const g = ctx.createGain(), lp = ctx.createBiquadFilter(), vca = ctx.createGain();
      lp.type = 'lowpass'; lp.frequency.value = 2400; lp.Q.value = 0.8;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.27, t + 0.014);
      g.gain.setValueAtTime(0.27, t + dur - 0.07);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      [[233.1, 'sawtooth', 0.4], [236.6, 'square', 0.26], [466.9, 'sawtooth', 0.14], [116.4, 'square', 0.2]].forEach(v => {
        const o = ctx.createOscillator(), og = ctx.createGain();
        o.type = v[1]; o.frequency.value = v[0]; og.gain.value = v[2];
        o.connect(og); og.connect(lp); o.start(t); o.stop(t + dur + 0.05);
      });
      const am = ctx.createOscillator(), amg = ctx.createGain();
      am.type = 'square'; am.frequency.value = 58; amg.gain.value = 0.22; vca.gain.value = 0.78;
      am.connect(amg); amg.connect(vca.gain); am.start(t); am.stop(t + dur + 0.05);
      lp.connect(vca); vca.connect(g); g.connect(bus);
      const sd = ctx.createGain(); sd.gain.value = 0.2; g.connect(sd); sd.connect(revSend);
    },
    bounce(v) {   /* a ball on the boards */
      const n = performance.now();
      if (n - lastTick < 60) return; lastTick = n;
      const g = clamp(v, 0.15, 1);
      tone({ f: 210, f2: 82, d: 0.12, g: 0.5 * g });
      noise({ d: 0.03, g: 0.14 * g, type: 'bandpass', f: 1500, q: 0.8 });
    },
    /* arena stings for a three: our own short organ riffs, an air horn and a drum roll, each with the crowd behind it */
    three(i, at) {
      if (!live() || !laneOn()) return;
      const T = at || 0;
      const organ = (f, t, d, g) => {
        tone({ t: T + t, f: f, d: d, g: g, type: 'square', a: 0.012, rev: 0.25 });
        tone({ t: T + t, f: f * 2, d: d, g: g * 0.45, type: 'sine', a: 0.012 });
        tone({ t: T + t, f: f / 2, d: d, g: g * 0.5, type: 'triangle', a: 0.012 });
      };
      const clap = t => { noise({ t: T + t, d: 0.09, g: 0.32, type: 'bandpass', f: 1500, q: 0.9, rev: 0.25 }); noise({ t: T + t + 0.012, d: 0.07, g: 0.14, type: 'bandpass', f: 2300, q: 1.2 }); };
      const crowd = (t, g) => {
        noise({ t: T + t, a: 0.3, d: 1.9, g: 0.22 * (g || 1), type: 'bandpass', f: 900, f2: 1500, q: 0.45, rev: 0.4 });
        noise({ t: T + t + 0.05, a: 0.35, d: 1.5, g: 0.09 * (g || 1), type: 'highpass', f: 3200, rev: 0.3 });
        for (let k = 0; k < 5; k++) tone({ t: T + t + 0.15 + k * 0.13, f: rnd(700, 1300), f2: rnd(900, 1700), d: 0.28, g: 0.012, type: 'sawtooth', rev: 0.5 });   /* whistles and whoops */
      };
      const C = 261.63, n = st => C * Math.pow(2, st / 12);
      i = ((i | 0) % 4 + 4) % 4;
      if (i === 0) {          /* the run up the keys */
        [0, 4, 7, 12, 16].forEach((st, k) => organ(n(st), k * 0.1, 0.1, 0.12));
        [12, 16, 19].forEach(st => organ(n(st), 0.52, 0.62, 0.1));
        crowd(0.5);
      } else if (i === 1) {   /* three blasts on the air horn */
        [0, 0.2, 0.4].forEach((t, k) => [440, 554.4, 659.3].forEach(f => tone({ t: T + t, f: f * 1.03, f2: f * 0.97, d: k === 2 ? 0.62 : 0.13, g: 0.1, type: 'sawtooth', a: 0.008, rev: 0.3 })));
        crowd(0.45, 1.1);
      } else if (i === 2) {   /* organ and handclaps */
        [[7, 0], [7, 0.2], [9, 0.4], [11, 0.6]].forEach(v => organ(n(v[0]), v[1], 0.15, 0.12));
        [12, 16, 19].forEach(st => organ(n(st), 0.8, 0.6, 0.095));
        [0.1, 0.3, 0.5, 0.6, 0.7].forEach(clap);
        crowd(0.8);
      } else {                /* drum roll and a crash */
        for (let k = 0; k < 14; k++) noise({ t: T + k * 0.045, d: 0.04, g: 0.07 + k * 0.012, type: 'bandpass', f: 1900, q: 0.8 });
        tone({ t: T + 0.66, f: 120, f2: 48, d: 0.3, g: 0.45 });
        noise({ t: T + 0.66, d: 1.3, a: 0.004, g: 0.16, type: 'highpass', f: 5200, rev: 0.4 });
        [12, 16, 19, 24].forEach(st => organ(n(st), 0.68, 0.7, 0.08));
        crowd(0.7, 1.15);
      }
    },
    /* a room on its feet. A recording, because a synth crowd never sounds like people. If the file hasn't landed yet it
       plays the moment it does, and either way the caller hears how long to hold the song back. */
    applause() {
      if (!live() || !laneOn()) return 0;
      const secs = sample('applause', { g: 0.4, rev: 0.1 });
      if (secs) return secs;
      let n = 0;
      const wait = setInterval(() => { if (sample('applause', { g: 0.4, rev: 0.1 }) || ++n > 40) clearInterval(wait); }, 120);
      return 5.5;
    },
    /* Betty's song: a short tune of her own for when her picture comes out. A clip, not one of the radio's songs.
       Says how long it runs so the radio can step right back, and stops when her picture is put away */
    betty() {
      if (!live() || !laneOn()) return 0;
      clearInterval(bettyWait);
      if (going.betty) return 0;                       /* already playing: the second picture doesn't start it again */
      const secs = sample('betty', { g: 0.55 });
      if (secs) return secs;
      let n = 0;
      bettyWait = setInterval(() => { if (sample('betty', { g: 0.55 }) || ++n > 40) clearInterval(bettyWait); }, 120);
      return 15;
    },
    bettyStop() { clearInterval(bettyWait); stopTake('betty'); },
    swish() {
      noise({ d: 0.26, a: 0.012, g: 0.26, type: 'bandpass', f: 4200, f2: 1300, q: 0.9, rev: 0.18 });
    },
    rim() {
      tone({ f: 640, f2: 560, d: 0.2, g: 0.17, type: 'triangle', rev: 0.2 });
      noise({ d: 0.03, g: 0.13, type: 'highpass', f: 3200 });
    },
    stretch(v) {   /* rubber creak as the band tightens */
      const now = performance.now();
      if (now - lastSlide < 90) return;
      lastSlide = now;
      tone({ f: 150 + v * 260, f2: 170 + v * 300, d: 0.07, g: 0.07, type: 'sawtooth' });
    },
    twang() {
      tone({ f: 190, f2: 70, d: 0.3, g: 0.28, type: 'triangle' });
      noise({ d: 0.34, a: 0.04, g: 0.2, type: 'bandpass', f: 400, f2: 2400, q: 1 });
    },
    slap() {
      noise({ d: 0.05, g: 0.22, type: 'lowpass', f: 2200 });
      tone({ f: 150, f2: 62, d: 0.09, g: 0.3 });
    },
    pop() {
      tone({ f: 520, f2: 1250, d: 0.07, g: 0.09, type: 'triangle' });
      noise({ d: 0.03, g: 0.05, type: 'highpass', f: 5000 });
    },
    tick() {
      const n = performance.now();
      if (n - lastTick < 55) return; lastTick = n;
      tone({ f: 2100 + Math.random() * 500, f2: 1500, d: 0.03, g: 0.046 });
    },
    click() {
      tone({ f: 190, f2: 68, d: 0.09, g: 0.2 });
      noise({ d: 0.02, g: 0.07, type: 'bandpass', f: 3200, q: 1.2 });
    },
    toggle() {
      tone({ f: 660, d: 0.07, g: 0.07, type: 'triangle' });
      tone({ t: 0.06, f: 990, d: 0.1, g: 0.07, type: 'triangle', rev: 0.2 });
    },
    close() {
      tone({ f: 880, d: 0.07, g: 0.06, type: 'triangle' });
      tone({ t: 0.06, f: 587, d: 0.11, g: 0.06, type: 'triangle', rev: 0.2 });
    },
    detent() {
      noise({ d: 0.012, g: 0.13, type: 'highpass', f: 2600 });
      tone({ f: 1250, d: 0.02, g: 0.05, type: 'square' });
      tone({ f: 150, f2: 80, d: 0.05, g: 0.14 });
    },
    slide(v) {
      const n = performance.now();
      if (n - lastSlide < 45) return; lastSlide = n;
      tone({ f: 420 + v * 900, d: 0.03, g: 0.045, type: 'triangle' });
    },
    whoosh(up) {
      noise({ d: 0.5, a: 0.12, g: 0.11, type: 'bandpass', f: up === false ? 2400 : 320, f2: up === false ? 300 : 2600, q: 0.9, rev: 0.25 });
    },
    pass() {
      noise({ d: 0.36, a: 0.1, g: 0.035, type: 'bandpass', f: 700, f2: 1500, q: 0.8, rev: 0.3 });
      tone({ f: 330, d: 0.3, g: 0.018, a: 0.04, rev: 0.6 });
    },
    air(v) {
      if (!live()) return;
      if (!laneOn()) { if (air) air.g.gain.setTargetAtTime(0, ctx.currentTime, 0.1); return; }
      if (!air) {
        const n = ctx.createBufferSource(); n.buffer = noiseBuf; n.loop = true;
        const f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 220; f.Q.value = 0.3;   /* 9 Oct (Jos): a soft low air, not a hiss */
        const g = ctx.createGain(); g.gain.value = 0;
        n.connect(f); f.connect(g); g.connect(bus); n.start();
        air = { f: f, g: g };
      }
      const t = ctx.currentTime, k = clamp((v - 0.25) / 0.75, 0, 1);   /* quiet until the page really moves */
      air.g.gain.setTargetAtTime(k * k * 0.02, t, 0.2);
      air.f.frequency.setTargetAtTime(180 + k * 340, t, 0.25);
    },
    spin(v) {
      const g = clamp(Math.abs(v) * 0.5, 0.02, 0.1);
      noise({ d: 0.32, a: 0.05, g: g, type: 'bandpass', f: 500, f2: 1900, q: 1.4 });
    },
    paper() {
      noise({ d: 0.05, g: 0.1, type: 'highpass', f: 3000 });
      noise({ t: 0.03, d: 0.14, g: 0.06, type: 'bandpass', f: 900, q: 0.6, rev: 0.2 });
    },
    boom() {
      tone({ f: 92, f2: 34, d: 1.5, g: 0.5, a: 0.006 });
      noise({ d: 1.3, a: 0.02, g: 0.16, type: 'lowpass', f: 2600, f2: 120, rev: 0.5 });
      [220, 329.63, 440, 554.37].forEach((f, k) => tone({ t: 0.12 + k * 0.07, f: f, d: 2.2, g: 0.04, type: 'triangle', a: 0.03, rev: 0.7 }));
    },
    add() {
      [523.25, 659.25, 783.99, 1046.5].forEach((f, k) => tone({ t: k * 0.07, f: f, d: 0.32, g: 0.085, type: 'triangle', rev: 0.35 }));
      tone({ f: 130.8, f2: 98, d: 0.2, g: 0.16 });
    },
    success() {
      [392, 493.88, 587.33, 783.99].forEach((f, k) => tone({ t: k * 0.09, f: f, d: 1.1, g: 0.07, type: 'triangle', a: 0.01, rev: 0.6 }));
    },
    error() {
      tone({ f: 160, d: 0.12, g: 0.12, type: 'square' });
      tone({ t: 0.13, f: 120, d: 0.16, g: 0.12, type: 'square' });
    },
    sting(i) {
      if (i === 0) {
        [440, 554.37, 659.25, 830.61].forEach((f, k) => tone({ t: k * 0.06, f: f, d: 0.5, g: 0.06, type: 'triangle', rev: 0.5 }));
      } else if (i === 1) {
        tone({ f: 150, f2: 44, d: 0.24, g: 0.42 });
        noise({ t: 0.17, d: 0.15, g: 0.16, type: 'bandpass', f: 1900, q: 0.7, rev: 0.25 });
        tone({ t: 0.17, f: 73.4, d: 0.4, g: 0.2, type: 'triangle' });
      } else {
        noise({ d: 0.42, a: 0.36, g: 0.12, type: 'bandpass', f: 300, f2: 4200, q: 2.2, rev: 0.3 });
        tone({ t: 0.42, f: 110, f2: 30, d: 0.7, g: 0.45 });
        tone({ t: 0.42, f: 1320, f2: 220, d: 0.3, g: 0.04, type: 'sawtooth', rev: 0.4 });
      }
    },
    _peak() {
      if (!analyser) return 0;
      const b = new Float32Array(analyser.fftSize);
      analyser.getFloatTimeDomainData(b);
      let m = 0; for (let i = 0; i < b.length; i++) { const a = Math.abs(b[i]); if (a > m) m = a; }
      return m;
    },
    _state: () => (ctx ? ctx.state : 'none')
  };
  /* the scene's own sounds answer to the Sound switch, unless something (the shot clock) has claimed them first */
  ['critter', 'honk', 'three', 'buzzer', 'whistle', 'bounce', 'rim', 'swish', 'stretch', 'twang', 'sting', 'air', 'applause', 'betty', 'beep'].forEach(k => {
    const f = api[k];
    if (f) api[k] = function () { return inLane(lane === 'fx' ? 'amb' : lane, f, arguments); };
  });
  /* 8 Oct (Jos): while our music plays, the scene's automatic sounds rest too (horns as vehicles pass, the scroll wind).
     Taps, stings and clicks still sound */
  ['honk', 'air'].forEach(k => { const f = api[k]; if (f) api[k] = function () { return musicOn ? 0 : f.apply(this, arguments); }; });
  api.world = f => inLane('amb', f);
  api.clock = f => inLane('clock', f);
  api.setClock = v => { clockOn = !!v; return clockOn; };
  api.clockOn = () => clockOn;
  return api;
})();

/* ---------- the music player: our own songs ---------- */
/* on the store, a chat bubble from another app sits bottom right. Measure it so the radio can step clear of it (see .live .player) */
if (typeof CFG.shop === 'string') {
  const clearChat = () => {
    const c = document.getElementById('chat-button'), r = c && c.getBoundingClientRect();
    root.style.setProperty('--chat', r && r.width && r.bottom > innerHeight - 160 && r.right > innerWidth - 200 ? Math.min(108, Math.round(innerWidth - r.left + 8)) + 'px' : '0px');   /* its frame can be wider than the bubble, so never step further than the bubble itself */
  };
  setInterval(clearChat, 1200); addEventListener('resize', clearChat);
}
const TRACKS = [
  ['Brother of Mine', 'brother-of-mine', 252],
  ['I Got You', 'i-got-you', 246],
  ['Windows Down', 'windows-down', 238],
  ['Little Wins', 'little-wins', 234],
  ['Good Morning', 'good-morning', 240],
  ['Morning People', 'morning-people', 164],
  ['First Sip', 'first-sip', 191],
  ['The Hustle', 'the-hustle', 160],
  ['Long Way Round', 'long-way-round', 250],
  ['Kitchen Table', 'kitchen-table', 242],
  ['Let It Go Cold', 'let-it-go-cold', 262],
  ['Funk in the Cup', 'funk-in-the-cup', 239]
];
const Music = (() => {
  const player = $('#player'), mini = $('#plMini'), card = $('#plCard'), list = $('#plList');
  const miniT = $('#plMiniT'), miniS = $('#plMiniS'), miniP = $('#plMiniP'), title = $('#plTitle'), state = $('#plState');
  const bar = $('#plBar'), fill = $('#plFill'), now = $('#plNow'), dur = $('#plDur'), playBtn = $('#plPlay'), quick = $('#plQuick'), vol = $('#plVol');
  const el = new Audio();
  el.preload = 'none'; el.volume = 0.8;   /* the songs are mastered 3 dB down as well, so the scene and the buttons still read over them */
  let at = 0, loaded = -1, playing = false, failed = false;
  /* the radio carries on from page to page: which song, how far in, how loud, and whether it was playing */
  const KEY = 'cflRadio', DAYKEY = 'cflRadioLast', TODAY = new Date().toDateString();
  let was = null, parkT = 0, wantT = 0, leaving = false, shownAt = -1, keptAt = 0;
  try { was = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (err) {}
  if (!was || typeof was.i !== 'number' || !TRACKS[was.i]) was = null;
  function keep(force) {
    if (leaving && !force) return;
    try { sessionStorage.setItem(KEY, JSON.stringify({ i: at, t: Math.floor(loaded === at ? Math.max(el.currentTime || 0, wantT) : parkT), on: playing, v: +vol.value, got: loaded > -1 || parkT > 0 || !!(was && was.got) })); } catch (err) {}
  }
  const mmss = s => { s = Math.max(0, Math.round(s || 0)); return ((s / 60) | 0) + ':' + String(s % 60).padStart(2, '0'); };
  const rows = TRACKS.map((t, i) => {
    const li = document.createElement('li'), b = document.createElement('button');
    b.type = 'button';
    [String(i + 1), t[0], mmss(t[2])].forEach(x => { const s = document.createElement('span'); s.textContent = x; b.appendChild(s); });
    b.addEventListener('click', () => { pick(i); });
    li.appendChild(b); list.appendChild(li);
    return b;
  });
  function paint() {
    const t = TRACKS[at];
    title.textContent = t[0];
    dur.textContent = mmss(isFinite(el.duration) && loaded === at ? el.duration : t[2]);
    rows.forEach((b, i) => { if (i === at) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    if (shownAt !== at) { shownAt = at; follow(); }
    player.classList.toggle('playing', playing);
    playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    quick.setAttribute('aria-label', playing ? 'Pause our music' : 'Play our music');
    state.textContent = failed ? 'That song didn\'t load' : playing ? 'Now playing' : 'The soundtrack';
    miniT.textContent = 'BOM Radio';
    miniS.textContent = failed ? 'Didn\'t load. Try another' : playing ? t[0] : loaded > -1 || parkT ? 'Paused: ' + t[0] : 'Our music. Your morning.';
    if (miniP) miniP.textContent = failed ? 'Didn\'t load' : playing || loaded > -1 || parkT ? t[0] : 'Our music';   /* the phone's one line: the song (8 Oct, Jos) */
    mini.setAttribute('aria-label', 'BOM Radio' + (playing ? ', now playing ' + t[0] : '') + '. ' + (card.hidden ? 'Open the controls' : 'Close the controls'));
  }
  /* the list follows the song: skip to track five and it comes into view */
  function follow(centre) {
    if (card.hidden) return;
    const b = rows[at], lr = list.getBoundingClientRect(), br = b.getBoundingClientRect();
    if (centre || br.top < lr.top + 1 || br.bottom > lr.bottom - 1) list.scrollTop += (br.top - lr.top) - (lr.height - br.height) / 2;
  }
  /* A stream can drop part-way and make the browser start the file again. So each song is fetched whole into memory
     and played from there; the next one is fetched in the background while this one plays. */
  const held = {}, direct = i => AUD + TRACKS[i][1] + '.mp3';
  let swapping = false, wantPlay = false, noBlob = false, lastTime = 0;
  function fetchTrack(i) {
    i = (i + TRACKS.length) % TRACKS.length;
    if (noBlob || !window.fetch || !window.URL || !URL.createObjectURL) return Promise.resolve(null);
    if (held[i]) return held[i].p;
    const rec = held[i] = { url: null, p: null };
    rec.p = fetch(direct(i))
      .then(r => {
        if (!r.ok) throw new Error('song');
        const want = +r.headers.get('content-length') || 0;
        return r.blob().then(b => { if (want && b.size < want * 0.97) throw new Error('short'); return b; });   /* a cut-off download never gets played */
      })
      .then(b => { rec.url = URL.createObjectURL(b); return rec.url; })
      .catch(() => { delete held[i]; return null; });
    return rec.p;
  }
  function tidy() {   /* keep this song and the next in memory, let the rest go */
    const next = (at + 1) % TRACKS.length;
    Object.keys(held).forEach(k => {
      const i = +k;
      if (i !== at && i !== next && held[i].url) { try { URL.revokeObjectURL(held[i].url); } catch (err) {} delete held[i]; }
    });
  }
  function resumeAt(t) {   /* after changing where the song comes from: back to the same second, and keep playing if we were */
    const on = () => {
      el.removeEventListener('loadedmetadata', on);
      try { if (t > 0.3) el.currentTime = t; } catch (err) {}
      const done = () => { swapping = false; };
      if (wantPlay) { const p = el.play(); if (p && p.then) p.then(done, done); else done(); } else done();
    };
    el.addEventListener('loadedmetadata', on);
  }
  function swapIn(url, i) {   /* the whole song has arrived: carry on from memory */
    if (noBlob || loaded !== i || el.src === url) return;
    const t = Math.max(el.currentTime || 0, wantT);   /* if the stream couldn't jump to where the last page left off, the full copy can */
    swapping = true;
    el.src = url;
    resumeAt(t);
  }
  function load(i) {
    at = (i + TRACKS.length) % TRACKS.length;
    if (loaded !== at) {
      loaded = at; failed = false; lastTime = 0;
      const me = at, rec = held[me];
      if (rec && rec.url && !noBlob) el.src = rec.url;
      else { el.src = direct(me); fetchTrack(me).then(url => { if (url) swapIn(url, me); }); }   /* start straight away, switch to the full copy when it lands */
      fill.style.width = '0%'; now.textContent = '0:00';
      wantT = 0;
      if (parkT > 0) { const t = parkT; parkT = 0; wantT = t; resumeAt(t); }   /* this is the song from the last page: back to where it was */
      tidy();
      if (!matchMedia('(pointer: coarse)').matches) setTimeout(() => { if (loaded === me) fetchTrack(me + 1); }, 4000);   /* phones keep just the one song in memory (13 Oct) */
    }
  }
  function play() {
    load(at);
    wantPlay = true;
    const p = el.play();
    if (p && p.catch) p.catch(() => { if (!el.error && !swapping) { playing = false; SFX.musicState(false); paint(); } });
  }
  function pause() { wantPlay = false; el.pause(); }
  function toggle() { if (playing) pause(); else play(); }
  function pick(i) { if ((i + TRACKS.length) % TRACKS.length !== at) parkT = 0; load(i); play(); paint(); }
  function open(v) {
    card.hidden = !v;
    mini.setAttribute('aria-expanded', String(v));
    paint();
    if (v) requestAnimationFrame(() => follow(true));
  }
  /* a song was playing on the last page: pick it up as soon as the browser lets us (straight away, or on the first tap) */
  function resume() {
    if (!was || !was.on || playing) return false;
    const go = () => { document.removeEventListener('pointerdown', go, true); document.removeEventListener('keydown', go, true); if (!playing) play(); };
    load(at); wantPlay = true;
    const p = el.play();
    if (p && p.catch) p.catch(() => { if (playing) return; wantPlay = false; document.addEventListener('pointerdown', go, true); document.addEventListener('keydown', go, true); });
    return true;
  }
  el.addEventListener('play', () => { playing = true; failed = false; if (el.muted) { el.muted = false; mutedAll = false; } SFX.musicState(true); paint(); soundUI(); keep(); try { localStorage.setItem(DAYKEY, JSON.stringify({ d: TODAY, i: at })); } catch (err) {} });
  el.addEventListener('pause', () => { if (swapping) return; playing = false; SFX.musicState(false); paint(); soundUI(); keep(); });
  window.addEventListener('pagehide', () => { keep(true); leaving = true; });
  window.addEventListener('pageshow', () => { leaving = false; });
  el.addEventListener('ended', () => { if (swapping) return; pick(at + 1); });
  function fail() { playing = false; wantPlay = false; failed = true; SFX.musicState(false); paint(); toast('That song didn\'t load. Try another one.'); }
  el.addEventListener('error', () => {
    if (loaded < 0) return;
    const me = loaded, t = lastTime;
    if (/^blob:/.test(el.src)) {
      if (noBlob) { swapping = false; fail(); return; }
      noBlob = true;   /* this browser won't play from memory: go back to streaming and stay there */
      swapping = true; el.src = direct(me); resumeAt(t);
      return;
    }
    swapping = false;
    if (noBlob) { fail(); return; }
    /* the stream fell over: wait for the full copy and carry on from there */
    fetchTrack(me).then(url => {
      if (loaded !== me) return;
      if (!url) { fail(); return; }
      swapping = true; el.src = url; resumeAt(t);
    });
  });
  el.addEventListener('loadedmetadata', paint);
  el.addEventListener('timeupdate', () => {
    const d = isFinite(el.duration) && el.duration ? el.duration : TRACKS[at][2];
    const p = clamp(el.currentTime / d, 0, 1);
    fill.style.width = (p * 100).toFixed(2) + '%';
    now.textContent = mmss(el.currentTime);
    if (!swapping && el.currentTime > 0) lastTime = el.currentTime;
    if (wantT && el.currentTime >= wantT - 1) wantT = 0;
    if (Math.abs(el.currentTime - keptAt) > 2) { keptAt = el.currentTime; keep(); }
    bar.setAttribute('aria-valuenow', Math.round(p * 100));
  });
  function seek(e) {
    const r = bar.getBoundingClientRect(), p = clamp((e.clientX - r.left) / r.width, 0, 1);
    if (loaded !== at) load(at);
    const d = isFinite(el.duration) && el.duration ? el.duration : 0;
    if (d) { wantT = 0; el.currentTime = p * d; }
  }
  let seeking = false;
  bar.addEventListener('pointerdown', e => { seeking = true; try { bar.setPointerCapture(e.pointerId); } catch (err) {} seek(e); });
  bar.addEventListener('pointermove', e => { if (seeking) seek(e); });
  bar.addEventListener('pointerup', () => { seeking = false; });
  bar.addEventListener('pointercancel', () => { seeking = false; });
  bar.addEventListener('keydown', e => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    if (isFinite(el.duration)) el.currentTime = clamp(el.currentTime + (e.key === 'ArrowRight' ? 10 : -10), 0, el.duration - 0.2);
  });
  mini.addEventListener('click', () => { open(card.hidden); });
  /* tap the record and it scratches: the song really does drag back and catch up */
  const rec = $('#plRec');
  let scrT = [];
  try { el.preservesPitch = false; el.mozPreservesPitch = false; el.webkitPreservesPitch = false; } catch (err) {}
  function scratch() {
    rec.classList.remove('scr'); void rec.offsetWidth; rec.classList.add('scr');
    SFX.critter('scratch2');
    scrT.forEach(clearTimeout); scrT = [];
    if (!playing) return;
    try { el.currentTime = Math.max(0, el.currentTime - 0.4); } catch (err) {}
    [[0, 0.45], [110, 2.1], [220, 0.5], [330, 1.7], [440, 1]].forEach(v => scrT.push(setTimeout(() => { try { el.playbackRate = v[1]; } catch (err) {} }, v[0])));
  }
  rec.addEventListener('click', scratch);
  quick.addEventListener('click', toggle);
  $('#plSkip').addEventListener('click', () => pick(loaded < 0 ? 0 : at + 1));
  const volPaint = () => { vol.style.setProperty('--v', vol.value + '%'); };
  let duckT = 0;
  vol.addEventListener('input', () => { clearTimeout(duckT); el.volume = vol.value / 100; volPaint(); keep(); });
  /* step the song back for a moment so a horn or a crowd can be heard over it */
  function duck(ms, to) { clearTimeout(duckT); try { el.volume = (vol.value / 100) * (to == null ? 0.3 : to); } catch (err) {} duckT = setTimeout(() => { try { el.volume = vol.value / 100; } catch (err) {} }, ms || 1600); }
  if (was) {
    at = was.i; parkT = was.got ? Math.max(0, +was.t || 0) : 0;
    if (was.v >= 0 && was.v <= 100) { vol.value = was.v; el.volume = was.v / 100; }
  } else {
    /* a new visit (6 Oct, Jos): the very first one opens on Brother of Mine. Come back another day and the radio moves on
       to the song after the last one you played; later the same day, it picks up that song again */
    let last = null;
    try { last = JSON.parse(localStorage.getItem(DAYKEY) || 'null'); } catch (err) {}
    if (last && typeof last.i === 'number' && TRACKS[last.i]) at = last.d === TODAY ? last.i : (last.i + 1) % TRACKS.length;
  }
  volPaint();
  $('#plClose').addEventListener('click', () => { open(false); mini.focus({ preventScroll: true }); });
  playBtn.addEventListener('click', toggle);
  $('#plPrev').addEventListener('click', () => { if (el.currentTime > 4) { el.currentTime = 0; } else pick(at - 1); });
  $('#plNext').addEventListener('click', () => pick(at + 1));
  paint();
  return { play: play, pause: pause, toggle: toggle, open: open, scratch: scratch, duck: duck, warm: () => { fetchTrack(at); }, isPlaying: () => playing, resume: resume, wasPlaying: () => !!(was && was.on), el: el };
})();

/* ---------- smooth scrolling (wheel only; touch and keyboard stay native) ---------- */
const Scroll = (() => {
  const active = FINE && !RM;
  let target = window.scrollY, cur = target, lastSet = Math.round(target), moving = false, glide = null;
  const max = () => Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  if (active) {
    let pad = 0;   /* a trackpad glides by itself: leave it native. Only a mouse wheel's steps get smoothed (6 Oct) */
    window.addEventListener('wheel', e => {
      if (S.overlay || !S.entered || e.ctrlKey) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      const notch = e.deltaMode !== 0 || (Math.abs(e.wheelDeltaY || 0) >= 120 && (e.wheelDeltaY || 0) % 120 === 0);
      if (!notch || performance.now() - pad < 500) { if (!notch) pad = performance.now(); moving = false; return; }
      e.preventDefault();
      glide = null;
      let d = e.deltaY;
      if (e.deltaMode === 1) d *= 32; else if (e.deltaMode === 2) d *= S.vh;
      if (!moving) { cur = window.scrollY; target = cur; }
      target = clamp(target + d, 0, max());
      moving = true;
    }, { passive: false });
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (glide) return;
      if (Math.abs(y - lastSet) > 3) { target = cur = y; lastSet = Math.round(y); moving = false; }
    }, { passive: true });
  }
  return {
    active,
    update(dt) {
      if (glide) {   /* a timed, eased trip: slow away, slow in, the same on a mouse or a phone */
        const p = clamp((performance.now() - glide.t0) / glide.ms, 0, 1), e = glide.out ? 1 - Math.pow(1 - p, 3) : p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
        cur = target = glide.from + (glide.to - glide.from) * e;
        lastSet = Math.round(cur);
        window.scrollTo(0, lastSet);
        if (p >= 1) glide = null;
        moving = false;
        return;
      }
      if (!active || !moving) return;
      cur = damp(cur, target, 12, dt);
      if (Math.abs(target - cur) < 0.4) { cur = target; moving = false; }
      lastSet = Math.round(cur);
      window.scrollTo(0, lastSet);
    },
    to(y) {
      y = clamp(y, 0, max());
      if (active) { if (!moving) cur = window.scrollY; target = y; moving = true; }
      else window.scrollTo({ top: y, behavior: RM ? 'auto' : 'smooth' });
    },
    glide(y, ms, out) {   /* out: leave at once and ease in (the side arrows); otherwise slow away, slow in */
      y = clamp(y, 0, max());
      const from = window.scrollY;
      if (RM) { window.scrollTo(0, y); return; }
      if (Math.abs(y - from) < 2) return;
      glide = { from: from, to: y, t0: performance.now(), ms: ms || clamp(520 + Math.abs(y - from) * 0.5, 700, 1800), out: !!out };
      moving = false;
    },
    gliding: () => !!glide,
    stop() { glide = null; },
    max
  };
})();
['touchstart', 'keydown'].forEach(ev => window.addEventListener(ev, e => { if (ev !== 'keydown' || /^(ArrowUp|ArrowDown|Page|Home|End| )/.test(e.key)) Scroll.stop(); }, { passive: true }));

const stackEl = $('#blends'), panelEls = $$('.panel', stackEl);
/* the blend pages stack like cards at every size. Each one tells the styles how tall it is, so it can hold with its bottom edge
   on the bottom of the screen while the next page slides over it (.panel uses --ph for where it sticks) */
const setPh = el => el.style.setProperty('--ph', el.offsetHeight + 'px');
panelEls.forEach(setPh);
if (window.ResizeObserver) { const phRO = new ResizeObserver(es => es.forEach(en => setPh(en.target))); panelEls.forEach(el => phRO.observe(el)); }
else window.addEventListener('resize', () => panelEls.forEach(setPh));
/* where a blend page sits in the document. Asking the page itself is no good once it is stuck in place, so add up the ones before it */
/* where to stand to buy blend i (7 Oct, Jos: Shop goes "straight to the product that you can buy"): the blend page itself on
   wider screens; on phones, where the page stacks, its price and Add to cart at the top under the header and the blend tabs */
function buyY(i) {
  const el = panelEls[i], top = panelTop(i);
  if (!S.stacked) return top + 2;
  const bx = el.querySelector('.p-buy .buy');
  return bx ? Math.round(top + bx.getBoundingClientRect().top - el.getBoundingClientRect().top - M.topH - 58) : top + 2;
}
function panelTop(i) {
  let y = stackEl.getBoundingClientRect().top + window.scrollY;
  /* 10 Oct: on wider screens the blend pages tuck a header's height up under the picker, and the first one holds still for
     that much longer before the next slides over, so its stop sits where the picker has gone and the next is still out of sight */
  for (let k = 0; k < i; k++) y += panelEls[k].offsetHeight + (parseFloat(getComputedStyle(panelEls[k]).marginBottom) || 0);
  if (!i) y -= parseFloat(getComputedStyle(stackEl).marginTop) || 0;
  if (!i && S.stacked) y -= 90;   /* 15 Oct: on phones People Everyday starts 90px higher (no gap under the picker), so land 90px higher on it */
  return Math.round(y);
}
function go(id, i) {
  if (id === 'home') { travel(0); return; }
  if (id === 'buy') { travel(buyY(0)); return; }
  const el = document.getElementById(id);
  if (!el) return;
  let y = el.getBoundingClientRect().top + window.scrollY;
  if (id === 'blends') {
    i = i || 0;
    y = panelTop(i) + 2;
    /* already on the blend pages: they sit side by side, so swapping coffee always glides, never warps (7 Oct, Jos) */
    const br = stackEl.getBoundingClientRect();
    if (br.top < S.vh * 0.5 && br.bottom > S.vh * 0.5) { Scroll.glide(clamp(y, 0, Scroll.max())); return; }
  }
  if (id === 'pick' && S.mobile) y -= M.topH - 12;   /* phones: the picker's heading sits close to its top edge, so land about a header higher (6 Oct) */
  travel(y);
}
/* hyperspace (6 Oct, Jos: racing the page past "is quite hard on the eyes"): a long jump warps, a short hop still glides */
function travel(y) {
  y = clamp(y, 0, Scroll.max());
  if (!RM && S.entered && Math.abs(y - window.scrollY) > S.vh * 1.5) Warp.to(y);
  else Scroll.glide(y);
}
const Warp = (() => {
  let el = null, cv = null, cx = null, stars = [], busy = false;
  const COLS = ['#F0F0EA', '#F0F0EA', '#F0F0EA', '#F0F0EA', '#D2F55C', '#FF69AE', '#8CCDE3', '#C888F8'];
  const IN = 360, JUMP = 240, OUT = 440, MIN = 380, MAX = 1900;   /* ms: speed-up, the jump (fully covered by then), out; the hold after the jump */
  const star = any => ({ a: Math.random() * Math.PI * 2, r: any ? Math.random() * 0.9 : 0.01 + Math.random() * 0.06, c: COLS[Math.random() * COLS.length | 0], w: Math.random() < 0.18 ? 2.4 : 1.3 });
  function build() {
    el = document.createElement('div'); el.className = 'warp'; el.setAttribute('aria-hidden', 'true');
    cv = document.createElement('canvas'); el.appendChild(cv); document.body.appendChild(el);
    cx = cv.getContext('2d');
  }
  function to(y) {
    if (busy) return;
    if (!el) build();
    if (!cx) { Scroll.glide(y); return; }
    busy = true;
    const W = window.innerWidth, H = window.innerHeight, d = Math.min(window.devicePixelRatio || 1, 1.5);
    cv.width = Math.round(W * d); cv.height = Math.round(H * d); cx.setTransform(d, 0, 0, d, 0, 0);
    cx.fillStyle = '#0B1026'; cx.fillRect(0, 0, W, H);
    stars = []; for (let k = 0, n = W < 700 ? 170 : 280; k < n; k++) stars.push(star(true));
    const ox = W / 2, oy = H / 2, R = Math.hypot(W, H) / 2 * 1.05;
    Scroll.stop(); SFX.whoosh(true);
    el.classList.add('on'); el.style.opacity = '0';
    const t0 = performance.now();
    let last = t0, jumped = false, jumpAt = 0, outAt = -1, checkAt = 0, outSaid = false, raf = 0;
    const jump = () => {
      if (jumped) return; jumped = true; jumpAt = performance.now();
      window.scrollTo(0, y); S.y = window.scrollY; S.vel = 0;
      /* the pictures where we are landing: fetch them now, not when the browser gets round to it */
      const vh = window.innerHeight;
      document.querySelectorAll('img[loading="lazy"]').forEach(im => { const r = im.getBoundingClientRect(); if (r.bottom > -vh * 0.5 && r.top < vh * 1.5) im.loading = 'eager'; });
    };
    /* still building in? a picture on screen not there yet, or an entrance animation on screen with more than a moment to run */
    const building = () => {
      const vh = window.innerHeight, on = r => r.width && r.bottom > 0 && r.top < vh;
      for (const im of document.images) if (im.src && !im.complete && on(im.getBoundingClientRect())) return true;
      if (!document.getAnimations) return performance.now() - jumpAt < 900;
      for (const a of document.getAnimations()) {
        if (a.playState !== 'running' || !a.effect || !a.effect.getComputedTiming) continue;
        const tg = a.effect.target, ti = a.effect.getComputedTiming();
        if (!tg || !tg.getBoundingClientRect || el.contains(tg) || ti.iterations === Infinity || ti.endTime === Infinity) continue;
        if (ti.endTime - (ti.localTime || 0) > 140 && on(tg.getBoundingClientRect())) return true;
      }
      return false;
    };
    const end = () => { cancelAnimationFrame(raf); clearTimeout(safe); jump(); el.classList.remove('on'); el.style.opacity = '0'; busy = false; };
    const safe = setTimeout(end, JUMP + MAX + OUT + 700);   /* a background tab stops the frames: never leave it covered */
    const frame = now => {
      const t = now - t0, dt = Math.min(0.05, (now - last) / 1000); last = now;
      let sp, op;
      if (t >= JUMP) jump();
      if (outAt < 0 && jumped && t >= IN) {   /* hold at full speed until the section has settled */
        const h = now - jumpAt;
        if (h >= MAX) outAt = now;
        else if (h >= MIN && now >= checkAt) { checkAt = now + 90; if (!building()) outAt = now; }
      }
      if (t < IN) { const p = t / IN; sp = 0.25 + p * p * 5.2; op = Math.min(1, p * 1.7); }
      else if (outAt < 0) { sp = 5.45; op = 1; }
      else { const p = Math.min(1, (now - outAt) / OUT); sp = 0.2 + 5.25 * (1 - p) * (1 - p); op = 1 - p * p; }
      if (outAt >= 0 && !jumped) jump();
      if (outAt >= 0 && !outSaid) { outSaid = true; SFX.whoosh(false); }   /* the whoosh out as the stars slow down */
      el.style.opacity = op.toFixed(3);
      cx.globalCompositeOperation = 'source-over';
      cx.fillStyle = 'rgba(11,16,38,0.42)'; cx.fillRect(0, 0, W, H);
      const glow = cx.createRadialGradient(ox, oy, 0, ox, oy, R * 0.45);
      glow.addColorStop(0, 'rgba(200,136,248,' + (0.28 * Math.min(1, sp / 5.45)).toFixed(3) + ')');
      glow.addColorStop(1, 'rgba(200,136,248,0)');
      cx.fillStyle = glow; cx.fillRect(0, 0, W, H);
      cx.globalCompositeOperation = 'lighter'; cx.lineCap = 'round';
      for (let k = 0; k < stars.length; k++) {
        const s = stars[k];
        s.r += (0.015 + s.r) * sp * dt * 0.9;
        if (s.r > 1.08) { stars[k] = star(false); continue; }
        const len = Math.min(s.r, (0.015 + s.r) * sp * 0.075), r1 = s.r * R, r0 = Math.max(0, s.r - len) * R;
        const ca = Math.cos(s.a), sa = Math.sin(s.a);
        cx.strokeStyle = s.c; cx.globalAlpha = Math.min(1, s.r * 3.2);
        cx.lineWidth = s.w * (0.5 + s.r * 1.6);
        cx.beginPath(); cx.moveTo(ox + ca * r0, oy + sa * r0); cx.lineTo(ox + ca * r1, oy + sa * r1); cx.stroke();
      }
      cx.globalAlpha = 1;
      if (outAt >= 0 && now - outAt >= OUT) { end(); return; }
      raf = requestAnimationFrame(frame);
    };
    raf = requestAnimationFrame(frame);
  }
  return { to: to, busy: () => busy };
})();

/* ---------- overlays: wholesale room, cart, poster lightbox ---------- */
const OV = { room: $('#room'), cart: $('#cart'), box: $('#box'), quiz: $('#quiz'), game: $('#game') };
const scrim = $('#scrim');
const BG = [$('#main'), $('#top')];
let opener = null;
function setInert(v) { BG.forEach(el => { if (el) el.inert = v; }); }
function openOv(name) {
  if (S.overlay === name) return;
  if (S.overlay) closeOv(true);
  opener = document.activeElement;
  S.overlay = name;
  const el = OV[name];
  el.classList.add('open'); el.setAttribute('aria-hidden', 'false');
  document.body.dataset.ov = name;                        /* the radio stays in reach on every page: it moves out of the way by this */
  if (name === 'cart') scrim.classList.add('open');
  if (name === 'room') { el.scrollTop = 0; SFX.whoosh(true); startSignal(); requestAnimationFrame(() => segReply.place()); }
  else if (name === 'box') SFX.paper();
  else SFX.whoosh(true);
  if (name === 'quiz') quizStart();
  document.body.classList.add('lock');
  setInert(true);
  const c = $('[data-close]', el);
  if (c) setTimeout(() => c.focus({ preventScroll: true }), 60);
}
/* the bag up close: the label is too small to read on a phone, so a tap on the bag opens it full screen */
function zoomBag(i) {
  const b = BLENDS[i], big = $('#boxImg');
  big.classList.remove('turn');
  big.dataset.front = pic('bag-' + b.id + '-front'); big.dataset.back = pic('bag-' + b.id + '-back'); big.dataset.side = 'front';
  big.src = big.dataset.front; big.alt = b.name + ' 250g bag, front';
  $('#boxCap').textContent = b.name;
  $('#boxNote').textContent = '';
  OV.box.classList.remove('polaroid'); OV.box.classList.add('bagzoom');
  $('#boxFlip').textContent = 'Flip it over';
  openOv('box'); SFX.spin(0.5);
}
function flipZoom() {
  const big = $('#boxImg'), back = big.dataset.side !== 'back';
  big.classList.add('turn'); SFX.spin(0.7);
  setTimeout(() => {
    big.dataset.side = back ? 'back' : 'front'; big.src = back ? big.dataset.back : big.dataset.front;
    big.alt = $('#boxCap').textContent + ' 250g bag, ' + (back ? 'back' : 'front');
    $('#boxFlip').textContent = back ? 'Flip it back' : 'Flip it over';
    big.classList.remove('turn');
  }, RM ? 0 : 300);
}
function closeOv(silent) {
  const name = S.overlay;
  if (!name) return;
  if (ROOMPAGE && name === 'room' && !silent) { location.assign(LIVE ? STORE : location.pathname); return; }
  const el = OV[name];
  el.classList.remove('open'); el.setAttribute('aria-hidden', 'true');
  scrim.classList.remove('open');
  delete document.body.dataset.ov;
  S.overlay = null;
  document.body.classList.remove('lock');
  setInert(false);
  if (name === 'room') stopSignal();
  if (name === 'box') OV.box.classList.remove('bagzoom');
  if (name === 'box' && SFX.bettyStop) { SFX.bettyStop(); Music.duck(350, 0.04); }   /* her song stops with her picture, and the radio comes back up */
  if (!silent) { SFX.close(); if (opener && opener.focus) opener.focus({ preventScroll: true }); }
  if (ROOMPAGE && name !== 'room') setTimeout(() => { if (!S.overlay) openOv('room'); }, 0);   /* the room is the page: anything opened over it closes back to it */
}

/* ---------- segmented controls with a sliding thumb ---------- */
function makeSeg(el, onChange) {
  const btns = $$('button', el), thumb = $('.thumb', el);
  const api = {
    value: (btns.find(b => b.getAttribute('aria-pressed') === 'true') || btns[0]).dataset.v,
    place() {
      const b = btns.find(x => x.dataset.v === api.value);
      if (!b || !b.offsetWidth) return;
      thumb.style.left = b.offsetLeft + 'px'; thumb.style.width = b.offsetWidth + 'px';
    },
    set(v, silent, quiet) {
      if (v === api.value) return;
      api.value = v;
      btns.forEach(x => x.setAttribute('aria-pressed', String(x.dataset.v === v)));
      api.place();
      if (!silent) SFX.toggle();
      if (onChange && !quiet) onChange(v);
    }
  };
  btns.forEach(b => b.addEventListener('click', () => api.set(b.dataset.v)));
  api.place();
  return api;
}

/* ---------- buy cards (one per blend, sharing size and plan) + cart ---------- */
const cartBtn = $('#cartBtn'), cartN = $('#cartN'), cartList = $('#cartList'), cartSum = $('#cartSum');
const buyState = { size: '250g', plan: FREQ.length ? 'sub' : 'one', grind: GRINDS[0], every: (FREQ.find(f => f.k === '2-week') || FREQ[0] || { k: '' }).k };
let quizBlend = 0, quizSingle = null;   /* 9 Oct: the quiz can land on a single origin too */
const unitPrice = (b, size, plan) => priceOf(b, size, buyState.grind, plan, buyState.every);
function showPrice(o) {
  const size = buyState.size, plan = buyState.plan;
  o.priceN.textContent = '';
  const s = document.createElement('span'); s.textContent = money(unitPrice(o.b, size, plan)); o.priceN.appendChild(s);
  o.flip = !o.flip;
  o.priceN.classList.toggle('fa', o.flip); o.priceN.classList.toggle('fb', !o.flip);
  o.was.hidden = plan !== 'sub';
  o.was.textContent = money(unitPrice(o.b, size, 'one'));
  o.per.textContent = 'per ' + size + ' bag' + (plan === 'sub' ? ', ' + everyText(buyState.every) : '');
  o.el.classList.toggle('once', plan !== 'sub');
  bndPaint(o);
}
function paintQuick() {   /* the coffee cards and the quiz follow the same size, grind and plan, and say exactly what their button adds (6 Oct) */
  const size = buyState.size, sub = buyState.plan === 'sub';
  const grind = buyState.grind === 'Wholebean' ? 'wholebean' : buyState.grind.replace(/^Ground for /, 'ground for ');
  $$('.pick-price').forEach(el => {
    const box = el.closest('.pick-buy, .quiz-price'), q = box && box.querySelector('[data-quick]'), b = q ? +q.dataset.quick : quizBlend;
    el.textContent = money(unitPrice(b, size, buyState.plan));
    const was = box && box.querySelector('.pick-was');
    if (was) { was.hidden = !sub; was.textContent = money(unitPrice(b, size, 'one')); }
  });
  $$('.pick-save').forEach(el => { el.hidden = !sub; el.textContent = 'Save ' + SUB_PCT + '%'; });
  $$('.pick-size').forEach(el => { el.textContent = size + ' ' + grind + (sub ? ', subscription ' + everyText(buyState.every) : ', one-off'); });
  $$('[data-quick], #quizAdd').forEach(btn => { if (btn.textContent !== 'Added') btn.textContent = sub ? 'Subscribe' : 'Add to cart'; });
  if (quizSingle) quizSinglePaint();
}
function syncBuy(key, v) {
  buyState[key] = v;
  buys.forEach(o => { o[key].set(v, true, true); showPrice(o); });
  paintQuick();
}
/* a plain select, kept in step across the three buy boxes the same way the sliding switches are */
function makeOpt(el, onChange) {
  el.addEventListener('change', () => { SFX.toggle(); onChange(el.value); });
  return { set(v) { el.value = v; }, place() {} };
}
const buys = $$('.buy').map(el => {
  const o = { el: el, b: +el.dataset.buy, priceN: $('.price-n', el), was: $('.price s', el), per: $('.price small', el), add: $('[data-add]', el), flip: false, t: 0 };
  /* the delivery choices are whatever plans the store has, and the saving is whatever those plans give */
  const every = $('[data-opt="every"]', el);
  every.textContent = '';
  FREQ.forEach(f => { const op = document.createElement('option'); op.value = f.k; op.textContent = freqLabel(f); every.appendChild(op); });
  every.value = buyState.every;
  const subBtn = $('[data-seg="plan"] [data-v="sub"]', el);
  subBtn.textContent = 'Subscribe, save ' + SUB_PCT + '%';
  if (!FREQ.length) { $('[data-seg="plan"]', el).hidden = true; subBtn.setAttribute('aria-pressed', 'false'); $('[data-seg="plan"] [data-v="one"]', el).setAttribute('aria-pressed', 'true'); }
  o.size = makeSeg($('[data-seg="size"]', el), v => syncBuy('size', v));
  o.plan = makeSeg($('[data-seg="plan"]', el), v => syncBuy('plan', v));
  o.grind = makeOpt($('[data-opt="grind"]', el), v => syncBuy('grind', v));
  o.every = makeOpt(every, v => syncBuy('every', v));
  o.bnd = bndStrip(o);
  showPrice(o);
  return o;
});
const quicks = $$('[data-quick]').map(btn => ({ b: +btn.dataset.quick, add: btn, from: btn.closest('.pick-card'), t: 0 }));
paintQuick();
const segReply = makeSeg($('#segReply'));
function placeSegs() { buys.forEach(o => { o.size.place(); o.plan.place(); }); segReply.place(); }

const cart = [];
/* on the store the drawer is the store's own cart (6 Oct): read when the page opens and whenever the drawer opens, and every
   add and every + or - goes straight to the store, one after another */
const OWN_BAGS = [['people everyday', 'bag-pe-front-s'], ['no sleep', 'bag-nsb-front-s'], ['hyperdrive', 'bag-hyd-front-s'], ['decaf', 'so-decaf-front-s'], ['colombia', 'so-colombia-front-s'], ['brazil', 'so-brazil-front-s'], ['peru', 'so-peru-front-s'], ['papua new guinea', 'so-png-front-s'], ['ethiopia', 'so-ethiopia-front-s'], ['mexico', 'so-mexico-front-s']];
let storeQ = Promise.resolve();
function storeLine(it) {
  const t = it.product_title || it.title || '', own = OWN_BAGS.find(o => t.toLowerCase().indexOf(o[0]) > -1);
  let img = it.image || '';
  if (img && !own) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  const sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
  const vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title.split(' / ').join(', ') : '';
  const off = (it.line_level_discount_allocations || []).map(a => a.discount_application && a.discount_application.title).filter(Boolean)[0] || '';
  const deal = /one for a mate|pick and mix/i.test(off), bi = own ? OWN_BAGS.indexOf(own) : -1;
  return { store: true, key: it.key, qty: it.quantity, name: t, thumb: own ? pic(own[1]) : img, line: [vt, sp ? sp.name : (vt ? 'one-off' : ''), off].filter(Boolean).join(', '), price: (+it.final_price || 0) / 100, plan: !!sp,
    deal: deal, save: deal ? ((+it.original_line_price || 0) - (+it.final_line_price || 0)) / 100 : 0, one250: !sp && !!own && !/1kg/i.test(vt),
    b: bi > -1 && bi < 3 ? bi : -1, grind: GRINDS.find(g => vt.toLowerCase().indexOf(g.toLowerCase()) > -1) || null };
}
function storeTake(c) { if (!c || !c.items) return; cart.length = 0; c.items.forEach(it => cart.push(storeLine(it))); renderCart(); }
function storeSync() {
  return fetch(STORE + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
    .then(r => { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }).then(storeTake);
}
function storeDo(job) {
  storeQ = storeQ.then(job).catch(() => { SFX.error(); toast('The cart didn\'t update. Give it another go.'); return storeSync().catch(() => {}); });
  return storeQ;
}
function storeAdd(lines) {
  return storeDo(() => fetch(STORE + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: lines }) })
    .then(r => { if (!r.ok) throw new Error('add ' + r.status); }).then(storeSync));
}
/* 9 Oct (Jos): clear the whole cart; on the store through cart/clear.js, then the drawer re-reads the store's cart */
function storeClear() {
  return storeDo(() => fetch(STORE + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
    .then(r => { if (!r.ok) throw new Error('clear ' + r.status); return r.json(); }).then(storeTake));
}
(function () {
  const btn = document.getElementById('cartClear'); if (!btn) return;
  let tm = 0;
  const reset = () => { clearTimeout(tm); btn.removeAttribute('data-sure'); btn.textContent = 'Clear cart'; };
  btn.addEventListener('click', () => {
    if (!btn.hasAttribute('data-sure')) { btn.setAttribute('data-sure', ''); btn.textContent = 'Clear everything?'; tm = setTimeout(reset, 4000); return; }
    reset();
    const live = cart.some(it => it.store);
    cart.length = 0; renderCart();
    if (live) storeClear(); else toast('Cart cleared');
  });
  document.addEventListener('click', e => { if (btn.hasAttribute('data-sure') && !btn.contains(e.target)) reset(); });
})();
function storeSet(key, qty) {
  return storeDo(() => fetch(STORE + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
    .then(r => { if (!r.ok) throw new Error('change ' + r.status); return r.json(); }).then(storeTake));
}
/* how far off free delivery ($90) the cart is (8 Oct) */
function freeLine(total) {
  const box = $('#cartFree'); if (!box) return;
  box.hidden = !(total > 0);
  if (!(total > 0)) return;
  const left = Math.max(0, 90 - total);
  $('#cartFreeBar').style.width = Math.min(100, total / 90 * 100).toFixed(1) + '%';
  $('#cartFreeL').textContent = left > 0.004 ? '$' + left.toFixed(2) + ' away from free delivery. Another bag?' : 'Free delivery. Sorted.';
}
function renderCart() {
  cartList.textContent = '';
  let qty = 0, sum = 0;
  if (!cart.length) {
    const p = document.createElement('p'); p.className = 'cart-empty'; p.textContent = 'Nothing in here yet. Grab a bag.'; cartList.appendChild(p);
  }
  cart.forEach(it => {
    const b = it.store ? null : BLENDS[it.b], line = it.store ? it.price * it.qty : priceOf(it.b, it.size, it.grind, it.plan, it.every) * it.qty;
    const name = it.store ? it.name : b.name;
    qty += it.qty; sum += line;
    const row = document.createElement('div'); row.className = 'ci';
    const img = document.createElement('img'); img.alt = ''; const src = it.store ? it.thumb : pic('bag-' + b.id + '-front'); if (src) img.src = src;
    const mid = document.createElement('div');
    const nm = document.createElement('b'); nm.textContent = name;
    const sm = document.createElement('small'); sm.textContent = it.store ? it.line : it.size + ', ' + it.grind + ', ' + (it.plan === 'sub' ? everyText(it.every) + ', ' + SUB_PCT + '% off' : 'one-off');
    const q = document.createElement('div'); q.className = 'qty';
    const minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'One less ' + name);
    const n = document.createElement('span'); n.textContent = it.qty;
    const plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'One more ' + name);
    minus.addEventListener('click', () => { it.qty--; if (it.qty < 1) cart.splice(cart.indexOf(it), 1); renderCart(); if (it.store) storeSet(it.key, it.qty); });
    plus.addEventListener('click', () => { it.qty++; renderCart(); if (it.store) storeSet(it.key, it.qty); });
    q.append(minus, n, plus); mid.append(nm, sm, q);
    const pr = document.createElement('span'); pr.className = 'ci-p'; pr.textContent = money(line);
    row.append(img, mid, pr); cartList.appendChild(row);
  });
  if (!cart.some(it => it.store)) sum -= bndBest(bndUnits()).amt;   /* the concept works the deal out; on the store the lines already carry it */
  cartNudge();
  const clr = $('#cartClear'); if (clr) { clr.hidden = !cart.length; if (!cart.length) { clr.removeAttribute('data-sure'); clr.textContent = 'Clear cart'; } }
  cartN.textContent = qty;
  cartSum.textContent = money(sum);
  freeLine(sum);
  const subsEl = $('#cartSubs'); if (subsEl) subsEl.hidden = !cart.some(it => it.plan === 'sub' || it.plan === true);
  cartBtn.setAttribute('aria-label', 'Open cart, ' + qty + (qty === 1 ? ' item' : ' items'));
}
/* the cart as the store wants it: a variant for the size and grind, and the selling plan when it's a subscription */
function shopLines() {
  return cart.map(it => {
    const line = { id: variantOf(it.b, it.size, it.grind), quantity: it.qty };
    if (it.plan === 'sub' && planOf(it.b, it.every)) line.selling_plan = planOf(it.b, it.every);
    return line;
  });
}
function bumpCart() { cartN.classList.remove('bump'); void cartN.offsetWidth; cartN.classList.add('bump'); }
function flyToCart(o) {
  const src = o.from || $('.bagflip', panelEls[o.b]) || o.add;
  const from = src.getBoundingClientRect(), to = cartBtn.getBoundingClientRect();
  const x0 = from.left + from.width / 2 - 42, y0 = from.top + from.height / 2 - 62;
  const x1 = to.left + to.width / 2 - 42, y1 = to.top + to.height / 2 - 62;
  if (RM || !document.body.animate) { bumpCart(); return; }
  const f = document.createElement('img'); f.className = 'flyer'; f.src = pic('bag-' + BLENDS[o.b].id + '-front'); f.alt = '';
  document.body.appendChild(f);
  const a = f.animate([
    { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(2.2) rotate(0deg)', opacity: 1 },
    { transform: 'translate(' + ((x0 + x1) / 2) + 'px,' + (Math.min(y0, y1) - 60) + 'px) scale(1.2) rotate(-18deg)', opacity: 1, offset: 0.55 },
    { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.2) rotate(30deg)', opacity: 0.6 }
  ], { duration: 780, easing: 'cubic-bezier(.5,0,.2,1)' });
  a.onfinish = () => { f.remove(); bumpCart(); };
}
/* ---------- bundle and save (8 Oct): One for a mate and Pick and mix ---------- */
const grindWord = g => g === 'Wholebean' ? 'wholebean' : String(g).replace(/^Ground for /, 'ground for ');
const all3Was = g => [0, 1, 2].reduce((t, b) => t + priceOf(b, '250g', g, 'one'), 0);
const all3Price = g => all3Was(g) - bndBest([0, 1, 2].map(b => priceOf(b, '250g', g, 'one'))).amt;
/* one: a one-off 250g bag (what the deals count); b: which blend (-1 for anything else); unit: one bag's price */
function bndOf(it) {
  /* 8 Oct, Jos: the deals are for the blends only, so single origins and decaf never count as bundle bags */
  if (it.store) return { one: !!it.one250 && it.b != null && it.b > -1, grind: it.grind || null, b: it.b == null ? -1 : it.b, unit: it.price };
  const k = it.key ? it.key.split('|') : null;
  if (k && k[0] === 'so') return { one: false, grind: null, b: -1, unit: it.price };
  if (k) { const kb = BLENDS.findIndex(x => x.id === k[0]); return { one: kb > -1 && kb < 3 && k[1] === '250g' && k[3] !== 'sub', grind: k[2] || null, b: kb, unit: it.price }; }
  return { one: it.size === '250g' && it.plan !== 'sub', grind: it.grind || null, b: it.b, unit: priceOf(it.b, '250g', it.grind, 'one') };
}
function bndUnits() { const u = []; cart.forEach(it => { const o = bndOf(it); if (o.one && !it.store) for (let i = 0; i < it.qty; i++) u.push(o.unit); }); return u; }
function bndFlash(from) { const b = from && from.querySelector && from.querySelector('b'); if (!b) return; const was = b.innerHTML; b.textContent = 'Added'; setTimeout(() => { b.innerHTML = was; }, 1500); }
function bndStrip(o, single, after) {
  const box = document.createElement('div'); box.className = 'bnd'; box.hidden = !single;
  box.innerHTML = '<p class="bnd-h">Bundle and save</p><div class="bnd-r">' +
    '<button type="button" class="bnd-b" data-bnd="mate"><b><i class="bl">Two bags, one for a mate</i><i class="bs">2 for a mate</i></b><span><em></em> <s></s></span></button>' +
    (single ? '' : '<button type="button" class="bnd-b" data-bnd="all3"><b><i class="bl">All three blends</i><i class="bs">All 3 blends</i></b><span><i class="bl">One of each </i><em></em> <s></s></span></button>') +
    '</div>' + (typeof CFG.shop === 'string' && CFG.pick === true ? '<a class="bnd-l" href="' + CFG.shop.replace(/\/*$/, '/') + PICK_PAGE + '">Or pick and mix any three blends. Third bag half price</a>' : '');   /* LIVE and STORE come later in the script */
  (after || o.add).insertAdjacentElement('afterend', box);
  box.addEventListener('click', e => {
    const btn = e.target.closest('[data-bnd]'); if (!btn) return;
    if (btn.dataset.bnd === 'mate') bndMate(o, btn); else addAll3(single ? GRINDS[0] : buyState.grind, btn);
  });
  return box;
}
function bndPrices(box, one, g) {
  const m = box.querySelector('[data-bnd="mate"]'), a = box.querySelector('[data-bnd="all3"]');
  if (m) { m.querySelector('em').textContent = money(2 * one * (1 - MATE)); m.querySelector('s').textContent = money(2 * one); m.setAttribute('aria-label', 'Add two bags, one for a mate, ' + money(2 * one * (1 - MATE)) + ' instead of ' + money(2 * one)); }
  if (a) { a.querySelector('em').textContent = money(all3Price(g)); a.querySelector('s').textContent = money(all3Was(g)); a.setAttribute('aria-label', 'Add all three blends, one of each, ' + money(all3Price(g)) + ' instead of ' + money(all3Was(g))); }
}
function bndPaint(o) {
  if (!o.bnd) return;
  const show = buyState.plan !== 'sub' && buyState.size === '250g';
  o.bnd.hidden = !show;
  if (show) bndPrices(o.bnd, priceOf(o.b, '250g', buyState.grind, 'one'), buyState.grind);
}
/* one nudge under the cart's lines */
function cartNudge() {
  if (!cart.length) return;
  const ls = cart.map(it => [it, bndOf(it)]), q = ls.reduce((n, x) => n + (x[1].one ? x[0].qty : 0), 0), store = cart.some(it => it.store);
  const gx = ls.find(x => x[1].grind), G = GRINDS.find(g => gx && g.toLowerCase() === String(gx[1].grind).toLowerCase()) || GRINDS[0];
  const box = document.createElement('div'); box.className = 'cart-nudge';
  const p = document.createElement('p'), btn = document.createElement('button'); btn.type = 'button'; btn.className = 'btn btn-sm';
  if (q === 1) {
    const L = ls.find(x => x[1].one)[0];
    p.innerHTML = '<b>One for a mate?</b> Add another bag and save 10% on both.'; btn.textContent = 'Add another';
    btn.addEventListener('click', () => { SFX.add(); L.qty++; renderCart(); if (L.store) storeSet(L.key, L.qty); toast('One for a mate: 10% off both bags'); });
    box.append(p, btn);
  } else if (q % 3 === 2) {
    const have = ls.filter(x => x[1].one).map(x => x[1].b), nb = [0, 1, 2].find(b => have.indexOf(b) < 0), b = nb == null ? 0 : nb;
    p.innerHTML = '<b>Make it three.</b> Add a bag of ' + BLENDS[b].name + ' and the third bag is half price.'; btn.textContent = 'Add it';
    btn.addEventListener('click', () => addOne(b, G, btn));
    box.append(p, btn);
  } else if (q >= 3) {
    const saved = store ? cart.reduce((t, it) => t + (it.store && it.deal ? it.save : 0), 0) : bndBest(bndUnits()).amt;
    if (!(saved > 0.004)) return;   /* on the store, only once the store has taken it off */
    p.innerHTML = '<b>Bundle and save.</b> You\'re saving ' + money(saved) + ' on your bags.'; box.classList.add('cn-ok');
    box.append(p);
  } else if (ls.some(x => x[1].b > -1)) {
    p.innerHTML = '<b>Try all three blends.</b> One of each, one-off, for ' + money(all3Price(G)) + '. The third bag is half price.'; btn.textContent = 'Add all three';
    btn.addEventListener('click', () => addAll3(G, btn));
    box.append(p, btn);
  } else return;
  cartList.appendChild(box);
}
function bndMate(o) { addToCart(o, 2); }
function addBag(b, g) {
  const hit = cart.find(it => !it.store && it.b === b && it.size === '250g' && it.plan !== 'sub' && it.grind === g);
  if (hit) hit.qty++; else cart.push({ b: b, size: '250g', plan: 'one', grind: g, every: '', qty: 1 });
}
function addOne(b, g, from) {
  addBag(b, g); renderCart();
  if (LIVE) storeAdd([{ id: variantOf(b, '250g', g), quantity: 1 }]);
  SFX.add(); bumpCart(); bndFlash(from);
  toast('Added ' + BLENDS[b].name + ', ' + grindWord(g) + '. Third bag half price');
}
function addAll3(g, from) {
  [0, 1, 2].forEach(b => addBag(b, g)); renderCart();
  if (LIVE) storeAdd([0, 1, 2].map(b => ({ id: variantOf(b, '250g', g), quantity: 1 })));
  SFX.add(); bumpCart(); bndFlash(from);
  toast('Added all three blends, ' + grindWord(g) + '. Third bag half price');
}
function addToCart(o, n) {
  n = n || 1;
  const b = BLENDS[o.b], size = buyState.size, plan = buyState.plan, grind = buyState.grind, every = plan === 'sub' ? buyState.every : '';
  if (shopOf(o.b).out[variantOf(o.b, size, grind)]) { SFX.error(); toast(b.name + ' ' + size + ' in that grind is sold out right now'); return; }
  const hit = cart.find(it => it.b === o.b && it.size === size && it.plan === plan && it.grind === grind && it.every === every);
  if (hit) hit.qty += n; else cart.push({ b: o.b, size: size, plan: plan, grind: grind, every: every, qty: n });
  renderCart();
  if (LIVE) { const l = { id: variantOf(o.b, size, grind), quantity: n }; if (plan === 'sub' && planOf(o.b, every)) l.selling_plan = planOf(o.b, every); storeAdd([l]); }
  SFX.add(); flyToCart(o);
  toast(n > 1 ? 'Added ' + n + ' bags of ' + b.name + '. One for a mate: 10% off both' : 'Added ' + b.name + ' ' + size + (plan === 'sub' ? ', subscription ' + everyText(every) : '') + ' to the cart');
  o.add.textContent = 'Added';
  clearTimeout(o.t); o.t = setTimeout(() => { o.add.textContent = 'Add to cart'; paintQuick(); }, 1500);
}

/* ---------- testimonials: one card everywhere (the same markup tools/reviews.py writes) ---------- */
const RV_COFFEE = { pe: ['People Everyday', 'bag-pe-front-s'], nsb: ['No Sleep Till Brooklyn', 'bag-nsb-front-s'], hyd: ['Hyperdrive', 'bag-hyd-front-s'], peru: ['Peru', 'so-peru-front-s'], decaf: ['Decaf', 'so-decaf-front-s'] };
const RV_STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.8l3.1 6.4 7 .9-5.1 4.9 1.3 7-6.3-3.4-6.3 3.4 1.3-7L1.9 9.1l7-.9z"/></svg>';
const RV_MARK = '<svg class="rv-mark" viewBox="0 0 64 48" aria-hidden="true"><path d="M5 44V27C5 13 12 5 26 3l2 8c-7 2-11 6-12 12h11v21zM36 44V27c0-14 7-22 21-24l2 8c-7 2-11 6-12 12h11v21z"/></svg>';
const RV_AV = ["#D2F55C", "#8CCDE3", "#C888F8", "#F27B20", "#FF69AE"];
function rvStars(n, cls) { return '<span class="rv-stars' + (cls ? ' ' + cls : '') + '" role="img" aria-label="' + n + ' out of 5 stars">' + [0, 1, 2, 3, 4].map(k => k < n ? RV_STAR : RV_STAR.replace('<svg ', '<svg class="off" ')).join('') + '</span>'; }
const RV_BG = { 'rv-sky': '#8CCDE3', 'rv-lime': '#D2F55C', 'rv-cream': '#F0F0EA', 'rv-purple': '#C888F8' };
function rvAv(i, bg) { for (let k = 0; k < RV_AV.length; k++) { const c = RV_AV[(i + k) % RV_AV.length]; if (c.toLowerCase() !== String(bg || '').toLowerCase()) return c; } return RV_AV[0]; }
function rvCard(r, i, tag, cls, bg) {
  const cf = RV_COFFEE[r[2]] || RV_COFFEE.pe, deckCard = tag === 'article';
  const c = document.createElement(tag || 'figure'); c.className = 'rv' + (cls ? ' ' + cls : '');
  if (!bg) (cls || '').split(' ').forEach(k => { if (RV_BG[k]) bg = RV_BG[k]; });
  if (bg) c.style.setProperty('--rb', bg);
  c.style.setProperty('--ra', rvAv(i, bg));
  const top = document.createElement('div'); top.className = 'rv-top'; top.innerHTML = rvStars(r[4] || 5) + RV_MARK;
  const q = document.createElement(deckCard ? 'q' : 'blockquote'); q.textContent = r[0];
  const who = document.createElement(deckCard ? 'footer' : 'figcaption'); who.className = 'rv-who';
  const av = document.createElement('span'); av.className = 'rv-av'; av.setAttribute('aria-hidden', 'true'); av.textContent = r[1].charAt(0);
  const id = document.createElement('span'); id.className = 'rv-id';
  const b = document.createElement('b'); b.textContent = r[1];
  const sm = document.createElement('small'); sm.textContent = cf[0] + ', ' + r[3];
  id.append(b, sm);
  const bag = document.createElement('img'); bag.className = 'rv-bag'; bag.alt = ''; bag.loading = 'lazy'; bag.width = 160; bag.height = 236; bag.src = pic(cf[1]);
  who.append(av, id, bag);
  c.append(top, q, who);
  return c;
}
function rvScore(st, what) { return '<b>' + st[0].toFixed(1) + '</b><span>' + rvStars(5, 'big') + '<small>out of 5, from ' + st[1] + ' reviews of ' + what + '</small></span>'; }

/* ---------- reviews: a deck you flick through ---------- */
const deck = $('#deck'), revI = $('#revI');
const crowd = $('#crowd');
function cheer() { if (!crowd || RM) return; crowd.classList.remove('hop'); void crowd.offsetWidth; crowd.classList.add('hop'); }
const RCOL = ['#F0F0EA', '#8CCDE3', '#ffffff', '#C888F8', '#D2F55C', '#F27B20'];
const NREV = REVIEWS.length;
const rcards = REVIEWS.map((r, i) => {
  const c = rvCard(r, i, 'article', 'rcard' + (r[0].length < 60 ? ' big' : ''), RCOL[i % RCOL.length]);
  deck.appendChild(c);
  return c;
});
let revAt = 0, revBusy = false;
function layoutDeck() {
  rcards.forEach((c, i) => {
    const d = (i - revAt + NREV) % NREV;
    c.style.setProperty('--d', Math.min(d, 3));
    c.style.zIndex = NREV - d;
    c.style.opacity = d > 3 ? 0 : 1;
    c.setAttribute('aria-hidden', String(d !== 0));
  });
  revI.textContent = (revAt + 1) + ' / ' + NREV;
}
function nextRev(dir) {
  if (revBusy) return;
  revBusy = true;
  const top = rcards[revAt];
  top.classList.remove('drag'); top.classList.add('gone');
  top.style.setProperty('--dx', (dir * (deck.offsetWidth * 0.9 + 160)) + 'px');
  top.style.setProperty('--dr', (dir * 16) + 'deg');
  SFX.paper(); cheer();
  setTimeout(() => {
    revAt = (revAt + 1) % NREV;
    top.classList.add('drag');
    top.style.setProperty('--dx', '0px'); top.style.setProperty('--dr', '0deg');
    layoutDeck();
    void top.offsetWidth;
    top.classList.remove('drag', 'gone');
    revBusy = false;
  }, RM ? 0 : 300);
}
function prevRev() {
  if (revBusy) return;
  cheer();
  revAt = (revAt - 1 + NREV) % NREV;
  const top = rcards[revAt];
  top.classList.add('drag');
  top.style.setProperty('--dx', (-(deck.offsetWidth * 0.9 + 160)) + 'px'); top.style.setProperty('--dr', '-16deg');
  layoutDeck();
  void top.offsetWidth;
  top.classList.remove('drag');
  top.style.setProperty('--dx', '0px'); top.style.setProperty('--dr', '0deg');
  SFX.paper();
}
(function deckDrag() {
  let d = null;
  deck.addEventListener('pointerdown', e => {
    if (revBusy || (e.pointerType === 'mouse' && e.button !== 0)) return;
    d = { x: e.clientX, y: e.clientY, dx: 0, live: false, id: e.pointerId };
  });
  window.addEventListener('pointermove', e => {
    if (!d || e.pointerId !== d.id) return;
    const dx = e.clientX - d.x, dy = e.clientY - d.y;
    if (!d.live) {
      if (Math.abs(dx) < 8 || Math.abs(dy) > Math.abs(dx)) return;
      d.live = true; rcards[revAt].classList.add('drag');
      try { deck.setPointerCapture(d.id); } catch (err) {}
    }
    d.dx = dx;
    const top = rcards[revAt];
    top.style.setProperty('--dx', dx.toFixed(0) + 'px'); top.style.setProperty('--dr', (dx * 0.04).toFixed(2) + 'deg');
  });
  const end = e => {
    if (!d || (e && e.pointerId !== d.id)) return;
    const top = rcards[revAt], dx = d.dx, live = d.live;
    d = null;
    if (!live) return;
    if (Math.abs(dx) > 70) nextRev(dx > 0 ? 1 : -1);
    else { top.classList.remove('drag'); top.style.setProperty('--dx', '0px'); top.style.setProperty('--dr', '0deg'); }
  };
  window.addEventListener('pointerup', end);
  window.addEventListener('pointercancel', end);
})();

/* ---------- wholesale room ---------- */
const wsForm = $('#wsForm'), wsSent = $('#wsSent');
/* Signal: the six numbers and their agents, with the sample day from the Signal site */
/* Signal, as the phone shows it: six numbers, three periods, an agent on each. Sample numbers. */
const SG = {
  s: ['Sierra', 'Sales specialist', 'Net sales', 'What drove sales?', '#bb85ff'],
  i: ['Iris', 'Ingredients & stock specialist', 'Cost of sales', 'Explain my cost of sales', '#ff75cf'],
  g: ['Gaia', 'Goals & performance specialist', 'Weekly goal', 'What is left to target?', '#8fe07a'],
  n: ['Nova', 'Net profit specialist', 'Est. net profit', 'We’ve been flat out. What’s actually left?', '#7edfe4'],
  a: ['Atlas', 'Average order value specialist', 'Average order', 'Lift average order value', '#ff8f45'],
  l: ['Luna', 'Labour cost specialist', 'Labour', 'Explain my labour cost', '#97aaff']
};
const SGP = {
  today: { range: 'Thursday 24 September', vs: 'vs last Thursday', when: 'today', goal: 'Daily goal',
    v: { s: ['$3,275', 'Up 4.2%'], i: ['28.0%', 'Down 0.5 pts'], g: ['91%', 'Up 3.0 pts'], n: ['$524', 'Up $61'], a: ['$16.38', 'Up $0.22'], l: ['30.0%', 'Down 0.8 pts'] } },
  week: { range: '18–24 September', vs: 'vs previous week', when: 'this week', goal: 'Weekly goal',
    v: { s: ['$21,580', 'Up 12.4%'], i: ['28.5%', 'Down 1.5 pts'], g: ['86%', 'Up 2.1 pts'], n: ['$3,836', 'Up $1,148'], a: ['$16.35', 'Up $0.35'], l: ['31.0%', 'Down 1.0 pts'] } },
  last: { range: '11–17 September', vs: 'vs the week before', when: 'last week', goal: 'Weekly goal',
    v: { s: ['$19,199', 'Up 3.1%'], i: ['30.0%', 'Up 0.4 pts'], g: ['84%', 'Down 1.2 pts'], n: ['$2,688', 'Up $212'], a: ['$16.00', 'Up $0.10'], l: ['32.0%', 'Up 0.6 pts'] } }
};
const sgSay = {
  s: (v, p) => 'Net sales are ' + v + ' ' + p.when + '. Start by separating the number of orders from the size of each order.',
  i: (v) => 'Your cost of sales is ' + v + ' of net sales: the ingredients and stock used to make what you sold.',
  g: (v, p) => 'You are ' + v + ' of the way to your ' + p.goal.toLowerCase().replace(' goal', '') + ' net sales target.',
  n: (v) => 'In this example, ' + v + ' is left after cost of sales, labour and other costs.',
  a: (v) => 'Each transaction is worth ' + v + ' on average, excluding GST.',
  l: (v) => 'Labour is ' + v + ' of net sales. This includes gross wages and super.'
};
const sgEl = $('#sg'), sgCard = $('#sgCard'), sgGrid = $('#sgTiles'), sgSegBtns = $$('#sgSeg button');
let sgT = 0, sgAt = 's', sgPer = 'week', sgSwap = 0, sgHold = false, sgTiles = [];
function sgBad(k, d) { return (k === 'i' || k === 'l') ? /^Up/.test(d) : /^Down/.test(d); }   /* costs going up is the bad way round */
function sgBuild() {
  const p = SGP[sgPer];
  sgGrid.textContent = '';
  sgTiles = Object.keys(SG).map(k => {
    const d = SG[k], v = p.v[k], b = document.createElement('button');
    b.type = 'button'; b.className = 'sg-tile' + (k === sgAt ? ' on' : ''); b.dataset.k = k; b.style.setProperty('--tone', d[4]);
    b.setAttribute('aria-pressed', String(k === sgAt));
    const top = document.createElement('span'); top.className = 'sg-tl';
    const badge = document.createElement('i'); badge.textContent = k.toUpperCase(); top.appendChild(badge);
    top.appendChild(document.createTextNode(k === 'g' ? p.goal : d[2]));
    const val = document.createElement('b'); val.className = 'sg-v'; val.textContent = v[0];
    b.appendChild(top); b.appendChild(val);
    if (k === 'g') { const bar = document.createElement('span'); bar.className = 'sg-prog'; const f = document.createElement('i'); f.style.width = parseFloat(v[0]) + '%'; bar.appendChild(f); b.appendChild(bar); }
    const dl = document.createElement('em'); dl.className = 'sg-d' + (sgBad(k, v[1]) ? ' bad' : ''); dl.textContent = v[1];
    const vs = document.createElement('small'); vs.textContent = p.vs;
    b.appendChild(dl); b.appendChild(vs);
    b.addEventListener('click', () => { showSignal(k); startSignal(); });
    sgGrid.appendChild(b);
    return b;
  });
  $('#sgRange').textContent = p.range;
  sgSegBtns.forEach(x => x.setAttribute('aria-pressed', String(x.dataset.p === sgPer)));
}
function sgFill() {
  const d = SG[sgAt], p = SGP[sgPer], v = p.v[sgAt];
  $('#sgName').textContent = d[0]; $('#sgRole').textContent = d[1]; $('#sgLabel').textContent = sgAt === 'g' ? p.goal : d[2];
  $('#sgNum').textContent = v[0]; $('#sgQ').textContent = d[3];
  $('#sgA').textContent = sgSay[sgAt](v[0], p) + ' ' + v[1] + ' ' + p.vs + '.';
}
function showSignal(k, quiet, force) {
  if (k === sgAt && !force) return;
  sgAt = k;
  sgTiles.forEach(t => { const on = t.dataset.k === k; t.classList.toggle('on', on); t.setAttribute('aria-pressed', String(on)); });
  sgEl.style.setProperty('--tone', SG[k][4]);
  sgCard.classList.add('swap');
  clearTimeout(sgSwap);
  sgSwap = setTimeout(() => { sgFill(); sgCard.classList.remove('swap'); }, RM ? 0 : 240);
  if (!quiet) SFX.toggle();
}
function startSignal() {
  stopSignal();
  if (RM) return;
  const keys = Object.keys(SG);
  sgT = setInterval(() => { if (!sgHold && !document.hidden) showSignal(keys[(keys.indexOf(sgAt) + 1) % keys.length], true); }, 3600);
}
function stopSignal() { clearInterval(sgT); }
sgSegBtns.forEach(x => x.addEventListener('click', () => { if (x.dataset.p === sgPer) return; sgPer = x.dataset.p; sgBuild(); showSignal(sgAt, false, true); startSignal(); }));
sgEl.addEventListener('mouseenter', () => { sgHold = true; });
sgEl.addEventListener('mouseleave', () => { sgHold = false; });
sgBuild(); sgFill();
/* the "what you get" cards spin round to the detail */
$$('.flipc').forEach(c => c.addEventListener('click', () => {
  const on = c.getAttribute('aria-pressed') !== 'true';
  c.setAttribute('aria-pressed', String(on));
  c.classList.remove('spun'); void c.offsetWidth; c.classList.add('spun');
  SFX.spin(0.7); setTimeout(() => SFX.detent(), RM ? 0 : 420);
}));
const cups = $('#cups');
const MILK_L = 2, BEAN_KG = 35;
function calc() {
  const n = +cups.value, yr = n * 364;
  $('#cupsN').textContent = n;
  $('#cupsY').textContent = num(yr) + ' cups a year.';
  /* every line is its cost a year in dollars, so the total adds up from them (8 Oct, Jos: they read the wrong way round).
     Working figures: milk $2 a litre, coffee $35 a kg */
  const rise = yr * 0.5, milk = yr * 0.03 * MILK_L, bean = yr / 1000 * BEAN_KG;
  $('#oRise').textContent = '$' + num(rise);
  $('#oMilk').textContent = '$' + num(milk);
  $('#oBean').textContent = '$' + num(bean);
  $('#oMilkQ').textContent = num(yr * 0.03) + ' litres';
  $('#oBeanQ').textContent = num(yr / 1000) + 'kg';
  $('#oYear').textContent = '$' + num(rise + milk + bean);
}

/* ---------- sound switch: site sounds and scene ambience (music has its own player) ---------- */
const soundBtn = $('#soundBtn'), soundLbl = $('#soundLbl'), nudge = $('#nudge');
const AMB_LABEL = { beach: 'Sound: beach', street: 'Sound: Brooklyn', space: 'Sound: deep space', roast: 'Sound: roastery', cafe: 'Sound: cafe', none: 'Sound on' };
const AMB_NAME = { beach: 'Surf and gulls', street: 'Brooklyn street', space: 'Deep space', roast: 'The roastery', cafe: 'Cafe hum', none: 'Quiet in this part' };
let ambNow = 'none', mutedAll = false;
const plAsk = $('#plAsk'), plAskPlay = $('#plAskPlay'), plAskAmb = $('#plAskAmb');
const plSceneS = $('#plSceneS'), plMute = $('#plMute'), plMute2 = $('#plMute2'), plScene = $('#plScene'), plAmb = $('#plAmb'), plAmbVol = $('#plAmbVol'), plFx = $('#plFx'), plNote = $('#plNote');
const fxBtn = $('#fxBtn'), fxLbl = $('#fxLbl');
function soundUI() {
  const on = SFX.isOn(), amb = on && SFX.ambOn(), fx = on && SFX.fxOn();
  root.classList.toggle('sound-on', amb);
  soundBtn.setAttribute('aria-pressed', String(amb || fx));
  soundLbl.textContent = amb ? AMB_LABEL[ambNow] : fx ? 'Sound on' : 'Sound off';
  fxBtn.setAttribute('aria-pressed', String(fx));
  fxLbl.textContent = fx ? 'Clicks on' : 'Clicks off';
  soundBtn.title = soundLbl.textContent; fxBtn.title = fxLbl.textContent;
  plSceneS.textContent = amb ? (Music.isPlaying() ? 'Resting for the music' : ambNow === 'none' ? 'Scene sound on' : AMB_NAME[ambNow]) : 'Scene sound off';
  plMute.textContent = plMute2.textContent = mutedAll || (!on && !Music.isPlaying()) ? 'Unmute' : 'Mute all';
  plScene.textContent = AMB_NAME[ambNow];
  plAmb.checked = SFX.isOn() && SFX.ambOn(); plFx.checked = SFX.isOn() && SFX.fxOn();
  plNote.hidden = on;
  if (!plAsk.hidden) askPaint();
  plAmbVol.style.setProperty('--v', plAmbVol.value + '%');
}
function soundSet(v) {
  const on = SFX.setOn(v);
  if (v && !on) toast('Sound isn\'t available in this browser');
  nudge.classList.remove('on');
  soundUI();
  return on;
}
function setAmb(name) {
  if (name === ambNow) return;
  ambNow = name;
  SFX.scene(name);
  soundUI();
}
/* come in with the sound on and the scene is already playing. Two offers sit over the radio: start the music, pause the background */
let askT = 0;
function askPaint() {
  plAskPlay.textContent = Music.isPlaying() ? 'Pause the music' : 'Start the music';
  plAskAmb.textContent = SFX.isOn() && SFX.ambOn() ? 'Pause background sound' : 'Play background sound';
  plAskAmb.hidden = Music.isPlaying();   /* 8 Oct: the scene already rests while the music plays */
}
function askHide() { clearTimeout(askT); plAsk.hidden = true; }
function askShow(ms) { askPaint(); plAsk.hidden = false; clearTimeout(askT); askT = setTimeout(askHide, ms || 18000); }
plAskPlay.addEventListener('click', () => { Music.toggle(); askShow(6000); });
plAskAmb.addEventListener('click', () => {
  const want = !(SFX.isOn() && SFX.ambOn());
  if (want && !SFX.isOn()) { mutedAll = false; Music.el.muted = false; soundSet(true); }
  SFX.setAmb(want); soundUI(); askShow(6000);
});
$('#plAskX').addEventListener('click', () => { askHide(); $('#plMini').focus({ preventScroll: true }); });
/* BOM Radio: one place for the music, the scene sounds and the button sounds */
[plMute, plMute2].forEach(btn => btn.addEventListener('click', () => {
  const quiet = !(mutedAll || (!SFX.isOn() && !Music.isPlaying()));
  mutedAll = quiet;
  Music.el.muted = quiet;
  soundSet(!quiet);
}));
plAmb.addEventListener('change', () => soundPart('amb', plAmb.checked));   /* 8 Oct: each switch on its own */
plAmbVol.addEventListener('input', () => { SFX.ambLevel(plAmbVol.value / 100); plAmbVol.style.setProperty('--v', plAmbVol.value + '%'); });
plFx.addEventListener('change', () => soundPart('fx', plFx.checked));
$('#plOn').addEventListener('click', () => { mutedAll = false; Music.el.muted = false; soundSet(true); SFX.toggle(); });

/* ---------- small enhancers ---------- */
function enhanceMagnets() {
  if (!FINE || RM) return;
  $$('.btn,.nb').forEach(el => {
    el.addEventListener('mousemove', e => {
      const r = el.getBoundingClientRect();
      el.style.setProperty('--tx', ((e.clientX - r.left - r.width / 2) * 0.14).toFixed(1) + 'px');
      el.style.setProperty('--ty', ((e.clientY - r.top - r.height / 2) * 0.2).toFixed(1) + 'px');
    });
    el.addEventListener('mouseleave', () => { el.style.setProperty('--tx', '0px'); el.style.setProperty('--ty', '0px'); });
  });
}
function enhanceTilt() {
  if (!FINE || RM) return;
  $$('.frame').forEach(f => {
    f.addEventListener('mousemove', e => {
      const r = f.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      f.classList.add('live');
      f.style.setProperty('--ry', ((x - 0.5) * 14).toFixed(2) + 'deg');
      f.style.setProperty('--rx', ((0.5 - y) * 10).toFixed(2) + 'deg');
    });
    f.addEventListener('mouseleave', () => {
      f.classList.remove('live');
      f.style.setProperty('--rx', '0deg'); f.style.setProperty('--ry', '0deg');
    });
  });
}
/* headings split into words that rise out of a mask */
function splitWords(el) {
  let n = 0;
  (function walk(node) {
    Array.from(node.childNodes).forEach(c => {
      if (c.nodeType === 3) {
        const frag = document.createDocumentFragment();
        c.textContent.split(/(\s+)/).forEach(tok => {
          if (!tok) return;
          if (/^\s+$/.test(tok)) { frag.appendChild(document.createTextNode(' ')); return; }
          const w = document.createElement('span'); w.className = 'sw';
          const i = document.createElement('span'); i.textContent = tok; i.style.setProperty('--i', n++);
          w.appendChild(i); frag.appendChild(w);
        });
        c.replaceWith(frag);
      } else if (c.nodeType === 1) walk(c);
    });
  })(el);
  el.classList.add('split');
}

/* marquees */
const mqs = $$('[data-mq]').map(el => ({ el: el, kids: $$('.mq-t', el), dir: +el.dataset.mq || 1, x: 0, w: 1, vis: true }));
if ('IntersectionObserver' in window) {   /* a band only moves while it can be seen (6 Oct: every band moved every frame) */
  const mqIO = new IntersectionObserver(es => es.forEach(en => { const m = mqs.find(x => x.el === en.target); if (m) m.vis = en.isIntersecting; }), { rootMargin: '15% 0px 15% 0px' });
  mqs.forEach(m => mqIO.observe(m.el));
}
function mqSize() { mqs.forEach(m => { m.w = m.kids[0].offsetWidth || 1; }); }

/* the poster wall (6 Oct): no longer pinned, so scrolling the page goes straight past it. It drifts along by itself
   while it is on screen; drag it with the mouse, swipe it, or open one up */
const wall = $('#warehouse'), track = $('#track'), wallSc = $('.wall-scroll');
let wallMax = 0, wallPinned = false, wallDragged = false, wallX = 0, wallDir = 1, wallHold = false, wallRest = 0;
const posters = $$('.poster', track);
function wallSize() { wall.style.height = ''; track.style.transform = ''; wallX = wallSc.scrollLeft; }
(function wallDrag() {
  let d = null;
  wallSc.addEventListener('pointerdown', e => {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    d = { x: e.clientX, l: wallSc.scrollLeft, moved: false };
    wallDragged = false;
  });
  window.addEventListener('pointermove', e => {
    if (!d) return;
    const dx = e.clientX - d.x;
    if (!d.moved && Math.abs(dx) > 6) { d.moved = true; wallDragged = true; wallSc.classList.add('dragging'); }
    if (d.moved) { wallSc.scrollLeft = d.l - dx; wallX = wallSc.scrollLeft; wallRest = performance.now() + 2500; }
  });
  window.addEventListener('pointerup', () => { if (d) { d = null; wallSc.classList.remove('dragging'); setTimeout(() => { wallDragged = false; }, 0); } });
  track.addEventListener('dragstart', e => e.preventDefault());
  wallSc.addEventListener('scroll', () => { if (Math.abs(wallSc.scrollLeft - wallX) > 3) { wallX = wallSc.scrollLeft; wallRest = performance.now() + 2500; } }, { passive: true });
  wallSc.addEventListener('touchstart', () => { wallRest = performance.now() + 4000; }, { passive: true });
})();
function wallStep(dt, vh) {
  if (RM || wallHold || S.overlay || performance.now() < wallRest) return;
  const r = wall.getBoundingClientRect();
  if (r.top > vh * 0.75 || r.bottom < vh * 0.25) return;
  const max = wallSc.scrollWidth - wallSc.clientWidth;
  if (max < 4) return;
  wallX += wallDir * 34 * dt;
  if (wallX >= max) { wallX = max; wallDir = -1; } else if (wallX <= 0) { wallX = 0; wallDir = 1; }
  wallSc.scrollLeft = wallX;
}

/* subscribe: the hand of bags */
const fan = $('#fan'), subEl = $('#subscribe');
$$('.fan-card', fan).forEach(c => c.addEventListener('click', () => {
  const i = +c.dataset.fan;
  syncBuy('plan', 'sub');
  toast(BLENDS[i].name + ', on subscription. Pick your size.');
  go('blends', i);
}));

/* buttons throw a few squares when pressed */
const BITS = ['#FF69AE', '#C888F8', '#F0F0EA', '#8CCDE3', '#F27B20'];
function burst(x, y, n) {
  if (RM || !document.body.animate) return;
  for (let i = 0; i < (n || 7); i++) {
    const b = document.createElement('i'); b.className = 'bit';
    b.style.background = BITS[i % BITS.length];
    document.body.appendChild(b);
    const a = Math.random() * Math.PI * 2, d = 46 + Math.random() * 64, s = 0.5 + Math.random() * 0.8;
    const an = b.animate([
      { transform: 'translate(' + (x - 6) + 'px,' + (y - 6) + 'px) scale(' + s + ') rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + (x - 6 + Math.cos(a) * d) + 'px,' + (y - 6 + Math.sin(a) * d - 26) + 'px) scale(' + s + ') rotate(' + (Math.random() * 300 - 150) + 'deg)', opacity: 1, offset: 0.7 },
      { transform: 'translate(' + (x - 6 + Math.cos(a) * d * 1.15) + 'px,' + (y - 6 + Math.sin(a) * d * 1.15 + 18) + 'px) scale(0) rotate(' + (Math.random() * 400 - 200) + 'deg)', opacity: 1 }
    ], { duration: 520 + Math.random() * 180, easing: 'cubic-bezier(.2,.8,.3,1)' });
    an.onfinish = () => b.remove();
  }
}

/* ---------- find your coffee: four honest questions, ten coffees (9 Oct, Jos: "start with what they brew on ... include the singles ... less gimmicky and more honest") ---------- */
/* the ten coffees, in the order of every score list below. The blends are BLENDS[0..2]; the singles carry their own picture,
   handle and price (the theme hands over what the store says about them today in #cflSingles) */
const QK = ['pe', 'nsb', 'hyd', 'peru', 'colombia', 'brazil', 'decaf', 'ethiopia', 'png', 'mexico'];
const QSO = {
  peru: { name: 'Peru', h: 'peru-chanchamayo-washed', bag: 'so-peru-front', price: 25, vid: 39302168936537, roast: 4 },
  colombia: { name: 'Colombia', h: 'colombia-popayan-reserve-washed', bag: 'so-colombia-front', price: 25, vid: 39302134825049, roast: 3 },
  brazil: { name: 'Brazil', h: 'brazil-mogiana-natural-espresso-250g', bag: 'so-brazil-front', price: 25, vid: 41422892695641, roast: 3 },
  decaf: { name: 'Colombia Decaf', h: 'colombia-popayan-decaf', bag: 'so-decaf-front', price: 28, vid: 39302136856665, roast: 5 },
  ethiopia: { name: 'Ethiopia', h: 'ethiopia-yirgacheffe-natural-espresso', bag: 'so-ethiopia-front', price: 25, vid: 42648629706841, roast: 2 },
  png: { name: 'Papua New Guinea', h: 'papua-new-guinea-okapa-washed', bag: 'so-png-front', price: 25, vid: 39302152749145, roast: 3, out: true },
  mexico: { name: 'Mexico', h: 'mexico-chiapas-washed', bag: 'so-mexico-front', price: 26, vid: 39302156583001, roast: 3, out: true }
};
(function quizSingles() {
  let d = null;
  try { const el = document.getElementById('cflSingles'); d = el && JSON.parse(el.textContent); } catch (err) {}
  if (!d) return;
  Object.keys(QSO).forEach(k => {
    const x = d[QSO[k].h];
    if (!x || !x.id) { QSO[k].out = true; return; }
    QSO[k].vid = x.id; QSO[k].price = x.price / 100; QSO[k].out = x.ok === false;
  });
})();
const qName = k => k in QSO ? QSO[k].name : BLENDS[QK.indexOf(k)].name;
const qBagPic = k => k in QSO ? QSO[k].bag : 'bag-' + BLENDS[QK.indexOf(k)].id + '-front';
/* each answer: [title, line, art, scores for pe, nsb, hyd, peru, colombia, brazil, decaf, ethiopia, png, mexico] */
const QUIZ = [
  { q: 'What do you brew on?', o: [
    ['Espresso machine', 'Tamper, portafilter, the lot', 'bw-esp', [3, 3, 3, 2, 1, 3, 1, 0, 1, 1]],
    ['Plunger', 'French press, four minutes', 'bw-plg', [2, 2, 2, 2, 1, 2, 1, 1, 2, 2]],
    ['Pour over', 'V60, Chemex, filter', 'bw-v60', [0, 0, 0, 1, 4, 0, 1, 4, 2, 1]],
    ['AeroPress', 'Home, work or the tent', 'bw-aero', [2, 2, 3, 1, 2, 1, 1, 2, 1, 1]],
    ['Stovetop', 'The little moka pot', 'bw-moka', [3, 2, 3, 1, 0, 2, 1, 0, 0, 1]],
    ['Bit of everything', 'Depends on the day', 'bw-mug', [2, 1, 1, 1, 1, 1, 1, 1, 1, 1]]] },
  { q: 'How do you take it?', o: [
    ['White', 'Flat white, latte, a dash of milk', 'q-milk', [4, 4, 2, 2, 0, 3, 1, -2, 1, 1]],
    ['Black', 'Long black, filter, straight up', 'q-black', [0, 0, 2, 2, 3, 1, 1, 3, 2, 2]],
    ['Either way', "Depends who's making it", 'el-cup', [2, 1, 1, 1, 1, 1, 1, 0, 1, 2]]] },
  /* 9 Oct, 8:09pm (Jos: "is just 4 questions enough for the math?"): run over all 288 answer sets, the first table never
     landed on No Sleep Till Brooklyn or Brazil. Now: nutty and sweet is its own flavour (Brazil), and dark and strong
     splits on milk: white leans No Sleep (medium dark, made for milk), black and camping lean Hyperdrive */
  { q: 'Pick your flavour.', o: [
    ['Smooth and chocolatey', 'Comforting, no surprises', 'fl-milkchoc', [3, 1, 0, 4, 1, 1, 2, 0, 1, 3]],
    ['Bright and fruity', 'Clean, juicy, a bit lively', 'so-cherries', [0, 0, -2, 0, 4, 0, 0, 5, 3, 1]],
    ['Nutty and sweet', 'Toffee, hazelnut, low acid', 'fl-hazelnut', [2, 1, 0, 1, 0, 5, 1, -1, 1, 2]],
    ['Dark and strong', 'Heavy, bold, wakes the dead', 'q-short', [0, 4, 4, 1, -1, 0, 0, -2, 0, 0]]] },
  { q: 'Where do you drink it?', o: [
    ['At home, no rush', 'Weekend pace, every day', 'q-easy', [1, 0, 0, 1, 1, 1, 0, 1, 1, 1]],
    ['Out the door', 'Work, school run, the commute', 'q-thrust', [1, 2, 1, 0, 0, 0, 0, 0, 0, 0]],
    ['Camping and road trips', 'Off grid, still fussy', 'sc-pe-kombi', [0, 0, 3, 0, 0, 0, 0, 0, 0, 0]],
    ['Afternoons and late', 'Still want to sleep tonight', 'so-moon', [0, 0, 0, 0, 0, 0, 20, 0, 0, 0]]] }
];
/* what each coffee is, straight from what's in the bag */
const QUIZ_WHY = {
  pe: 'Our flagship crowd-pleaser. Medium roast, tastes like Coco Pops and vanilla milkshake: sweet enough to shine in milk, easy enough black.',
  nsb: 'Medium dark, Brazil and Peru. Jaffa cakes and a dark chocolate thickshake: bold without being bitter, and it loves milk.',
  hyd: 'Our darkest blend. Dark chocolate, malt and honey, roasted for punch: strong coffee that still tastes like something.',
  peru: 'Smooth and sweet: chocolate, panela and dried fruit, with none of the sharpness people expect from a single origin. It is the backbone of our darker blends, on its own.',
  colombia: 'Clean and sweet: milk chocolate and toffee apple. Bright enough to be interesting black, round enough to take a splash of milk.',
  brazil: "A natural from Mogiana: milk chocolate, hazelnut and Nan's toffees. Low acid and nutty, made for espresso and milk.",
  decaf: 'All the chocolate, none of the 2am ceiling staring. Chocolate, dried fruit and trail mix, from Popayán in Colombia.',
  ethiopia: 'Yirgacheffe, natural, roasted medium light: fruity, floral, peach iced tea at the finish. Try it black before you add milk.',
  png: 'From the Eastern Highlands: cocoa nib, maple and plum jam. Chocolatey, with more going on in the cup.',
  mexico: 'From Chiapas, washed: dark chocolate, a squeeze of citrus and nut butter. An easy everyday coffee, black or white.'
};
/* a starting point for the brewer they picked (the first question) */
const QUIZ_TIP = [
  'On your machine: start at 1:2, about 18g in and 36g out in 25 to 30 seconds.',
  'In the plunger: 30g to 450ml just off the boil, four minutes, then plunge slow.',
  'For pour over: 1:16, so 15g to 240ml, medium fine, done in about three minutes.',
  'In the AeroPress: 15g to 220ml, water just off the boil, two minutes, then press.',
  'On the stovetop: fill the basket level, no tamping, low heat, and off the flame when it starts to gurgle.',
  ''
];
const STR_HTML = ["<p class=\"str str-pe\" role=\"img\" aria-label=\"Strength 3 out of 5. Medium roast.\"><span>Strength 3/5</span><span><i class=\"bn f\"></i><i class=\"bn f\"></i><i class=\"bn f\"></i><i class=\"bn\"></i><i class=\"bn\"></i>Medium</span></p>", "<p class=\"str str-nsb\" role=\"img\" aria-label=\"Strength 4 out of 5. Medium dark roast.\"><span>Strength 4/5</span><span><i class=\"bn f\"></i><i class=\"bn f\"></i><i class=\"bn f\"></i><i class=\"bn f\"></i><i class=\"bn\"></i>Medium dark</span></p>", "<p class=\"str str-hyd\" role=\"img\" aria-label=\"Strength 5 out of 5. Dark roast.\"><span>Strength 5/5</span><span><i class=\"bn f\"></i><i class=\"bn f\"></i><i class=\"bn f\"></i><i class=\"bn f\"></i><i class=\"bn f\"></i>Dark</span></p>"];
const ROAST_WORD = ['', 'Light', 'Medium light', 'Medium', 'Medium dark', 'Dark'];
function qStrHtml(k) {
  if (!(k in QSO)) return STR_HTML[QK.indexOf(k)];
  const n = QSO[k].roast, w = ROAST_WORD[n];
  let beans = ''; for (let i = 0; i < 5; i++) beans += '<i class="bn' + (i < n ? ' f' : '') + '"></i>';
  return '<p class="str str-so" role="img" aria-label="Roast ' + n + ' out of 5. ' + w + '."><span>Roast ' + n + '/5</span><span>' + beans + w + '</span></p>';
}
const quiz = $('#quiz'), quizAsk = $('#quizAsk'), quizRes = $('#quizRes'), quizK = $('#quizK'), quizBar = $('#quizBar'), quizQ = $('#quizQ'), quizOpts = $('#quizOpts');
let qAt = 0, qScore = QK.map(() => 0), qPick = [], qWin = 'pe', qBusy = false;
const qOn = k => !(k in QSO) || !QSO[k].out;
function quizShow() {
  const it = QUIZ[qAt];
  quiz.dataset.step = qAt;
  quizAsk.hidden = false; quizRes.hidden = true;
  quizK.textContent = 'Question ' + (qAt + 1) + ' of ' + QUIZ.length;
  quizBar.style.width = (qAt / QUIZ.length * 100) + '%';
  quizQ.textContent = it.q;
  quizOpts.textContent = '';
  quizOpts.dataset.n = it.o.length;
  it.o.forEach((o, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'quiz-o'; b.style.setProperty('--i', i % 3);
    if (o[2]) { const im = document.createElement('img'); im.src = pic(o[2]); im.alt = ''; b.appendChild(im); }
    const t = document.createElement('b'); t.textContent = o[0]; b.appendChild(t);
    if (o[1]) { const sm = document.createElement('small'); sm.textContent = o[1]; b.appendChild(sm); }
    b.addEventListener('click', e => quizPick(i, b, e));
    quizOpts.appendChild(b);
  });
  quizAsk.classList.remove('in'); void quizAsk.offsetWidth; quizAsk.classList.add('in');
}
function quizPick(i, btn, e) {
  if (qBusy) return;
  qBusy = true;
  QUIZ[qAt].o[i][3].forEach((v, k) => { qScore[k] += v; });
  qPick[qAt] = i;
  btn.classList.add('picked');
  SFX.slap();
  if (e && e.clientX) burst(e.clientX, e.clientY, 9);
  setTimeout(() => { qBusy = false; qAt++; if (qAt < QUIZ.length) { SFX.pass(); quizShow(); } else quizDone(); }, RM ? 0 : 430);
}
/* the coffees on sale, best first: score, then how well each suits their brewer, then our order */
function quizRank() {
  const brew = QUIZ[0].o[qPick[0] || 0][3];
  return QK.map((k, n) => n).filter(n => qOn(QK[n])).sort((x, y) => qScore[y] - qScore[x] || brew[y] - brew[x] || x - y);
}
let quizSpinT = 0;
function quizMatch(rank) {   /* how their answers landed across the top three */
  const box = $('#quizMatch'), top = rank.slice(0, 3), val = top.map(n => Math.max(0, qScore[n])), sum = val.reduce((a, v) => a + v, 0) || 1;
  const pct = val.map(v => Math.round(v / sum * 100));
  pct[0] += 100 - pct.reduce((a, v) => a + v, 0);   /* rounding leftovers go to the winner */
  box.textContent = '';
  const h = document.createElement('p'); h.className = 'quiz-mh'; h.textContent = 'How your answers landed'; box.appendChild(h);
  top.forEach((n, j) => {
    const k = QK[n], row = document.createElement('button');
    row.type = 'button'; row.className = 'quiz-mr' + (j === 0 ? ' win' : ''); row.style.setProperty('--n', j);
    row.setAttribute('aria-label', qName(k) + ', ' + pct[j] + ' percent. Take me to it.');
    const nm = document.createElement('span'); nm.textContent = qName(k);
    const bar = document.createElement('i'), fill = document.createElement('i'); fill.style.setProperty('--w', pct[j] + '%'); bar.appendChild(fill);
    const v = document.createElement('b'); v.textContent = pct[j] + '%';
    row.appendChild(nm); row.appendChild(bar); row.appendChild(v);
    row.addEventListener('click', () => quizGo(k));
    box.appendChild(row);
  });
}
function quizGo(k) {   /* a blend opens its panel on this page; a single origin is its own product page */
  if (!(k in QSO)) { closeOv(); go('blends', QK.indexOf(k)); return; }
  if (LIVE) { location.assign(STORE + 'products/' + QSO[k].h); return; }
  toast(QSO[k].name + ' has its own page on the store');
}
function quizSinglePaint() {   /* a single origin: one bag, wholebean, a one-off */
  const so = QSO[quizSingle], box = $('#quizRes .quiz-price');
  if (!so || !box) return;
  box.querySelector('.pick-price').textContent = money(so.price);
  const was = box.querySelector('.pick-was'); if (was) was.hidden = true;
  const sv = box.querySelector('.pick-save'); if (sv) sv.hidden = true;
  box.querySelector('.pick-size').textContent = '250g wholebean, one-off. Grind it fresh';
  const add = $('#quizAdd'); if (add.textContent !== 'Added') add.textContent = 'Add to cart';
}
function quizLand() {
  const bag = $('#quizBag');
  quiz.dataset.step = qWin in QSO ? 'rs' : 'r' + QK.indexOf(qWin);
  quizRes.classList.remove('spin');
  bag.src = pic(qBagPic(qWin)); bag.alt = 'A bag of ' + qName(qWin);
  quizRes.classList.remove('in'); void quizRes.offsetWidth; quizRes.classList.add('in');
  SFX.sting(qWin in QSO ? 0 : QK.indexOf(qWin)); setTimeout(() => SFX.success(), 380);
  if (!RM) setTimeout(() => { const r = bag.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, 26); }, 260);
  setTimeout(() => $('#quizAdd').focus({ preventScroll: true }), 120);
}
function quizDone() {
  const rank = quizRank();
  qWin = QK[rank[0]];
  quizSingle = qWin in QSO ? qWin : null;
  if (!quizSingle) quizBlend = QK.indexOf(qWin);
  paintQuick();   /* the price shown is this coffee's own */
  const bag = $('#quizBag');
  quizAsk.hidden = true; quizRes.hidden = false;
  $('#quizKick').textContent = quizSingle ? 'Your single origin is' : "You're a";
  $('#quizName').textContent = qName(qWin);
  $('#quizLine').textContent = QUIZ_WHY[qWin];
  const tip = QUIZ_TIP[qPick[0] || 0];
  $('#quizTip').textContent = tip; $('#quizTip').hidden = !tip;
  $('#quizStr').innerHTML = qStrHtml(qWin);
  quizMatch(rank);
  clearInterval(quizSpinT);
  if (RM) { quizLand(); return; }
  /* the top bags shuffle like a fruit machine, then yours drops */
  quiz.dataset.step = 's'; quizRes.classList.remove('in'); quizRes.classList.add('spin');
  const pool = rank.slice(0, 5).map(n => QK[n]);
  let n = 0;
  const flip = () => { bag.src = pic(qBagPic(pool[(1 + n) % pool.length])); bag.alt = ''; SFX.tick(); n++; };
  flip();
  quizSpinT = setInterval(() => { if (n >= 11) { clearInterval(quizSpinT); quizLand(); } else flip(); }, 105);
}
function quizStart() { clearInterval(quizSpinT); quizRes.classList.remove('spin'); qAt = 0; qScore = QK.map(() => 0); qPick = []; qBusy = false; quiz.scrollTop = 0; quizShow(); }
const quizBuy = { b: 0, add: $('#quizAdd'), from: $('#quizBag'), t: 0 };
$('#quizAdd').addEventListener('click', () => {
  if (!quizSingle) { quizBuy.b = QK.indexOf(qWin); addToCart(quizBuy); return; }
  const so = QSO[quizSingle], add = $('#quizAdd');
  if (LIVE) storeAdd([{ id: so.vid, quantity: 1 }]);
  else { cart.push({ store: true, key: 'q-' + quizSingle, qty: 1, name: so.name, thumb: pic(so.bag + '-s'), line: '250g, wholebean, one-off', price: so.price, plan: false, deal: false, save: 0, one250: true, b: -1, grind: 'Wholebean' }); renderCart(); }
  SFX.add(); flyToCart(quizBuy);
  toast('Added ' + so.name + ' 250g, wholebean, to the cart');
  add.textContent = 'Added';
  clearTimeout(quizBuy.t); quizBuy.t = setTimeout(() => { add.textContent = 'Add to cart'; }, 1500);
});
$('#quizSee').addEventListener('click', () => quizGo(qWin));
$('#quizAgain').addEventListener('click', () => { SFX.toggle(); quizStart(); });

/* ---------- the wholesale page's own menu: jump to a section, show where you are ---------- */
const roomEl = $('#room'), roomBar = $('#roomBar'), roomLinks = $$('#roomNav [data-rgo]');
function roomGo(id) {
  const t = document.getElementById(id);
  if (!t) return;
  const y = t.getBoundingClientRect().top - roomEl.getBoundingClientRect().top + roomEl.scrollTop - roomBar.offsetHeight - 14;
  roomEl.scrollTo({ top: Math.max(0, y), behavior: RM ? 'auto' : 'smooth' });
  if (id === 'formCard') setTimeout(() => { const f = $('#wName'); if (f && !$('#wsForm').hidden) f.focus({ preventScroll: true }); }, RM ? 0 : 650);
}
$$('[data-rgo]', roomEl).forEach(b => b.addEventListener('click', () => roomGo(b.dataset.rgo)));
let roomSpyT = 0;
roomEl.addEventListener('scroll', () => {
  const now = performance.now();
  if (now - roomSpyT < 120) return;
  roomSpyT = now;
  const top = roomEl.getBoundingClientRect().top + roomBar.offsetHeight + 90;
  let cur = '';
  roomLinks.forEach(b => { const t = document.getElementById(b.dataset.rgo); if (t && t.getBoundingClientRect().top <= top) cur = b.dataset.rgo; });
  roomLinks.forEach(b => { if (b.dataset.rgo === cur) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
}, { passive: true });

/* ---- the pass: tap a docket and it gets sorted ---- */
$$('.dkt', roomEl).forEach(b => b.addEventListener('click', e => {
  const on = b.getAttribute('aria-pressed') !== 'true';
  b.setAttribute('aria-pressed', String(on));
  if (on) { SFX.slap(); if (e.clientX) burst(e.clientX, e.clientY, 8); } else SFX.toggle();
}));

/* ---------- the scenes: hero, the travelling bag, the wheel, the blend panels, the footer ---------- */
const topEl = $('#top'), navEl = $('#nav');
const hero = $('#home'), world = $('#world'), wipe = $('#wipe'), hType = $('#hType'), hGap = $('#hGap'), heroUi = $('#heroUi');
const hL1 = $('.h-l.l1'), hL2 = $('.h-l.l2'), cue = $('.scrollcue'), hFind = $('#hFind');
const wGhost = $('#wGhost'), heroPin = $('.hero-pin'), heroFront = $('#heroFront');
const scenes = $$('.scene', world), fronts = $$('.front', heroFront);
const swName = $('#swName'), swLine = $('#swLine'), swNote = $('.sw-note');
const actor = $('#actor'), aTilt = $('#actorTilt'), aFlip = $('#actorFlip'), aFr = $('.fr', aFlip), aBk = $('.bk', aFlip);
const wheel = $('#why'), wheelPin = $('.wheel-pin'), wheelHead = $('#wheelHead'), wcards = $$('.wcard', wheel), wheelDots = $$('#wheelDots i');
const betty = $('#betty'), bizPic = $('#bizPic');
/* the wheel turns by itself (6 Oct): stop 0 is the heading, 1 to 4 are the cards. Each holds, then it turns on; after the
   last card it turns back round to the heading. Off screen it waits; scroll back above it and it starts from the heading */
const WH = { at: 0, to: -1, t0: 0, hold: 0 };
const whT = i => (i === 0 ? -2 : i - 1), whH = i => (i === 0 ? 0 : -64);
function wheelGo(to, user) {
  if (WH.to > -1 || to === WH.at) return;
  WH.to = to; WH.t0 = performance.now();
  if (user && S.entered) SFX.detent();
}
function wheelTurn(now, seen) {
  if (WH.to > -1) {
    const ms = WH.to === 0 ? 1500 : 900, p = clamp((now - WH.t0) / ms, 0, 1), e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
    const out = { t: lerp(whT(WH.at), whT(WH.to), e), h: lerp(whH(WH.at), whH(WH.to), e) };
    if (p >= 1) { WH.at = WH.to; WH.to = -1; WH.hold = now; }
    return out;
  }
  if (!seen) WH.hold = now;
  else if (now - WH.hold > (WH.at === 0 ? 2000 : 3200)) wheelGo((WH.at + 1) % 5);
  return { t: whT(WH.at), h: whH(WH.at) };
}
wcards.forEach(c => c.addEventListener('click', () => wheelGo((WH.at + 1) % 5, true)));
wheelDots.forEach((d, i) => d.addEventListener('click', () => wheelGo(i + 1, true)));

const panels = panelEls.map(el => ({ el: el, inner: $('.panel-in', el), ghost: $('.p-ghost', el), art: $('.p-burst', el), bag: $('.bagflip', el), gw: 1 }));
const darkEls = $$('[data-nav="dark"]'), ambEls = $$('[data-amb]');
const AMB_OF = ['beach', 'street', 'space'];

/* the bag: which way up it is, and which blend it's wearing */
let turns = 0, back = false, wipeT = 0, swapT = 0, frT = 0, heroPop = false, navDark = null, wheelPop = false, ambT = 0;
function flipSet() { aFlip.style.transform = 'rotateY(' + (turns * 360 + (back ? 180 : 0)) + 'deg)'; }
function paintWorld(b) {
  root.style.setProperty('--w', b.w);
  root.style.setProperty('--w-ink', b.ink);
  root.style.setProperty('--w-ghost', b.ghost);
  root.style.setProperty('--w-edge', b.edge);
  if (b.dark) world.dataset.nav = 'dark'; else delete world.dataset.nav;
  navDark = null;
}
/* swap which coffee's world is showing: the old pieces shrink away, the new ones pop in */
function showScene(i) {
  scenes.forEach((sc, k) => { sc.classList.toggle('on', k === i); sc.classList.remove('pop'); });
  fronts.forEach((f, k) => { f.classList.toggle('on', k === i); f.classList.remove('pop'); });
  root.dataset.blend = i;
  if (heroPop) requestAnimationFrame(() => requestAnimationFrame(() => { scenes[i].classList.add('pop'); fronts[i].classList.add('pop'); }));
}
/* the facts about each coffee ride along with its scene: read off the blend's own page so there is one source */
const hi = { box: $('#hInfo'), roast: $('#hiRoast'), str: $('#hiStr'), taste: $('#hiTaste'), beans: $('#hiBeans'), best: $('#hiBest'), price: $('#hiPrice'), ps: $('#hiPriceS') };
function heroInfo(i, quiet) {
  const meta = {};
  $$('.p-meta dt', panelEls[i]).forEach(dt => { meta[dt.textContent.trim()] = dt.nextElementSibling.textContent.trim(); });
  hi.roast.textContent = (meta.Roast || '') + ' roast';
  hi.taste.textContent = meta['Tastes like'] || ''; hi.beans.textContent = meta.Beans || ''; hi.best.textContent = meta['Best for'] || '';
  const n = i + 3;
  hi.str.setAttribute('aria-label', 'Strength ' + n + ' out of 5');
  $$('.bn', hi.str).forEach((b, k) => b.classList.toggle('f', k < n));
  const k = (FREQ.find(f => f.k === '2-week') || FREQ[0] || { k: '' }).k;
  hi.price.textContent = money(priceOf(i, '250g', GRINDS[0], FREQ.length ? 'sub' : 'one', k));
  hi.ps.textContent = FREQ.length ? 'a 250g bag on subscription, ' + money(priceOf(i, '250g', GRINDS[0], 'one', k)) + ' one-off' : 'a 250g bag';
  if (!quiet) { hi.box.classList.remove('hit'); void hi.box.offsetWidth; hi.box.classList.add('hit'); }
}
function setBlend(i, quiet) {
  i = (i + 3) % 3;
  if (i === S.blend) return;
  const b = BLENDS[i];
  S.blend = i;
  /* the bag spins round and comes back wearing the new label */
  aBk.src = pic('bag-' + b.id + '-back');
  turns += 1; flipSet();
  clearTimeout(frT); frT = setTimeout(() => { aFr.src = pic('bag-' + b.id + '-front'); }, RM ? 0 : 300);
  /* the colour floods over the old world, the new world is swapped in underneath, then the flood lifts */
  clearTimeout(wipeT); clearTimeout(swapT);
  scenes.forEach(sc => sc.classList.remove('pop')); fronts.forEach(f => f.classList.remove('pop'));
  clearSlaps();
  if (RM) { paintWorld(b); showScene(i); }
  else {
    wipe.style.background = b.w;
    wipe.classList.remove('go', 'out'); void wipe.offsetWidth; wipe.classList.add('go');
    wipeT = setTimeout(() => {
      paintWorld(b); showScene(i);
      wipe.classList.add('out');
      swapT = setTimeout(() => wipe.classList.remove('go', 'out'), 480);
    }, 640);
  }
  swName.textContent = b.name; swLine.textContent = b.line;
  heroInfo(i);
  $$('span', wGhost).forEach(s => { s.textContent = b.name; });
  requestAnimationFrame(() => { M.ghostW = wGhost.firstElementChild.offsetWidth || 1; });
  if (!quiet) SFX.sting(i);
  burstAt(swName);
}

/* ---------- measure ---------- */
const M = { H: 1, W: 1, topH: 100, ghostW: 1, k0: { x: 0, y: 0, s: 1 }, k1: { x: 0, y: 0, s: 1 }, k2: { x: 0, y: 0, s: 1 } };
function measure(force) {
  const w = window.innerWidth, h = window.innerHeight;
  if (!force && !FINE && w === S.vw && Math.abs(h - S.vh) < 140) return;   /* phones resize as the address bar hides; ignore it */
  S.vw = w; S.vh = h; S.mobile = w <= 700; S.stacked = w <= 980;
  M.topH = topEl.getBoundingClientRect().height;   /* 9 Oct: the bar is zoomed on big screens, so its height on screen */
  root.style.setProperty('--top', M.topH + 'px');
  /* big screens (7 Oct, Jos): how much bigger than 1440 x 900 this one is; the landing page's bag and parts grow by it (--bz) */
  root.style.setProperty('--bz', (!S.stacked && w > 1100 && h > 640 && w >= h ? clamp(Math.min(w / 1440, h / 900), 1, 2.4) : 1).toFixed(3));
  M.H = actor.offsetHeight || 1; M.W = actor.offsetWidth || 1;
  /* opener: on wide screens the bag stands in the gap between FOR and LIFE; on phones it sits under the type */
  const lastLine = hType.lastElementChild, typeBottom = lastLine.offsetTop + lastLine.offsetHeight;
  if (hGap.offsetWidth > 0) {
    const s0 = hGap.offsetWidth / M.W;
    let gx = 0;
    for (let n = hGap; n && n !== hType; n = n.offsetParent) gx += n.offsetLeft;   /* the line is centred, so measure from the page, not from the line */
    M.k0 = { x: gx + hGap.offsetWidth / 2, y: h * 0.99 - M.H * s0 / 2, s: s0 };
  } else {
    const top = typeBottom + h * 0.014, s0 = Math.min(clamp((h - top - 58) / M.H, 0.4, 0.86), w * 0.7 / M.W);
    M.k0 = { x: w / 2, y: top + M.H * s0 / 2, s: s0 };
  }
  /* the colour world: centred between the nav and the blend switcher */
  const narrow = hGap.offsetWidth === 0;   /* phones and upright tablets: keep the bag small enough to see the scene round it */
  /* on a phone the headline sits top left over the scene, so the bag starts underneath it rather than covering it */
  let shoutBottom = 0;
  if (w <= 700) $$('.shout').forEach(sh => { if (sh.offsetHeight) shoutBottom = Math.max(shoutBottom, sh.offsetTop + sh.offsetHeight); });
  const a = Math.max(M.topH + 6, shoutBottom + 10), b = heroUi.firstElementChild.getBoundingClientRect().top - heroUi.getBoundingClientRect().top - 12, s1 = Math.min(0.94, (b - a) / M.H, narrow ? w * 0.6 / M.W : 9);
  M.k1 = { x: w / 2, y: (a + b) / 2, s: s1 };
  /* the wheel: under the cards */
  let cardBottom = 0;
  wcards.forEach(c => { cardBottom = Math.max(cardBottom, c.offsetTop + c.offsetHeight); });
  /* phones: the bag stands clear of the next section's zigzag, because the heading there sits close under it (6 Oct) */
  const top2 = Math.max(cardBottom + 14, h * 0.5), s2 = clamp((w <= 700 ? h - clamp(w * 0.05, 26, 74) - 18 - top2 : (h - top2) / 0.95) / M.H, 0.4, 0.8);
  M.k2 = { x: w / 2, y: top2 + M.H * s2 / 2, s: s2 };
  M.ghostW = wGhost.firstElementChild.offsetWidth || 1;
  panels.forEach(p => { p.gw = p.ghost.firstElementChild.offsetWidth || 1; });
  wallSize(); mqSize(); placeSegs(); playSize();
}

/* ---------- footer: a half court. Pull a sticker back, let it fly, hit the hoop ---------- */
const play = $('#play');
const ALLB = $$('.tk', play).map(el => ({ el: el, x: 0, y: 0, vx: 0, vy: 0, a: 0, va: 0, r: 60, w: 100, h: 100, held: false, gx: 0, gy: 0, st: 0, sv: 0, sa: 0, shot: false, from: 0, ball: el.classList.contains('tk-ball') }));
const playApron = $('#playApron');
let bodies = ALLB;   /* the balls on the floor right now: a phone court is small, so it gets fewer */
let playW = 1, playH = 1, playDropped = false, playLive = false, grab = null, lastThud = 0, lastRim = 0;
const hoop = $('#hoop'), hoopFront = $('#hoopFront'), hoopPop = $('#hoopPop'), hoopRim = $('.hoop-rim', hoop), hoopBoard = $('.hoop-board', hoop), courtBoard = $('#courtBoard');
/* seven-segment readouts for the scoreboard */
const SEGS = { a: '14,6 46,6 40,14 20,14', b: '48,8 48,46 44,50 40,44 40,16', c: '48,92 48,54 44,50 40,56 40,84', d: '14,94 46,94 40,86 20,86', e: '12,92 12,54 16,50 20,56 20,84', f: '12,8 12,46 16,50 20,44 20,16', g: '18,50 22,46 38,46 42,50 38,54 22,54' };
const DIGIT = ['abcdef', 'bc', 'abged', 'abgcd', 'fgbc', 'afgcd', 'afgedc', 'abc', 'abcdefg', 'abcdfg'];
function segMake(svg, n) {
  const out = [];
  for (let i = 0; i < n; i++) {
    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g'), d = {};
    g.setAttribute('transform', 'translate(' + (i * 64 + 2) + ',0) skewX(-5)');
    Object.keys(SEGS).forEach(k => { const pl = document.createElementNS('http://www.w3.org/2000/svg', 'polygon'); pl.setAttribute('points', SEGS[k]); g.appendChild(pl); d[k] = pl; });
    svg.appendChild(g); out.push(d);
  }
  return out;
}
function segSet(digits, v) {
  const str = String(Math.min(v, Math.pow(10, digits.length) - 1));
  digits.forEach((d, i) => {
    const ch = str[i - (digits.length - str.length)], lit = ch == null ? '' : DIGIT[+ch];
    Object.keys(d).forEach(k => d[k].classList.toggle('on', lit.indexOf(k) > -1));
  });
}
const segPts = segMake($('#segPts'), 3), segRun = segMake($('#segRun'), 2);
let hoopRun = 0;
const GAME_SECS = 25, GAME_TARGET = 10;
const G25 = { armed: false, on: false, t0: 0, left: GAME_SECS, over: 0, final: 0 };
function boardShow() { segSet(segPts, hoopScore); segSet(segRun, G25.left); hoop.classList.toggle('fire', hoopRun >= 3); }
function hoopMiss() { if (hoopRun) { hoopRun = 0; boardShow(); } }
const sling = $('#sling'), bands = $$('.band', sling), pin = $('.pin', sling), dotBox = $('#slingDots');
const playNote = $('#playNote');
const NS = 'http://www.w3.org/2000/svg', DOTS = [];
for (let i = 0; i < 15; i++) { const c = document.createElementNS(NS, 'circle'); c.setAttribute('class', 'dot'); c.setAttribute('r', (6.5 - i * 0.28).toFixed(1)); dotBox.appendChild(c); DOTS.push(c); }
const H = { on: false, x0: 0, x1: 0, y: 0, bt: 0, bb: 0, w: 1 };   /* ring tip, backboard face, ring height */
let G = 2600;
let PULL = 220, LAUNCH = 2500, hoopScore = 0;
function playSize() {
  /* the floor stops short of the bottom edge, so the music dock and the stepper never sit on the balls */
  playW = play.clientWidth; playH = play.clientHeight - playApron.offsetHeight;
  const bzc = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bz')) || 1;   /* 9 Oct: the big-screen scale (--bz) */
  const k = (S.vw <= 700 ? 0.58 : S.vw < 1100 ? 0.8 : 1) * bzc;
  G = 2600 * bzc;
  const few = S.vw <= 700;
  ALLB.forEach(b => {
    const off = few && b.el.classList.contains('tk-big');
    if (off && b.held) grabEnd(false);
    if (b.off && !off && playDropped) { b.x = playW * 0.3; b.y = -200; b.vx = b.vy = 0; }   /* back on a wider court: drop in from the top */
    b.off = off; b.el.hidden = off;
  });
  bodies = ALLB.filter(b => !b.off);
  bodies.forEach(b => {
    const s = parseFloat(b.el.style.getPropertyValue('--s')) * k;
    const nw = +b.el.getAttribute('width') || b.el.naturalWidth || 1, nh = +b.el.getAttribute('height') || b.el.naturalHeight || 1;
    b.w = s; b.h = s * nh / nw; b.r = b.ball ? s * 0.48 : (b.w + b.h) / 4 * 0.84;
    b.el.style.width = s + 'px';
    if (playDropped) { b.x = clamp(b.x, b.r, playW - b.r); b.y = Math.min(b.y, playH - b.r); }
  });
  PULL = clamp(playW * 0.2, 120, 240) * bzc; LAUNCH = clamp(playW * 2.6, 1950, 2650) * bzc;
  const pr = play.getBoundingClientRect(), rr = hoopRim.getBoundingClientRect(), br = hoopBoard.getBoundingClientRect();
  H.on = !RM && rr.width > 0;
  H.x0 = rr.left - pr.left; H.x1 = br.left - pr.left; H.y = rr.top - pr.top;
  H.bt = br.top - pr.top; H.bb = br.bottom - pr.top; H.w = H.x1 - H.x0;
  if (RM) playRest();
}
function playRender(b) {
  let t = 'translate3d(' + (b.x - b.w / 2).toFixed(1) + 'px,' + (b.y - b.h / 2).toFixed(1) + 'px,0)';
  if (Math.abs(b.st) > 0.01) t += ' rotate(' + b.sa.toFixed(1) + 'deg) scale(' + (1 + b.st * 0.5).toFixed(3) + ',' + (1 - b.st * 0.24).toFixed(3) + ') rotate(' + (-b.sa).toFixed(1) + 'deg)';
  b.el.style.transform = t + ' rotate(' + b.a.toFixed(1) + 'deg)';
}
function playRest() {   /* reduced motion: stickers just sit along the floor */
  playDropped = true;
  bodies.forEach((b, i) => { b.x = playW * (i + 0.5) / bodies.length; b.y = playH - b.h / 2 - 8; b.a = (i % 2 ? 6 : -7); b.vx = b.vy = b.va = 0; playRender(b); });
}
function playDrop() {
  playDropped = true;
  bodies.forEach((b, i) => {
    b.x = playW * (0.1 + 0.62 * ((i * 0.37 + 0.2) % 1)); b.y = -b.r - 80 - i * 150;
    b.vx = (i % 2 ? -1 : 1) * (60 + i * 30); b.vy = 0; b.a = (i * 47) % 40 - 20; b.va = (i % 2 ? -1 : 1) * 90;
  });
}
const shotCall = $('#shotCall'), shotWord = $('#shotWord'), shotPts = $('#shotPts');
const CALL2 = ['Nice shot!', 'Buckets!', 'Swish!', 'Count it!', 'Too easy!', 'Money!'];
const CALL3 = ['From downtown!', 'Splash!', 'Bang!', 'Nothing but net!', 'From the car park!', 'Way out!'];
let callN = 0, stingN = 0;
function hoopScoreUp(b) {
  const pts = Math.abs(b.from - (H.x0 + H.x1) / 2) > playW * 0.5 ? 3 : 2;
  hoopScore += pts; hoopRun++;
  hoopPop.textContent = '';
  b.shot = false; b.vx *= 0.22; b.vy *= 0.5;
  boardShow();
  [hoop, hoopFront].forEach(el => { el.classList.remove('swish'); void el.offsetWidth; el.classList.add('swish'); });
  courtBoard.classList.remove('bump'); void courtBoard.offsetWidth; courtBoard.classList.add('bump');
  /* the call: what the crowd shouts, then the points */
  const list = pts === 3 ? CALL3 : CALL2;
  shotWord.textContent = hoopRun === 3 ? 'On fire!' : hoopRun === 5 ? 'Unstoppable!' : hoopRun === 2 && pts === 2 ? 'Heating up!' : list[callN++ % list.length];
  shotPts.textContent = '+' + pts;
  shotCall.style.left = clamp(H.x0 - playW * 0.02, playW * 0.3, playW - 20) + 'px';
  shotCall.style.top = Math.max(60, H.y - H.w * 0.55) + 'px';
  shotCall.className = 'shot-call ' + (pts === 3 ? 'three' : 'two');
  void shotCall.offsetWidth; shotCall.classList.add('go');
  if (S.entered) {
    SFX.swish(); SFX.buzzer();
    if (pts === 3) SFX.three(stingN++, 0.7);   /* a three gets the arena treatment once the horn clears */
    Music.duck(pts === 3 ? 3200 : 1700);        /* the song steps back so the horn can be heard */
  }
  const pr = play.getBoundingClientRect();
  burst(pr.left + (H.x0 + H.x1) / 2, pr.top + H.y + 20, pts === 3 ? 26 : 14);
}
function slingDraw(b) {
  const ax = grab.ax, ay = grab.ay;
  bands.forEach(l => { l.setAttribute('x1', ax.toFixed(1)); l.setAttribute('y1', ay.toFixed(1)); l.setAttribute('x2', b.x.toFixed(1)); l.setAttribute('y2', b.y.toFixed(1)); });
  pin.setAttribute('cx', ax.toFixed(1)); pin.setAttribute('cy', ay.toFixed(1));
  const k = LAUNCH / PULL, vx = -grab.px * k, vy = -grab.py * k, show = grab.len > 16;
  for (let i = 0; i < DOTS.length; i++) {
    const t = (i + 1) * 0.062, x = b.x + vx * t, y = b.y + vy * t + 0.5 * G * t * t;
    DOTS[i].setAttribute('cx', x.toFixed(1)); DOTS[i].setAttribute('cy', y.toFixed(1));
    DOTS[i].style.opacity = show && y < playH - 6 && x > 0 && x < playW ? 1 : 0;
  }
}
function playStep(dt, now) {
  for (let i = 0; i < bodies.length; i++) {
    const b = bodies[i], py = b.y;
    if (b.held && (!grab || grab.b !== b)) b.held = false;   /* nobody is actually holding it */
    if (b.held) {
      /* the sticker hangs off a rubber band pinned where you picked it up */
      const dx = grab.x - b.gx - grab.ax, dy = grab.y - b.gy - grab.ay, len = Math.hypot(dx, dy), k = len > PULL ? PULL / len : 1;
      grab.px = dx * k; grab.py = dy * k; grab.len = Math.min(len, PULL);
      b.x = clamp(grab.ax + grab.px, b.r, playW - b.r); b.y = clamp(grab.ay + grab.py, b.r, playH - b.r);
      b.vx = b.vy = b.va = 0; b.sv = 0;
      b.st = lerp(b.st, grab.len / PULL, 0.4); if (len > 4) b.sa = Math.atan2(dy, dx) * 57.3;
      if (Math.abs(grab.len - grab.last) > 14) { grab.last = grab.len; if (S.entered) SFX.stretch(grab.len / PULL); }
      continue;
    }
    b.sv += (-b.st * 300 - b.sv * 13) * dt; b.st += b.sv * dt;   /* snaps back with a wobble */
    if (Math.abs(b.st) < 0.004 && Math.abs(b.sv) < 0.05) b.st = b.sv = 0;
    /* same arc as the dotted aim line, whatever the frame rate */
    b.x += b.vx * dt; b.y += b.vy * dt + 0.5 * G * dt * dt; b.a += b.va * dt;
    b.vy += G * dt;
    b.vx *= 1 - 0.1 * dt; b.va *= 1 - 0.9 * dt;
    const wb = b.ball ? 0.72 : 0.5;
    if (b.x < b.r) { b.x = b.r; if (b.vx < 0) b.vx = -b.vx * wb; }
    else if (b.x > playW - b.r) { b.x = playW - b.r; if (b.vx > 0) b.vx = -b.vx * wb; }
    if (b.y > playH - b.r) {
      b.y = playH - b.r;
      if (b.vy > 0) {
        if (b.shot) { b.shot = false; hoopMiss(); }   /* hit the floor first: the streak is over */
        if (b.vy > 420 && now - lastThud > 90 && S.entered) { lastThud = now; if (b.ball) SFX.bounce(b.vy / 1800); else SFX.world(SFX.tick); }
        b.vy = b.vy > (b.ball ? 90 : 160) ? -b.vy * (b.ball ? 0.7 : 0.38) : 0;
      }
      b.vx *= b.ball ? 0.985 : 0.94;
      b.va = lerp(b.va, b.vx / b.r * 57.3, 0.2);   /* roll along the floor */
    }
    if (H.on) {
      const hr = Math.min(b.r * 0.55, H.w * 0.3);
      /* the front of the ring */
      const dx = b.x - H.x0, dy = b.y - H.y, d = Math.hypot(dx, dy), min = hr + 6;
      if (d < min && d > 0) {
        const nx = dx / d, ny = dy / d, vn = b.vx * nx + b.vy * ny;
        b.x += nx * (min - d); b.y += ny * (min - d);
        if (vn < 0) {
          b.vx -= 1.5 * vn * nx; b.vy -= 1.5 * vn * ny;
          if (vn < -260 && now - lastRim > 140) { lastRim = now; if (S.entered) SFX.rim(); hoop.classList.remove('clang'); void hoop.offsetWidth; hoop.classList.add('clang'); }
        }
      }
      /* the backboard */
      if (b.vx > 0 && b.y > H.bt - hr * 0.4 && b.y < H.bb + hr * 0.4 && b.x + hr > H.x1 && b.x < H.x1 + 8) {
        b.x = H.x1 - hr; b.vx = -b.vx * 0.55;
        if (now - lastRim > 140 && S.entered) { lastRim = now; SFX.world(SFX.tick); }
      }
      /* through the ring, top to bottom, and only if someone actually took the shot */
      if (b.shot && b.vy > 0 && py < H.y && b.y >= H.y && b.x > H.x0 + 4 && b.x < H.x1 - 4) hoopScoreUp(b);
    }
  }
  for (let i = 0; i < bodies.length; i++) for (let j = i + 1; j < bodies.length; j++) {
    const a = bodies[i], b = bodies[j];
    let dx = b.x - a.x, dy = b.y - a.y;
    const min = a.r + b.r, d2 = dx * dx + dy * dy;
    if (d2 >= min * min || d2 === 0) continue;
    const d = Math.sqrt(d2), nx = dx / d, ny = dy / d, over = min - d;
    const ma = a.held ? 0 : 1, mb = b.held ? 0 : 1, mt = ma + mb || 1;
    a.x -= nx * over * ma / mt; a.y -= ny * over * ma / mt;
    b.x += nx * over * mb / mt; b.y += ny * over * mb / mt;
    const rv = (b.vx - a.vx) * nx + (b.vy - a.vy) * ny;
    if (rv < 0) {
      const jv = -rv * 1.35 / mt;
      a.vx -= nx * jv * ma; a.vy -= ny * jv * ma;
      b.vx += nx * jv * mb; b.vy += ny * jv * mb;
      a.va -= rv * 0.04 * ma; b.va += rv * 0.04 * mb;
    }
  }
  if (grab) slingDraw(grab.b);
  for (let i = 0; i < bodies.length; i++) playRender(bodies[i]);
}
/* letting go: fire it if it was pulled back, otherwise just drop it */
function grabEnd(launch) {
  if (!grab) return;
  const b = grab.b;
  b.held = false; b.el.style.zIndex = ''; b.el.style.cursor = '';
  try { b.el.releasePointerCapture(grab.id); } catch (err) {}
  if (launch && grab.len > 16) {
    const k = LAUNCH / PULL;
    b.vx = -grab.px * k; b.vy = -grab.py * k; b.va = b.vx * 0.14;
    b.shot = true; b.from = grab.ax; b.sv = -9 * (grab.len / PULL);
    playNote.classList.add('done');   /* they have got the idea */
    if (S.entered) SFX.twang();
  }
  sling.classList.remove('on');
  grab = null;
}
ALLB.forEach(b => {
  b.el.addEventListener('pointerdown', e => {
    if (RM || G25.over || b.off) return;
    if (e.button > 0 || e.ctrlKey) return;   /* a right click is not a shot */
    if (grab) grabEnd(false);                 /* a second finger, or a release we never heard about: one ball at a time */
    if (G25.armed) gameGo();
    const r = play.getBoundingClientRect();
    grab = { x: e.clientX - r.left, y: e.clientY - r.top, id: e.pointerId, b: b, ax: b.x, ay: b.y, px: 0, py: 0, len: 0, last: 0 };
    b.held = true; b.gx = grab.x - b.x; b.gy = grab.y - b.y;
    b.el.style.zIndex = 4; b.el.style.cursor = 'grabbing';
    try { b.el.setPointerCapture(e.pointerId); } catch (err) {}
    sling.classList.add('on');
    SFX.click();
    e.preventDefault();
  });
});
/* the pull and the release are heard on the window, so they land wherever the pointer ends up, in every browser */
window.addEventListener('pointermove', e => {
  if (!grab || e.pointerId !== grab.id) return;
  if (e.pointerType === 'mouse' && e.buttons === 0) { grabEnd(true); return; }   /* the button came up somewhere we could not see */
  const r = play.getBoundingClientRect();
  grab.x = e.clientX - r.left; grab.y = e.clientY - r.top;
}, true);
window.addEventListener('pointerup', e => { if (grab && e.pointerId === grab.id) grabEnd(true); }, true);
window.addEventListener('pointercancel', e => { if (grab && e.pointerId === grab.id) grabEnd(false); }, true);
window.addEventListener('blur', () => grabEnd(false));
document.addEventListener('visibilitychange', () => { if (document.hidden) grabEnd(false); });
play.addEventListener('contextmenu', e => { if (e.target.closest('.tk')) e.preventDefault(); });

boardShow();

/* a store form sent from the page the way a person sends one (6 Oct): filled, armed for the store's spam check (it only
   arms a form someone has been in), submitted, and posted into a hidden frame so the page stays where it is */
function sinkSend(sf, fields) {
  if (!sf || !sf.getAttribute('action')) return;
  let sink = document.getElementById('sfSink');
  if (!sink) {
    sink = document.createElement('iframe'); sink.name = sink.id = 'sfSink'; sink.title = 'Sending'; sink.setAttribute('aria-hidden', 'true'); sink.tabIndex = -1;
    sink.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;border:0;visibility:hidden';
    document.body.appendChild(sink);
  }
  sf.querySelectorAll('[data-sf]').forEach(n => n.remove());
  Object.keys(fields).forEach(k => { const v = fields[k]; if (v == null || v === '') return; const i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = String(v); i.setAttribute('data-sf', ''); sf.appendChild(i); });
  sf.target = 'sfSink';
  sinkArm(sf);
  const go = () => { try { if (sf.requestSubmit) sf.requestSubmit(); else sf.submit(); } catch (e) {} };
  const armed = () => sf.dataset.hcaptchaBound || sf.dataset.recaptchaBound;
  if (armed()) go();
  else { const w0 = Date.now(), w = setInterval(() => { if (armed() || Date.now() - w0 > 6000) { clearInterval(w); setTimeout(go, armed() ? 300 : 0); } }, 100); }
  const t0 = Date.now(), watch = setInterval(() => {   /* the store answers with a page: stop it loading in the frame */
    let url = ''; try { url = sink.contentWindow.location.href; } catch (e) { url = 'x'; }
    if (url && url !== 'about:blank') { clearInterval(watch); sf.setAttribute('data-sent', /customer_posted=true|contact_posted=true/.test(url) ? 'ok' : /challenge/.test(url) ? 'challenge' : 'other'); try { sink.contentWindow.stop(); sink.contentWindow.location.replace('about:blank'); } catch (e) {} }
    else if (Date.now() - t0 > 30000) clearInterval(watch);
  }, 60);
}
function sinkArm(sf) { if (sf && !sf.dataset.armed) { sf.dataset.armed = '1'; try { sf.dispatchEvent(new FocusEvent('focusin', { bubbles: true })); sf.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} } }

/* ---------- the 25 second game: beat the clock, win 10% off, get on the board ---------- */
const GAME_CODE = 'HOOPS10';   /* a Shopify discount code (6 Oct) */
const HOUSE = [['Bigfoot', 14], ['The Pigeon', 11], ['Space Skeleton', 9], ['The Pelican', 7], ['The Postie', 5]];   /* the regulars, so the board is never empty */
const gameStart = $('#gameStart'), gameMsg = $('#gameMsg'), count5 = $('#count5'), ledRun = $('#segRun');
const gmK = $('#gmK'), gmScoreP = $('#gmScoreP'), gmLine = $('#gmLine'), gmForm = $('#gmForm'), gmDone = $('#gmDone'), gmList = $('#gmList'), gmAgain = $('#gmAgain'), gmEmailF = $('#gmEmailF');
const gmArt = $('#gmArt');
let boardMem = [], gmMine = 0;
/* 15 Oct (Jos): one board for everyone, kept by our bom-hoops service on Cloudflare. If it can't be reached, the board
   works as it did, on this device. */
const HOOPS = 'https://bom-hoops.jos-866.workers.dev';
let boardRemote = null, hoopsTicket = '', hoopsMine = null;   /* hoopsMine: this player's score the service turned away (27 Oct) */
function boardFetch() {
  if (!window.fetch) return;
  fetch(HOOPS + '/top', { mode: 'cors' }).then(r => r.ok ? r.json() : null).then(d => {
    if (d && Array.isArray(d.rows)) { boardRemote = d.rows.filter(r => r && typeof r.n === 'string' && typeof r.s === 'number'); boardPaint(); }
  }).catch(() => {});
}
function hoopsStart() {
  hoopsTicket = '';
  if (!window.fetch) return;
  fetch(HOOPS + '/start', { method: 'POST', mode: 'cors' }).then(r => r.ok ? r.json() : null).then(d => { if (d && d.g) hoopsTicket = d.g; }).catch(() => {});
}
function boardLoad() {   /* this device's own scores: the board when the shared one can't be reached */
  try {
    const v = JSON.parse(localStorage.getItem('cfl_hoops_v1') || '[]');
    return Array.isArray(v) ? v.filter(r => r && typeof r.n === 'string' && typeof r.s === 'number').slice(0, 30) : [];
  } catch (err) { return boardMem; }
}
function boardSave(rows) { boardMem = rows; try { localStorage.setItem('cfl_hoops_v1', JSON.stringify(rows)); } catch (err) {} }
function boardPaint() {
  const rows = HOUSE.map(h => ({ n: h[0], s: h[1], house: true })).concat(boardRemote ? boardRemote.concat(hoopsMine && !boardRemote.some(r => r.n.toLowerCase() === hoopsMine.n.toLowerCase() && r.s >= hoopsMine.s) ? [hoopsMine] : []) : boardLoad()).sort((a, b) => b.s - a.s || (a.house ? 1 : -1)).slice(0, 8);
  gmList.textContent = '';
  $('#gmFine').textContent = boardRemote ? 'Live: the best score for each name, from everyone who\'s played.' : 'Scores are kept on this device.';
  rows.forEach(r => {
    const li = document.createElement('li'), n = document.createElement('span'), p = document.createElement('b');
    n.textContent = r.n; p.textContent = r.s;
    if (r.house) { const t = document.createElement('i'); t.textContent = 'house'; n.appendChild(t); }
    if (r.t && r.t === gmMine) li.className = 'me';
    li.appendChild(n); li.appendChild(p); gmList.appendChild(li);
  });
}
function gameIdle() {
  G25.armed = G25.on = false; G25.over = 0; G25.left = GAME_SECS;
  play.classList.remove('game', 'time'); ledRun.classList.remove('hot');
  gameStart.disabled = false; gameStart.textContent = 'Play ' + GAME_SECS + ' seconds for 10% off';
  gameMsg.textContent = GAME_SECS + ' seconds on the clock. ' + GAME_TARGET + ' points gets you 10% off.';
  boardShow();
}
function gameArm() {   /* rack the balls up, zero the board, wait for the first shot */
  if (RM) return;
  G25.armed = true; G25.on = false; G25.over = 0; G25.left = GAME_SECS;
  hoopScore = 0; hoopRun = 0; boardShow();
  ledRun.classList.remove('hot'); play.classList.remove('time'); play.classList.add('game');
  bodies.forEach((b, i) => {
    b.x = playW * (0.07 + 0.56 * (i / Math.max(1, bodies.length - 1))); b.y = -b.r - 30 - (i % 3) * 110;
    b.vx = 0; b.vy = 0; b.va = (i % 2 ? -1 : 1) * 60; b.shot = false; b.held = false;
  });
  playNote.classList.add('done');
  gameStart.disabled = true; gameStart.textContent = 'The clock starts on your first shot';
  gameMsg.textContent = GAME_TARGET + ' points gets you 10% off. Far side counts 3.';
  if (S.entered) SFX.whistle();
}
function gameGo() { G25.armed = false; G25.on = true; G25.t0 = performance.now(); gameStart.textContent = 'Go go go'; hoopsStart(); }
function gameStep(now) {
  if (G25.on) {
    const left = GAME_SECS - (now - G25.t0) / 1000, show = Math.max(0, Math.ceil(left));
    if (show !== G25.left) {
      G25.left = show; segSet(segRun, show);
      if (show <= 5 && show > 0) {   /* the last five are loud */
        ledRun.classList.add('hot');
        count5.textContent = show; count5.classList.remove('go'); void count5.offsetWidth; count5.classList.add('go');
        if (S.entered) SFX.beep(show === 1);
      }
    }
    if (left <= 0) {
      G25.on = false; G25.over = now + 1500;   /* a ball already in the air still counts */
      grabEnd(false);
      play.classList.add('time'); gameStart.textContent = 'Full time';
      if (S.entered) SFX.buzzer(1.7);
    }
  } else if (G25.over && now > G25.over) { G25.over = 0; gameEnd(); }
}
function gameEnd() {
  G25.final = hoopScore;
  const won = G25.final >= GAME_TARGET;
  gameOpen(true, won);
  gameIdle();
  if (S.entered) { if (won) { SFX.success(); SFX.three(0, 0.2); } else SFX.close(); }
}
function gameOpen(result, won) {
  gmMine = 0;
  const pts = G25.final;
  gmScoreP.hidden = !result; gmForm.hidden = !result; gmDone.hidden = true;
  gmArt.src = pic(result && won ? 'gm-win' : 'gm-dunk');
  gmArt.classList.toggle('win', !!(result && won));
  if (result) {
    gmK.textContent = 'Full time.';
    $('#gmScore').textContent = pts;
    if (won && LIVE) sinkArm($('#gmStore'));
    gmLine.textContent = won ? (LIVE ? 'That\'s 10% off. Pop your email in and the code is yours, right here.' : 'That\'s 10% off. Tell us where to send it and we\'ll put you on the board.') : pts === 0 ? 'Nothing dropped. ' + GAME_TARGET + ' points gets you 10% off, so go again.' : (GAME_TARGET - pts) + ' short of 10% off. Post your score or go again.';
    gmEmailF.hidden = !won; $('#gmSubmit').textContent = won ? 'Claim my 10% and post my score' : 'Post my score';
    gmForm.dataset.won = won ? '1' : '';
    gmAgain.textContent = 'Go again';
  } else {
    gmK.textContent = 'Beat the clock.';
    gmLine.textContent = GAME_SECS + ' seconds on the clock. ' + GAME_TARGET + ' points gets you 10% off. Shots from the far side count 3.';
    gmAgain.textContent = 'Play';
  }
  boardPaint(); boardFetch();
  openOv('game');
  if (result) setTimeout(() => $('#gmName').focus({ preventScroll: true }), 120);
}
gameStart.addEventListener('click', gameArm);
$('#gameBoard').addEventListener('click', () => gameOpen(false));
gmAgain.addEventListener('click', () => { closeOv(true); Scroll.glide($('#foot').getBoundingClientRect().top + window.scrollY, 500); gameArm(); });
gmForm.addEventListener('submit', e => {
  e.preventDefault();
  const name = $('#gmName').value.trim().slice(0, 18), won = gmForm.dataset.won === '1', email = $('#gmEmail').value.trim();
  if (!name) { SFX.error(); toast('Add a name for the board'); $('#gmName').focus(); return; }
  if (won && !/^\S+@\S+\.\S+$/.test(email)) { SFX.error(); toast('Add an email so we know where to send your 10%'); $('#gmEmail').focus(); return; }
  const sub = $('#gmSubmit');
  if (sub.disabled) return;
  const local = () => { gmMine = Date.now(); hoopsMine = { n: name, s: G25.final, t: gmMine }; boardSave(boardLoad().concat([{ n: name, s: G25.final, t: gmMine }]).sort((a, b) => b.s - a.s).slice(0, 20)); };
  const ticket = hoopsTicket;
  hoopsTicket = '';
  if (ticket && window.fetch) {   /* onto the board everyone sees */
    sub.disabled = true;
    fetch(HOOPS + '/score', { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ g: ticket, n: name, s: G25.final }) })
      .then(r => r.json().catch(() => null)).then(d => {
        sub.disabled = false;
        if (d && d.ok) { boardRemote = d.rows || boardRemote; local(); gmMine = d.t; hoopsMine = null; gmPosted(name, won, email); return; }
        if (d && (d.error === 'rude' || d.error === 'name')) { hoopsTicket = ticket; SFX.error(); toast('Pick another name for the board'); $('#gmName').focus(); return; }
        local(); gmPosted(name, won, email);
      }).catch(() => { sub.disabled = false; local(); gmPosted(name, won, email); });
    return;
  }
  local(); gmPosted(name, won, email);
});
function gmPosted(name, won, email) {
  boardPaint();
  gmForm.hidden = true; gmDone.hidden = false;
  if (won && LIVE) {   /* on the store: the code on the spot, and the email onto the newsletter (6 Oct) */
    sinkSend($('#gmStore'), { 'contact[email]': email, 'contact[first_name]': name.split(' ')[0], 'contact[tags]': 'newsletter, hoops' });
    gmDone.textContent = '';
    const code = document.createElement('b'); code.className = 'gm-code'; code.textContent = GAME_CODE;
    const use = document.createElement('a'); use.className = 'btn gm-use'; use.textContent = 'Use it now';
    use.href = STORE + 'discount/' + GAME_CODE + '?redirect=' + encodeURIComponent('/collections/all-coffee');
    gmDone.append('You\'re on the board, ' + name.split(' ')[0] + '. Your 10% off code: ', code, '. It\'s on your cart the moment you tap this. ', use);
  } else gmDone.textContent = won ? '(concept site, so nothing was sent) You\'re on the board, ' + name.split(' ')[0] + '. On the live site your 10% code would be in your inbox by now.' : 'You\'re on the board, ' + name.split(' ')[0] + '. ' + GAME_TARGET + ' points next time and the 10% is yours.';
  $('#gmEmail').value = '';   /* the email is never kept */
  SFX.success();
}

/* ---------- beep beep: anything with wheels sounds off as it drives past ---------- */
const TOOT = { van: 'beep beep', cab: 'beep beeep', bike: 'ring ring', rover: 'bip bip', tram: 'ding ding' };
const HONKERS = [['.nsb-train', 'tram'], ['.pp-kombi', 'van'], ['.biz-vanfly', 'van'], ['.room-van', 'van'], ['.pp-cab', 'cab'], ['.nsb-cab', 'cab'], ['.sub-rider', 'bike'], ['.rm-rider', 'bike'], ['.pp-rover', 'rover'], ['.hyd-rover', 'rover']]
  .map(h => { const el = $(h[0]); return el && { el: el, kind: h[1], x: null, room: !!el.closest('#room'), hero: !!el.closest('#home'), panel: el.closest('.panel') }; })
  .filter(Boolean);
let honkT = 0;
function honkWatch() {
  const ok = S.entered && !document.hidden && SFX.isOn() && SFX.ambOn(), now = performance.now(), line = S.vw * 0.3;
  HONKERS.forEach(h => {
    const here = ok && (h.room ? S.overlay === 'room' : !S.overlay) && (!h.hero || heroPop);
    const r = here ? h.el.getBoundingClientRect() : null;
    if (!r || !r.width || r.bottom < 60 || r.top > S.vh - 30) { h.x = null; return; }
    const cx = r.left + r.width / 2, was = h.x;
    h.x = cx;
    if (was === null || was >= line || cx < line || cx - was > S.vw * 0.4) return;   /* it has to be seen driving across the line, not just turn up past it */
    if (h.panel) {   /* the blend pages stack: nothing sounds from under the page on top */
      const over = h.panel.nextElementSibling;
      if (over && over.classList.contains('panel') && over.getBoundingClientRect().top < r.top + r.height * 0.6) return;
    }
    if (now - honkT < 2200) return;
    honkT = now;
    SFX.honk(h.kind, cx / S.vw * 2 - 1);
    const tag = document.createElement('b');
    tag.className = 'toot'; tag.textContent = TOOT[h.kind]; tag.setAttribute('aria-hidden', 'true');
    h.el.appendChild(tag);
    setTimeout(() => tag.remove(), 1500);
  });
}
setInterval(honkWatch, 180);

/* ---------- the stepper: up and down through the page for anyone who would rather not scroll ---------- */
const railUp = $('#railUp'), railDown = $('#railDown'), railN = $('#railN');
let STOPS = [0], railGoal = -1, railT = 0, railTry = 0;
function stopsBuild() {
  /* every stop is a view that makes sense on its own: the top of a section, or the end of a tall one sitting flush with the
     bottom of the screen. A tall section is walked top to bottom in even steps, so nothing is skipped and no step lands on a sliver */
  const top = el => Math.round(el.getBoundingClientRect().top + window.scrollY);
  const out = [0], hero = $('#home'), vh = S.vh;
  const flowAt = (t, h) => {
    const over = h - vh;
    out.push(t);
    if (over > vh * 0.2) { const n = Math.ceil(over / (vh * 0.94)); for (let k = 1; k <= n; k++) out.push(Math.round(t + over * k / n)); }
  };
  const flow = el => flowAt(top(el), el.offsetHeight);
  if (hero.offsetHeight > vh * 1.5) out.push(Math.round(Math.min(hero.offsetHeight - vh, vh * 1.75)));
  const wt = top(wheel), wh = wheel.offsetHeight - vh;
  if (!RM && wh > vh) { out.push(wt); [0.302, 0.488, 0.674, 0.86].forEach(q => out.push(Math.round(wt + wh * q))); }   /* the headline, then one stop per card on the wheel */
  else flow(wheel);
  if (S.mobile) { const pk = $('#pick'), d = M.topH - 12; flowAt(top(pk) - d, pk.offsetHeight + d); }   /* as go('pick') on phones */
  else flow($('#pick'));
  /* the blend pages stack and stick, so each is placed by adding up the ones before it; a tall one gets its top and then its
     bottom edge flush with the screen, which is where it holds while the next slides over */
  panelEls.forEach((el, i) => flowAt(panelTop(i) + (S.stacked ? 0 : 2), el.offsetHeight));
  /* phones: a stop on each blend that puts its buy box at the top of the screen, under the header and the blend tabs (6 Oct) */
  if (S.stacked) panelEls.forEach((el, i) => {
    const bx = el.querySelector('.p-buy .buy');
    if (bx) out.push(Math.round(panelTop(i) + bx.getBoundingClientRect().top - el.getBoundingClientRect().top - M.topH - 58));
  });
  ['brewit', 'betty', 'warehouse', 'subscribe', 'word', 'business', 'wild', 'foot'].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    if (id === 'warehouse' && wallPinned && el.offsetHeight > vh * 1.2) { out.push(top(el)); out.push(top(el) + el.offsetHeight - vh); }   /* the near and far ends of the poster wall */
    else flow(el);
  });
  const max = Scroll.max();
  out.push(max);   /* the very bottom, so the footer is never left out */
  STOPS = out.map(y => Math.min(y, max)).sort((a, b) => a - b).filter((y, i, a) => i === 0 || y - a[i - 1] > vh * 0.14 || i === a.length - 1);
  /* the last two can end up almost on top of each other: keep the true bottom */
  if (STOPS.length > 1 && STOPS[STOPS.length - 1] - STOPS[STOPS.length - 2] < vh * 0.14) STOPS.splice(STOPS.length - 2, 1);
}
function railStep(dir) {
  stopsBuild();
  const now = performance.now(), base = now - railT < 1500 && railGoal > -1 && STOPS[railGoal] != null ? STOPS[railGoal] : window.scrollY;
  let k = -1;
  if (dir > 0) { for (let i = 0; i < STOPS.length; i++) if (STOPS[i] > base + 12) { k = i; break; } }
  else { for (let i = STOPS.length - 1; i >= 0; i--) if (STOPS[i] < base - 12) { k = i; break; } }
  if (k < 0) return;
  railGoal = k; railT = now; railTry = 0;
  Scroll.glide(STOPS[k], clamp(260 + Math.abs(STOPS[k] - window.scrollY) * 0.3, 380, 820), true);   /* 6 Oct: off at once, no slow start */
}
/* phones (6 Oct, Jos: the radio sat on the price): while a price or an Add to cart button passes under the radio and the
   arrows, they slip down out of the way and come back once it has gone by. Not straight after a tap on the arrows (they stay
   for the next tap) and not while the radio's card is open. The look is in the styles (html.bar-away, phones only) */
(() => {
  const targets = $$('.buy .price, .buy [data-add], .pick-buy');
  if (!targets.length || !('IntersectionObserver' in window)) return;
  const under = new Set(), root = document.documentElement, plCard = $('#plCard');
  let away = false;
  const paint = () => {
    const want = under.size > 0 && S.mobile && !S.overlay && performance.now() - railT > 1800 && (!plCard || plCard.hidden);
    if (want !== away) { away = want; root.classList.toggle('bar-away', want); }
  };
  const io = new IntersectionObserver(es => { es.forEach(e => { if (e.isIntersecting) under.add(e.target); else under.delete(e.target); }); paint(); }, { rootMargin: '-88% 0px 0px 0px' });
  targets.forEach(t => io.observe(t));
  window.addEventListener('scroll', () => { if (under.size || away) paint(); }, { passive: true });
})();
const blendBar = $('#blendBar'), blendBtns = $$('button', blendBar), blendsEl = $('#blends');
let barOn = false, barAt = -1;
function barPaint() {   /* phones: the three blends stay one tap away for as long as you are among them */
  const r = blendsEl.getBoundingClientRect(), show = S.stacked && !S.overlay && r.top < M.topH + 60 && r.bottom > S.vh * 0.45;
  if (show !== barOn) { barOn = show; blendBar.classList.toggle('on', show); blendBar.inert = !show; }
  if (!show) return;
  let cur = 0;
  panelEls.forEach((el, i) => { if (el.getBoundingClientRect().top < S.vh * 0.5) cur = i; });
  if (cur !== barAt) { barAt = cur; blendBtns.forEach((b, i) => { if (i === cur) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); }); }
}
blendBar.inert = true;
function railPaint() {
  barPaint();
  const y = window.scrollY;
  let n = 0;
  for (let i = 0; i < STOPS.length; i++) if (STOPS[i] <= y + 12) n = i + 1;
  railN.textContent = n + '/' + STOPS.length;
  $('#rail').classList.toggle('first', y < 12 && S.entered);
  railUp.disabled = y < 12; railDown.disabled = STOPS.length > 1 && y > STOPS[STOPS.length - 1] - 12;
  /* once the trip is over, if the page shifted under it (a late image), close the last few pixels */
  if (railGoal > -1 && railTry < 1 && !Scroll.gliding() && performance.now() - railT < 3200) {
    railTry = 1;
    stopsBuild();
    if (STOPS[railGoal] != null && Math.abs(window.scrollY - STOPS[railGoal]) > 6) Scroll.glide(STOPS[railGoal], 420);
  }
}
['wheel', 'touchstart', 'keydown'].forEach(ev => window.addEventListener(ev, () => { railGoal = -1; }, { passive: true }));
railUp.addEventListener('click', () => railStep(-1));
railDown.addEventListener('click', () => railStep(1));

/* ---------- the sneakers on the wire: push them, drag them, let go and they swing ---------- */
const shoes = $$('.nsb-sneak,.pp-sneak').map((el, i) => ({ el: el, img: $('img', el), host: el.closest('#home,.panel'), a: i ? -5 : 6, v: 0, held: false, moved: false, px: 0, py: 0, dx: 0, dy: 0, lt: 0, ph: i * 2.1 }));
shoes.forEach(sh => {
  sh.img.style.animation = 'none';
  sh.el.classList.add('shoe'); sh.el.dataset.cursor = 'Swing';
  sh.el.addEventListener('pointerdown', e => {
    if (RM) return;
    const r = sh.el.getBoundingClientRect();
    sh.px = r.left + r.width / 2; sh.py = r.top;   /* where they hang from */
    sh.held = true; sh.moved = false; sh.dx = e.clientX; sh.dy = e.clientY; sh.lt = performance.now(); sh.v = 0;
    try { sh.el.setPointerCapture(e.pointerId); } catch (err) {}
    SFX.click();
  });
  sh.el.addEventListener('pointermove', e => {
    if (!sh.held) return;
    if (Math.abs(e.clientX - sh.dx) + Math.abs(e.clientY - sh.dy) > 6) sh.moved = true;
    if (!sh.moved) return;
    const now = performance.now(), dt = Math.max(8, now - sh.lt) / 1000;
    const a = clamp(-Math.atan2(e.clientX - sh.px, Math.max(24, e.clientY - sh.py)) * 57.3, -80, 80);
    sh.v = lerp(sh.v, (a - sh.a) / dt, 0.5); sh.a = a; sh.lt = now;
  });
  sh.el.addEventListener('pointerup', e => {
    if (!sh.held) return;
    sh.held = false;
    if (!sh.moved) sh.v += (e.clientX < sh.px ? -1 : 1) * 340;   /* a tap is a shove */
    else sh.v = clamp(sh.v, -720, 720);
    if (S.entered) SFX.spin(0.5);
  });
  sh.el.addEventListener('pointercancel', () => { sh.held = false; });
});
function shoesStep(dt, now) {
  for (let i = 0; i < shoes.length; i++) {
    const sh = shoes[i];
    if (sh.host && sh.host.classList.contains('off')) continue;
    if (sh.held) sh.v *= 0.9;
    else {   /* a pendulum with a little wind on it */
      sh.v += (-900 * Math.sin(sh.a / 57.3) - 0.9 * sh.v + (RM ? 0 : 90 * Math.sin(now / 1300 + sh.ph))) * dt;
      sh.a += sh.v * dt;
    }
    sh.img.style.transform = 'rotate(' + sh.a.toFixed(2) + 'deg)';
  }
}

/* artwork is for looking at: no save menu, no dragging it off the page */
document.addEventListener('contextmenu', e => { if (e.target.closest && e.target.closest('.poster,.box,.frame,.nan,.bz-poster,.p-taste')) e.preventDefault(); });
document.addEventListener('dragstart', e => { if (e.target.tagName === 'IMG') e.preventDefault(); });

/* the court: a how-to card the first time it comes into view this visit; it goes when you grab a ball (6 Oct) */
(function courtTip() {
  const tip = $('#courtTip');
  if (!tip) return;
  let shown = false, gone = false, t = 0;
  const hide = () => { if (gone) return; gone = true; clearTimeout(t); tip.classList.remove('on'); };
  if ('IntersectionObserver' in window) new IntersectionObserver(es => {
    if (es[0].isIntersecting && S.entered && !shown && !gone) { shown = true; tip.classList.add('on'); t = setTimeout(hide, 8000); }
  }, { threshold: 0.35 }).observe(play);
  play.addEventListener('pointerdown', hide, true);
})();

/* ---------- wiring ---------- */
$$('[data-split]').forEach(splitWords);
enhanceMagnets(); enhanceTilt();
renderCart(); calc(); layoutDeck();
paintWorld(BLENDS[0]);
heroInfo(0, true);
root.dataset.blend = 0;
/* stars for the space scenes */
$$('.stars').forEach(box => {
  const cols = ['#F0F0EA', '#C888F8', '#FF69AE', '#F0F0EA', '#A6F53B'];
  const count = (box.closest('.scene') ? 22 : 44) >> (innerWidth <= 700 ? 1 : 0);   /* the hero's space plate already has stars painted in */
  for (let i = 0; i < count; i++) {
    const st = document.createElement('i');
    st.style.left = (Math.random() * 100).toFixed(1) + '%'; st.style.top = (Math.random() * 100).toFixed(1) + '%';
    st.style.setProperty('--s', (6 + Math.random() * 16).toFixed(0) + 'px');
    st.style.setProperty('--c', cols[i % cols.length]);
    st.style.setProperty('--t', (2.4 + Math.random() * 4).toFixed(1) + 's');
    st.style.setProperty('--w', (-Math.random() * 5).toFixed(1) + 's');
    box.appendChild(st);
  }
});
/* tap the world to slap a sticker on it; tap a character and it answers back */
const slapBox = $('#slaps');
const SLAPS = [
  ['el-pe-coconut', 'stk-salt-air', 'el-pe-popcorn', 'el-pe-cereal', 'stk-pack-the-good-stuff', 'stk-up-before-the-sun', 'el-pe-wave', 'stk-special-delivery', 'el-pe-husky', 'stk-rain-or-shine', 'stk-good-things-ahead', 'el-pe-shake'],
  ['el-nsb-vinyl', 'stk-dialled-in', 'el-nsb-orange', 'el-nsb-jaffa', 'el-nsb-sneakers', 'stk-good-company', 'el-nsb-pigeon', 'stk-small-but-mighty', 'stk-follow-your-nose', 'stk-logo-brush', 'el-nsb-hydrant', 'el-nsb-taxi'],
  ['el-hyd-moon', 'stk-far-out', 'el-hyd-malt', 'el-hyd-comet', 'el-hyd-satellite', 'stk-stay-strange', 'stk-logo-for-our-people', 'el-hyd-alien', 'stk-special-delivery', 'stk-curiosity-club', 'stk-good-things-ahead', 'el-hyd-rocket']
];
let slapN = 0;
function clearSlaps() {
  $$('img', slapBox).forEach(im => { im.classList.add('bye'); setTimeout(() => im.remove(), 420); });
}
function slap(x, y) {
  const r = slapBox.getBoundingClientRect(), pool = SLAPS[S.blend];
  const im = document.createElement('img');
  im.src = pic(pool[slapN++ % pool.length]); im.alt = '';
  im.style.left = (x - r.left) + 'px'; im.style.top = (y - r.top) + 'px';
  im.style.setProperty('--s', Math.round(clamp(S.vw * 0.09, 84, 150) * (0.8 + Math.random() * 0.5)) + 'px');
  im.style.setProperty('--r', (Math.random() * 50 - 25).toFixed(1) + 'deg');
  slapBox.appendChild(im);
  const all = $$('img:not(.bye)', slapBox);
  if (all.length > 14) { const old = all[0]; old.classList.add('bye'); setTimeout(() => old.remove(), 420); }
  SFX.slap(); burst(x, y, 5);
}
function poke(el) {
  const target = el.classList.contains('el') ? $('.el-in', el) : el;
  target.classList.remove('poked'); void target.offsetWidth; target.classList.add('poked');
  setTimeout(() => target.classList.remove('poked'), 650);
  SFX.critter(el.dataset.crit);
  burstAt(el, 5);
}
world.addEventListener('click', e => {
  if (!heroPop) return;
  if (e.target.closest('.shoe')) return;   /* the sneakers swing, they don't get a sticker */
  const t = e.target.closest('.tap');
  if (t) { poke(t); return; }
  slap(e.clientX, e.clientY);
});
function burstAt(el, n) { const r = el.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, n); }
wheelDots[0].classList.add('on');
document.body.classList.add('lock');
setInert(true);

/* ---------- links that open a part of this page: /#wholesale, /#quiz, /#audit, /#brew, /#subscribe and the rest.
   They work typed into the address bar, from another page, and from a menu built in Shopify's Navigation. ---------- */
function hashGo(h, first) {
  h = String(h || '').replace(/^#/, '');
  if (h === 'wholesale') { if (S.overlay !== 'room') openOv('room'); }
  else if (/^(formCard|wsForm|wsForm2)$/.test(h)) { if (S.overlay !== 'room') openOv('room'); setTimeout(() => roomGo(h === 'wsForm' ? 'formCard' : h), 350); }
  else if (h === 'quiz') { if (S.overlay !== 'quiz') openOv('quiz'); }
  else if (h === 'audit') { if (!first && Audit) Audit.open(); }       /* on arrival the audit and the timer open themselves */
  else if (h === 'brew') { if (!first) Brew.open(); }
  else if (/^(home|why|pick|buy|blends|brewit|betty|warehouse|subscribe|word|business|wild)$/.test(h)) { if (S.overlay) closeOv(true); go(h); }
  else return false;
  return true;
}
window.addEventListener('hashchange', () => { if (S.entered) hashGo(location.hash); });
document.addEventListener('click', e => {
  const t = e.target;
  const hl = t.closest('a[href*="#"]');
  if (hl && !hl.dataset.go && !hl.dataset.open && !hl.hasAttribute('data-brew') && hl.target !== '_blank') {
    try {
      const u = new URL(hl.getAttribute('href'), location.href);
      if (u.origin === location.origin && u.pathname === location.pathname && u.hash.length > 1 && hashGo(u.hash)) { e.preventDefault(); return; }
    } catch (err) {}
  }
  const pickEl = t.closest('[data-pick]');
  if (pickEl) { go('blends', +pickEl.dataset.pick); return; }
  const goEl = t.closest('[data-go]');
  if (goEl) { e.preventDefault(); go(goEl.dataset.go); return; }
  const op = t.closest('[data-open]');
  if (op) { e.preventDefault(); openOv(op.dataset.open); return; }
  if (t.closest('[data-close]')) { closeOv(); return; }
  const ad = t.closest('[data-add]');
  if (ad) { addToCart(buys[+ad.dataset.add]); return; }
  const qk = t.closest('[data-quick]');
  if (qk) { addToCart(quicks.find(o => o.add === qk)); return; }
  if (t.closest('#actor')) { zoomBag(S.blend); return; }
  if (OV.box.classList.contains('bagzoom') && (t.closest('#boxCard') || t.closest('#boxFlip'))) { flipZoom(); return; }
  if (t.closest('#boxShop')) { closeOv(true); go('blends', S.blend); return; }
  const pk = t.closest('.tap');
  if (pk && !world.contains(pk)) { poke(pk); return; }
  const bf = t.closest('.bagflip');
  if (bf) {
    const on = bf.getAttribute('aria-pressed') !== 'true';
    bf.setAttribute('aria-pressed', String(on));
    $('.flip', bf).classList.toggle('back', on);
    $('.flip-hint', bf).textContent = on ? 'Flip it back' : 'Flip it over';
    SFX.spin(0.7);
    return;
  }
  const bx = t.closest('[data-box]');
  if (bx) {
    if (wallDragged) return;
    const im = $('img', bx), big = $('#boxImg');
    big.src = bx.dataset.box; big.alt = im ? im.alt : '';
    $('#boxCap').textContent = bx.dataset.cap || '';
    /* our nan's photo is a Polaroid on the page, so it comes out as one, with her name written on it */
    const pol = bx.closest('.nan'), note = pol && $('figcaption', pol);
    OV.box.classList.toggle('polaroid', !!pol);
    $('#boxNote').textContent = note ? note.textContent : '';
    openOv('box');
    if (bx.hasAttribute('data-clap')) {   /* Betty has a song of her own: it plays while her picture is out, and the radio steps right back for it */
      const secs = SFX.betty();
      if (secs) Music.duck(secs * 1000 + 400, 0.04);
    }
    return;
  }
  const cp = t.closest('[data-copy]');
  if (cp) {
    const v = cp.dataset.copy;
    const done = ok => { toast(ok ? 'Copied ' + v : 'Copy didn\'t work. Press and hold the text instead.'); if (ok) SFX.toggle(); };
    try { navigator.clipboard.writeText(v).then(() => done(true), () => done(false)); } catch (err) { done(false); }
    return;
  }
  const fq = t.closest('.faq-q');
  if (fq) {
    const item = fq.parentNode, open = !item.classList.contains('open');
    item.classList.toggle('open', open); fq.setAttribute('aria-expanded', String(open));
    if (open) SFX.toggle(); else SFX.close();
    return;
  }
  if (t === OV.box) closeOv();
});
scrim.addEventListener('click', () => closeOv());
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && S.overlay) { if (!(ROOMPAGE && S.overlay === 'room')) closeOv(); return; }
  /* left and right swap the coffee: on the landing while its world is showing, and among the blend pages from one to the next */
  if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && S.entered && !S.overlay && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName) && !document.activeElement.closest('.player,.deck')) {
    const step = e.key === 'ArrowRight' ? 1 : -1, br = blendsEl.getBoundingClientRect();
    if (br.top < S.vh * 0.5 && br.bottom > S.vh * 0.5) {
      let cur = 0;
      panelEls.forEach((el, i) => { if (el.getBoundingClientRect().top < S.vh * 0.5) cur = i; });
      go('blends', (cur + step + 3) % 3);
    } else if (uiLive) setBlend(S.blend + step);
  }
});

$('#cueBtn').addEventListener('click', () => railStep(1));
$('#swPrev').addEventListener('click', () => setBlend(S.blend - 1));
$('#swNext').addEventListener('click', () => setBlend(S.blend + 1));
cartBtn.addEventListener('click', () => { openOv('cart'); if (LIVE) storeSync().catch(() => {}); });
/* checkout. As a concept it stops here. Inside the Shopify theme (window.CFL.shop is the store root) the same cart goes
   to the store's own cart as real lines, subscriptions included, and then on to the store's checkout */
const checkoutBtn = $('#checkoutBtn'), LIVE = typeof CFG.shop === 'string', STORE = LIVE ? CFG.shop.replace(/\/*$/, '/') : '';
if (LIVE) {
  root.classList.add('live');
  const fine = $('#cartFine');
  fine.textContent = 'Flat rate shipping $9.95 Australia-wide. Free over $90.';
  /* the drawer shows the store's cart, so what was added on another page or an earlier visit is here too (6 Oct) */
  storeSync().catch(() => {});
  window.addEventListener('pageshow', e => { if (e.persisted) storeSync().catch(() => {}); });
}
checkoutBtn.addEventListener('click', () => {
  SFX.toggle();
  if (!cart.length) { toast('Nothing in the cart yet'); return; }
  if (!LIVE) { toast('Concept site. Checkout isn\'t connected.'); return; }
  checkoutBtn.disabled = true; checkoutBtn.textContent = 'Taking you to checkout';
  storeQ.then(() => location.assign(STORE + 'checkout'));   /* everything is already in the store's cart: wait for the last add, then go */
});
window.addEventListener('pageshow', e => { if (e.persisted) { checkoutBtn.disabled = false; checkoutBtn.textContent = 'Checkout'; } });   /* back from checkout */
$('#subBtn').addEventListener('click', () => { syncBuy('plan', 'sub'); go('blends', S.blend); toast('Subscription is on. Pick your blend.'); });
/* the two switches in the bar (6 Oct): the scene sound and the clicks, each on its own. Either one wakes the sound up;
   with both off it goes quiet altogether */
function soundPart(which, want) {   /* which: 'amb', 'fx', 'clock' (the shot clock's Beeps), or 'rest' (just settle) */
  const was = SFX.isOn();
  if (which === 'amb') SFX.setAmb(want); else if (which === 'fx') SFX.setFx(want); else if (which === 'clock') SFX.setClock(want);
  if (want && !was) {
    if (which !== 'amb') SFX.setAmb(false);   /* the others stay off, as the bar shows them */
    if (which !== 'fx') SFX.setFx(false);
    mutedAll = false; Music.el.muted = false;
    if (!soundSet(true)) return;
  }
  if (!want && !SFX.ambOn() && !SFX.fxOn()) soundSet(false);
  SFX.toggle(); soundUI();
}
/* the one speaker button (8 Oct): the scene sound and the clicks together */
function soundAll(want) {
  if (want) { SFX.setAmb(true); SFX.setFx(true); mutedAll = false; Music.el.muted = false; if (!soundSet(true)) return; }
  else { SFX.setAmb(false); SFX.setFx(false); soundSet(false); }
  SFX.toggle(); soundUI();
}
soundBtn.addEventListener('click', () => soundAll(!(SFX.isOn() && (SFX.ambOn() || SFX.fxOn()))));
/* the sound offer after a quiet walk-in (8 Oct): on the speaker button, or above the radio on a phone. "Nah" is remembered
   for a month in this browser */
const NAH_KEY = 'cfl-sound-nah';
let nudgeT = 0;
function nudgeNah() { try { return Date.now() - (+localStorage.getItem(NAH_KEY) || 0) < 30 * 864e5; } catch (e) { return false; } }
function nudgeHide() { clearTimeout(nudgeT); nudge.classList.remove('on'); }
function nudgeShow() {
  if (nudgeNah() || SFX.isOn() || ROOMPAGE) return;
  const b = soundBtn.getBoundingClientRect(), nav = nudge.offsetParent ? nudge.offsetParent.getBoundingClientRect() : null;
  if (b.width && nav && getComputedStyle(nudge).position === 'absolute') {
    nudge.style.right = Math.max(8, nav.right - b.right - 4) + 'px';
    nudge.style.setProperty('--ar', Math.max(8, b.width / 2 - 4) + 'px');
  } else { nudge.style.right = ''; nudge.style.removeProperty('--ar'); }
  nudge.classList.add('on'); clearTimeout(nudgeT); nudgeT = setTimeout(nudgeHide, 15000);
}
$('#nudgeOn').addEventListener('click', e => {
  nudgeHide(); soundAll(true);
  if (!SFX.isOn()) return;
  SFX.boom(); if (e.clientX) burst(e.clientX, e.clientY, 10);
  if (!Music.resume()) setTimeout(() => { if (!Music.isPlaying()) askShow(); }, RM ? 300 : 1500);
});
$('#nudgeNah').addEventListener('click', () => { nudgeHide(); try { localStorage.setItem(NAH_KEY, String(Date.now())); } catch (e) {} });
fxBtn.addEventListener('click', () => soundPart('fx', !(SFX.isOn() && SFX.fxOn())));
$('#revPrev').addEventListener('click', prevRev);
$('#revNext').addEventListener('click', () => nextRev(-1));
deck.addEventListener('keydown', e => { if (e.key === 'ArrowRight') nextRev(-1); else if (e.key === 'ArrowLeft') prevRev(); });

cups.addEventListener('input', () => { calc(); SFX.slide((+cups.value - 80) / 520); });
wsForm.addEventListener('submit', e => {
  if (!$('#wName')) return;                                   /* on the store, after sending, the form is just the thank you */
  const name = $('#wName').value.trim(), mobile = $('#wMobile').value.trim(), email = $('#wEmail').value.trim();
  if (!name) { e.preventDefault(); SFX.error(); toast('Add your name so we know who to ask for'); $('#wName').focus(); return; }
  if (!mobile && !email) { e.preventDefault(); SFX.error(); toast('Add a mobile or an email so we can reply'); $('#wMobile').focus(); return; }
  if (LIVE) {
    /* the store's form needs an email to accept it */
    if (!/^\S+@\S+\.\S+$/.test(email)) { e.preventDefault(); SFX.error(); toast('Pop your email in as well, so the form can reach us'); $('#wEmail').focus(); return; }
    const r = $('#wReply'); if (r) r.value = { text: 'Text me', email: 'Email me', call: 'Call me' }[segReply.value] || segReply.value;
    $('button[type="submit"]', wsForm).textContent = 'Sending';
    return;
  }
  e.preventDefault();
  $('#wsHello').textContent = 'We got you, ' + name.split(' ')[0] + '.';
  wsForm.hidden = true; wsSent.hidden = false;
  SFX.success();
});
$('#wsAgain').addEventListener('click', () => { wsForm.reset(); wsSent.hidden = true; wsForm.hidden = false; segReply.place(); });
const wsForm2 = $('#wsForm2'), wsSent2 = $('#wsSent2');
wsForm2.addEventListener('submit', e => {
  if (!$('#w2Name')) return;
  const name = $('#w2Name').value.trim(), contact = $('#w2Contact').value.trim();
  if (!name) { e.preventDefault(); SFX.error(); toast('Add your name so we know who to ask for'); $('#w2Name').focus(); return; }
  if (!/^\S+@\S+\.\S+$/.test(contact)) { e.preventDefault(); SFX.error(); toast('Add your email so we can reply'); $('#w2Contact').focus(); return; }
  if (LIVE) { $('button[type="submit"]', wsForm2).textContent = 'Sending'; return; }
  e.preventDefault();
  $('#wsHello2').textContent = 'We got you, ' + name.split(' ')[0] + '. On the live site we\'d be in touch within 24 hours.';
  wsForm2.hidden = true; wsSent2.hidden = false;
  SFX.success();
});
$('#wsAgain2').addEventListener('click', () => { wsForm2.reset(); wsSent2.hidden = true; wsForm2.hidden = false; });
$('#newsForm').addEventListener('submit', e => {
  const box = $('#newsEmail'), v = box ? box.value.trim() : '';
  if (!/^\S+@\S+\.\S+$/.test(v)) { e.preventDefault(); SFX.error(); toast('That email doesn\'t look right. Check it and try again.'); return; }
  if (LIVE) return;                                    /* on the store this is the store's own sign-up form, and it takes it from here */
  e.preventDefault();
  SFX.success(); toast('Concept site. Nothing was sent.'); e.target.reset();
});

/* pointer: custom cursor, hover and press sounds */
const cursorEl = $('#cursor'), cLab = $('#cLab');
let cOn = false, rx = 0, ry = 0, lastHot = null;
window.addEventListener('pointermove', e => {
  S.px = e.clientX / S.vw * 2 - 1; S.py = e.clientY / S.vh * 2 - 1;
  if (e.pointerType !== 'mouse' || !FINE) return;
  S.mx = e.clientX; S.my = e.clientY;
  cOn = true;
  cursorEl.style.transform = 'translate3d(' + S.mx + 'px,' + S.my + 'px,0)';   /* pinned to the arrow, no lag */
}, { passive: true });
window.addEventListener('pointerdown', e => {
  cursorEl.classList.add('down');
  const hot = e.target.closest && e.target.closest('a,button');
  if (hot && !hot.disabled) { SFX.click(); if (hot.matches('.btn')) burst(e.clientX, e.clientY); }
}, true);
window.addEventListener('pointerup', () => cursorEl.classList.remove('down'), true);
document.addEventListener('mouseover', e => {
  const t = e.target.closest ? e.target : null;
  if (!t) return;
  const hot = t.closest('a,button,input,.faq-q,.tk');
  const lab = t.closest('[data-cursor]');
  if (hot && hot !== lastHot) SFX.tick();
  lastHot = hot;
  const useLab = !!lab && (!hot || hot === lab || lab.contains(hot) && hot.matches('.frame-in,.fan-card,.bagflip'));
  cursorEl.classList.toggle('lab', useLab && cOn);
  if (lab) cLab.textContent = lab.dataset.cursor;
});
document.addEventListener('mouseleave', () => { cOn = false; cursorEl.classList.remove('lab'); });

/* the blend pages are cards stacked on each other: a page the next one has slid over is still "on screen" underneath, so
   whether its pieces pop in is worked out from how much of it is really showing (7 Oct, Jos: they popped in on Hyperdrive
   but not on the other two) */
let panelPopLive = false;
const panelPopOn = panelEls.map(() => false);
function panelPops(st, vh) {
  const near = st.top < vh && st.bottom > 0;
  const rs = near ? panelEls.map(el => el.getBoundingClientRect()) : null;
  panelEls.forEach((el, i) => {
    let pop = false;
    if (near) {
      const r = rs[i], top = Math.max(0, r.top), bot = Math.min(vh, r.bottom, i < rs.length - 1 ? rs[i + 1].top : Infinity);
      const shown = Math.max(0, bot - top);
      pop = S.stacked ? shown > 40 : shown >= r.height * 0.39;
    }
    if (pop !== panelPopOn[i]) { panelPopOn[i] = pop; el.classList.toggle('pop', pop); }
  });
}

/* things that switch on when they scroll into view */
if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -12% 0px' });
  $$('[data-rv],[data-split],[data-draw]').forEach(el => io.observe(el));
  /* 15 Oct (Jos): the counter runs off the clock in Perth, during roasting hours; off hours Betty rests */
  const RC = (() => {
    const DAY = 864e5, OPEN = 8 * 3600e3, SHUT = 16 * 3600e3, PERTH = 8 * 3600e3;
    const B0 = 1494560000, RATE = 4 / 45, A_AT = Date.UTC(2026, 9, 15, 14, 15);   /* A_AT: Perth wall time, kept as UTC */
    const OFF = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-01-26', '2027-03-01', '2027-03-26', '2027-03-29', '2027-04-26', '2027-06-07', '2027-09-27', '2027-12-27', '2027-12-28'];
    const WD = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const roastDay = d0 => { const d = new Date(d0), w = d.getUTCDay(); return w > 0 && w < 6 && OFF.indexOf(d.toISOString().slice(0, 10)) < 0; };
    let baseDay = -1, baseMs = 0;   /* roasting time from the anchor to the start of today, worked out once a day */
    return now => {
      const t = Math.max(A_AT, now + PERTH), day = t - t % DAY, tod = t - day;
      if (day !== baseDay) {
        baseDay = day; baseMs = 0;
        for (let d0 = A_AT - A_AT % DAY; d0 < day; d0 += DAY) if (roastDay(d0)) baseMs += Math.max(0, d0 + SHUT - Math.max(d0 + OPEN, A_AT));
      }
      const today = roastDay(day), from = Math.max(day + OPEN, A_AT), to = Math.min(day + SHUT, t);
      const ms = baseMs + (today && to > from ? to - from : 0);
      let nx = day + (today && tod < OPEN ? 0 : DAY); while (!roastDay(nx)) nx += DAY;
      const when = nx === day ? '8am' : nx === day + DAY ? '8am tomorrow' : '8am ' + WD[new Date(nx).getUTCDay()];
      return { beans: B0 + ms * RATE, open: today && tod >= OPEN && tod < SHUT, today: today, after: today && tod >= SHUT, when: when, weekend: !today && (new Date(day).getUTCDay() % 6 === 0) };
    };
  })();
  const beansN = $('#beansN'), rcCups = $('#rcCups'), rcNight = $('#rcNight'), rcNightT = $('#rcNightT');
  let beanT = 0, rcWas = '';
  function rcPaint() {
    const r = RC(Date.now()), night = !r.open;
    beansN.textContent = Math.floor(r.beans).toLocaleString('en-AU');
    rcCups.textContent = (Math.round(r.beans / 160000) * 1000).toLocaleString('en-AU');
    const say = r.after ? (r.when === '8am tomorrow' ? 'Roasting\'s done for the day. Now we rest, recover and plan tomorrow. The fire\'s back on at 8am.' : 'Roasting\'s done for the week. Now we rest, recover and plan what\'s next. The fire\'s back on at ' + r.when + '.')
      : r.today ? 'Rested, recovered and today\'s roasts are planned. The fire\'s back on at 8am.'
      : r.weekend ? 'Weekend off. We rest, recover and plan the week ahead. The fire\'s back on at ' + r.when + '.'
      : 'Public holiday, so we rest, recover and plan what\'s next. The fire\'s back on at ' + r.when + '.';
    if (rcWas !== say) { rcWas = say; rcNightT.textContent = say; }
    if (betty.classList.contains('night') !== night) { betty.classList.toggle('night', night); rcNight.hidden = !night; }
  }
  rcPaint();
  new IntersectionObserver(es => {
    clearInterval(beanT);
    if (es[0].isIntersecting) { rcPaint(); beanT = setInterval(rcPaint, RM ? 30000 : 180); }
  }).observe(betty);
  new IntersectionObserver(es => { playLive = es[0].isIntersecting; }).observe(play);
  /* anything off screen stops animating: it saves a phone a lot of work */
  const rest = new IntersectionObserver(es => es.forEach(en => en.target.classList.toggle('off', !en.isIntersecting)), { rootMargin: '25% 0px 25% 0px' });
  $$('#home,#why,#pick,.panel,#betty,#warehouse,#subscribe,#word,#business,#wild,#foot').forEach(el => rest.observe(el));
  /* the van sets off as the wholesale section arrives, not whenever its loop happens to come round */
  const van = $('.biz-vanfly');
  new IntersectionObserver(es => { if (es[0].isIntersecting && !RM) { van.style.animation = 'none'; void van.offsetWidth; van.style.animation = ''; } }, { threshold: 0.15 }).observe($('#business'));
  /* stacked panels are taller than the window, so "40% showing" can be false while you are looking right at the scenery */
  /* the blend pages pop their pieces in from the frame loop (panelPops), which knows when one is covered by the next */
  panelPopLive = true;
} else {
  $$('[data-rv],[data-split],[data-draw]').forEach(el => el.classList.add('in')); playLive = true; panelEls.forEach(el => el.classList.add('pop'));
}

let rzT = 0, rzOn = false, anchor = null, anchorRaf = 0;
/* browser zoom is a resize: keep the reader in the same part of the page, the same distance through it */
const ANCHOR_IDS = ['brewit', 'betty', 'warehouse', 'subscribe', 'word', 'business', 'wild', 'foot'];
function natTop(el) {
  const i = panelEls.indexOf(el);
  return i > -1 ? panelTop(i) : el.getBoundingClientRect().top + window.scrollY;   /* the blend pages stick, so add them up */
}
function anchorTake() {
  if (rzOn || !S.entered || S.overlay) return;
  const y = window.scrollY, mid = y + window.innerHeight * 0.5;
  let best = null;
  [$('#home'), wheel, $('#pick')].concat(panelEls, ANCHOR_IDS.map(id => document.getElementById(id))).forEach(el => {
    if (!el || !el.offsetHeight) return;
    const t = natTop(el), h = el.offsetHeight;
    if (t <= mid && t + h > mid) best = { el: el, f: (y - t) / h, w: window.innerWidth };   /* later (stacked on top) wins */
  });
  anchor = best;
}
window.addEventListener('scroll', () => { if (!anchorRaf) anchorRaf = requestAnimationFrame(() => { anchorRaf = 0; anchorTake(); }); }, { passive: true });
window.addEventListener('resize', () => {
  rzOn = true;
  clearTimeout(rzT);
  rzT = setTimeout(() => {
    measure(false);
    requestAnimationFrame(() => {
      if (anchor && anchor.w !== window.innerWidth && S.entered && !S.overlay && anchor.el.isConnected) {
        window.scrollTo(0, Math.max(0, Math.round(natTop(anchor.el) + anchor.f * anchor.el.offsetHeight)));
      }
      stopsBuild(); railPaint();
      rzOn = false; anchorTake();
    });
  }, 150);
});
window.addEventListener('load', () => measure(true));
if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => measure(true));
measure(true);

/* ---------- the frame loop ---------- */
let lastT = performance.now(), frameN = 0, lean = 0, tiltX = 0, tiltY = 0, wheelAt = 0, uiLive = false, actorOn = null, actorTap = null, actorOver = false, parX = 0, parY = 0;
function loop(now) {
  requestAnimationFrame(loop);
  const dt = Math.min(0.05, Math.max(0.001, (now - lastT) / 1000)); lastT = now; frameN++;
  try {
    Scroll.update(dt);
    const y = window.scrollY, vh = S.vh, vw = S.vw;
    S.vel = lerp(S.vel, y - S.y, 0.2); S.y = y;

    const hr = hero.getBoundingClientRect(), wr = wheel.getBoundingClientRect(), st = stackEl.getBoundingClientRect();
    if (panelPopLive) panelPops(st, vh);
    const hp = clamp(-hr.top / Math.max(1, hr.height - vh), 0, 1);
    const win = clamp(1 - wr.top / vh, 0, 1);
    const e1 = ease(seg(hp, 0.03, 0.52));

    /* hero: the type opener, then the blend's colour world rises over it */
    if (hr.bottom > -40) {
      world.style.setProperty('--rise', ((1 - e1) * 96).toFixed(2) + '%');
      hType.style.transform = 'translate3d(0,' + (-e1 * vh * 0.2).toFixed(1) + 'px,0)';
      hL1.style.transform = 'translate3d(' + (-e1 * vw * 0.07).toFixed(1) + 'px,0,0)';
      hL2.style.transform = 'translate3d(' + (e1 * vw * 0.07).toFixed(1) + 'px,0,0)';
      const pop = hp > 0.4 && hr.bottom > vh * 0.35;
      if (pop !== heroPop) {
        heroPop = pop;
        scenes[S.blend].classList.toggle('pop', pop); fronts[S.blend].classList.toggle('pop', pop);
        if (pop && S.entered) SFX.world(SFX.pop);
      }
      if (!RM) {
        parX = damp(parX, S.px, 4, dt); parY = damp(parY, S.py, 4, dt);
        heroPin.style.setProperty('--px', parX.toFixed(3)); heroPin.style.setProperty('--py', parY.toFixed(3));
        heroFront.style.setProperty('--px', parX.toFixed(3)); heroFront.style.setProperty('--py', parY.toFixed(3));
      }
      const gx = ((y * 0.45 + (RM ? 0 : now * 0.03)) % M.ghostW);
      wGhost.style.transform = 'translate3d(' + (-gx).toFixed(1) + 'px,0,0)';
      const ui = seg(hp, 0.42, 0.58);   /* the picker comes up as the bag lands in the scene */
      heroUi.style.setProperty('--ui', ui.toFixed(3));
      if ((ui > 0.6) !== uiLive) { uiLive = ui > 0.6; heroUi.inert = !uiLive; if (uiLive) swNote.classList.add('in'); }
      const cq = seg(hp, 0, 0.05);
      cue.style.setProperty('--cue', cq.toFixed(2));
      cue.classList.toggle('gone', cq >= 1);
      hFind.style.setProperty('--cue', cq.toFixed(2)); hFind.classList.toggle('gone', cq >= 1);   /* "Find your coffee" goes with the cue */
    } else if (!hFind.classList.contains('gone')) hFind.classList.add('gone');

    /* the bag travels: opener -> colour world -> under the wheel */
    const on = RM ? win < 0.15 : st.top > 1;
    if (on !== actorOn) { actorOn = on; actor.classList.toggle('on', on); }
    const tapme = on && e1 > 0.97 && win < 0.03 && !S.overlay;
    if (tapme !== actorTap) { actorTap = tapme; actor.classList.toggle('tapme', tapme); actor.dataset.cursor = tapme ? 'Zoom' : ''; actor.setAttribute('aria-hidden', String(!tapme)); }
    if (on) {
      const e2 = ease(win), k0 = M.k0, k1 = M.k1, k2 = M.k2;
      let cx = lerp(k0.x, k1.x, e1), cy = lerp(k0.y, k1.y, e1), sc = lerp(k0.s, k1.s, e1);
      let rot = RM ? 0 : lerp(-7, 5, e1) + Math.sin(Math.PI * e1) * -22;
      if (win > 0) {
        cx = lerp(cx, k2.x, e2); cy = lerp(cy, k2.y, e2); sc = lerp(sc, k2.s, e2);
        if (!RM) rot = lerp(rot, -3, e2) + Math.sin(Math.PI * e2) * 16;
        if (wr.top < 0) cy += wr.top;
      }
      if (!RM) {
        lean = damp(lean, clamp(S.vel * 0.12, -7, 7), 6, dt);
        rot += lean;
        cy += Math.sin(now / 950) * 5;
        tiltX = damp(tiltX, S.px * 9, 5, dt); tiltY = damp(tiltY, -S.py * 7, 5, dt);
        aTilt.style.transform = 'rotateX(' + tiltY.toFixed(2) + 'deg) rotateY(' + tiltX.toFixed(2) + 'deg)';
      }
      actor.style.transform = 'translate3d(' + (cx - M.W / 2).toFixed(1) + 'px,' + (cy - M.H / 2).toFixed(1) + 'px,0) rotate(' + rot.toFixed(2) + 'deg) scale(' + sc.toFixed(4) + ')';
      /* the next section's zigzag rises over the wheel's last --sawh: once its teeth would reach the bag, the bag is drawn in
         front of that section, so it is never cut (6 Oct) */
      const over = win > 0.5 && cy + M.H * sc / 2 + 14 > wr.bottom - clamp(vw * 0.05, 26, 74);
      if (over !== actorOver) { actorOver = over; actor.classList.toggle('over', over); }
    } else if (actorOver) { actorOver = false; actor.classList.remove('over'); }

    /* the wheel (6 Oct): one screen that turns by itself. The heading swings away and the four cards swing through */
    if (!RM && wr.top < vh && wr.bottom > 0) {
      const seen = wr.top < vh * 0.5 && wr.bottom > vh * 0.5;
      if (!seen && wr.top > vh * 0.75 && WH.to < 0) WH.at = 0;   /* scrolled back up above it: it starts again from the heading */
      const w = wheelTurn(now, seen);
      wheelHead.style.transform = 'rotate(' + w.h.toFixed(2) + 'deg)';
      if (seen !== wheelPop) { wheelPop = seen; wheelPin.classList.toggle('pop', seen); }
      const A = S.mobile ? 34 : 30;
      for (let i = 0; i < wcards.length; i++) {
        const ang = (i - w.t) * A;
        wcards[i].style.transform = 'rotate(' + ang.toFixed(2) + 'deg)';
        wcards[i].style.visibility = Math.abs(ang) > 80 ? 'hidden' : '';
      }
      const at = clamp(Math.round(w.t), 0, 3);
      if (at !== wheelAt) { wheelDots[wheelAt].classList.remove('on'); wheelDots[at].classList.add('on'); wheelAt = at; }
      const wantBack = w.t > 2.45 && w.t < 3.6;   /* the last card is about what's printed on the back, so the bag turns round */
      if (wantBack !== back) { back = wantBack; flipSet(); if (S.entered && seen) SFX.world(() => SFX.spin(0.6)); }
    } else if (back && (wr.top >= vh || wr.bottom <= 0)) { back = false; flipSet(); }

    /* blend panels: ghost names drift, art lags, each panel sinks a little as the next one covers it */
    for (let i = 0; i < panels.length; i++) {
      const p = panels[i], r = p.el.getBoundingClientRect();
      if (r.top > vh || r.bottom < 0) continue;
      p.ghost.style.transform = 'translate3d(' + (-((y * 0.4) % p.gw)).toFixed(1) + 'px,0,0)';
      if (RM) continue;
      const c = clamp(r.top / vh, -1, 1);
      p.art.style.transform = 'translate3d(0,' + (c * 70).toFixed(1) + 'px,0) rotate(' + (c * -10).toFixed(2) + 'deg)';
      /* phones (7 Oct): the bag only rocks a little, so it never drifts onto its badge or its tasting stickers */
      p.bag.style.transform = S.stacked ? 'rotate(' + (c * 3).toFixed(2) + 'deg)' : 'translate3d(0,' + (c * 120).toFixed(1) + 'px,0) rotate(' + (c * 9).toFixed(2) + 'deg)';
      if (!S.stacked && i < 2) {
        const cv = clamp(1 - panels[i + 1].el.getBoundingClientRect().top / vh, 0, 1);
        p.inner.style.transform = cv > 0 ? 'translate3d(0,' + (-cv * 4).toFixed(2) + 'vh,0) scale(' + (1 - cv * 0.07).toFixed(4) + ')' : '';
      } else if (p.inner.style.transform) p.inner.style.transform = '';
    }

    /* poster wall: drifts along while it is on screen */
    wallStep(dt, vh);

    /* the hand of bags opens as it arrives */
    const sr = subEl.getBoundingClientRect();
    if (sr.top < vh && sr.bottom > 0) {
      const fa = fan.getBoundingClientRect();
      fan.style.setProperty('--o', (RM ? 1 : clamp((vh * 0.98 - fa.top) / (vh * 0.6), 0, 1)).toFixed(3));
    }

    /* business photo drifts inside its frame */
    const pr = bizPic.parentNode.getBoundingClientRect();
    if (pr.top < vh && pr.bottom > 0 && !RM) bizPic.style.transform = 'translate3d(0,' + (((pr.top + pr.height / 2 - vh / 2) / vh) * -34).toFixed(1) + 'px,0)';

    /* marquees speed up with the scroll */
    for (let k = 0; k < mqs.length; k++) {
      const m = mqs[k];
      if (!m.vis) continue;
      if (!RM) m.x += m.dir * (46 + Math.abs(S.vel) * 9) * dt;
      const o = ((m.x % m.w) + m.w) % m.w, tr = 'translate3d(' + (-o).toFixed(1) + 'px,0,0)';
      for (let j = 0; j < m.kids.length; j++) m.kids[j].style.transform = tr;
    }

    if (frameN % 12 === 0) { if (frameN % 120 === 0) stopsBuild(); railPaint(); }
    shoesStep(Math.min(dt, 1 / 30), now);
    gameStep(now);

    /* footer stickers */
    if (playLive && !RM) {
      if (!playDropped) playDrop();
      try { playStep(Math.min(dt, 1 / 30), now); }
      catch (err) { grab = null; ALLB.forEach(b => { b.held = false; }); sling.classList.remove('on'); }   /* never let one bad frame freeze the court */
    }

    /* the logo and nav flip for dark sections */
    if (frameN % 3 === 0 || navDark === null) {
      let dark = false;
      const ny = M.topH * 0.62;
      for (let i = 0; i < darkEls.length; i++) {
        const r = darkEls[i].getBoundingClientRect();
        if (r.top <= ny && r.bottom >= ny) { dark = true; break; }
      }
      if (!dark && world.dataset.nav === 'dark') { const r = world.getBoundingClientRect(); dark = r.top <= ny && r.bottom >= ny; }
      if (dark !== navDark) { navDark = dark; navEl.classList.toggle('dark', dark); }
    }

    /* which place are we standing in: that decides the background sound */
    if (now - ambT > 220 && S.entered) {
      ambT = now;
      let amb = 'none';
      if (S.overlay === 'room') amb = 'cafe';
      else {
        const mid = vh * 0.5;
        for (let i = 0; i < ambEls.length; i++) {
          const r = ambEls[i].getBoundingClientRect();
          if (r.top <= mid && r.bottom >= mid) amb = ambEls[i].dataset.amb;   /* later (stacked-on-top) sections win */
        }
        if (amb === 'blend') amb = AMB_OF[S.blend];   /* the opener already sounds like the coffee that's showing */
      }
      setAmb(amb);
    }

    /* 9 Oct (Jos): no scroll wind */
  } catch (err) {
    if (!loop.said) { loop.said = true; console.error(err); }
  }
}
requestAnimationFrame(loop);

/* ---------- loader: our lines flick past while it loads, then you choose sound or quiet ---------- */
(function boot() {
  const loader = $('#loader'), numEl = $('#ldNum'), word = $('#ldWord'), enter = $('#ldEnter');
  const LINES = [
    ['Brew wild.', '#111A37', '#FF69AE'], ['Keep exploring.', '#C888F8', '#111A37'], ['Take the long way.', '#8CCDE3', '#111A37'],
    ['Come say g\'day.', '#F27B20', '#111A37'], ['Bean me up.', '#FF69AE', '#111A37'], ['Hang with BOM.', '#F0F0EA', '#111A37']
  ];
  const first = ROOMPAGE ? ['logo-ink', 'logo-solid'] : ['logo-ink', 'logo-solid', 'bag-pe-front', 'bag-pe-back', 'wd-pe-plate', 'wd-pe-dunes', 'wd-pe-surf', 'sc-pe-palm', 'sc-pe-sun', 'sc-pe-surfer', 'sc-pe-gull', 'el-pe-cereal', 'el-pe-shake', 'el-pe-popcorn', 'sc-pe-gull2', 'sc-pe-pelican', 'sc-pe-crab', 'sc-pe-dolphin'];
  const later = ['bag-nsb-front', 'bag-nsb-back', 'bag-hyd-front', 'bag-hyd-back', 'wd-nsb-plate', 'wd-nsb-left', 'wd-nsb-right', 'wd-nsb-street', 'wd-hyd-plate', 'wd-hyd-ground', 'sc-nsb-boombox', 'sc-nsb-bboy', 'sc-nsb-sign', 'sc-nsb-subway', 'sc-nsb-taxi', 'sc-nsb-vinyl', 'sc-nsb-sneakers', 'el-nsb-jaffa', 'el-nsb-shake', 'el-nsb-orange', 'sc-nsb-pigeon',
    'sc-hyd-planet', 'sc-hyd-moon', 'sc-hyd-ufo', 'sc-hyd-astro', 'sc-hyd-fighter', 'sc-hyd-rocket', 'sc-hyd-comet', 'sc-hyd-satellite', 'el-hyd-honey', 'el-hyd-choc', 'el-hyd-malt', 'sc-hyd-alien', 'sc-nsb-cart', 'sc-nsb-bigfoot', 'sc-hyd-rover'];
  /* been in already this session (the logo, Home, a link back): no loading screen, straight in */
  const BACK = document.documentElement.classList.contains('cfl-back');
  const total = first.length + 1, t0 = performance.now(), MIN = RM || ROOMPAGE || BACK ? 0 : 2700;
  let done = 0, shown = 0, ready = false, line = 0, lineT = 0;
  first.forEach(n => { const im = new Image(); im.onload = im.onerror = () => { done++; }; im.src = pic(n); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { done++; }, () => { done++; }); else done++;
  setTimeout(() => { done = total; }, 7000);
  function paint(l) {
    loader.style.setProperty('--lb', l[1]); loader.style.setProperty('--lf', l[2]);
    word.textContent = l[0];
    word.classList.remove('hit'); void word.offsetWidth; word.classList.add('hit');
  }
  function nextLine() {
    if (ready) return;
    line++;
    if (line < LINES.length) { paint(LINES[line]); lineT = setTimeout(nextLine, 430); }
  }
  paint(LINES[0]);
  if (!RM) lineT = setTimeout(nextLine, 430);
  function finish() {
    if (ready) return; ready = true;
    clearTimeout(lineT);
    numEl.textContent = '100';
    loader.style.setProperty('--lb', '#111A37'); loader.style.setProperty('--lf', '#F0F0EA');
    word.textContent = '';
    word.append('Coffee for ');
    const hl = document.createElement('span'); hl.className = 'hl'; hl.textContent = 'life.'; word.appendChild(hl);
    word.classList.remove('hit'); void word.offsetWidth; word.classList.add('hit');
    word.removeAttribute('aria-hidden');
    /* 8 Oct (Jos): no gate. "Coffee for life." lands, then you walk in quietly; the sound is offered on the speaker button */
    measure(true);
    if (!ROOMPAGE) later.forEach(n => { const im = new Image(); im.src = pic(n); });
    /* the first scene is in. Now everything that was held back so it could land sooner: the other two scenes, the pieces
       further down the page and the wholesale page. The first song waits a few seconds so it does not take the line from
       the pictures. (We tried feeding these in a queue, nearest first: on a slow line it was no quicker, so it stays simple.) */
    $$(ROOMPAGE ? '#room img[data-src]' : 'img[data-src]').forEach(im => { if (im.dataset.srcset) { im.sizes = im.dataset.sizes || ''; im.srcset = im.dataset.srcset; im.removeAttribute('data-srcset'); } im.src = im.dataset.src; im.removeAttribute('data-src'); });
    setTimeout(() => Music.warm(), 6000);
    if (!ROOMPAGE) setTimeout(() => comeIn(false), RM ? 0 : 900);
    /* the wholesale page walks straight in, quietly, and opens the room (at the form, if that is where the address points) */
    if (ROOMPAGE) {
      comeIn(false);
      openOv('room');
      const h = location.hash.replace(/^#/, '');
      if (/^(formCard|wsForm|wsForm2|r[A-Z]\w+)$/.test(h)) setTimeout(() => roomGo(h === 'wsForm' ? 'formCard' : h), 350);
    }
  }
  (function count() {
    if (ready) return;
    const loadP = done / total, timeP = MIN ? Math.min(1, (performance.now() - t0) / MIN) : 1;
    const target = Math.min(loadP, timeP) * 100;
    shown = ROOMPAGE && done >= total ? 100 : Math.min(target, shown + Math.max(0.9, (target - shown) * 0.12));
    numEl.textContent = String(Math.floor(shown));
    if (shown >= 99.9) finish(); else requestAnimationFrame(count);
  })();
  function comeIn(sound, e) {
    if (!ready || S.entered) return;
    S.entered = true;
    try { sessionStorage.setItem('cfl-in', '1'); } catch (err) {}
    window.scrollTo(0, 0);
    /* sound on means the scene plays. The music is offered, not started, unless a song was already going on the last page */
    if (sound) { soundSet(true); SFX.boom(); if (!Music.resume()) setTimeout(() => { if (!Music.isPlaying()) askShow(); }, RM ? 300 : 1500); }
    else Music.resume();   /* 9 Oct: a song from the last page carries on through a quiet walk-in too (it never did; the other pages always resumed) */
    if (e && e.clientX) burst(e.clientX, e.clientY, 12);
    loader.classList.add('out'); root.classList.add('ready');
    document.body.classList.remove('lock');
    setInert(false);
    requestAnimationFrame(() => { stopsBuild(); railPaint(); });   /* the page can scroll now: count its stops straight away */
    loader.setAttribute('aria-hidden', 'true'); loader.inert = true;
    if (!sound && !ROOMPAGE && !BACK) setTimeout(nudgeShow, 1800);    cue.classList.remove('in'); setTimeout(() => cue.classList.add('in'), RM ? 0 : 900);   /* the scroll note draws itself once you are in */
    if (location.hash.length > 1 && !ROOMPAGE) setTimeout(() => hashGo(location.hash, true), /^#(wholesale|quiz|formCard|wsForm2?)$/.test(location.hash) ? 0 : 700);   /* a link straight to the wholesale page, the quiz or a part of the page (the overlays open straight away) */
  }
  $('#enterSound').addEventListener('click', e => comeIn(true, e));
  $('#enterQuiet').addEventListener('click', e => comeIn(false, e));
  if (BACK) { finish(); comeIn(false); }
  window.__cfl = { S: S, SFX: SFX, M: M, Music: Music, setBlend: setBlend, go: go, travel: travel, comeIn: comeIn, rail: { stops: () => STOPS, step: railStep }, shoes: shoes, honk: { list: HONKERS, watch: honkWatch }, shop: { SHOP: SHOP, FREQ: FREQ, lines: shopLines, cart: cart, state: buyState, live: LIVE, fromStore: STORE_LIVE, pct: () => SUB_PCT, priceOf: priceOf }, game: { G: G25, arm: gameArm, end: gameEnd, rows: () => boardLoad() }, court: { get bodies() { return bodies; }, all: ALLB, H: H, score: () => hoopScore, setScore: v => { hoopScore = v; }, run: () => hoopRun, pull: () => [PULL, LAUNCH] } };
})();

/* ---------- the wholesale page: three things to play with, and the docket that prints ----------
   Better sales: a sum on their own coffees a day. More dollars: the way into the audit. Learn AI: sample questions,
   answered the way Brew Guide and Signal answer them. Everything here is a worked example, labelled as one. */
(() => {
  const room = $('#room');
  if (!room || !$('#rGrow')) return;
  /* the van drives in when the street comes into view, and parks */
  const van = $('.room-van', room);
  if (van && 'IntersectionObserver' in window) {
    new IntersectionObserver(es => es.forEach(en => {
      if (en.isIntersecting && en.intersectionRatio > 0.15) van.classList.add('go');
      else if (!en.isIntersecting) van.classList.remove('go');
    }), { threshold: [0, 0.15] }).observe(van.parentNode.querySelector('.rm-street') || van);
  } else if (van) van.classList.add('go');
  const seen = (el, fn, at) => {
    if (!el) return;
    if (!('IntersectionObserver' in window)) { fn(); return; }
    const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); fn(); } }, { threshold: at || 0.35 });
    io.observe(el);
  };

  /* ---- better sales ---- */
  const sales = $('#gwSales'), main = $('#cups'), mine = $('#gwCups');
  if (sales && mine) {
    const st = { rate: 5, worth: 4 }, bars = $$('#gwBars i'), out = $('#gwSalesOut'), nEl = $('#gwSalesN');
    const MAX = 600 / 3 * 6 * 364;
    let shown = 0, raf = 0;
    bars.forEach((b, i) => b.style.setProperty('--k', i));
    const paint = quick => {
      const n = +mine.value, total = n / st.rate * st.worth * 364, k = Math.pow(total / MAX, 0.4);
      nEl.textContent = n;
      mine.style.setProperty('--v', ((n - mine.min) / (mine.max - mine.min) * 100) + '%');
      bars.forEach((b, i) => b.style.setProperty('--h', ((i + 1) / 12 * k).toFixed(3)));
      cancelAnimationFrame(raf);
      if (RM || quick) { shown = total; out.textContent = '+$' + num(total); return; }
      const a = shown, t0 = performance.now();
      const step = now => { const p = Math.min((now - t0) / 420, 1); shown = a + (total - a) * (1 - Math.pow(1 - p, 3)); out.textContent = '+$' + num(shown); if (p < 1) raf = requestAnimationFrame(step); };
      raf = requestAnimationFrame(step);
    };
    sales.addEventListener('click', e => {
      const b = e.target.closest('.gw-chips button');
      if (!b) return;
      st[b.parentElement.dataset.k] = +b.dataset.v;
      $$('button', b.parentElement).forEach(c => c.setAttribute('aria-pressed', String(c === b)));
      SFX.toggle(); paint();
    });
    /* one number for coffees a day: this slider and the one in the savings sum move together */
    mine.addEventListener('input', () => { if (main) { main.value = mine.value; main.dispatchEvent(new Event('input')); } else paint(true); });
    if (main) main.addEventListener('input', () => { mine.value = main.value; paint(true); });
    if (main) mine.value = main.value;
    paint(true);
  }

  /* ---- more dollars: until they have done the audit the dial hunts. Afterwards it holds their own score ---- */
  const leak = $('#gwLeak');
  function paintLeak() {
    if (!leak) return;
    const r = Audit && Audit.results(), btn = $('.btn', leak);
    leak.classList.toggle('has', !!r);
    $('#gwArc').style.strokeDashoffset = r ? 100 - r.total : '';
    $('#gwScore').textContent = r ? r.total : '?';
    btn.textContent = r ? 'See my results' : 'Find my leak';
  }

  /* ---- learn AI ---- */
  const chat = $('#gwChat');
  if (chat) {
    const QA = [
      ['Brew Guide', 'Shots are running sour this morning. What do we change?', 'Sour usually means the shot ran too fast and came up short. Go one step finer on the grinder, keep the dose the same and pull another. Taste it before you change anything else.'],
      ['Brew Guide', 'Customer says the flat white is too hot. How hot should milk be?', 'Aim for 60 to 65 degrees. Past 70 the milk loses its sweetness and starts to taste cooked. No thermometer? When the jug is too hot to hold, give it a second or two and stop.'],
      ['Sierra, in Signal', 'Why was Tuesday down?', 'Tuesday closed 14% under your usual. Coffee held up. Food dropped away after 11, and it rained from 10. Worth planning the cabinet for wet days.']
    ];
    const q = $('#gwQ'), a = $('#gwA'), who = $('#gwWho');
    let typing = 0;
    const ask = i => {
      const row = QA[i];
      clearInterval(typing);
      $$('.gw-chips button', chat).forEach(b => b.setAttribute('aria-pressed', String(+b.dataset.q === i)));
      who.textContent = row[0]; q.textContent = row[1]; a.textContent = '';
      chat.classList.remove('done');
      if (RM) { a.textContent = row[2]; chat.classList.add('done'); return; }
      let n = 0;
      typing = setInterval(() => { n += 2; a.textContent = row[2].slice(0, n); if (n >= row[2].length) { clearInterval(typing); chat.classList.add('done'); } }, 26);
    };
    chat.addEventListener('click', e => { const b = e.target.closest('[data-q]'); if (b) { SFX.toggle(); ask(+b.dataset.q); } });
    q.textContent = QA[0][1];
    seen(chat, () => ask(0), 0.5);
  }

  /* ---- the docket prints when it scrolls into view ---- */
  const roll = $('#stkRoll');
  seen(roll, () => {
    roll.classList.add('on');
    if (RM) return;
    SFX.paper();
    setTimeout(() => { if (room.classList.contains('open')) SFX.slap(); }, 2520);
  }, 0.3);

  new MutationObserver(() => { if (room.classList.contains('open')) paintLeak(); }).observe(room, { attributes: true, attributeFilter: ['class'] });
})();

/* ---------- the menu: everything on the site, one tap away, the same on a desktop and a phone.
   On the site it is one of the overlays. On a product page it looks after itself. ---------- */
const Menu = (() => {
  const el = $('#menu');
  if (!el) return null;
  const MAIN = typeof openOv === 'function';
  let opener3 = null;
  function shown(v) {
    if (MAIN) { if (v) openOv('menu'); else if (S.overlay === 'menu') closeOv(); return; }
    if (el.classList.contains('open') === v) return;
    el.classList.toggle('open', v); el.setAttribute('aria-hidden', String(!v));
    document.body.classList.toggle('lock', v);
    if (v) document.body.dataset.ov = 'menu'; else delete document.body.dataset.ov;
    ['#main', '#top'].forEach(q => { const x = $(q); if (x) x.inert = v; });
    if (v) { opener3 = document.activeElement; SFX.whoosh(true); setTimeout(() => $('[data-close]', el).focus({ preventScroll: true }), 60); }
    else { SFX.close(); if (opener3 && opener3.focus) opener3.focus({ preventScroll: true }); }
  }
  if (MAIN) OV.menu = el;
  else {
    document.addEventListener('click', e => { const b = e.target.closest('[data-open="menu"]'); if (b) { e.preventDefault(); shown(true); } });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && el.classList.contains('open')) shown(false); });
  }
  /* the magnifier in the bar opens the menu with the cursor already in the search box */
  let wantFind = false;
  document.addEventListener('click', e => { if (e.target.closest('[data-find]')) wantFind = true; }, true);
  new MutationObserver(() => {
    const open = el.classList.contains('open'), q = $('#mnQ');
    if (open && wantFind && q) setTimeout(() => q.focus({ preventScroll: true }), 160);
    wantFind = false;
  }).observe(el, { attributes: true, attributeFilter: ['class'] });
  /* pick anything and the menu gets out of the way first, so the page underneath can move */
  el.addEventListener('click', e => {
    const t = e.target.closest('a,button');
    if (!t) return;
    if (t.id === 'mnSound') { const sb = $('#soundBtn'); if (sb) sb.click(); return; }
    if (t.id === 'mnFx') { const fb = $('#fxBtn'); if (fb) fb.click(); return; }
    if (t.closest('[data-close]')) { if (!MAIN) shown(false); return; }
    if (MAIN && t.dataset.open) return;               /* another overlay: it takes over by itself */
    if (MAIN) { if (S.overlay === 'menu') closeOv(true); } else shown(false);
  }, true);
  /* the sound switch in here mirrors the one in the bar (which a phone has no room for) */
  const sb = $('#soundBtn'), ms = $('#mnSound'), ml = $('#mnSoundL');
  if (sb && ms) {
    const sync = () => { const on = sb.getAttribute('aria-pressed') === 'true'; ms.setAttribute('aria-pressed', String(on)); ml.textContent = on ? 'Sound on' : 'Sound off'; };
    new MutationObserver(sync).observe(sb, { attributes: true, attributeFilter: ['aria-pressed'] });
    sync();
  }
  const fb = $('#fxBtn'), mf = $('#mnFx'), mfl = $('#mnFxL');
  if (fb && mf) {
    const syncFx = () => { const on = fb.getAttribute('aria-pressed') === 'true'; mf.setAttribute('aria-pressed', String(on)); mfl.textContent = on ? 'Clicks on' : 'Clicks off'; };
    new MutationObserver(syncFx).observe(fb, { attributes: true, attributeFilter: ['aria-pressed'] });
    syncFx();
  }
  return { open: () => shown(true), close: () => shown(false) };
})();

/* ---------- the shot clock: a brew timer that runs our own recipes and calls every step.
   Pick the coffee and how you're brewing it; the recipe comes from the store's blend pages (RECIPES). Espresso gets a clock
   with a target window. Plunger, V60 and AeroPress get the timed stages: the coach calls each one, the kettle swings in when
   it's time to pour and the scale shows what yours should read. Single origins and decaf run on the People Everyday recipe.
   The same tool sits on the site and on the product pages, so it finds out which of the two it is in (MAIN). ---------- */
const Brew = (() => {
  const el = $('#tm');
  if (!el) return null;
  const NSV = 'http://www.w3.org/2000/svg', MAIN = typeof openOv === 'function';
  const R = RECIPES;
  const METH = { esp: { art: 'bw-esp', prep: 3 }, plg: { art: 'bw-plg', prep: 2 }, v60: { art: 'bw-v60', prep: 1 }, aero: { art: 'bw-aero', prep: 1 } };
  const SINGLES = [['peru', 'Peru', 'peru-chanchamayo-washed', 'so-peru-front'], ['colombia', 'Colombia', 'colombia-popayan-reserve-washed', 'so-colombia-front'], ['brazil', 'Brazil', 'brazil-mogiana-natural-espresso-250g', 'so-brazil-front'], ['decaf', 'Decaf', 'colombia-popayan-decaf', 'so-decaf-front']];
  const COFFEES = BLENDS.map((b, i) => ({ key: b.id, name: b.name, short: ['Everyday', 'Brooklyn', 'Hyperdrive'][i], recipe: b.id, bag: 'bag-' + b.id + '-front', b: i, handle: SHOP[b.id].handle }))
    .concat(SINGLES.map(s => ({ key: s[0], name: s[0] === 'decaf' ? 'Colombia Decaf' : s[1], short: s[1], recipe: 'pe', bag: s[3], b: -1, handle: s[2] })));
  const STORE_ROOT = typeof CFG.shop === 'string' ? CFG.shop.replace(/\/*$/, '/') : 'https://brotherofmine.com.au/';
  /* run: 0 waiting, 1 running, 2 paused, 3 full time */
  const st = { c: 'pe', m: 'esp', cups: 1, dose: 0, yld: 0, ratio: 0, touched: false, run: 0, ms: 0, t0: 0, stage: -1, count: -1, zone: 'pre', act: 'idle', voice: false, built: false, list: null, hinted: false, face: 'recipe', soundBefore: false, beeped: false };
  const inEl = $('#tmIn'), stage = $('#tmStage'), goBtn = $('#tmGo'), rsBtn = $('#tmReset'), clock = $('#tmClock'), led = $('#tmLed');
  const nowEl = $('#tmNow'), subEl = $('#tmSub'), nextEl = $('#tmNext'), nextT = $('#tmNextT'), nextIn = $('#tmNextIn');
  let coach = null;
  const fill = $('#tmFill'), zone = $('#tmZone'), ticks = $('#tmTicks'), playsEl = $('#tmPlays'), done = $('#tmDone');
  const shoutEl = $('#tmShout'), soundTgl = $('#tmSound'), voiceTgl = $('#tmVoice');
  const coffee = () => COFFEES.find(x => x.key === st.c) || COFFEES[0];
  const base = () => R.B[coffee().recipe][st.m];
  const num1 = v => (Math.round(v * 10) / 10 % 1 === 0 ? String(Math.round(v)) : (Math.round(v * 10) / 10).toFixed(1));
  const ratioText = () => '1:' + (st.m === 'esp' ? (st.yld / st.dose).toFixed(1).replace(/\.0$/, '') : Math.round(st.yld / st.dose));
  const loud = () => SFX.isOn() && SFX.clockOn();
  const mk = (tag, cls, txt) => { const n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; };

  /* ---- lit readouts, built the way the scoreboard's are ---- */
  const LSEG = { a: '14,6 46,6 40,14 20,14', b: '48,8 48,46 44,50 40,44 40,16', c: '48,92 48,54 44,50 40,56 40,84', d: '14,94 46,94 40,86 20,86', e: '12,92 12,54 16,50 20,56 20,84', f: '12,8 12,46 16,50 20,44 20,16', g: '18,50 22,46 38,46 42,50 38,54 22,54' };
  const LDIG = ['abcdef', 'bc', 'abged', 'abgcd', 'fgbc', 'afgcd', 'afgedc', 'abc', 'abcdefg', 'abcdfg'];
  function ledDigit(svg, x, s) {
    const g = document.createElementNS(NSV, 'g'), d = { was: null };
    g.setAttribute('transform', 'translate(' + (x + 2) + ',' + (100 * (1 - s)) + ') scale(' + s + ') skewX(-5)');
    Object.keys(LSEG).forEach(k => { const p = document.createElementNS(NSV, 'polygon'); p.setAttribute('points', LSEG[k]); g.appendChild(p); d[k] = p; });
    svg.appendChild(g);
    return d;
  }
  function ledDot(svg, x, y, r) { const c = document.createElementNS(NSV, 'circle'); c.setAttribute('cx', x); c.setAttribute('cy', y); c.setAttribute('r', r); svg.appendChild(c); return c; }
  function ledSet(d, ch) {
    if (d.was === ch) return;
    d.was = ch;
    const lit = ch == null || ch === ' ' ? '' : LDIG[+ch];
    Object.keys(LSEG).forEach(k => d[k].classList.toggle('on', lit.indexOf(k) > -1));
  }
  const T = { m: ledDigit(led, 0, 1), s1: ledDigit(led, 88, 1), s2: ledDigit(led, 152, 1), t: ledDigit(led, 228, 0.6) };
  [ledDot(led, 76, 32, 6), ledDot(led, 76, 68, 6), ledDot(led, 222, 90, 4.5)].forEach(c => c.classList.add('on'));
  const scaleLed = $('#tmScaleLed'), SC = [0, 64, 128, 192].map(x => ledDigit(scaleLed, x, 1));
  let lastSec = -1;
  function paintClock(s) {
    s = Math.min(s, 599.9);
    const whole = Math.floor(s), m = Math.floor(whole / 60), sec = whole % 60;
    ledSet(T.m, String(m)); ledSet(T.s1, String(Math.floor(sec / 10))); ledSet(T.s2, String(sec % 10)); ledSet(T.t, String(Math.floor(s * 10) % 10));
    if (whole !== lastSec) { lastSec = whole; led.setAttribute('aria-label', 'Brew time ' + m + (m === 1 ? ' minute ' : ' minutes ') + sec + (sec === 1 ? ' second' : ' seconds')); }
  }
  function paintScale(v) {
    const str = String(Math.max(0, Math.min(9999, Math.round(v))));
    SC.forEach((d, i) => ledSet(d, str[i - (4 - str.length)]));
  }

  /* ---- the recipe: ours to start with, and three numbers you can nudge the way the store's tool lets you ---- */
  function recipeReset() { const d = base(); st.cups = 1; st.ratio = d.ratio; st.dose = d.dose; st.yld = d.yield; st.touched = false; }
  function adjust(what, dir) {
    const d = base();
    if (what === 'dose') { st.dose = clamp(st.dose + dir * d.ds, 1, 150); st.yld = Math.round(st.dose * st.ratio * 10) / 10; }
    else if (what === 'yield') { st.yld = clamp(st.yld + dir * d.ys, 1, 3000); st.dose = Math.round(st.yld / st.ratio * 10) / 10; }
    else if (what === 'ratio') { st.ratio = clamp(Math.round((st.ratio + dir * d.rs) * 100) / 100, 0.5, 25); st.yld = Math.round(st.dose * st.ratio * 10) / 10; }
    else if (what === 'cups') { if (!d.hasCups) return; st.cups = clamp(st.cups + dir, 1, 10); st.dose = Math.round(d.dose * st.cups * 10) / 10; st.yld = Math.round(st.dose * st.ratio * 10) / 10; }
    st.touched = st.cups !== 1 || Math.abs(st.dose - d.dose) > 0.01 || Math.abs(st.yld - d.yield) > 0.5 || Math.abs(st.ratio - d.ratio) > 0.001;
    SFX.tick(); paintRecipe(); paintPlays(); paintHow(); paintIdle();
  }
  /* the timed stages for this coffee and method, with every weight scaled to the water you're actually using */
  function buildList() {
    const d = base(), G = R.G[coffee().recipe] && R.G[coffee().recipe][st.m];
    if (!G) return null;
    const k = st.yld / d.yield;
    let poured = 0, flip = false;
    return G.map(g => {
      const end = /^DONE/.test(g[1]);
      const title = g[1].replace(/(\d+)G\b/g, (m, n) => Math.round(+n * k) + 'G');
      const sub = /^\d+G AT \d+°C$/.test(g[3]) ? Math.round(st.yld) + 'G AT ' + d.temp + '°C' : g[3];
      const grams = /(\d+)G\b/.exec(g[1]);
      const act = end ? 'done' : /FLIP/.test(g[1]) ? 'flip' : /PLUNGE|PRESS/.test(g[1]) ? 'press' : /^POUR GENTLY/.test(g[1]) ? 'serve' : /POUR|BLOOM/.test(g[1]) ? 'pour' : /SWIRL|STIR/.test(g[1]) ? 'swirl' : /LID/.test(g[1]) ? 'lid' : 'wait';
      const p = { t: g[0], title: nice(title), sub: nice(sub), act: act, end: end, from: poured, target: poured, flipped: flip };
      if (act === 'pour') { p.target = grams ? Math.round(+grams[1] * k) : Math.round(st.yld); poured = p.target; }
      if (act === 'flip') { flip = true; p.flipped = true; }
      p.stir = /STIR/.test(g[1]);
      return p;
    });
  }
  /* a recipe line with its numbers marked */
  function rich(parent, line) {
    nice(line.replace(/%D/g, num1(st.dose)).replace(/%Y/g, Math.round(st.yld)).replace(/<span class="h">(.*?)<\/span>/g, '{{$1}}')).split(/(\{\{.*?\}\})/).forEach(part => {
      const m = /^\{\{(.*)\}\}$/.exec(part);
      if (m) parent.appendChild(mk('em', '', m[1])); else if (part) parent.appendChild(document.createTextNode(part));
    });
  }
  function paintRecipe() {
    const d = base(), c = coffee();
    $('#tmFor').textContent = c.name + ', ' + (st.m === 'aero' ? 'AeroPress' : BREW_METHOD[st.m] === 'V60' ? 'V60' : BREW_METHOD[st.m].toLowerCase());
    const adj = $('#tmAdj'); adj.textContent = '';
    [['dose', 'Dose', num1(st.dose) + 'g'], ['yield', d.yl === 'WATER' ? 'Water' : 'Yield', Math.round(st.yld) + 'g'], ['ratio', 'Ratio', ratioText()]].forEach(a => {
      const row = mk('div'), dt = mk('dt', '', a[1]), dd = mk('dd');
      const minus = mk('button', '', '−'), val = mk('b', '', a[2]), plus = mk('button', '', '+');
      minus.type = plus.type = 'button'; minus.dataset.tmAdj = a[0]; minus.dataset.d = '-1'; plus.dataset.tmAdj = a[0]; plus.dataset.d = '1';
      minus.setAttribute('aria-label', 'Less ' + a[1].toLowerCase()); plus.setAttribute('aria-label', 'More ' + a[1].toLowerCase());
      dd.append(minus, val, plus); row.append(dt, dd); adj.appendChild(row);
    });
    const fx = $('#tmFixed'); fx.textContent = '';
    [['Temp', d.temp + '°C'], ['Grind', nice(d.grind)], ['Time', /-/.test(d.time) ? d.time + 's' : d.time]].forEach(f => { const row = mk('div'); row.append(mk('dt', '', f[0]), mk('dd', '', f[1])); fx.appendChild(row); });
    $('#tmCups').hidden = !d.hasCups; $('#tmCupsN').textContent = st.cups;
    $('#tmBack').hidden = !st.touched;
    $('#tmSo').hidden = c.b > -1;
    const prep = $('#tmPrep'); prep.textContent = '';
    R.STEPS[c.recipe][st.m].slice(0, METH[st.m].prep).forEach(line => { const li = mk('li'); rich(li, line); prep.appendChild(li); });
  }
  function paintPlays() {
    const d = base(), c = coffee();
    st.list = buildList();
    playsEl.textContent = ''; ticks.textContent = '';
    if (st.list) {
      const total = st.list[st.list.length - 1].t;
      st.list.forEach((p, i) => {
        const li = mk('li'); li.append(mk('b', '', mmss(p.t)));
        const sp = mk('span', '', p.end ? 'Full time' : p.title); sp.appendChild(mk('small', '', p.sub)); li.appendChild(sp);
        playsEl.appendChild(li);
        if (i && !p.end) { const tk = mk('i'); tk.style.left = (p.t / total * 100) + '%'; ticks.appendChild(tk); }
      });
      $('#tmTotal').textContent = mmss(total) + ' start to finish';
      $('#tmTgt').textContent = 'Full time at ' + mmss(total);
    } else {
      R.STEPS[c.recipe][st.m].slice(METH[st.m].prep).forEach((line, i) => { const li = mk('li', 'plain'); li.append(mk('b', '', String(i + 1))); const sp = mk('span'); rich(sp, line); li.appendChild(sp); playsEl.appendChild(li); });
      $('#tmTotal').textContent = 'Stop at ' + Math.round(st.yld) + 'g';
      $('#tmTgt').textContent = 'Target ' + d.tMin + ' to ' + d.tMax + ' seconds';
      const span = d.tMax + 10;
      zone.style.left = (d.tMin / span * 100) + '%'; zone.style.width = ((d.tMax - d.tMin) / span * 100) + '%';
    }
    $('#tmTip').textContent = nice(c.b > -1 ? R.TIPS[c.recipe][st.m] : SINGLE_TIPS[st.m]);
    $('#tmFix').textContent = nice(R.TROUBLE[st.m]) + '.';
  }
  /* the back of the recipe card: what you need and how the method goes, with this coffee's own times dropped in */
  function paintHow() {
    const h = HOWTO[st.m];
    if (!h) return;
    const name = st.m === 'aero' ? 'AeroPress' : st.m === 'v60' ? 'V60' : BREW_METHOD[st.m].toLowerCase();
    const L = st.list || [], at = L.find(p => p.act === 'press' || p.act === 'flip'), first = L.find(p => p.act === 'pour');
    const fill = t => t.replace(/\{t\}/g, at ? mmss(at.t) : 'the call').replace(/\{g\}/g, first ? first.target : 30);
    $('#tmHowFor').textContent = st.m === 'aero' ? 'AeroPress' : BREW_METHOD[st.m];
    $('#tmHowLine').textContent = h.line;
    const need = $('#tmNeed'); need.textContent = '';
    h.need.forEach(n => need.appendChild(mk('li', '', n)));
    need.appendChild(mk('li', 'g', 'Grind: ' + h.grind));
    const ol = $('#tmHow'); ol.textContent = '';
    h.steps.forEach(x => { const li = mk('li'); li.append(mk('b', '', x[0] + '. '), document.createTextNode(fill(x[1]))); ol.appendChild(li); });
    const fx = $('#tmHowFix'); fx.textContent = ''; fx.append(mk('b', '', 'If it\'s not right'), document.createTextNode(h.fix));
    $('#tmHowBtn').textContent = 'New to ' + name + '? See how to brew it';
  }
  const card = $('#tmCard'), faceA = $('#tmFaceA'), faceB = $('#tmFaceB');
  function face(which, focus) {
    if (st.face === which) return;
    st.face = which;
    const swap = () => {
      faceA.hidden = which !== 'recipe'; faceB.hidden = which !== 'how';
      card.dataset.face = which; $('#tmFlip').setAttribute('aria-expanded', String(which === 'how'));
      if (focus) (which === 'how' ? $('#tmFlipBack') : $('#tmFlip')).focus({ preventScroll: true });
    };
    if (RM) { swap(); return; }
    card.classList.remove('turning'); void card.offsetWidth; card.classList.add('turning');
    setTimeout(swap, 180); setTimeout(() => card.classList.remove('turning'), 400);
    SFX.spin(0.5);
  }
  /* a song steps back for a moment so a call can be heard over it */
  const dip = () => { try { if (Music.isPlaying()) Music.duck(1500); } catch (err) {} };
  /* everything that shows which coffee and method are picked */
  function paintPick() {
    const c = coffee();
    el.dataset.c = c.key; el.dataset.m = st.m;
    $$('[data-tm-c]', el).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tmC === st.c)));
    $$('[data-tm-m]', el).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tmM === st.m)));
    $('#tmBrewerImg').src = pic(METH[st.m].art);
    $('#tmBag').src = pic(c.bag);
    const notes = $('#tmNotes'); notes.textContent = '';
    (CUP_NOTES[c.key] || []).forEach((n, i) => {
      const f = mk('div', 'tm-note'); f.style.setProperty('--i', i);
      const im = mk('img'); im.src = pic(n[0]); im.alt = '';
      f.append(im, mk('span', '', n[1])); notes.appendChild(f);
    });
  }

  /* ---- the coach's call, the word on the bench, a voice if asked ---- */
  function call(now, sub, bump) {
    if (nowEl.textContent !== now) { nowEl.textContent = now; if (bump) { nowEl.classList.remove('in'); void nowEl.offsetWidth; nowEl.classList.add('in'); coach.classList.remove('tm-hop'); void coach.offsetWidth; coach.classList.add('tm-hop'); } }
    subEl.textContent = sub || '';
  }
  const DOODLE = { down: ['M34 6C38 24 37 42 35 58', 'M20 44l15 16 14-17'], swirl: ['M52 36A18 18 0 1 1 36 16', 'M27 8l10 8-9 9'], flip: ['M12 50C8 14 58 10 58 44', 'M47 36l11 12 8-14'] };
  function shout(kind, word) {
    const d = DOODLE[kind] || ['', ''];
    $('#tmShA').setAttribute('d', d[0]); $('#tmShB').setAttribute('d', d[1]);
    $('.doodle', shoutEl).style.display = kind ? '' : 'none';
    $('#tmShW').textContent = word || '';
    shoutEl.classList.remove('on');
    if (word) { void shoutEl.offsetWidth; shoutEl.classList.add('on'); }
  }
  function say(text) {
    if (!st.voice || !window.speechSynthesis) return;
    try {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(String(text).replace(/(\d+)g\b/g, '$1 grams').replace(/°C/g, ' degrees').replace(/(\d+):(\d+)/g, '$1 $2'));
      u.lang = 'en-AU'; u.rate = 1.02; window.speechSynthesis.speak(u);
    } catch (err) {}
  }
  function buzz(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (err) {} }
  function setAct(a) { if (st.act !== a) { st.act = a; el.dataset.act = a; } }
  function confetti() {
    const box = $('#tmConf'), cols = ['#FF69AE', '#D2F55C', '#C888F8', '#8CCDE3', '#F27B20', '#ffffff'];
    box.textContent = '';
    if (RM) return;
    for (let i = 0; i < 30; i++) {
      const a = Math.random() * Math.PI * 2, r = 120 + Math.random() * 240, n = mk('i');
      n.style.setProperty('--x', Math.round(Math.cos(a) * r) + 'px'); n.style.setProperty('--y', Math.round(Math.sin(a) * r - 80) + 'px');
      n.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg'); n.style.setProperty('--c', cols[i % cols.length]);
      n.style.animationDelay = (Math.random() * 0.12) + 's';
      box.appendChild(n);
    }
    setTimeout(() => { box.textContent = ''; }, 1700);
  }

  /* ---- the clock ---- */
  let raf = 0, bg = 0, lock = null;
  function wake(v) {
    try {
      if (v && navigator.wakeLock && !lock) navigator.wakeLock.request('screen').then(l => { lock = l; if (st.run !== 1) wake(false); }, () => {});
      else if (!v && lock) { lock.release().catch(() => {}); lock = null; }
    } catch (err) {}
  }
  function setState() {
    el.dataset.state = ['idle', 'run', 'paused', 'done'][st.run];
    goBtn.textContent = st.run === 1 ? (st.list ? 'Pause' : 'Stop the shot') : st.run === 2 ? 'Carry on' : st.run === 3 ? 'Go again' : 'Start the clock';
    rsBtn.disabled = st.run === 1 || (st.run === 0 && st.ms === 0);
    $$('.tm-picks button:not(.tm-howlink), .tm-recipe button:not(.tm-flip)', el).forEach(b => { if (st.run === 1) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); });   /* no swapping coffee mid-brew */
    el.classList.toggle('steamy', st.run === 3 || (st.run === 1 && /^(wait|swirl|lid|press|serve)$/.test(st.act)));
  }
  function paintIdle() {
    /* nothing running: the clock at zero, the scale ready, the first call waiting */
    const d = base();
    paintClock(0); lastSec = -1;
    fill.style.width = '0%';
    clock.dataset.zone = 'pre'; st.zone = 'pre';
    setAct('idle'); el.classList.remove('flipped');
    stage.style.setProperty('--fill', '0');
    shout('', '');
    nextEl.hidden = true;
    $$('li', playsEl).forEach(li => { li.classList.remove('on', 'past'); });
    if (st.list) {
      $('#tmScaleK').textContent = 'Scale should read';
      paintScale(0);
      call('Press start', 'First up: ' + st.list[0].title.replace(/^./, ch => ch.toLowerCase()) + '.');
    } else {
      $('#tmScaleK').textContent = 'Stop the shot at';
      paintScale(st.yld);
      call('Press start', 'Start the clock as the pump goes on.');
    }
    setState();
  }
  function reset() {
    cancelAnimationFrame(raf); clearInterval(bg); wake(false);
    st.run = 0; st.ms = 0; st.stage = -1; st.count = -1;
    hideDone();
    paintIdle();
  }
  function enter(i) {
    const p = st.list[i], first = st.stage === -1;
    st.stage = i; st.count = -1;
    $$('li', playsEl).forEach((li, k) => { li.classList.toggle('on', k === i); li.classList.toggle('past', k < i); });
    el.classList.toggle('flipped', p.flipped);
    if (p.end) { finish(); return; }
    call(p.title, p.sub, true);
    if (!first) { SFX.clock(() => SFX.beep(true)); buzz([12, 40, 12]); dip(); }
    say(p.title + '. ' + p.sub);
  }
  const WORD = { press: ['down', 'slow and steady'], flip: ['flip', 'flip it'], lid: ['down', 'lid on'], serve: ['', 'pour gently'] };
  function frame() {
    if (st.run !== 1) return;
    const ms = performance.now() - st.t0, s = ms / 1000, d = base();
    st.ms = ms;
    paintClock(s);
    if (st.list) {
      const L = st.list, total = L[L.length - 1].t;
      let i = 0;
      for (let k = L.length - 1; k >= 0; k--) if (s >= L[k].t) { i = k; break; }
      if (i !== st.stage) { enter(i); if (st.run !== 1) return; }
      const p = L[i], nx = L[i + 1], left = nx ? nx.t - s : 0;
      let act = p.act, reading = p.target;
      if (p.act === 'pour') {
        const win = clamp((nx ? nx.t - p.t : 12) * 0.66, 5, 20), k = clamp((s - p.t) / win, 0, 1);
        reading = lerp(p.from, p.target, ease(k));
        if (k >= 1) act = p.stir ? 'swirl' : 'wait';
      }
      if (act !== st.act) {
        setAct(act);
        const w = act === 'swirl' ? ['swirl', p.stir ? 'stir' : 'swirl'] : act === 'wait' ? ['', /draw/i.test(p.title) ? 'let it drip' : /settle/i.test(p.title) ? 'let it settle' : 'hands off'] : WORD[act] || ['', ''];
        shout(w[0], w[1]);
        setState();
      }
      paintScale(reading);
      fill.style.width = Math.min(100, s / total * 100) + '%';
      if (nx) {
        nextEl.hidden = false;
        const t = nx.end ? 'Full time in' : 'Next: ' + nx.title.replace(/^./, ch => ch.toLowerCase()) + ' in';
        if (nextT.textContent !== t) nextT.textContent = t;
        const c = Math.ceil(left), txt = mmss(c);
        if (nextIn.textContent !== txt) nextIn.textContent = txt;
        nextEl.classList.toggle('soon', left <= 3.05);
        /* three, two, one */
        if (c <= 3 && c >= 1 && c !== st.count) { st.count = c; SFX.clock(SFX.count); }
      }
    } else {
      const span = d.tMax + 10, z = s < d.tMin ? 'pre' : s <= d.tMax ? 'in' : 'over';
      fill.style.width = Math.min(100, s / span * 100) + '%';
      stage.style.setProperty('--fill', clamp((s - 4) / (d.tMin - 4), 0, 1).toFixed(3));
      if (z !== st.zone) {
        st.zone = z; clock.dataset.zone = z;
        if (z === 'in') { call('In the window', 'Stop when the scale reads ' + Math.round(st.yld) + 'g.', true); SFX.clock(() => SFX.beep(true)); buzz(20); dip(); say('In the window'); }
        else if (z === 'over') { call('Running long', 'Stop the shot.', true); SFX.clock(() => SFX.beep(false)); buzz([20, 60, 20]); dip(); say('Running long. Stop the shot.'); }
      }
      const c = Math.ceil(d.tMin - s);
      if (z === 'pre' && c <= 3 && c >= 1 && c !== st.count) { st.count = c; SFX.clock(SFX.count); }
    }
  }
  function loop() { frame(); if (st.run === 1) raf = requestAnimationFrame(loop); }
  function start() {
    if (st.run === 1) return;
    if (st.run === 3) reset();
    const fresh = st.ms === 0;
    st.run = 1; st.t0 = performance.now() - st.ms;
    if (fresh) {
      if (loud()) SFX.clock(SFX.whistle); buzz(18);
      if (!st.list) { call('Stop at ' + Math.round(st.yld) + 'g', 'Aim for ' + base().tMin + ' to ' + base().tMax + ' seconds.', true); setAct('pull'); say('Stop at ' + Math.round(st.yld) + ' grams'); }
      if (!loud() && !st.hinted) { st.hinted = true; toast('Turn on Beeps to hear every call'); }
    } else { SFX.toggle(); if (!st.list) setAct('pull'); }
    setState(); wake(true);
    cancelAnimationFrame(raf); clearInterval(bg);
    loop();
    bg = setInterval(frame, 250);   /* keeps the calls coming when the screen isn't being drawn */
  }
  function pause() {
    if (st.run !== 1) return;
    st.ms = performance.now() - st.t0; st.run = 2;
    cancelAnimationFrame(raf); clearInterval(bg); wake(false);
    setAct('idle'); shout('', '');
    setState(); SFX.toggle();
  }
  function finish() {
    const d = base(), s = st.ms / 1000;
    st.run = 3;
    cancelAnimationFrame(raf); clearInterval(bg); wake(false);
    setAct('done'); shout('', ''); nextEl.hidden = true;
    let verdict, ok = true;
    if (st.list) { fill.style.width = '100%'; verdict = 'That\'s the recipe, start to finish.'; call('Full time', 'Pour it and drink it.', true); }
    else if (s < d.tMin) { ok = false; verdict = 'Too quick. Grind finer next time.'; call('Too quick', 'Grind finer.', true); }
    else if (s > d.tMax) { ok = false; verdict = 'That ran long. Grind coarser next time.'; call('Ran long', 'Grind coarser.', true); }
    else { verdict = 'Right in the window.'; call('Nice shot', 'Right in the window.', true); }
    if (ok) { if (loud()) SFX.clock(SFX.buzzer); setTimeout(() => SFX.success(), 500); confetti(); } else SFX.error();
    dip();
    buzz([30, 60, 30, 60, 60]); say(ok ? 'Full time. ' + verdict : verdict);
    setState();
    $('#tmDoneK').textContent = st.list ? 'Full time' : ok ? 'Nice shot' : 'Not quite';
    $('#tmDoneT').textContent = st.list ? mmss(s) : (Math.floor(s * 10) / 10).toFixed(1) + 's';
    $('#tmDoneV').textContent = verdict;
    paintTaste();
    setTimeout(() => { if (st.run === 3) showDone(); }, RM ? 200 : 1300);
  }
  /* what went wrong, in the recipe's own words: "sour = grind finer" becomes a button and an answer */
  function paintTaste() {
    const c = coffee(), box = $('#tmTaste'), ans = $('#tmTasteA');
    box.textContent = ''; ans.textContent = '';
    const opts = [['Spot on', 'That\'s the one. Same again tomorrow.']].concat(R.TROUBLE[st.m].split('|').map(x => { const p = x.split('='); return [nice(p[0].trim()), 'Next time: ' + nice(p[1].trim()).replace(/^./, ch => ch.toLowerCase()) + '.']; }));
    opts.forEach(o => {
      const b = mk('button', '', o[0]); b.type = 'button'; b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', () => { $$('button', box).forEach(x => x.setAttribute('aria-pressed', String(x === b))); ans.textContent = o[1]; SFX.toggle(); });
      box.appendChild(b);
    });
    const cup = $('#tmCupN'), notes = CUP_NOTES[c.key] || [];
    cup.textContent = '';
    notes.forEach(n => { const f = mk('figure'); const im = mk('img'); im.src = pic(n[0]); im.alt = ''; f.append(im, mk('figcaption', '', n[1])); cup.appendChild(f); });
    $('#tmCup').hidden = !notes.length;
    const shop = $('#tmShop');
    shop.textContent = 'Get more ' + c.short.replace('Everyday', 'People Everyday').replace('Brooklyn', 'No Sleep').replace(/^Decaf$/, 'decaf');
    shop.href = STORE_ROOT + 'products/' + c.handle + (c.b < 0 && CFG.view ? '?view=' + CFG.view : '');
    if (STORE_ROOT.indexOf('http') === 0) { shop.target = '_blank'; shop.rel = 'noopener'; }
  }
  function showDone() { done.classList.add('on'); done.setAttribute('aria-hidden', 'false'); inEl.inert = true; setTimeout(() => { const b = $('#tmAgain'); if (done.classList.contains('on')) b.focus({ preventScroll: true }); }, 80); }
  function hideDone() { done.classList.remove('on'); done.setAttribute('aria-hidden', 'true'); inEl.inert = false; }

  /* ---- built the first time it opens, so none of its pictures load before they're wanted ---- */
  function build() {
    if (st.built) return;
    st.built = true;
    const chip = (c, box) => { const b = mk('button', 'tm-chip'); b.type = 'button'; b.dataset.tmC = c.key; b.setAttribute('aria-pressed', 'false'); const im = mk('img'); im.src = pic(c.bag); im.alt = ''; const tg = mk('span', 'tm-tag'); tg.textContent = c.short; b.append(im, tg); box.appendChild(b); };
    COFFEES.forEach(c => chip(c, c.b > -1 ? $('#tmBlends') : $('#tmSingles')));
    Object.keys(METH).forEach(m => { const b = mk('button', 'tm-meth'); b.type = 'button'; b.dataset.tmM = m; b.setAttribute('aria-pressed', 'false'); const im = mk('img'); im.src = pic(METH[m].art); im.alt = ''; const tg = mk('span', 'tm-tag'); tg.textContent = BREW_METHOD[m]; b.append(im, tg); $('#tmMeth').appendChild(b); });
    /* the pictures on the bench are made here, so nothing asks for them until the clock is opened */
    const im = (cls, id, name) => { const n = mk('img', cls); n.id = id; n.alt = ''; if (name) n.src = pic(name); return n; };
    stage.insertBefore(im('tm-bag', 'tmBag'), $('#tmNotes'));
    stage.insertBefore(im('tm-mug', 'tmMug', 'bw-mug'), $('#tmBrewer'));
    $('#tmBrewer').prepend(im('', 'tmBrewerImg'));
    stage.insertBefore(im('tm-kettle', 'tmKettle', 'bw-kettle'), $('.tm-scale', stage));
    coach = im('tm-coach', 'tmCoach', 'bw-coach'); $('.tm-call', el).prepend(coach);
    $('.tm-done-card', el).prepend(im('tm-done-art', 'tmDoneArt', 'bw-coach'));
    voiceTgl.hidden = !('speechSynthesis' in window && 'SpeechSynthesisUtterance' in window);
  }
  /* phones get the clock in two steps: what and how first, then the bench (desktop has room for both at once) */
  function sum() {
    const c = coffee(), mb = $('[data-tm-m="' + st.m + '"]', el);
    const a = $('#tmSumBag'), b = $('#tmSumMeth');
    if (a) a.src = pic(c.bag);
    if (b) b.src = pic(METH[st.m].art);
    $('#tmSumC').textContent = c.name;
    $('#tmSumM').textContent = (mb ? mb.textContent.trim() : '') + ', our recipe';
  }
  function step(s, focus) {
    el.dataset.step = s;
    sum();
    inEl.scrollTop = 0;
    if (focus) { const f = s === 'pick' ? $('[data-tm-c][aria-pressed="true"]', el) : goBtn; if (f) f.focus({ preventScroll: true }); }
  }
  function pick(c, m) {
    if (st.run === 1) return;
    if (c && COFFEES.some(x => x.key === c)) st.c = c;
    if (m && METH[m]) st.m = m;
    recipeReset();
    st.run = 0; st.ms = 0; st.stage = -1; st.count = -1;
    hideDone();
    paintPick(); paintRecipe(); paintPlays(); paintHow(); paintIdle(); sum();
    try { localStorage.setItem('cfl-brew', st.c + ',' + st.m); } catch (err) {}
  }
  /* the clock's own Beeps switch (6 Oct): no longer the Clicks switch in the bar */
  const syncSound = () => soundTgl.setAttribute('aria-pressed', String(loud()));

  /* ---- opening and closing: on the site it's one of the overlays; on a product page it looks after itself ---- */
  let opener2 = null;
  function shown(v) {
    if (MAIN) { if (v) openOv('brew'); else if (S.overlay === 'brew') closeOv(); return; }
    el.classList.toggle('open', v); el.setAttribute('aria-hidden', String(!v));
    document.body.classList.toggle('lock', v);
    if (v) document.body.dataset.ov = 'brew'; else delete document.body.dataset.ov;
    ['#main', '#top'].forEach(q => { const x = $(q); if (x) x.inert = v; });
    const bar = $('#ppBar'); if (bar) bar.inert = v || !bar.classList.contains('on');
    if (v) { opener2 = document.activeElement; SFX.whoosh(true); setTimeout(() => $('[data-close]', el).focus({ preventScroll: true }), 60); }
    else { SFX.close(); if (opener2 && opener2.focus) opener2.focus({ preventScroll: true }); }
  }
  function open(o) {
    o = o || {};
    build();
    let c = o.c, m = o.m;
    if (!c || !m) { try { const was = (localStorage.getItem('cfl-brew') || '').split(','); c = c || was[0]; m = m || was[1]; } catch (err) {} }
    if (st.run === 1 || st.run === 2) { /* a brew is on the go: leave it be */ }
    else pick(c || st.c, m || st.m);
    syncSound();
    step(st.run === 1 || st.run === 2 ? 'brew' : 'pick');   /* a brew on the go opens on the bench; otherwise start with the picks */
    shown(true);
    inEl.scrollTop = 0;
  }
  function close() { shown(false); }
  if (MAIN) OV.brew = el;
  /* however it closes (the cross, Escape, another overlay opening), a running clock stops where it is */
  let wasOpen = false;
  new MutationObserver(() => {
    const open = el.classList.contains('open');
    if (open === wasOpen) return;
    wasOpen = open;
    SFX.hush(open);            /* the waves, the street and the rest wait outside: in here it's the beeps and the voice */
    if (open) { syncSound(); return; }
    if (st.run === 1) pause();
    wake(false);
    try { if (window.speechSynthesis) window.speechSynthesis.cancel(); } catch (err) {}
    if (SFX.isOn() && !SFX.ambOn() && !SFX.fxOn()) soundPart('rest', false);   /* the sound only came on for the beeps: it goes quiet with the clock */
  }).observe(el, { attributes: true, attributeFilter: ['class'] });

  el.addEventListener('click', e => {
    const t = e.target;
    if (t.closest('[data-close]')) { e.stopPropagation(); close(); return; }
    if (t.closest('#tmLets')) { SFX.toggle(); step('brew', true); return; }
    if (t.closest('#tmChange')) { if (st.run === 1) return; SFX.toggle(); step('pick', true); return; }
    const cb = t.closest('[data-tm-c]'); if (cb) { if (cb.dataset.tmC !== st.c) { SFX.toggle(); pick(cb.dataset.tmC, null); } return; }
    const mb = t.closest('[data-tm-m]'); if (mb) { if (mb.dataset.tmM !== st.m) { SFX.toggle(); pick(null, mb.dataset.tmM); } return; }
    const ad = t.closest('[data-tm-adj]'); if (ad) { if (st.run === 0) adjust(ad.dataset.tmAdj, +ad.dataset.d); return; }
    const cu = t.closest('[data-tm-cups]'); if (cu) { if (st.run === 0) adjust('cups', +cu.dataset.tmCups); return; }
  });
  $('#tmBack').addEventListener('click', () => { if (st.run === 1) return; SFX.toggle(); pick(null, null); });
  goBtn.addEventListener('click', () => { if (st.run === 1) { if (st.list) pause(); else finish(); } else start(); });
  rsBtn.addEventListener('click', () => { SFX.toggle(); reset(); });
  $('#tmAgain').addEventListener('click', () => { SFX.toggle(); reset(); goBtn.focus({ preventScroll: true }); });
  $('#tmBench').addEventListener('click', () => { SFX.close(); hideDone(); rsBtn.focus({ preventScroll: true }); });
  $('#tmShop').addEventListener('click', e => {
    const c = coffee();
    if (MAIN && c.b > -1) { e.preventDefault(); reset(); close(); go('blends', c.b); }
    else if (!MAIN && typeof show === 'function') { e.preventDefault(); reset(); close(); show(c.key); window.scrollTo(0, 0); }
  });
  soundTgl.addEventListener('click', () => { soundPart('clock', !loud()); syncSound(); if (loud()) SFX.clock(SFX.count); });
  $('#tmFlip').addEventListener('click', () => face('how', true));
  $('#tmFlipBack').addEventListener('click', () => face('recipe', true));
  $('#tmHowBtn').addEventListener('click', () => { face('how'); setTimeout(() => card.scrollIntoView({ block: 'start', behavior: RM ? 'auto' : 'smooth' }), RM ? 0 : 200); });
  voiceTgl.addEventListener('click', () => { st.voice = !st.voice; voiceTgl.setAttribute('aria-pressed', String(st.voice)); SFX.toggle(); if (st.voice) say('Calling the plays'); else { try { window.speechSynthesis.cancel(); } catch (err) {} } });
  document.addEventListener('keydown', e => {
    if (!el.classList.contains('open')) return;
    if (e.key === 'Escape' && !MAIN) { close(); return; }
    /* space starts and stops the clock from anywhere on the bench */
    if (e.key === ' ' && !done.classList.contains('on') && !/^(BUTTON|A|INPUT|SELECT|TEXTAREA)$/.test(e.target.tagName)) { e.preventDefault(); goBtn.click(); }
  });
  /* anything on the page marked data-brew opens it, on that coffee if it names one */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-brew]');
    if (!b) return;
    e.preventDefault();
    open({ c: b.dataset.brew || undefined, m: b.dataset.brewM || undefined });
  });
  /* the clock in the section that introduces it: it runs a thirty second shot over and over while it's on screen */
  const demo = $('#brewitLed');
  if (demo) {
    const D = { m: ledDigit(demo, 0, 1), s1: ledDigit(demo, 88, 1), s2: ledDigit(demo, 152, 1), t: ledDigit(demo, 228, 0.6) };
    [ledDot(demo, 76, 32, 6), ledDot(demo, 76, 68, 6), ledDot(demo, 222, 90, 4.5)].forEach(c => c.classList.add('on'));
    const show = s => { const w = Math.floor(s); ledSet(D.m, '0'); ledSet(D.s1, String(Math.floor(w / 10))); ledSet(D.s2, String(w % 10)); ledSet(D.t, String(Math.floor(s * 10) % 10)); };
    let dt = 0, d0 = 0;
    show(28.4);
    if (!RM && 'IntersectionObserver' in window) new IntersectionObserver(en => {
      clearInterval(dt);
      if (en[0].isIntersecting) { d0 = performance.now(); dt = setInterval(() => { const s = ((performance.now() - d0) / 1000) % 33; show(Math.min(s, 30)); }, 100); }
    }, { threshold: 0.2 }).observe(demo);
  }
  /* a link straight to it */
  if (/^#brew\b/.test(location.hash)) { let n = 0; const wait = setInterval(() => { if (!MAIN || S.entered) { clearInterval(wait); setTimeout(() => open(), 0); } else if (++n > 600) clearInterval(wait); }, 200); }
  return { open: open, close: close, pick: pick, start: start, pause: pause, reset: reset, st: st, frame: frame, COFFEES: COFFEES };
})();
if (window.__cfl) window.__cfl.Brew = Brew;
if (window.__pp) window.__pp.Brew = Brew;

/* ---------- the 5 minute profit audit ----------
   The same questions, scoring and wording as the audit we already run at audit.brotherofmine.com.au, rebuilt as part of
   the site: one question at a time on the left, and a docket on the right that prints a line for every answer.
   The scoring model below is copied across as it stands, so a venue gets the same score in both places. */
const Audit = (() => {
  const el = $('#audit');
  if (!el) return null;
  const MAIN = typeof openOv === 'function';
  const STORE = typeof CFG.shop === 'string';                       /* on the store the report really is sent */
  const POST = 'https://bom-email-marketing.jos-866.workers.dev/audit/';
  const stage = $('#auStage'), linesEl = $('#auLines'), nav = $('#auNav'), backBtn = $('#auBack'), nextBtn = $('#auNext');
  const prog = $('#auProg'), countEl = $('#auCount'), tape = $('#auTape'), body = $('#auBody');

  /* ---- scoring model: constants at the top so they can be tuned without touching logic. Bands read: value <= threshold
     -> points, first match wins. Labour 40 to 50% is the current WA independent norm; never present 30 to 35% as the pass mark. ---- */
  const SCORING = {
    labour:    { weight: 17, bands: [[0.35, 17], [0.40, 14], [0.45, 10], [0.50, 6], [Infinity, 2]], unknown: 6 },
    cogs:      { weight: 17, bands: [[0.28, 17], [0.32, 13], [0.35, 9], [0.40, 4], [Infinity, 2]], unknown: 6 },
    occupancy: { weight: 9,  bands: [[0.08, 9], [0.12, 7], [0.15, 4], [Infinity, 2]], unknown: 3 }
  };
  const DOSE_G = 20, CUP_LID = 0.20, MILK_FRAC = 0.90, MILK_L_PER_CUP = 0.207, MILK_PRICE_2L = 4.80;
  const BOM_PRICE = 42, BROWNES_PRICE = 3.49, BOTTLES_PER_CARTON = 9;
  const BAND_RANGES = {
    revenue: { 'under8k': [3000, 8000, 250], '8-15k': [8000, 15000, 250], '15-25k': [15000, 25000, 250], '25-32k': [25000, 32000, 250], '32-40k': [32000, 40000, 250], '40k+': [40000, 80000, 1000] },
    wage:    { 'under3k': [1000, 3000, 100], '3-6k': [3000, 6000, 100], '6-10k': [6000, 10000, 250], '10-16k': [10000, 16000, 250], '16k+': [16000, 30000, 500] },
    rent:    { 'under1k': [300, 1000, 50], '1-2k': [1000, 2000, 50], '2-3.5k': [2000, 3500, 100], '3.5k+': [3500, 8000, 250] }
  };
  const BANDS = {
    revenue: [['under8k', 6000, 'Under $8K a week'], ['8-15k', 11500, '$8K to $15K a week'], ['15-25k', 20000, '$15K to $25K a week'], ['25-32k', 28500, '$25K to $32K a week'], ['32-40k', 36000, '$32K to $40K a week'], ['40k+', 50000, '$40K+ a week']],
    wage:    [['under3k', 2200, 'Under $3K a week'], ['3-6k', 4500, '$3K to $6K a week'], ['6-10k', 8000, '$6K to $10K a week'], ['10-16k', 13000, '$10K to $16K a week'], ['16k+', 19000, '$16K+ a week']],
    rent:    [['under1k', 750, 'Under $1K a week'], ['1-2k', 1500, '$1K to $2K a week'], ['2-3.5k', 2750, '$2K to $3.5K a week'], ['3.5k+', 4500, '$3.5K+ a week']]
  };
  const VENUES = [['cafe', 'Cafe'], ['cafe-kitchen', 'Cafe + kitchen'], ['restaurant', 'Restaurant'], ['qsr', 'Takeaway / QSR'], ['bar', 'Bar']];
  const OPTS = {
    stocktake: [['weekly', 'Weekly'], ['monthly', 'Monthly'], ['rarely', 'Rarely'], ['never', 'Never']],
    ordering: [['system', 'System or par levels'], ['owner-gut', 'Owner, gut feel'], ['staff-gut', 'Staff or chef, gut feel']],
    wasteTracked: [['yes', 'Yes, written down'], ['sort-of', 'Sort of'], ['no', 'No']],
    plFrequency: [['weekly', 'Weekly'], ['monthly', 'Monthly'], ['quarterly', 'Quarterly'], ['tax-time', 'Tax time only']],
    yesterdayRevenue: [['dollar', 'To the dollar'], ['roughly', 'Roughly'], ['no-idea', 'No idea']],
    hoursBand: [['under40', 'Under 40'], ['40-50', '40 to 50'], ['50-60', '50 to 60'], ['60+', '60+']],
    onBusiness: [['block', 'A decent block most weeks'], ['some', 'An hour here and there'], ['none', 'None. I\'m on the tools all week']],
    social: [['consistent', 'Consistent, it brings people in'], ['sometimes', 'We post when we remember'], ['barely', 'Barely touched'], ['none', 'Not our thing']],
    bottomLine: [['profitable', 'Yes, profitable'], ['breakeven', 'About breakeven'], ['losing', 'Losing money'], ['not-sure', 'Honestly not sure']]
  };
  const SCREENS = ['intro', 'revenue', 'labour', 'cogs', 'rent', 'coffee', 'coffeeplus', 'stock', 'numbers', 'week', 'found', 'bottom', 'results'];
  const TOTAL = 11;
  const fresh = () => ({
    cafeName: '', venueType: null,
    revenueBand: null, revenueMid: null, revenueExact: false,
    wageBand: null, wageMid: null, wageKnown: true, wageExact: false,
    cogsPct: 0.32, cogsKnown: true, cogsTouched: false,
    rentBand: null, rentMid: null, rentKnown: true, rentExact: false,
    cupsPerDay: 150, daysPerWeek: 6, coffeeKgPrice: 48, menuPrice: 6.00,
    deepDive: null, milkCartonsPerWeek: 4, milkPricePer2L: 4.80, milkWasteML: 50, grinderDrift: 1,
    stocktake: null, ordering: null, wasteTracked: null,
    plFrequency: null, yesterdayRevenue: null,
    hoursBand: null, onBusiness: null, social: null, bottomLine: null,
    contactName: '', contactEmail: '', contactPhone: ''
  });
  let d = fresh(), step = 0, unlocked = false, last = null, subId = null, pendingCta = null, from = null, fromTop = 0, built = false, timer = 0;
  const doc = {};                                                    /* the docket: one line per thing they have told us */
  const DOC_ORDER = ['venue', 'till', 'wages', 'cogs', 'rent', 'coffee', 'milk', 'stock', 'numbers', 'week', 'found', 'bottom'];

  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const fmtNum = n => Math.round(n).toLocaleString('en-AU');
  const label = (list, v) => { const o = list.find(x => x[0] === v); return o ? o[o.length - 1] : ''; };
  function roundRange(n) {
    if (n <= 0) return 0;
    if (n < 1000) return Math.round(n / 100) * 100;
    if (n < 10000) return Math.round(n / 500) * 500;
    return Math.round(n / 1000) * 1000;
  }
  function bandScore(value, cfg) {
    for (const [thresh, pts] of cfg.bands) if (value <= thresh) return pts;
    return cfg.bands[cfg.bands.length - 1][1];
  }
  const barColour = pct => (pct >= 80 ? 'win' : pct >= 60 ? 'good' : pct >= 40 ? 'mid' : 'low');
  function scoreBand(total) {
    if (total >= 80) return { label: 'Tight ship', cls: 'win', verdict: 'You run a better operation than most. The gaps below are fine-tuning.' };
    if (total >= 60) return { label: 'Solid, but leaking', cls: 'good', verdict: 'Good bones. Two or three leaks are quietly taxing you.' };
    if (total >= 40) return { label: 'Leaks are compounding', cls: 'mid', verdict: 'Nothing fatal yet. But these numbers say the business is running you.' };
    return { label: 'Flying blind', cls: 'low', verdict: 'You\'re working too hard to not know these numbers. Let\'s fix that this month.' };
  }

  /* ---- the docket ---- */
  function line(key, name, value, note) {
    const was = doc[key];
    if (value == null) { if (!was) return; delete doc[key]; }
    else doc[key] = { name: name, value: value, note: note || '' };
    linesEl.innerHTML = DOC_ORDER.filter(k => doc[k]).map(k =>
      '<li data-k="' + k + '"' + (k === key && !was ? ' class="new"' : '') + '><span>' + doc[k].name + '</span><b>' + doc[k].value + '</b>' + (doc[k].note ? '<small>' + doc[k].note + '</small>' : '') + '</li>').join('');
    const li = $('[data-k="' + key + '"]', linesEl);
    if (li) {
      if (!was) { requestAnimationFrame(() => li.classList.remove('new')); SFX.paper(); }
      const roll = linesEl.parentElement.parentElement;                 /* feed the paper up so the newest line is in view */
      roll.scrollTop = roll.scrollHeight;
      setTimeout(() => { roll.scrollTop = roll.scrollHeight; }, 560);
      tape.innerHTML = '<span>' + doc[key].name + '</span> ' + doc[key].value;
    }
  }

  /* ---- what each answer says back. Mid-flow rule: mirror their own numbers, never grade them.
     Every comparison against a benchmark waits for the results, next to the fix. ---- */
  function revenueNote() {
    const annual = d.revenueMid * 52;
    const pretty = annual >= 1e6 ? '$' + (annual / 1e6).toFixed(2).replace(/\.?0+$/, '') + 'M' : '$' + Math.round(annual / 1000) + 'K';
    const nod = annual >= 2e6 ? 'Big ship. Take a bow.' : annual >= 1e6 ? 'That\'s a serious operation. Well done.' : annual >= 5e5 ? 'Solid trade. Plenty to work with.' : 'Real money when it\'s your name on the door.';
    return ['That\'s about ' + pretty + ' a year through the till. ' + nod, 'About ' + pretty + ' a year'];
  }
  function mirror(field) {
    const ins = $('#auIns');
    if (field === 'revenue' && d.revenueMid) {
      const n = revenueNote(); if (ins) ins.textContent = n[0];
      line('till', 'Through the till', '$' + fmtNum(d.revenueMid) + ' a week', n[1]);
    }
    if (field === 'wage' && d.wageMid) {
      const pct = d.revenueMid ? Math.round(d.wageMid / d.revenueMid * 100) : null;
      if (ins && pct != null) ins.textContent = 'That\'s about ' + pct + '% of your revenue on wages. Wages have jumped for everyone since the award rise. We\'ll show you where this sits at the end.';
      line('wages', 'Wages', '$' + fmtNum(d.wageMid) + ' a week', pct != null ? 'About ' + pct + '% of revenue' : '');
    }
    if (field === 'rent' && d.rentMid) {
      const pct = d.revenueMid ? Math.round(d.rentMid / d.revenueMid * 100) : null;
      if (ins && pct != null) ins.textContent = 'That\'s about ' + pct + '% of revenue on rent. We\'ll benchmark it against WA venues at the end.';
      line('rent', 'Rent', '$' + fmtNum(d.rentMid) + ' a week', pct != null ? 'About ' + pct + '% of revenue' : '');
    }
  }
  function cogsNote() {
    const ins = $('#auIns');
    if (!d.cogsKnown) { if (ins) ins.textContent = 'Fair enough. We\'ll flag it. Knowing your food cost is step one.'; line('cogs', 'Food and drink', 'No idea', 'That\'s a finding too'); return; }
    const weekly = d.revenueMid ? Math.round(d.cogsPct * d.revenueMid) : 0;
    if (ins) ins.textContent = weekly ? 'About $' + fmtNum(weekly) + ' a week on ingredients and packaging. We\'ll show you where that sits at the end.' : 'Locked in. We\'ll show you where that sits at the end.';
    line('cogs', 'Food and drink', Math.round(d.cogsPct * 100) + '% of sales', weekly ? 'About $' + fmtNum(weekly) + ' a week' : '');
  }
  function coffeeNote() {
    const ins = $('#auIns');
    if (!d.menuPrice || d.menuPrice <= 0) { if (ins) ins.textContent = ''; return; }
    const perCupBeans = (d.coffeeKgPrice / 1000) * DOSE_G, milkPerCup = MILK_L_PER_CUP * (MILK_PRICE_2L / 2);
    const avgCOGS = (perCupBeans + milkPerCup + CUP_LID) * MILK_FRAC + (perCupBeans + CUP_LID) * (1 - MILK_FRAC);
    const gp = Math.round((d.menuPrice - avgCOGS) / d.menuPrice * 100);
    if (ins) ins.textContent = 'About $' + avgCOGS.toFixed(2) + ' a cup all-in, ' + gp + '% gross margin. We\'ll show you what that means at the end.';
    line('coffee', 'Coffee', d.cupsPerDay + ' a day, ' + d.daysPerWeek + ' days', '$' + d.coffeeKgPrice + ' a kilo, $' + d.menuPrice.toFixed(2) + ' on the menu');
  }
  function deepNote() {
    if (d.deepDive !== true) { line('milk', '', null); return; }
    const litres = d.milkCartonsPerWeek * BOTTLES_PER_CARTON * 2, spend = d.milkCartonsPerWeek * BOTTLES_PER_CARTON * d.milkPricePer2L;
    const annual = d.cupsPerDay * d.daysPerWeek * 52;
    const a = $('#auMilkIns'), b = $('#auWasteIns'), c = $('#auDriftIns');
    if (a) a.textContent = litres + ' litres a week, about $' + Math.round(spend) + ' on dairy.';
    if (b) b.textContent = d.milkWasteML > 0 && annual > 0 ? 'That\'s about ' + fmtNum(d.milkWasteML * annual * MILK_FRAC / 1000) + ' litres a year down the drain.' : 'Jug overfill, stirring, sugar prep. It adds up.';
    if (c) c.textContent = d.grinderDrift > 0 && annual > 0 ? (d.grinderDrift * annual / 1000).toFixed(1) + 'kg of extra beans a year.' : 'Most uncalibrated grinders drift 0.5 to 2g.';
    line('milk', 'Milk and grinder', litres + ' L a week', d.milkWasteML + 'ml wasted a serve, ' + d.grinderDrift + 'g drift');
  }
  const pair = (list, keys) => keys.map(k => label(OPTS[k], d[k])).filter(Boolean).join(', ');

  /* ---- the screens ---- */
  const chip = (attrs, text, on) => '<button type="button" class="au-chip" ' + attrs + ' aria-pressed="' + (on ? 'true' : 'false') + '">' + text + '</button>';
  const group = (f, q) => '<div class="au-g"><p class="au-l" id="auL' + f + '">' + q + '</p><div class="au-chips" role="group" aria-labelledby="auL' + f + '">' + OPTS[f].map(o => chip('data-f="' + f + '" data-v="' + o[0] + '"', o[1], d[f] === o[0])).join('') + '</div></div>';
  const head = (h, sub) => '<h2 class="au-q" tabindex="-1">' + h + '</h2>' + (sub ? '<p class="au-sub">' + sub + '</p>' : '');
  const stepper = (key, text, by) => '<div class="au-f"><p class="au-l" id="auL' + key + '">' + text + '</p><div class="au-step"><button type="button" data-adj="' + key + '" data-by="' + (-by) + '" aria-label="Less">&minus;</button><input type="number" inputmode="decimal" id="au_' + key + '" data-num="' + key + '" value="' + d[key] + '" aria-labelledby="auL' + key + '"><button type="button" data-adj="' + key + '" data-by="' + by + '" aria-label="More">+</button></div></div>';
  const dollars = (key, text) => '<div class="au-f"><label class="au-l" for="au_' + key + '">' + text + '</label><div class="au-cash"><span aria-hidden="true">$</span><input type="number" inputmode="decimal" step="0.1" id="au_' + key + '" data-num="' + key + '" value="' + (key === 'coffeeKgPrice' ? d[key] : (+d[key]).toFixed(2)) + '"></div></div>';
  function bandScreen(field, h, sub, unknown) {
    const band = d[field + 'Band'], known = d[field + 'Known'] !== false, r = band && BAND_RANGES[field][band];
    return head(h, sub) +
      '<div class="au-chips au-col" role="group" aria-label="' + esc(h) + '">' + BANDS[field].map(o => chip('data-band="' + field + '" data-id="' + o[0] + '" data-mid="' + o[1] + '"', o[2], band === o[0])).join('') +
      (unknown ? chip('data-unknown="' + field + '"', 'Not sure', !known) : '') + '</div>' +
      '<div class="au-fine' + (r ? ' on' : '') + '" id="auFine"><p class="au-read" id="auRead">' + (r ? '$' + fmtNum(d[field + 'Mid']) + '<small> a week</small>' : '') + '</p>' +
      '<input class="range au-range" type="range" id="auSlide" data-fine="' + field + '" aria-label="Fine tune the weekly figure"' + (r ? ' min="' + r[0] + '" max="' + r[1] + '" step="' + r[2] + '" value="' + d[field + 'Mid'] + '" style="--v:' + ((d[field + 'Mid'] - r[0]) / (r[1] - r[0]) * 100) + '%"' : '') + '>' +
      '<p class="au-hint">We\'ll score you on this number. Drag if it\'s off. Rough is fine.</p></div>' +
      '<p class="au-ins" id="auIns" aria-live="polite">' + (!known ? 'No worries. Not knowing this one is itself a finding.' : '') + '</p>';
  }
  const SCREEN = {
    intro: () => '<p class="au-kick">Brother of Mine, for venues</p>' + head('5 minute <span class="hl">profit audit</span>', 'Mostly taps, a couple of numbers. We\'ll score the whole operation, price your biggest leak, and email you the report.') +
      '<ul class="au-ticks"><li>Under 5 min</li><li>Mostly taps</li><li>Report emailed to you</li></ul>' +
      '<div class="au-f"><label class="au-l" for="auCafe">Business name (optional)</label><input class="au-text" type="text" id="auCafe" placeholder="e.g. The Corner Grind" autocomplete="organization" value="' + esc(d.cafeName) + '"></div>' +
      '<div class="au-g"><p class="au-l" id="auLvenue">What kind of venue?</p><div class="au-chips" role="group" aria-labelledby="auLvenue">' + VENUES.map(o => chip('data-venue="' + o[0] + '"', o[1], d.venueType === o[0])).join('') + '</div></div>' +
      '<img class="au-art" src="' + pic('au-detective') + '" alt="" aria-hidden="true">',
    revenue: () => bandScreen('revenue', 'What\'s the <span class="hl">till</span> doing?', 'Average weekly revenue, all in. Rough is fine.'),
    labour: () => bandScreen('wage', 'What\'s the <span class="hl">wage bill?</span>', 'Weekly wages including super. Include what you pay yourself.', true),
    cogs: () => head('Food and drink <span class="hl">costs</span>', 'What you spend on ingredients, beans, milk and packaging, as a share of sales.') +
      '<div class="au-fine on"><p class="au-read' + (d.cogsKnown ? '' : ' off') + '" id="auRead">' + (d.cogsKnown ? Math.round(d.cogsPct * 100) + '%' : '?') + '</p>' +
      '<input class="range au-range" type="range" id="auSlide" data-cogs min="20" max="45" step="1" value="' + Math.round(d.cogsPct * 100) + '" style="--v:' + ((Math.round(d.cogsPct * 100) - 20) / 25 * 100) + '%" aria-label="Food and drink costs as a share of sales"' + (d.cogsKnown ? '' : ' disabled') + '>' +
      '<p class="au-ends" aria-hidden="true"><span>20%</span><span>45%</span></p></div>' +
      '<div class="au-chips">' + chip('data-cogsunknown', 'No idea', !d.cogsKnown) + '</div>' +
      '<p class="au-ins" id="auIns" aria-live="polite">Slide to your best guess. Rough is fine.</p>',
    rent: () => bandScreen('rent', 'What\'s the <span class="hl">rent?</span>', 'Weekly rent and outgoings.', true),
    coffee: () => head('Your coffee <span class="hl">programme</span>', 'The bit we know better than anyone.') +
      '<div class="au-grid">' + stepper('cupsPerDay', 'Coffees per day', 10) +
      '<div class="au-f"><p class="au-l" id="auLdays">Days open per week</p><div class="au-chips au-mini" role="group" aria-labelledby="auLdays">' + [5, 6, 7].map(n => chip('data-days="' + n + '"', n, d.daysPerWeek === n)).join('') + '</div></div>' +
      dollars('coffeeKgPrice', 'Bean cost / kg') + dollars('menuPrice', '12oz menu price') + '</div>' +
      '<p class="au-ins" id="auIns" aria-live="polite"></p>',
    coffeeplus: () => head('Want the full coffee <span class="hl">breakdown?</span>', '3 more taps, about 30 seconds. We\'ll price your milk, waste and grinder as well as the beans.') +
      '<div class="au-chips">' + chip('data-deep="1"', 'Yes, do the lot', d.deepDive === true) + chip('data-deep="0"', 'Skip, beans are enough', d.deepDive === false) + '</div>' +
      '<div class="au-deep" id="auDeep"' + (d.deepDive === true ? '' : ' hidden') + '><div class="au-grid">' +
      stepper('milkCartonsPerWeek', 'Milk crates / week (9 x 2L)', 1) + dollars('milkPricePer2L', 'Price / 2L bottle') + '</div><p class="au-ins sm" id="auMilkIns"></p>' +
      '<div class="au-f"><p class="au-l" id="auLwaste">Milk wasted per serve</p><div class="au-chips au-mini" role="group" aria-labelledby="auLwaste">' + [[30, 'Low'], [50, 'Typical'], [80, 'High']].map(o => chip('data-waste="' + o[0] + '"', o[1] + '<small>' + o[0] + 'ml</small>', d.milkWasteML === o[0])).join('') + '</div></div><p class="au-ins sm" id="auWasteIns">Jug overfill, stirring, sugar prep. It adds up.</p>' +
      '<div class="au-grid">' + stepper('grinderDrift', 'Grinder drift (grams over target per shot)', 0.5) + '</div><p class="au-ins sm" id="auDriftIns">Most uncalibrated grinders drift 0.5 to 2g.</p></div>',
    stock: () => head('Stock and <span class="hl">ordering</span>', 'Honest answers. Nobody\'s watching.') + group('stocktake', 'How often do you stocktake?') + group('ordering', 'Who does the ordering, and how?') + group('wasteTracked', 'Do you track waste?'),
    numbers: () => head('How close are you to your <span class="hl">numbers?</span>', 'No judgement. This is the whole point of the audit.') + group('plFrequency', 'How often do you look at a P&amp;L?') + group('yesterdayRevenue', 'Yesterday\'s revenue. Do you know it?'),
    week: () => head('Your <span class="hl">week</span>', 'Every operator we meet is stretched. This is about where the hours go, not how hard you work.') + group('hoursBand', 'How many hours a week do you put in?') + group('onBusiness', 'How much of that is working ON the business? Planning, numbers, marketing.'),
    found: () => head('Getting <span class="hl">found</span>') + group('social', 'How\'s the social media presence?'),
    bottom: () => head('Straight up. Is the business <span class="hl">making money?</span>', 'Your gut answer is the right answer.') + group('bottomLine', 'Your call')
  };

  function paintNav() {
    const name = SCREENS[step], res = name === 'results';
    el.dataset.at = name;
    nav.hidden = res;
    backBtn.hidden = step === 0;
    nextBtn.textContent = step === 0 ? 'Let\'s go' : step === TOTAL ? 'See my score' : 'Next';
    nextBtn.disabled = step === 0 && !d.venueType;
    prog.innerHTML = step > 0 && !res ? Array.from({ length: TOTAL }, (_, i) => '<i class="' + (i + 1 < step ? 'done' : i + 1 === step ? 'on' : '') + '"></i>').join('') : '';
    countEl.textContent = step > 0 && !res ? step + ' of ' + TOTAL : '';
  }
  function goTo(n, quiet) {
    clearTimeout(timer);
    step = clamp(n, 0, SCREENS.length - 1);
    const name = SCREENS[step];
    stage.classList.remove('in'); void stage.offsetWidth;
    if (name === 'results') showResults(); else stage.innerHTML = SCREEN[name]();
    stage.classList.add('in');
    paintNav();
    body.scrollTop = 0; stage.scrollTop = 0;
    if (name === 'coffee') coffeeNote();
    if (name === 'coffeeplus') deepNote();
    if (name === 'cogs' && d.cogsTouched) cogsNote();
    if (name === 'revenue' || name === 'labour' || name === 'rent') mirror(name === 'labour' ? 'wage' : name);
    if (!quiet) { const h = $('.au-q', stage) || $('.au-score', stage); if (h) h.focus({ preventScroll: true }); }
  }
  const advance = ms => { clearTimeout(timer); timer = setTimeout(() => goTo(step + 1), ms || 280); };
  const press = (b, all) => { (all || $$('.au-chip', b.parentElement)).forEach(c => c.setAttribute('aria-pressed', String(c === b))); SFX.toggle(); };

  stage.addEventListener('click', e => {
    const b = e.target.closest('button');
    if (!b || !stage.contains(b)) return;
    const s = b.dataset;
    if (s.venue) { d.venueType = s.venue; press(b); line('venue', 'Venue', label(VENUES, s.venue), d.cafeName ? esc(d.cafeName) : ''); paintNav(); return; }
    if (s.band) {
      const f = s.band; d[f + 'Band'] = s.id; d[f + 'Mid'] = +s.mid; d[f + 'Known'] = true; d[f + 'Exact'] = false; press(b);
      const r = BAND_RANGES[f][s.id], sl = $('#auSlide');
      sl.min = r[0]; sl.max = r[1]; sl.step = r[2]; sl.value = s.mid; sl.style.setProperty('--v', ((+s.mid - r[0]) / (r[1] - r[0]) * 100) + '%');
      $('#auRead').innerHTML = '$' + fmtNum(+s.mid) + '<small> a week</small>'; $('#auFine').classList.add('on');
      mirror(f); return;
    }
    if (s.unknown) {
      const f = s.unknown; d[f + 'Band'] = null; d[f + 'Mid'] = null; d[f + 'Known'] = false; d[f + 'Exact'] = false; press(b);
      $('#auFine').classList.remove('on'); $('#auIns').textContent = 'No worries. Not knowing this one is itself a finding.';
      line(f === 'wage' ? 'wages' : 'rent', f === 'wage' ? 'Wages' : 'Rent', 'Not sure', 'That\'s a finding too'); advance(900); return;
    }
    if ('cogsunknown' in s) { d.cogsKnown = false; d.cogsTouched = true; b.setAttribute('aria-pressed', 'true'); SFX.toggle(); $('#auSlide').disabled = true; const r = $('#auRead'); r.textContent = '?'; r.classList.add('off'); cogsNote(); advance(700); return; }
    if (s.days) { d.daysPerWeek = +s.days; press(b); coffeeNote(); return; }
    if (s.deep) { d.deepDive = s.deep === '1'; press(b); $('#auDeep').hidden = !d.deepDive; deepNote(); if (!d.deepDive) advance(320); return; }
    if (s.waste) { d.milkWasteML = +s.waste; press(b); deepNote(); return; }
    if (s.adj) {
      const key = s.adj, inp = $('#au_' + key);
      let v = (parseFloat(inp.value) || 0) + parseFloat(s.by);
      v = Math.round(Math.max(key === 'milkCartonsPerWeek' ? 1 : 0, v) * 10) / 10;
      inp.value = v; d[key] = v; SFX.tick();
      if (key === 'cupsPerDay') coffeeNote(); else deepNote();
      return;
    }
    if (s.f) {
      d[s.f] = s.v; press(b);
      const at = SCREENS[step];
      if (at === 'stock') line('stock', 'Stock', pair(OPTS, ['stocktake', 'ordering', 'wasteTracked']));
      if (at === 'numbers') line('numbers', 'Numbers', pair(OPTS, ['plFrequency', 'yesterdayRevenue']));
      if (at === 'week') { line('week', 'Your week', pair(OPTS, ['hoursBand', 'onBusiness'])); if (d.hoursBand && d.onBusiness) advance(400); }
      if (at === 'found') { line('found', 'Getting found', label(OPTS.social, d.social)); advance(320); }
      if (at === 'bottom') { line('bottom', 'Making money?', label(OPTS.bottomLine, d.bottomLine)); advance(320); }
      return;
    }
    if (s.area != null) { const open = b.getAttribute('aria-expanded') !== 'true'; b.setAttribute('aria-expanded', String(open)); SFX.tick(); return; }
    if (s.cta) { oneTap(s.cta, b); return; }
    if ('restart' in s) { restart(); return; }
    if ('save' in s) { window.print(); return; }
  });
  stage.addEventListener('input', e => {
    const t = e.target, s = t.dataset;
    if (t.id === 'auCafe') { d.cafeName = t.value; if (doc.venue) line('venue', 'Venue', doc.venue.value, esc(d.cafeName)); return; }
    if (s.fine) {
      const f = s.fine, v = parseInt(t.value, 10);
      d[f + 'Mid'] = v; d[f + 'Exact'] = true; $('#auRead').innerHTML = '$' + fmtNum(v) + '<small> a week</small>';
      t.style.setProperty('--v', ((v - t.min) / (t.max - t.min) * 100) + '%'); mirror(f); return;
    }
    if ('cogs' in s) {
      d.cogsPct = parseInt(t.value, 10) / 100; d.cogsKnown = true; d.cogsTouched = true;
      const r = $('#auRead'); r.textContent = t.value + '%'; r.classList.remove('off');
      t.style.setProperty('--v', ((t.value - 20) / 25 * 100) + '%'); cogsNote(); return;
    }
    if (s.num) { d[s.num] = parseFloat(t.value) || 0; if (SCREENS[step] === 'coffee') coffeeNote(); else deepNote(); return; }
    if (t.name && t.name in d) { d[t.name] = t.value; const i = $('#auCapIns'); if (i) i.textContent = ''; }
  });
  stage.addEventListener('submit', e => { e.preventDefault(); unlock(); });
  nextBtn.addEventListener('click', () => {
    if (step === 0 && !d.venueType) return;
    if (SCREENS[step] === 'cogs' && !d.cogsTouched) { d.cogsTouched = true; cogsNote(); }
    SFX.click(); goTo(step + 1);
  });
  backBtn.addEventListener('click', () => { SFX.click(); goTo(step - 1); });

  /* ---- scoring engine ---- */
  function calculate() {
    let revenueMid = d.revenueMid, assumed = false;
    if (!revenueMid) { revenueMid = 20000; assumed = true; }
    const annualRev = revenueMid * 52;
    const labourKnown = d.wageKnown && d.wageMid != null;
    const labourPct = labourKnown ? d.wageMid / revenueMid : null;
    const labourScore = labourKnown ? bandScore(labourPct, SCORING.labour) : SCORING.labour.unknown;
    const cogsKnown = d.cogsKnown, cogsPct = cogsKnown ? d.cogsPct : null;
    const cogsScore = cogsKnown ? bandScore(cogsPct, SCORING.cogs) : SCORING.cogs.unknown;
    const rentKnown = d.rentKnown && d.rentMid != null;
    const occupancyPct = rentKnown ? d.rentMid / revenueMid : null;
    const occupancyScore = rentKnown ? bandScore(occupancyPct, SCORING.occupancy) : SCORING.occupancy.unknown;
    /* coffee. The deep dive uses their real milk price; the fast path uses the default */
    const deep = d.deepDive === true;
    const milkPrice = deep ? d.milkPricePer2L : MILK_PRICE_2L;
    const perCupBeans = (d.coffeeKgPrice / 1000) * DOSE_G, milkPerCup = MILK_L_PER_CUP * (milkPrice / 2);
    const avgCOGS = (perCupBeans + milkPerCup + CUP_LID) * 0.9 + (perCupBeans + CUP_LID) * 0.1;
    const coffeeGpPct = d.menuPrice > 0 ? (d.menuPrice - avgCOGS) / d.menuPrice : 0;
    const coffeeScore = coffeeGpPct >= 0.75 ? 13 : coffeeGpPct >= 0.65 ? 10 : coffeeGpPct >= 0.55 ? 7 : 3;
    const annualCups = d.cupsPerDay * d.daysPerWeek * 52;
    const coffeeDelta = (perCupBeans - (BOM_PRICE / 1000) * DOSE_G) * annualCups;
    const menuOpportunity = Math.max(0, Math.min(0.50, 6.50 - d.menuPrice)) * annualCups;
    let deepDive = null;
    if (deep) {
      const currentMilkWeekly = d.milkCartonsPerWeek * BOTTLES_PER_CARTON * d.milkPricePer2L;
      const brownesMilkWeekly = d.milkCartonsPerWeek * BOTTLES_PER_CARTON * BROWNES_PRICE;
      const annualMilkSavings = Math.max(0, currentMilkWeekly - brownesMilkWeekly) * 52;
      const annualDriftKg = (d.grinderDrift * annualCups) / 1000, grinderSavings = annualDriftKg * d.coffeeKgPrice;
      const wasteLitresPerYear = (d.milkWasteML * annualCups * MILK_FRAC) / 1000;
      const milkWasteCost = wasteLitresPerYear * (d.milkPricePer2L / 2), milkWasteCostBrownes = wasteLitresPerYear * (BROWNES_PRICE / 2);
      const milkWasteSavings = Math.max(0, milkWasteCost - milkWasteCostBrownes);
      const directSavings = Math.max(0, coffeeDelta) + annualMilkSavings + grinderSavings + milkWasteSavings;
      const annualKg = (annualCups * DOSE_G) / 1000, annualBomSpend = annualKg * BOM_PRICE;
      const effectivePerKg = annualKg > 0 ? (annualBomSpend - directSavings) / annualKg : BOM_PRICE;
      deepDive = { currentMilkWeekly, brownesMilkWeekly, annualMilkSavings, annualDriftKg, grinderSavings, wasteLitresPerYear, milkWasteCost, milkWasteCostBrownes, milkWasteSavings, directSavings, annualKg, annualBomSpend, effectivePerKg };
    }
    const pts = (map, v, none) => (v in map ? map[v] : none);
    const stockScore = pts({ weekly: 5, monthly: 3, rarely: 1, never: 0 }, d.stocktake, 0) + pts({ system: 4, 'owner-gut': 2, 'staff-gut': 1 }, d.ordering, 0) + pts({ yes: 4, 'sort-of': 2, no: 0 }, d.wasteTracked, 0);
    const numbersScore = pts({ weekly: 5, monthly: 4, quarterly: 2, 'tax-time': 0 }, d.plFrequency, 0) + pts({ dollar: 4, roughly: 2, 'no-idea': 0 }, d.yesterdayRevenue, 0);
    const ownerScore = pts({ 'under40': 4, '40-50': 3, '50-60': 2, '60+': 1 }, d.hoursBand, 0) + pts({ block: 6, some: 3, none: 0 }, d.onBusiness, 0);
    const presenceScore = pts({ consistent: 5, sometimes: 3, barely: 1, none: 0 }, d.social, 0);
    const bottomScore = pts({ profitable: 7, breakeven: 4, 'not-sure': 2, losing: 1 }, d.bottomLine, 2);
    const areas = {
      labour: { score: labourScore, weight: 17, known: labourKnown, pct: labourPct },
      cogs: { score: cogsScore, weight: 17, known: cogsKnown, pct: cogsPct },
      occupancy: { score: occupancyScore, weight: 9, known: rentKnown, pct: occupancyPct },
      coffee: { score: coffeeScore, weight: 13, known: true, gpPct: coffeeGpPct },
      stock: { score: stockScore, weight: 13, known: (d.stocktake || d.ordering || d.wasteTracked) != null },
      numbers: { score: numbersScore, weight: 9, known: (d.plFrequency || d.yesterdayRevenue) != null },
      owner: { score: ownerScore, weight: 10, known: (d.hoursBand || d.onBusiness) != null },
      presence: { score: presenceScore, weight: 5, known: d.social != null },
      bottom: { score: bottomScore, weight: 7, known: d.bottomLine != null }
    };
    const total = Math.round(Object.values(areas).reduce((s, a) => s + a.score, 0));
    const leak = biggestLeak(areas, { annualRev, coffeeDelta, menuOpportunity, cogsPct });
    /* total money found. The coffee leak is built from coffeeDelta + menuOpportunity, so when coffee headlines it must not count twice */
    const leakBest = (leak.area && leak.area !== 'coffee' && leak.low != null) ? roundRange((leak.low + leak.high) / 2) : 0;
    const foundTotal = Math.round(leakBest + Math.max(0, coffeeDelta) + menuOpportunity + (deepDive ? deepDive.annualMilkSavings + deepDive.grinderSavings + deepDive.milkWasteSavings : 0));
    return { total, areas, revenueMid, annualRev, assumed, labourPct, cogsPct, occupancyPct, coffeeGpPct, coffeeDelta, menuOpportunity, avgCOGS, annualCups, leak, deepDive, leakBest, foundTotal };
  }
  function biggestLeak(areas, ctx) {
    const { annualRev, coffeeDelta, menuOpportunity } = ctx;
    const cogsForStock = ctx.cogsPct != null ? ctx.cogsPct : 0.32;
    const order = ['labour', 'cogs', 'coffee', 'stock', 'owner', 'occupancy'];   /* tie-break priority */
    const formulas = {
      labour:    () => (areas.labour.known ? [(areas.labour.pct - 0.45) * annualRev, (areas.labour.pct - 0.40) * annualRev] : null),
      cogs:      () => (areas.cogs.known ? [(areas.cogs.pct - 0.32) * annualRev, (areas.cogs.pct - 0.28) * annualRev] : null),
      occupancy: () => (areas.occupancy.known ? [(areas.occupancy.pct - 0.12) * annualRev, (areas.occupancy.pct - 0.10) * annualRev] : null),
      coffee:    () => [Math.max(0, coffeeDelta), Math.max(0, coffeeDelta) + menuOpportunity],
      stock:     () => [0.02 * cogsForStock * annualRev, 0.05 * cogsForStock * annualRev],
      owner:     () => (areas.owner.known ? 'unpriced' : null)                  /* a real leak with no honest dollar figure */
    };
    /* rank by points lost, not by gap ratio, so a small area can't headline over a big-dollar one on percentage alone */
    const candidates = order.map(area => ({ area, pointsLost: areas[area].weight - areas[area].score }));
    candidates.sort((a, b) => (b.pointsLost !== a.pointsLost ? b.pointsLost - a.pointsLost : order.indexOf(a.area) - order.indexOf(b.area)));
    for (const c of candidates) {
      const range = formulas[c.area]();
      if (!range) continue;
      if (range === 'unpriced') { if (c.pointsLost < 6) continue; return { area: c.area, low: null, high: null, pointsLost: c.pointsLost }; }
      const low = Math.max(0, range[0]), high = Math.max(0, range[1]);
      if (high <= 0 && low <= 0 && c.area !== 'stock') continue;
      return { area: c.area, low: roundRange(low), high: roundRange(high), pointsLost: c.pointsLost };
    }
    return { area: null, low: null, high: null, pointsLost: 0 };
  }

  /* ---- what the results say, area by area: honest, specific and tied to a benchmark ---- */
  const areaCopy = {
    labour(a) {
      if (!a.known) return { known: false, detail: 'You couldn\'t tell us the wage bill. That\'s the finding. Labour is usually the biggest cost in the building, and you can\'t manage what you don\'t measure.' };
      const pct = Math.round(a.pct * 100);
      return { known: true, detail: pct <= 35 ? 'Labour about ' + pct + '% of revenue. Exceptional. The 2026 norm is 40 to 50%, so you\'re well ahead.'
        : pct <= 40 ? 'Labour about ' + pct + '% of revenue. Strong. That\'s ahead of the pack in 2026.'
        : pct <= 45 ? 'Labour about ' + pct + '% of revenue. That\'s the current normal for WA independents. The winners hold under 45.'
        : pct <= 50 ? 'Labour about ' + pct + '% of revenue. Squeezed. This is your heaviest cost and your biggest lever. Time for a roster plan.'
        : 'Labour about ' + pct + '% of revenue. Danger zone, and your biggest upside. Every point above 45 is money off the bottom line.' };
    },
    cogs(a) {
      if (!a.known) return { known: false, detail: 'You couldn\'t tell us your food cost. That\'s the finding. This is the second biggest number in the building and it needs a weekly eye on it.' };
      const pct = Math.round(a.pct * 100);
      return { known: true, detail: pct <= 28 ? 'Food and drink cost about ' + pct + '%. Best-practice territory (25 to 28%). Hold it there.'
        : pct <= 35 ? 'Food and drink cost about ' + pct + '%. Typical range (28 to 35%). A tighter buy and less waste pulls this down.'
        : 'Food and drink cost about ' + pct + '%. Above the 35% red line. Purchasing, portioning and waste are all leaking here.' };
    },
    occupancy(a) {
      if (!a.known) return { known: false, detail: 'You couldn\'t tell us the rent. Fair enough. Just know that above 15% of revenue, rent quietly eats the business.' };
      const pct = Math.round(a.pct * 100);
      return { known: true, detail: pct <= 8 ? 'Rent about ' + pct + '% of revenue. Excellent (high performers sit 6 to 8%). This gives you room to move.'
        : pct <= 12 ? 'Rent about ' + pct + '% of revenue. Healthy (8 to 12% is the sweet spot).'
        : pct <= 15 ? 'Rent about ' + pct + '% of revenue. Getting heavy. 15% is the ceiling. Volume is your way out.'
        : 'Rent about ' + pct + '% of revenue. Above the 15% ceiling. Either the rent comes down or the revenue goes up.' };
    },
    coffee(a) {
      const gp = Math.round(a.gpPct * 100);
      return { known: true, detail: gp >= 75 ? 'Coffee gross margin about ' + gp + '%. Excellent, top of the 65 to 75% band. The programme is working.'
        : gp >= 65 ? 'Coffee gross margin about ' + gp + '%. Right in the healthy 65 to 75% band.'
        : gp >= 55 ? 'Coffee gross margin about ' + gp + '%. Below the 65 to 75% benchmark. Bean price or menu price is the lever.'
        : 'Coffee gross margin about ' + gp + '%. Well under benchmark. You\'re leaving real money in every cup.' };
    },
    stock(a) {
      const pct = Math.round(a.score / a.weight * 100);
      return { known: true, detail: pct >= 80 ? 'Tight stock discipline. Counting, a real ordering system, and waste tracked. This is where the well-run venues separate.'
        : pct >= 50 ? 'Some discipline, some gaps. Par levels and a written waste log would tighten the buy and stop money walking out the back.'
        : 'Stock is running on gut feel. No count, no system, no waste log. This is quiet money leaving every week.' };
    },
    numbers(a) {
      const pct = Math.round(a.score / a.weight * 100);
      return { known: true, detail: pct >= 80 ? 'You\'re close to your numbers. Regular P&amp;L, you know your daily takings. That habit is the whole game.'
        : pct >= 50 ? 'You glance at the numbers but not often enough to catch a problem early. Weekly beats monthly beats tax time.'
        : 'You\'re too far from your numbers. If you only see a P&amp;L at tax time, every problem is already months old.' };
    },
    owner(a) {
      if (!a.known) return { known: false, detail: 'You skipped the hours question. Fair enough. Just know the owner\'s week is a cost line too, even when it never hits the P&amp;L.' };
      const pct = Math.round(a.score / a.weight * 100);
      return { known: true, detail: pct >= 80 ? 'You\'ve carved out real time to work ON the business, not just in it. That\'s the habit that compounds. Guard it.'
        : pct >= 50 ? 'You\'re getting some planning time but the tools still own most of your week. One protected hour on the numbers beats 10 more on the machine.'
        : d.hoursBand === '60+' ? 'You\'re putting in 60+ hour weeks with no time to steer. Nobody makes sharp calls at hour 60. This isn\'t a work-harder problem, it\'s a leverage problem.'
        : 'All your hours go into the business and none go onto it. The fix isn\'t more hours, it\'s one protected block a week to look at the numbers and decide things.' };
    },
    presence(a) {
      if (!a.known) return { known: false, detail: 'You skipped the social question. No drama. Just know an empty feed reads as a closed door to people who haven\'t visited yet.' };
      const s = d.social;
      return { known: true, detail: s === 'consistent' ? 'Social is consistent and pulling people in. That puts you well ahead. Keep feeding it.'
        : s === 'sometimes' ? 'You post when you remember, which means the feed goes quiet exactly when you\'re busiest. A simple weekly rhythm beats bursts.'
        : s === 'barely' ? 'The feed is nearly silent. For new customers, that\'s the shopfront. This is the cheapest growth lever on this page.'
        : 'No social at all means the only people who find you are the ones who walk past. You don\'t need to dance on camera. One photo a week is a start.' };
    }
  };
  const leakCopy = {
    labour: r => ({ title: 'Labour', tease: 'Wages are your biggest leak. We\'ve priced what\'s on the table.', body: 'You\'re running roughly ' + Math.round(r.labourPct * 100) + '% of revenue on wages. Most independents sit 40 to 50% right now, and every point above 45 is money off your bottom line. Rosters, not people, are usually the fix.' }),
    cogs: r => ({ title: 'Food and drink costs', tease: 'Your cost of goods is the biggest leak on the board. We\'ve priced it.', body: 'Your cost of goods is running roughly ' + Math.round(r.cogsPct * 100) + '% of sales. Best-practice sits 25 to 28%, and above 35% is a red flag. Sharper purchasing and less waste is the fastest dollar you\'ll find.' }),
    occupancy: r => ({ title: 'Rent', tease: 'Rent is carrying more of your revenue than it should. We\'ve priced the gap.', body: 'Rent is roughly ' + Math.round(r.occupancyPct * 100) + '% of revenue. Healthy is under 10%, and 15% is the ceiling. You can\'t cut a lease overnight, so the answer is more revenue through the same door.' }),
    coffee: r => ({ title: 'Coffee programme', tease: 'Your coffee margin is the biggest leak. We\'ve priced what\'s sitting in every cup.', body: 'Your coffee is running at about ' + Math.round(r.coffeeGpPct * 100) + '% gross margin against a 65 to 75% benchmark. Between bean price and menu price, there\'s margin sitting in every cup you pour.' }),
    stock: () => ({ title: 'Stock and ordering', tease: 'Loose stock control is your biggest leak. We\'ve priced what usually walks out the back.', body: 'Loose stock control typically leaks a few percent of everything you buy to over-ordering, waste and shrinkage. On your food and drink spend that\'s real money, and it\'s the kind that never shows up on a receipt.' }),
    owner: () => ({ title: 'Your week', body: 'The biggest leak might be your week. Every hour on the tools is an hour nobody spends steering, and the expensive mistakes (over-ordering, quiet-day rosters, stale pricing) all come from decisions made tired. One protected block a week to look at the numbers pays for itself faster than anything else on this page.' })
  };
  const LEAK_NAME = { labour: 'labour', cogs: 'food cost', occupancy: 'rent', stock: 'stock control', coffee: 'coffee margin' };

  /* ---- results. Phase one is free: the score, the areas and the leak with its number blurred. No gate before value. ---- */
  function countUp(node, target, fmt, ms) {
    const t0 = performance.now(), dur = RM ? 0 : (ms || 1300);
    const tick = now => { const p = dur ? Math.min((now - t0) / dur, 1) : 1; node.innerHTML = fmt(target * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
  }
  function areasHtml(r) {
    const A = r.areas, rows = [['labour', 'Labour'], ['cogs', 'Food and drink'], ['occupancy', 'Rent'], ['coffee', 'Coffee'], ['stock', 'Stock'], ['numbers', 'Numbers'], ['owner', 'Your week'], ['presence', 'Getting found']];
    return rows.map((row, i) => {
      const a = A[row[0]], c = areaCopy[row[0]](a), pct = Math.round(a.score / a.weight * 100), col = c.known === false ? 'none' : barColour(pct);
      return '<div class="au-row c-' + col + '" style="--i:' + i + '"><button type="button" data-area="' + row[0] + '" aria-expanded="false" aria-controls="auD' + row[0] + '"><span class="au-rn">' + row[1] + '</span><span class="au-bar2" aria-hidden="true"><i style="--w:' + (c.known === false ? 100 : pct) + '%"></i></span><span class="au-rs">' + a.score + '<small>/' + a.weight + '</small></span></button><p class="au-rd" id="auD' + row[0] + '">' + c.detail + '</p></div>';
    }).join('');
  }
  function leakHtml(r, locked) {
    const L = r.leak;
    if (!L.area) return '<div class="au-leak"><p class="au-k">Your biggest leak</p><h3>Visibility</h3><p>Your biggest leak is visibility. You can\'t fix what you can\'t see. Start by getting three numbers on a wall: wages, food cost, and yesterday\'s takings.</p></div>';
    const c = leakCopy[L.area](r);
    let range = '';
    if (L.low != null && L.high != null) {
      const best = roundRange((L.low + L.high) / 2), spread = L.low === L.high ? '' : '<small>somewhere between $' + fmtNum(L.low) + ' and $' + fmtNum(L.high) + '</small>';
      range = '<p class="au-leak-n' + (locked ? ' blur" aria-hidden="true' : '') + '">About $' + fmtNum(best) + ' <small>a year</small>' + spread + '</p>' + (locked ? '<p class="au-lock">Unlock below to see the number</p>' : '');
    }
    return '<div class="au-leak"><img src="' + pic('au-leak') + '" alt="" aria-hidden="true"><p class="au-k">Your biggest leak</p><h3>' + c.title + '</h3><p>' + (locked && L.low != null ? c.tease || c.body : c.body) + '</p>' + range + '</div>';
  }
  function foundHtml(r, locked) {
    if (!r.foundTotal || r.foundTotal <= 0) return '';
    return '<div class="au-found"><p class="au-k">Money we spotted</p><p class="au-found-n" id="auFoundN">$0<small> a year</small></p><p>' + (locked ? 'Real dollars, itemised from your own numbers. Unlock below to see where every piece is hiding.' : 'Itemised below. Every number comes from what you told us.') + '</p></div>';
  }
  function showResults() {
    const r = last = calculate(), band = scoreBand(r.total);
    stage.innerHTML = '<div class="au-res b-' + band.cls + '">' +
      '<div class="au-top"><p class="au-venue">' + esc(d.cafeName || 'Your venue') + '</p>' +
      '<div class="au-gauge" role="img" aria-label="' + r.total + ' out of 100. ' + band.label + '"><svg viewBox="0 0 240 132" aria-hidden="true"><path class="g-track" d="M20 122 A100 100 0 0 1 220 122"/><path class="g-fill" id="auArc" d="M20 122 A100 100 0 0 1 220 122" pathLength="100"/></svg><p class="au-score" tabindex="-1"><b id="auScore">0</b><span>out of 100</span></p></div>' +
      '<p class="au-stamp" id="auStamp">' + band.label + '</p><p class="au-verdict">' + band.verdict + '</p></div>' +
      '<div id="auFoundSlot">' + foundHtml(r, !unlocked) + '</div>' +
      '<h3 class="au-h">Area by area <small>Tap a row for the detail</small></h3><div class="au-areas">' + areasHtml(r) + '</div>' +
      '<div id="auLeakSlot">' + leakHtml(r, !unlocked) + '</div>' +
      '<form class="au-unlock" id="auUnlock" novalidate' + (unlocked ? ' hidden' : '') + '><p class="au-k">Your report is ready</p><h3>Pop your email in. Get the numbers.</h3><p>Unlocks the dollar figures on this page and emails you the full report to keep. No spam, no list you can\'t leave.</p>' +
      '<div class="au-fields"><div class="au-f"><label class="au-l" for="auName">Your name</label><input class="au-text" id="auName" name="contactName" type="text" placeholder="First name" autocomplete="name" value="' + esc(d.contactName) + '"></div>' +
      '<div class="au-f"><label class="au-l" for="auEmail">Email</label><input class="au-text" id="auEmail" name="contactEmail" type="email" inputmode="email" placeholder="you@venue.com.au" autocomplete="email" value="' + esc(d.contactEmail) + '"></div>' +
      '<div class="au-f"><label class="au-l" for="auPhone">Phone (optional)</label><input class="au-text" id="auPhone" name="contactPhone" type="tel" inputmode="tel" placeholder="04__ ___ ___" autocomplete="tel" value="' + esc(d.contactPhone) + '"></div></div>' +
      '<button class="btn" type="submit">Unlock + email my report</button><p class="au-ins warn" id="auCapIns" role="alert"></p></form>' +
      '<div class="au-gated" id="auGated"' + (unlocked ? '' : ' hidden') + '>' + (unlocked ? gatedHtml(r, band) : '') + '</div>' +
      '</div>';
    requestAnimationFrame(() => {
      const arc = $('#auArc'); if (arc) arc.style.strokeDashoffset = 100 - r.total;
      countUp($('#auScore'), r.total, v => Math.round(v));
      const fn = $('#auFoundN'); if (fn) countUp(fn, r.foundTotal, v => '$' + fmtNum(v) + '<small> a year</small>');
      $$('.au-row', stage).forEach(row => row.classList.add('on'));
      setTimeout(() => { const s = $('#auStamp'); if (s) { s.classList.add('on'); SFX.slap(); } }, RM ? 0 : 1250);
    });
    SFX.success();
    if (doc.till || r.foundTotal) tape.innerHTML = '<span>Score</span> ' + r.total + ' out of 100';
  }

  /* ---- phase two: the email unlocks the dollar figures, the full breakdown and the report ---- */
  function moneyHtml(r) {
    const D = r.deepDive, cards = [], gp = Math.round(r.coffeeGpPct * 100);
    const card = (cls, num, unit, name, sub) => '<div class="au-m ' + cls + '"><p class="au-mn">' + num + '<small>' + unit + '</small></p><p class="au-ml">' + name + '</p><p class="au-ms">' + sub + '</p></div>';
    const reprice = Math.round(r.menuOpportunity);
    if (reprice > 0) {
      const gap = Math.min(0.50, 6.50 - d.menuPrice);
      cards.push(card('pink wide', '$' + fmtNum(reprice), ' a year', 'Menu price, our straight suggestion', 'You\'re at $' + d.menuPrice.toFixed(2) + ' for a 12oz. Move to $' + (d.menuPrice + gap).toFixed(2) + ' and that\'s ' + (gap === 0.5 ? '50c' : Math.round(gap * 100) + 'c') + ' more on every one of your ' + fmtNum(r.annualCups) + ' cups a year. Perth sits $5.50 to $6.50. Most customers won\'t notice. This one\'s yours whether you ever buy a bean from us or not.'));
    }
    const delta = Math.max(0, Math.round(r.coffeeDelta));
    if (delta > 0) cards.push(card('', '$' + fmtNum(delta), ' a year', 'Beans', 'Your $' + d.coffeeKgPrice + '/kg against ours at $' + BOM_PRICE + '/kg, across every cup you pour.'));
    if (r.leakBest > 0) cards.push(card('lime', '$' + fmtNum(r.leakBest), ' a year', 'Your biggest leak', 'The ' + (LEAK_NAME[r.leak.area] || r.leak.area) + ' gap priced above.'));
    if (D) {
      if (D.annualMilkSavings > 0) cards.push(card('lime', '$' + fmtNum(D.annualMilkSavings), ' a year', 'Milk', 'Brownes at our partner rate: $' + BROWNES_PRICE.toFixed(2) + ' a 2L against your $' + d.milkPricePer2L.toFixed(2) + '. Same fridge.'));
      if (D.milkWasteCost > 0) cards.push(card('lime', '$' + fmtNum(D.milkWasteCost), ' a year', 'Milk waste', d.milkWasteML + 'ml a serve down the drain, about ' + fmtNum(D.wasteLitresPerYear) + ' litres a year at your milk price. Jug discipline gets most of it back.'));
      if (D.grinderSavings > 0) cards.push(card('lime', '$' + fmtNum(D.grinderSavings), ' a year', 'Grinder drift', d.grinderDrift + 'g over on every shot is ' + D.annualDriftKg.toFixed(1) + 'kg of beans ground into nothing. Our free dial-in zeroes it.'));
      if (D.directSavings > 0 && D.effectivePerKg < BOM_PRICE) cards.push(card('wide', '$' + Math.max(0, D.effectivePerKg).toFixed(2), '/kg effective', 'The real number', 'You\'d pay $' + BOM_PRICE + '/kg on the invoice, but $' + fmtNum(D.directSavings) + ' a year in savings across ' + fmtNum(D.annualKg) + ' kilos brings your real cost to $' + Math.max(0, D.effectivePerKg).toFixed(2) + '/kg. Show us another roaster who does that.'));
    }
    if (!cards.length) return '<div class="au-leak"><p class="au-k">Coffee, the bit we own</p><h3>Your numbers are sharp</h3><p>You\'re at ' + gp + '% gross on coffee and priced right. Where we earn our keep is the rest of the package: free dial-in, training, and a team that backs you. The margin holds and the cup gets better.</p></div>';
    return '<h3 class="au-h">Where the money is</h3><div class="au-money">' + cards.join('') + '</div>';
  }
  function verdictHtml(r, band) {
    let text, sub;
    if (d.bottomLine === 'losing') { text = 'You told us straight. That honesty is worth more than the score.'; sub = 'Most operators bleeding money won\'t say it out loud. You did. That\'s the mindset that fixes it. Let\'s find the biggest leak and stop it this month.'; }
    else if (r.total >= 80) { text = 'Fine-tuning, not firefighting.'; sub = 'Protect the coffee margin, keep the numbers habit tight, and the gaps above close on their own schedule.'; }
    else if (r.total >= 60) { text = 'Plug the biggest leak first.'; sub = 'Nothing here is fatal. Fix the one card above with your name on it and the score, and the bank balance, both move.'; }
    else if (r.total >= 40) { text = 'Start with the leak card above.'; sub = 'The leaks are compounding, but the biggest one is usually the easiest to fix first. One fix a month changes the year.'; }
    else { text = 'Three numbers on the wall this week.'; sub = 'Wages, food cost, yesterday\'s takings. Flying blind is exhausting and expensive, and it fixes faster than you\'d think.'; }
    return '<div class="au-next b-' + band.cls + '"><h3>' + text + '</h3><p>' + sub + '</p></div>';
  }
  function timeHtml() {
    if (!d.hoursBand && !d.onBusiness) return '';
    const big = { 'under40': 'Under 40', '40-50': '40-50', '50-60': '50-60', '60+': '60+' }[d.hoursBand] || null;
    const on = { block: 'and you still protect a block to work on it. That is rarer than you think. Guard it.', some: 'and you get an hour here and there to lift your head. Everything above needs more than that.', none: 'and none of it goes on the business, only in it. That is the real reason these leaks stay hidden.' }[d.onBusiness];
    return '<h3 class="au-h">The number nobody prices</h3><div class="au-time">' +
      (big ? '<p class="au-mn">' + big + '<small> hours a week</small></p><p class="au-ml">What you told us you work</p>' : '<p class="au-mn">Your week</p><p class="au-ml">The line no P&amp;L shows</p>') +
      '<p>' + (on ? 'That is your week, ' + on : 'Your week is a cost line too, even though it never appears on a P&amp;L.') + '</p>' +
      '<p>Everything above is money. This is the one thing you cannot buy back, and the reason most of it goes unnoticed is simply that nobody has the hours to go looking.</p>' +
      '<p class="au-sig">Signal reads the lot overnight and has it waiting at 6am, so knowing where you stand costs you none of your week.</p></div>';
  }
  function stackHtml(r) {
    const found = Number(r.foundTotal) || 0, D = r.deepDive, row = (t, v) => '<li><span>' + t + '</span><b>' + v + '</b></li>', rows = [];
    rows.push(row('Signal watches these same numbers every morning and emails you the one worth fixing, from your own Xero', 'Included'));
    if (r.leak && r.leak.area && r.leakBest > 0) rows.push(row('Your ' + (LEAK_NAME[r.leak.area] || r.leak.area) + ' gap, the $' + fmtNum(r.leakBest) + ' above, watched daily instead of found once in five minutes', 'Included'));
    rows.push(row('Brownes milk at our partner rate, ordered direct and invoiced direct', D && D.annualMilkSavings > 0 ? '$' + fmtNum(D.annualMilkSavings) + '/yr' : 'Included'));
    rows.push(row('Grinder dialled in, recipes set, your baristas trained on your machine, on site', 'Included'));
    rows.push(row('Launchpad, so your team can build the fixes themselves', 'Included'));
    rows.push(row('Wholesale portal: reorder in seconds, standing orders, full history', 'Included'));
    rows.push(row('We answer the phone at 6am. Not a ticket, not a bot. Us.', 'Included'));
    return '<div class="au-stack"><h3>The partnership, stacked up</h3><p>You pay for the coffee. That is the whole invoice. Nothing below is an add-on, an upsell, or a line item later.</p><ul>' + rows.join('') + '</ul>' +
      '<p class="au-stack-t">' + (found > 0 ? '<span>Five minutes found you $' + fmtNum(found) + ' a year</span><b>Imagine a full week</b>' : '<span>Everything above</span><b>Comes with the beans</b>') + '</p>' +
      '<p class="au-guar">30 day guarantee. Not right? We take the stock back and refund you, no strings attached. No one has actually done this yet.</p></div>';
  }
  function ctaHtml(r) {
    const found = Number(r.foundTotal) || 0, name = encodeURIComponent(d.cafeName || 'my venue');
    return '<div class="au-bridge"><p>' + (found > 0 ? 'Five minutes and rough numbers found $' + fmtNum(found) + '.' : 'That was five minutes and rough numbers.') + '</p><h3>Imagine what we\'d find <span class="hl">working alongside you.</span></h3></div>' +
      '<div class="au-cta"><p class="au-k">Your next step</p><h3>Switch your beans, keep the rest free</h3><p>The savings above, Signal watching your numbers every morning, your team trained on your machine, Brownes at our rate. You pay for the coffee and nothing else. No lock-in, 30 days to change your mind.</p>' +
      '<button class="btn" type="button" data-cta="coffee">Send me a sample and a price</button>' +
      '<a class="au-mail" href="mailto:wholesale@brotherofmine.com.au?subject=Coffee%20chat%20-%20' + name + '&amp;body=Just%20did%20the%20profit%20audit.%20Keen%20to%20talk%20coffee.">Or email us directly</a></div>' +
      '<p class="au-ops">Running more than one site, or want this done properly with your real books? <button type="button" class="au-link" data-cta="ops">Talk to us about the full audit</button></p>';
  }
  const gatedHtml = (r, band) => moneyHtml(r) + verdictHtml(r, band) + timeHtml() + stackHtml(r) + ctaHtml(r) +
    '<div class="au-acts"><button class="btn btn-white btn-sm" type="button" data-save>Save or print my results</button><button class="btn btn-white btn-sm" type="button" data-restart>Start over</button></div>' +
    (STORE ? '' : '<p class="au-concept">(concept site, so nothing was sent)</p>');
  function unlock() {
    const ins = $('#auCapIns'), name = d.contactName.trim(), email = d.contactEmail.trim();
    if (!name) { ins.textContent = 'Pop your name in and we\'ll send the report.'; $('#auName').focus(); SFX.error(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { ins.textContent = 'That email doesn\'t look right. Check it?'; $('#auEmail').focus(); SFX.error(); return; }
    if (unlocked) return;
    unlocked = true;
    const r = last, band = scoreBand(r.total);
    submit(r);
    $('#auFoundSlot').innerHTML = foundHtml(r, false);
    const fn = $('#auFoundN'); if (fn) fn.innerHTML = '$' + fmtNum(r.foundTotal) + '<small> a year</small>';
    $('#auLeakSlot').innerHTML = leakHtml(r, false);
    $('#auUnlock').hidden = true;
    const g = $('#auGated'); g.innerHTML = gatedHtml(r, band); g.hidden = false;
    SFX.add();
    body.scrollTop = 0; stage.scrollTop = 0;
    const s = $('.au-score', stage); if (s) s.focus({ preventScroll: true });
  }
  function oneTap(cta, btn) {
    tagCta(cta);
    if (STORE) storeSend({ name: d.contactName, email: d.contactEmail, phone: d.contactPhone, 'Enquiry from': '5 minute profit audit: they want to talk', Venue: d.cafeName,
      'Asked for': cta === 'ops' ? 'A call about the full audit' : cta === 'coffee' ? 'A sample and a price' : cta, body: 'They tapped "' + btn.textContent.trim() + '" on their audit results.' });
    btn.disabled = true; btn.classList.add('done');
    btn.textContent = cta === 'ops' ? 'Got it. We\'ll call you within a day.' : 'Got it. We\'ll be in touch within a day.';
    if (btn.parentNode && !$('.au-conf', btn.parentNode)) {
      const note = document.createElement('p'); note.className = 'au-conf'; note.setAttribute('role', 'status');
      note.textContent = !STORE ? '(concept site, so nothing was sent)' : cta === 'ops' ? 'Your answers came through with it, so we already have your numbers in front of us.' : 'Your answers came through with it, so we already know what your coffee is costing you.';
      btn.parentNode.appendChild(note);
    }
    SFX.success();
  }

  /* the store's own contact form (6 Oct): the audit lands in the store's inbox like every other enquiry. The endpoint above
     now asks for a login and sends no CORS header, so the store's page can't reach it */
  /* (6 Oct, 3:31pm) a real submit, not a fetch: the store's contact form runs Shopify's spam check on its submit event and
     drops anything posted round it. The form posts into a hidden frame, one send at a time */
  const auQ = []; let auBusy = false;
  function storeSend(fields) { auQ.push(fields); if (!auBusy) auNext(); }
  function auNext() {
    const fields = auQ.shift(), sf = document.getElementById('auStore');
    if (!fields || !sf || !sf.getAttribute('action')) return;
    let sink = document.getElementById('auSink');
    if (!sink) {
      sink = document.createElement('iframe'); sink.name = sink.id = 'auSink'; sink.title = 'Sending your audit';
      sink.setAttribute('aria-hidden', 'true'); sink.tabIndex = -1;
      sink.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;border:0;visibility:hidden';
      document.body.appendChild(sink);
    }
    sf.querySelectorAll('[data-au]').forEach(n => n.remove());   /* the last send's fields; the spam check's own widget stays */
    Object.keys(fields).forEach(k => {
      const v = fields[k]; if (v == null || v === '') return;
      const i = document.createElement('input'); i.type = 'hidden'; i.name = 'contact[' + k + ']'; i.value = String(v); i.setAttribute('data-au', ''); sf.appendChild(i);
    });
    sf.target = 'auSink';
    auBusy = true;
    const t0 = Date.now();
    const done = how => { if (!auBusy) return; auBusy = false; clearInterval(watch); sf.setAttribute('data-sent', how); setTimeout(auNext, 400); };
    const watch = setInterval(() => {   /* the store answers with a page: read where it landed, then stop it loading */
      let url = '';
      try { url = sink.contentWindow.location.href; } catch (e) { url = 'x'; }
      if (url && url !== 'about:blank') {
        try { sink.contentWindow.stop(); } catch (e) {}
        try { sink.contentWindow.location.replace('about:blank'); } catch (e) {}
        done(/contact_posted=true/.test(url) ? 'ok' : /challenge/.test(url) ? 'challenge' : 'other');
      } else if (Date.now() - t0 > 30000) done('timeout');
    }, 60);
    /* the store's spam check only arms a form once someone has been in it (focus or change), then loads its widget: wait
       for that, a few seconds at most, before sending */
    auPrime();
    const go = () => { try { if (sf.requestSubmit) sf.requestSubmit(); else sf.submit(); } catch (e) { done('error'); } };
    const armed = () => sf.dataset.hcaptchaBound || sf.dataset.recaptchaBound;
    if (armed()) go();
    else { const w0 = Date.now(), w = setInterval(() => { if (armed() || Date.now() - w0 > 6000) { clearInterval(w); setTimeout(go, armed() ? 300 : 0); } }, 100); }
  }
  /* arms the spam check on the hidden form as the audit opens, so its widget is ready long before the results go */
  let auPrimed = false;
  function auPrime() {
    const sf = document.getElementById('auStore');
    if (auPrimed || !sf || !sf.getAttribute('action')) return;
    auPrimed = true;
    try { sf.dispatchEvent(new FocusEvent('focusin', { bubbles: true })); sf.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
  }
  function leakLine(r) {
    const l = r.leak || {};
    return (l.area || '') + (typeof l.low === 'number' && typeof l.high === 'number' ? ' ($' + fmtNum(l.low) + ' to $' + fmtNum(l.high) + ' a year)' : '');
  }
  /* ---- sending. Only on the store: the same endpoint and the same payload the audit already uses ---- */
  function submit(r) {
    if (!STORE) return;
    const deep = d.deepDive === true;
    const payload = {
      version: 3, src: new URLSearchParams(location.search).get('src') || 'site',
      cafeName: d.cafeName, contactName: d.contactName, contactEmail: d.contactEmail, contactPhone: d.contactPhone, venueType: d.venueType,
      inputs: {
        revenueBand: d.revenueBand, revenueMid: r.revenueMid, revenueExact: d.revenueExact, revenueAssumed: r.assumed || undefined,
        wageBand: d.wageKnown ? d.wageBand : null, wageMid: d.wageKnown ? d.wageMid : null, wageKnown: d.wageKnown, wageExact: d.wageExact,
        cogsPct: d.cogsKnown ? d.cogsPct : null, cogsKnown: d.cogsKnown,
        rentBand: d.rentKnown ? d.rentBand : null, rentMid: d.rentKnown ? d.rentMid : null, rentKnown: d.rentKnown, rentExact: d.rentExact,
        cupsPerDay: d.cupsPerDay, daysPerWeek: d.daysPerWeek, coffeeKgPrice: d.coffeeKgPrice, menuPrice: d.menuPrice,
        deepDive: deep, milkCartonsPerWeek: deep ? d.milkCartonsPerWeek : null, milkPricePer2L: deep ? d.milkPricePer2L : null, milkWasteML: deep ? d.milkWasteML : null, grinderDrift: deep ? d.grinderDrift : null,
        stocktake: d.stocktake, ordering: d.ordering, wasteTracked: d.wasteTracked, plFrequency: d.plFrequency, yesterdayRevenue: d.yesterdayRevenue,
        hoursBand: d.hoursBand, onBusiness: d.onBusiness, social: d.social, bottomLine: d.bottomLine
      },
      scores: { total: r.total, labour: r.areas.labour.score, cogs: r.areas.cogs.score, occupancy: r.areas.occupancy.score, coffee: r.areas.coffee.score, stock: r.areas.stock.score, numbers: r.areas.numbers.score, owner: r.areas.owner.score, presence: r.areas.presence.score, bottom: r.areas.bottom.score },
      biggestLeak: { area: r.leak.area, low: r.leak.low, high: r.leak.high },
      coffee: { coffeeDelta: Math.round(r.coffeeDelta), menuOpportunity: Math.round(r.menuOpportunity), coffeeGpPct: +(r.coffeeGpPct * 100).toFixed(1) },
      foundTotal: r.foundTotal,
      deepDiveResults: r.deepDive ? { annualMilkSavings: Math.round(r.deepDive.annualMilkSavings), milkWasteCost: Math.round(r.deepDive.milkWasteCost), wasteLitresPerYear: Math.round(r.deepDive.wasteLitresPerYear), grinderSavings: Math.round(r.deepDive.grinderSavings), annualDriftKg: +r.deepDive.annualDriftKg.toFixed(1), directSavings: Math.round(r.deepDive.directSavings), effectivePerKg: +r.deepDive.effectivePerKg.toFixed(2) } : null,
      ctaClicked: null, submittedAt: new Date().toISOString()
    };
    const said = [];
    Object.keys(payload.inputs).forEach(k => { const v = payload.inputs[k]; if (v != null && v !== '') said.push(k + ': ' + v); });
    storeSend({ name: d.contactName, email: d.contactEmail, phone: d.contactPhone, 'Enquiry from': '5 minute profit audit', Venue: d.cafeName, 'Venue type': d.venueType,
      Score: r.total + ' out of 100', 'Found a year': '$' + fmtNum(r.foundTotal || 0), 'Biggest leak': leakLine(r), body: 'Their answers:\n' + said.join('\n') });
    fetch(POST + 'submit', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(res => res.json()).then(res => { if (res && res.id) { subId = res.id; if (pendingCta) { tagCta(pendingCta); pendingCta = null; } } }).catch(() => {});
  }
  /* keepalive fetch, not sendBeacon: a beacon forces credentials, which the endpoint's open CORS header turns away */
  function tagCta(cta) {
    if (!STORE) return;
    if (!subId) { pendingCta = cta; return; }
    try { fetch(POST + 'cta', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: subId, cta: cta }), keepalive: true, credentials: 'omit' }).catch(() => {}); } catch (e) {}
  }
  function restart() {
    d = fresh(); unlocked = false; last = null; subId = null; pendingCta = null;
    Object.keys(doc).forEach(k => delete doc[k]); linesEl.innerHTML = ''; tape.textContent = '';
    goTo(0);
  }

  /* ---- opening and closing. Opened from the wholesale page, it hands you back there when you close it. ---- */
  function build() {
    if (built) return; built = true;
    $('#auDate').textContent = new Date().toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
    goTo(0, true);
  }
  function open() { build(); if (MAIN) openOv('audit'); auPrime(); }
  function close() { if (MAIN && S.overlay === 'audit') closeOv(); }
  if (MAIN) {
    OV.audit = el;
    document.addEventListener('click', e => {
      const t = e.target.closest && e.target.closest('[data-open="audit"]');
      if (!t) return;
      from = S.overlay; fromTop = from === 'room' ? OV.room.scrollTop : 0; build();
    }, true);
    new MutationObserver(() => {
      if (el.classList.contains('open')) { build(); return; }
      clearTimeout(timer);
      if (from === 'room') { const top = fromTop; from = null; setTimeout(() => { if (!S.overlay) { openOv('room'); requestAnimationFrame(() => { OV.room.scrollTop = top; }); } }, 0); }
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
    if (/^#audit\b/.test(location.hash)) { let n = 0; const wait = setInterval(() => { if (S.entered) { clearInterval(wait); setTimeout(open, 0); } else if (++n > 600) clearInterval(wait); }, 200); }
  }
  return { open: open, close: close, goTo: goTo, calculate: calculate, restart: restart, data: () => d, results: () => last, step: () => step, STORE: STORE };
})();
if (window.__cfl) window.__cfl.Audit = Audit;

})();

/* 9 Oct (Jos): on a wide screen (1500x801 up) the tasting stickers sit beside "Brew it right", at the foot of the words, not
   under the bag; narrower screens keep them under the bag. The page is marked html.tzw while they are moved. */
const tzWide = matchMedia('(min-width:1500px) and (min-height:801px)');
function placeTastes() {
  const wide = tzWide.matches;
  document.documentElement.classList.toggle('tzw', wide);
  document.querySelectorAll('.panel').forEach(p => {
    const tz = p.querySelector('.tastes'), bag = p.querySelector('.p-bag'), copy = p.querySelector('.p-copy');
    if (!tz || !bag || !copy) return;
    if (wide) {
      let row = copy.querySelector('.p-foot');
      if (!row) { const brew = copy.querySelector('.p-brew'); if (!brew) return; row = document.createElement('div'); row.className = 'p-foot'; brew.after(row); row.appendChild(brew); }
      if (tz.parentNode !== row) row.appendChild(tz);
    } else if (tz.parentNode !== bag) bag.appendChild(tz);
  });
}
placeTastes(); tzWide.addEventListener('change', placeTastes);

/* 13 Oct (Jos: "website creashes when skipping pages on phone"): on phones and tablets, sticker loops in sections well off
   screen are switched off until the section comes back near the screen. A loop holds a graphics layer the whole time it
   runs, and Safari on an iPhone reloads a page that runs out of memory. Only loops are touched: anything that plays once
   (an entrance) is left alone, so nothing looks different on screen. */
(function lean() {
  if (!(matchMedia('(pointer: coarse)').matches || innerWidth < 1101) || !window.IntersectionObserver || !document.getAnimations) return;
  const RP = document.documentElement.classList.contains('roompage'), room = RP ? document.getElementById('room') : null;
  const secs = Array.from(document.querySelectorAll(RP ? '#room .wrap > *, #room .room-foot' : '#main > section, #main > footer, #blends > .panel'));
  const loops = el => el.getAnimations().every(x => x.effect && x.effect.getComputedTiming().iterations === Infinity);
  const mark = sec => {
    sec.getAnimations({ subtree: true }).forEach(a => {
      const ef = a.effect;
      if (!ef || !ef.target || ef.target.nodeType !== 1 || ef.getComputedTiming().iterations !== Infinity) return;
      if (ef.pseudoElement) ef.target.setAttribute(ef.pseudoElement === '::before' ? 'data-loopb' : 'data-loopa', '');
      else if (loops(ef.target)) ef.target.setAttribute('data-loop', '');
    });
  };
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) e.target.classList.remove('zz');
    else if (!e.target.classList.contains('zz')) { mark(e.target); e.target.classList.add('zz'); }
  }), { root: room, rootMargin: '60% 0px' });
  secs.forEach(sec => io.observe(sec));
})();
